webpackJsonp([33587185282056],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(59);
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
	          return fn(a, _b);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b);
	        }) : fn(a, b);
	    }
	  };
	}
	module.exports = _curry2;

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = /*#__PURE__*/__webpack_require__(59);
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	}
	module.exports = _curry1;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(59);
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _curry1(function (_c) {
	          return fn(a, b, _c);
	        });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
	          return fn(_a, _b, c);
	        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
	          return fn(_a, b, _c);
	        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
	          return fn(a, _b, _c);
	        }) : _isPlaceholder(a) ? _curry1(function (_a) {
	          return fn(_a, b, c);
	        }) : _isPlaceholder(b) ? _curry1(function (_b) {
	          return fn(a, _b, c);
	        }) : _isPlaceholder(c) ? _curry1(function (_c) {
	          return fn(a, b, _c);
	        }) : fn(a, b, c);
	    }
	  };
	}
	module.exports = _curry3;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(88);
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	
	
	function _dispatchable(methodNames, xf, fn) {
	  return function () {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	}
	module.exports = _dispatchable;

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

	module.exports = {
	  init: function () {
	    return this.xf['@@transducer/init']();
	  },
	  result: function (result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _curryN = /*#__PURE__*/__webpack_require__(56);
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curryN = /*#__PURE__*/_curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});
	module.exports = curryN;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	module.exports = _has;

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _map = /*#__PURE__*/__webpack_require__(60);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xmap = /*#__PURE__*/__webpack_require__(354);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	
	
	var map = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function () {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function (acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));
	module.exports = map;

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _equals = /*#__PURE__*/__webpack_require__(329);
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	
	
	var equals = /*#__PURE__*/_curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});
	module.exports = equals;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = /*#__PURE__*/__webpack_require__(57);
	
	var _xwrap = /*#__PURE__*/__webpack_require__(152);
	
	var bind = /*#__PURE__*/__webpack_require__(130);
	
	function _arrayReduce(xf, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    acc = xf['@@transducer/step'](acc, list[idx]);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    idx += 1;
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _iterableReduce(xf, acc, iter) {
	  var step = iter.next();
	  while (!step.done) {
	    acc = xf['@@transducer/step'](acc, step.value);
	    if (acc && acc['@@transducer/reduced']) {
	      acc = acc['@@transducer/value'];
	      break;
	    }
	    step = iter.next();
	  }
	  return xf['@@transducer/result'](acc);
	}
	
	function _methodReduce(xf, acc, obj, methodName) {
	  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
	}
	
	var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
	
	function _reduce(fn, acc, list) {
	  if (typeof fn === 'function') {
	    fn = _xwrap(fn);
	  }
	  if (_isArrayLike(list)) {
	    return _arrayReduce(fn, acc, list);
	  }
	  if (typeof list['fantasy-land/reduce'] === 'function') {
	    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
	  }
	  if (list[symIterator] != null) {
	    return _iterableReduce(fn, acc, list[symIterator]());
	  }
	  if (typeof list.next === 'function') {
	    return _iterableReduce(fn, acc, list);
	  }
	  if (typeof list.reduce === 'function') {
	    return _methodReduce(fn, acc, list, 'reduce');
	  }
	
	  throw new TypeError('reduce: list must be array or iterable');
	}
	module.exports = _reduce;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _concat;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(40);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	
	
	var slice = /*#__PURE__*/_curry3( /*#__PURE__*/_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));
	module.exports = slice;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.apply(this, arguments);
	      };
	    case 1:
	      return function (a0) {
	        return fn.apply(this, arguments);
	      };
	    case 2:
	      return function (a0, a1) {
	        return fn.apply(this, arguments);
	      };
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.apply(this, arguments);
	      };
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.apply(this, arguments);
	      };
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.apply(this, arguments);
	      };
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.apply(this, arguments);
	      };
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.apply(this, arguments);
	      };
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.apply(this, arguments);
	      };
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.apply(this, arguments);
	      };
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.apply(this, arguments);
	      };
	    default:
	      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	}
	module.exports = _arity;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(147);
	
	// cover IE < 9 keys issues
	
	
	var hasEnumBug = ! /*#__PURE__*/{ toString: null }.propertyIsEnumerable('toString');
	var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	// Safari bug
	var hasArgsEnumBug = /*#__PURE__*/function () {
	  'use strict';
	
	  return arguments.propertyIsEnumerable('length');
	}();
	
	var contains = function contains(list, item) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (list[idx] === item) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @see R.keysIn, R.values
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	var _keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? function keys(obj) {
	  return Object(obj) !== obj ? [] : Object.keys(obj);
	} : function keys(obj) {
	  if (Object(obj) !== obj) {
	    return [];
	  }
	  var prop, nIdx;
	  var ks = [];
	  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	  for (prop in obj) {
	    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	      ks[ks.length] = prop;
	    }
	  }
	  if (hasEnumBug) {
	    nIdx = nonEnumerableProps.length - 1;
	    while (nIdx >= 0) {
	      prop = nonEnumerableProps[nIdx];
	      if (_has(prop, obj) && !contains(ks, prop)) {
	        ks[ks.length] = prop;
	      }
	      nIdx -= 1;
	    }
	  }
	  return ks;
	};
	var keys = /*#__PURE__*/_curry1(_keys);
	module.exports = keys;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * [`R.reduced`](#reduced) to shortcut the iteration.
	 *
	 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
	 * is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present. When
	 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
	 * shortcuting, as this is not implemented by `reduce`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *      //          -               -10
	 *      //         / \              / \
	 *      //        -   4           -6   4
	 *      //       / \              / \
	 *      //      -   3   ==>     -3   3
	 *      //     / \              / \
	 *      //    -   2           -1   2
	 *      //   / \              / \
	 *      //  0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	
	
	var reduce = /*#__PURE__*/_curry3(_reduce);
	module.exports = reduce;

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
	};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x : {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	module.exports = _reduced;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	
	
	var always = /*#__PURE__*/_curry1(function always(val) {
	  return function () {
	    return val;
	  };
	});
	module.exports = always;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var _indexOf = /*#__PURE__*/__webpack_require__(146);
	
	function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	}
	module.exports = _contains;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	
	
	var max = /*#__PURE__*/_curry2(function max(a, b) {
	  return b > a ? b : a;
	});
	module.exports = max;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	
	
	var path = /*#__PURE__*/_curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});
	module.exports = path;

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	
	
	function _checkForMethod(methodname, fn) {
	  return function () {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	}
	module.exports = _checkForMethod;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	}
	module.exports = _isString;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(58);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var toString = /*#__PURE__*/__webpack_require__(45);
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @see R.construct
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	
	
	var invoker = /*#__PURE__*/_curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function () {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});
	module.exports = invoker;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isString = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	
	
	var nth = /*#__PURE__*/_curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});
	module.exports = nth;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var prop = /*#__PURE__*/__webpack_require__(90);
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * `pluck` will work on
	 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
	 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => k -> f {k: v} -> f v
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} f The array or functor to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	
	
	var pluck = /*#__PURE__*/_curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});
	module.exports = pluck;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _toString = /*#__PURE__*/__webpack_require__(341);
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	
	
	var toString = /*#__PURE__*/_curry1(function toString(val) {
	  return _toString(val, []);
	});
	module.exports = toString;

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	
	
	var add = /*#__PURE__*/_curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});
	module.exports = add;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var assoc = /*#__PURE__*/_curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});
	module.exports = assoc;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	
	
	var flip = /*#__PURE__*/_curry1(function flip(fn) {
	  return curryN(fn.length, function (a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});
	module.exports = flip;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}
	module.exports = _containsWith;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _isPlaceholder = /*#__PURE__*/__webpack_require__(59);
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	
	
	function _curryN(length, received, fn) {
	  return function () {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
	  };
	}
	module.exports = _curryN;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var _isString = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @private
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @example
	 *
	 *      _isArrayLike([]); //=> true
	 *      _isArrayLike(true); //=> false
	 *      _isArrayLike({}); //=> false
	 *      _isArrayLike({length: 10}); //=> false
	 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	
	
	var _isArrayLike = /*#__PURE__*/_curry1(function isArrayLike(x) {
	  if (_isArray(x)) {
	    return true;
	  }
	  if (!x) {
	    return false;
	  }
	  if (typeof x !== 'object') {
	    return false;
	  }
	  if (_isString(x)) {
	    return false;
	  }
	  if (x.nodeType === 1) {
	    return !!x.length;
	  }
	  if (x.length === 0) {
	    return true;
	  }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});
	module.exports = _isArrayLike;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	}
	module.exports = _isFunction;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	function _isPlaceholder(a) {
	       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
	}
	module.exports = _isPlaceholder;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _map;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	
	
	var lens = /*#__PURE__*/_curry2(function lens(getter, setter) {
	  return function (toFunctorFn) {
	    return function (target) {
	      return map(function (focus) {
	        return setter(focus, target);
	      }, toFunctorFn(getter(target)));
	    };
	  };
	});
	module.exports = lens;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var liftN = /*#__PURE__*/__webpack_require__(158);
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	
	
	var lift = /*#__PURE__*/_curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});
	module.exports = lift;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _isObject = /*#__PURE__*/__webpack_require__(87);
	
	var mergeWithKey = /*#__PURE__*/__webpack_require__(89);
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to the key and associated values
	 *   using the resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeDeepWithKey(concatValues,
	 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
	 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
	 */
	
	
	var mergeDeepWithKey = /*#__PURE__*/_curry3(function mergeDeepWithKey(fn, lObj, rObj) {
	  return mergeWithKey(function (k, lVal, rVal) {
	    if (_isObject(lVal) && _isObject(rVal)) {
	      return mergeDeepWithKey(fn, lVal, rVal);
	    } else {
	      return fn(k, lVal, rVal);
	    }
	  }, lObj, rObj);
	});
	module.exports = mergeDeepWithKey;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @see R.binary, R.unary
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	
	
	var nAry = /*#__PURE__*/_curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0:
	      return function () {
	        return fn.call(this);
	      };
	    case 1:
	      return function (a0) {
	        return fn.call(this, a0);
	      };
	    case 2:
	      return function (a0, a1) {
	        return fn.call(this, a0, a1);
	      };
	    case 3:
	      return function (a0, a1, a2) {
	        return fn.call(this, a0, a1, a2);
	      };
	    case 4:
	      return function (a0, a1, a2, a3) {
	        return fn.call(this, a0, a1, a2, a3);
	      };
	    case 5:
	      return function (a0, a1, a2, a3, a4) {
	        return fn.call(this, a0, a1, a2, a3, a4);
	      };
	    case 6:
	      return function (a0, a1, a2, a3, a4, a5) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5);
	      };
	    case 7:
	      return function (a0, a1, a2, a3, a4, a5, a6) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
	      };
	    case 8:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
	      };
	    case 9:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
	      };
	    case 10:
	      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
	        return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
	      };
	    default:
	      throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});
	module.exports = nAry;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(56);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xreduceBy = /*#__PURE__*/__webpack_require__(355);
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general [`groupBy`](#groupBy) function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	
	
	var reduceBy = /*#__PURE__*/_curryN(4, [], /*#__PURE__*/_dispatchable([], _xreduceBy, function reduceBy(valueFn, valueAcc, keyFn, list) {
	  return _reduce(function (acc, elt) {
	    var key = keyFn(elt);
	    acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	    return acc;
	  }, {}, list);
	}));
	module.exports = reduceBy;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(144);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var filter = /*#__PURE__*/__webpack_require__(81);
	
	/**
	 * The complement of [`filter`](#filter).
	 *
	 * Acts as a transducer if a transformer is given in list position. Filterable
	 * objects include plain objects or any object that has a filter method such
	 * as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var reject = /*#__PURE__*/_curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});
	module.exports = reject;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isString = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	
	
	var reverse = /*#__PURE__*/_curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
	});
	module.exports = reverse;

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
	 * @param {*} applyF
	 * @param {*} applyX
	 * @return {*}
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 *
	 *      // R.ap can also be used as S combinator
	 *      // when only two functions are passed
	 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	
	
	var ap = /*#__PURE__*/_curry2(function ap(applyF, applyX) {
	  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
	    return applyF(x)(applyX(x));
	  } :
	  // else
	  _reduce(function (acc, f) {
	    return _concat(acc, map(f, applyX));
	  }, [], applyF);
	});
	module.exports = ap;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _makeFlat = /*#__PURE__*/__webpack_require__(149);
	
	var _xchain = /*#__PURE__*/__webpack_require__(344);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	
	
	var chain = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function (x) {
	      return fn(monad(x))(x);
	    };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));
	module.exports = chain;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = /*#__PURE__*/__webpack_require__(167);
	
	var reverse = /*#__PURE__*/__webpack_require__(67);
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	
	
	function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	}
	module.exports = compose;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(58);
	
	var _isString = /*#__PURE__*/__webpack_require__(41);
	
	var toString = /*#__PURE__*/__webpack_require__(45);
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 * Can also concatenate two members of a [fantasy-land
	 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	
	
	var concat = /*#__PURE__*/_curry2(function concat(a, b) {
	  if (_isArray(a)) {
	    if (_isArray(b)) {
	      return a.concat(b);
	    }
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  if (_isString(a)) {
	    if (_isString(b)) {
	      return a + b;
	    }
	    throw new TypeError(toString(b) + ' is not a string');
	  }
	  if (a != null && _isFunction(a['fantasy-land/concat'])) {
	    return a['fantasy-land/concat'](b);
	  }
	  if (a != null && _isFunction(a.concat)) {
	    return a.concat(b);
	  }
	  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
	});
	module.exports = concat;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
	 * the following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	
	
	var curry = /*#__PURE__*/_curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});
	module.exports = curry;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _filter = /*#__PURE__*/__webpack_require__(84);
	
	var _isObject = /*#__PURE__*/__webpack_require__(87);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xfilter = /*#__PURE__*/__webpack_require__(349);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Takes a predicate and a `Filterable`, and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array} Filterable
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	
	
	var filter = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['filter'], _xfilter, function (pred, filterable) {
	  return _isObject(filterable) ? _reduce(function (acc, key) {
	    if (pred(filterable[key])) {
	      acc[key] = filterable[key];
	    }
	    return acc;
	  }, {}, keys(filterable)) :
	  // else
	  _filter(pred, filterable);
	}));
	module.exports = filter;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _identity = /*#__PURE__*/__webpack_require__(85);
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	
	
	var identity = /*#__PURE__*/_curry1(_identity);
	module.exports = identity;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var _objectAssign = /*#__PURE__*/__webpack_require__(334);
	
	module.exports = typeof Object.assign === 'function' ? Object.assign : _objectAssign;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	}
	module.exports = _filter;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	function _identity(x) {
	  return x;
	}
	module.exports = _identity;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return n << 0 === n;
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	}
	module.exports = _isObject;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	}
	module.exports = _isTransformer;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	
	
	var mergeWithKey = /*#__PURE__*/_curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !_has(k, result)) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});
	module.exports = mergeWithKey;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var path = /*#__PURE__*/__webpack_require__(38);
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	
	var prop = /*#__PURE__*/_curry2(function prop(p, obj) {
	  return path([p], obj);
	});
	module.exports = prop;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(40);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	
	
	var tail = /*#__PURE__*/_curry1( /*#__PURE__*/_checkForMethod('tail', /*#__PURE__*/slice(1, Infinity)));
	module.exports = tail;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xtake = /*#__PURE__*/__webpack_require__(356);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	
	
	var take = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));
	module.exports = take;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 *      R.type(() => {}); //=> "Function"
	 *      R.type(undefined); //=> "Undefined"
	 */
	
	
	var type = /*#__PURE__*/_curry1(function type(val) {
	  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
	});
	module.exports = type;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = /*#__PURE__*/__webpack_require__(82);
	
	var uniqBy = /*#__PURE__*/__webpack_require__(176);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. [`R.equals`](#equals) is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	
	
	var uniq = /*#__PURE__*/uniqBy(identity);
	module.exports = uniq;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var adjust = /*#__PURE__*/__webpack_require__(125);
	
	var always = /*#__PURE__*/__webpack_require__(35);
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	
	
	var update = /*#__PURE__*/_curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});
	module.exports = update;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(208);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	
	
	var adjust = /*#__PURE__*/_curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});
	module.exports = adjust;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	
	
	var and = /*#__PURE__*/_curry2(function and(a, b) {
	  return a && b;
	});
	module.exports = and;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xany = /*#__PURE__*/__webpack_require__(150);
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	
	
	var any = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));
	module.exports = any;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	
	
	var apply = /*#__PURE__*/_curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});
	module.exports = apply;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(86);
	
	var assoc = /*#__PURE__*/__webpack_require__(53);
	
	var isNil = /*#__PURE__*/__webpack_require__(154);
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	
	
	var assocPath = /*#__PURE__*/_curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = !isNil(obj) && _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});
	module.exports = assocPath;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	
	
	var bind = /*#__PURE__*/_curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function () {
	    return fn.apply(thisObj, arguments);
	  });
	});
	module.exports = bind;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var chain = /*#__PURE__*/__webpack_require__(77);
	
	var compose = /*#__PURE__*/__webpack_require__(78);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), f)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	
	
	function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	}
	module.exports = composeK;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var curry = /*#__PURE__*/__webpack_require__(80);
	
	var nAry = /*#__PURE__*/__webpack_require__(64);
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      }
	 *
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
	 *        return R.join('\n', instructions);
	 *      };
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad);
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
	 *
	 *      console.log(salad.recipe());
	 *      // Add a dollop of Mayonnaise
	 *      // Add a dollop of Potato Chips
	 *      // Add a dollop of Ketchup
	 */
	
	
	var constructN = /*#__PURE__*/_curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function () {
	      return new Fn();
	    };
	  }
	  return curry(nAry(n, function ($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case 1:
	        return new Fn($0);
	      case 2:
	        return new Fn($0, $1);
	      case 3:
	        return new Fn($0, $1, $2);
	      case 4:
	        return new Fn($0, $1, $2, $3);
	      case 5:
	        return new Fn($0, $1, $2, $3, $4);
	      case 6:
	        return new Fn($0, $1, $2, $3, $4, $5);
	      case 7:
	        return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case 8:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case 9:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10:
	        return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});
	module.exports = constructN;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _map = /*#__PURE__*/__webpack_require__(60);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var max = /*#__PURE__*/__webpack_require__(37);
	
	var pluck = /*#__PURE__*/__webpack_require__(44);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	
	
	var converge = /*#__PURE__*/_curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function () {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function (fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});
	module.exports = converge;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	
	
	var defaultTo = /*#__PURE__*/_curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});
	module.exports = defaultTo;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared in terms of
	 * value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	
	
	var difference = /*#__PURE__*/_curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});
	module.exports = difference;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = /*#__PURE__*/__webpack_require__(55);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	
	
	var differenceWith = /*#__PURE__*/_curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) && !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});
	module.exports = differenceWith;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	
	
	var dissoc = /*#__PURE__*/_curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});
	module.exports = dissoc;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xdrop = /*#__PURE__*/__webpack_require__(345);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	
	
	var drop = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));
	module.exports = drop;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xdropRepeatsWith = /*#__PURE__*/__webpack_require__(151);
	
	var last = /*#__PURE__*/__webpack_require__(156);
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig ((a, a) -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	
	
	var dropRepeatsWith = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	module.exports = dropRepeatsWith;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isArguments = /*#__PURE__*/__webpack_require__(147);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var _isObject = /*#__PURE__*/__webpack_require__(87);
	
	var _isString = /*#__PURE__*/__webpack_require__(41);
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty`,
	 * `<Type>.prototype.empty` or implement the
	 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	
	
	var empty = /*#__PURE__*/_curry1(function empty(x) {
	  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
	    return arguments;
	  }() :
	  // else
	  void 0;
	});
	module.exports = empty;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	
	
	var identical = /*#__PURE__*/_curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});
	module.exports = identical;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = /*#__PURE__*/__webpack_require__(143);
	
	var type = /*#__PURE__*/__webpack_require__(93);
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	
	
	function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':
	      return copy({});
	    case 'Array':
	      return copy([]);
	    case 'Date':
	      return new Date(value.valueOf());
	    case 'RegExp':
	      return _cloneRegExp(value);
	    default:
	      return value;
	  }
	}
	module.exports = _clone;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	function _cloneRegExp(pattern) {
	                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
	}
	module.exports = _cloneRegExp;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	function _complement(f) {
	  return function () {
	    return !f.apply(this, arguments);
	  };
	}
	module.exports = _complement;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	function _createPartialApplicator(concat) {
	  return _curry2(function (fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function () {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	}
	module.exports = _createPartialApplicator;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var equals = /*#__PURE__*/__webpack_require__(18);
	
	function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}
	module.exports = _indexOf;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var toString = Object.prototype.toString;
	var _isArguments = function () {
	  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
	    return toString.call(x) === '[object Arguments]';
	  } : function _isArguments(x) {
	    return _has('callee', x);
	  };
	};
	
	module.exports = _isArguments;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	}
	module.exports = _isNumber;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArrayLike = /*#__PURE__*/__webpack_require__(57);
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	
	
	function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (_isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	}
	module.exports = _makeFlat;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XAny = /*#__PURE__*/function () {
	
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function (result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return XAny;
	}();
	
	var _xany = /*#__PURE__*/_curry2(function _xany(f, xf) {
	  return new XAny(f, xf);
	});
	module.exports = _xany;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XDropRepeatsWith = /*#__PURE__*/function () {
	
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function (result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDropRepeatsWith;
	}();
	
	var _xdropRepeatsWith = /*#__PURE__*/_curry2(function _xdropRepeatsWith(pred, xf) {
	  return new XDropRepeatsWith(pred, xf);
	});
	module.exports = _xdropRepeatsWith;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	var XWrap = /*#__PURE__*/function () {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function () {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function (acc) {
	    return acc;
	  };
	  XWrap.prototype['@@transducer/step'] = function (acc, x) {
	    return this.f(acc, x);
	  };
	
	  return XWrap;
	}();
	
	function _xwrap(fn) {
	  return new XWrap(fn);
	}
	module.exports = _xwrap;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	
	
	var is = /*#__PURE__*/_curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});
	module.exports = is;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	
	
	var isNil = /*#__PURE__*/_curry1(function isNil(x) {
	  return x == null;
	});
	module.exports = isNil;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var converge = /*#__PURE__*/__webpack_require__(133);
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	
	
	var juxt = /*#__PURE__*/_curry1(function juxt(fns) {
	  return converge(function () {
	    return Array.prototype.slice.call(arguments, 0);
	  }, fns);
	});
	module.exports = juxt;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = /*#__PURE__*/__webpack_require__(43);
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	
	
	var last = /*#__PURE__*/nth(-1);
	module.exports = last;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _isNumber = /*#__PURE__*/__webpack_require__(148);
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	
	
	var length = /*#__PURE__*/_curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});
	module.exports = length;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var ap = /*#__PURE__*/__webpack_require__(76);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	
	
	var liftN = /*#__PURE__*/_curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function () {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});
	module.exports = liftN;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var sum = /*#__PURE__*/__webpack_require__(173);
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.median
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	
	
	var mean = /*#__PURE__*/_curry1(function mean(list) {
	  return sum(list) / list.length;
	});
	module.exports = mean;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
	 * additional function that will be applied to a given argument set and used to
	 * create the cache key under which the results of the function to be memoized
	 * will be stored. Care must be taken when implementing key generation to avoid
	 * clashes that may overwrite previous entries erroneously.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to generate the cache key.
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoize
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoizeWith(R.identity, n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	
	
	var memoizeWith = /*#__PURE__*/_curry2(function memoizeWith(mFn, fn) {
	  var cache = {};
	  return _arity(fn.length, function () {
	    var key = mFn.apply(this, arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});
	module.exports = memoizeWith;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	
	
	var multiply = /*#__PURE__*/_curry2(function multiply(a, b) {
	  return a * b;
	});
	module.exports = multiply;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	
	
	var not = /*#__PURE__*/_curry1(function not(a) {
	  return !a;
	});
	module.exports = not;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	
	
	var objOf = /*#__PURE__*/_curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});
	module.exports = objOf;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	
	
	var or = /*#__PURE__*/_curry2(function or(a, b) {
	  return a || b;
	});
	module.exports = or;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	// `Identity` is a functor that holds a single value, where `map` simply
	// transforms the held value with the provided function.
	
	
	var Identity = function (x) {
	  return { value: x, map: function (f) {
	      return Identity(f(x));
	    } };
	};
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	var over = /*#__PURE__*/_curry3(function over(lens, f, x) {
	  // The value returned by the getter function is first transformed with `f`,
	  // then set as the value of an `Identity`. This is then mapped over with the
	  // setter function of the lens.
	  return lens(function (y) {
	    return Identity(f(y));
	  })(x).value;
	});
	module.exports = over;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	
	
	var pickAll = /*#__PURE__*/_curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});
	module.exports = pickAll;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _pipe = /*#__PURE__*/__webpack_require__(336);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	var tail = /*#__PURE__*/__webpack_require__(91);
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	
	
	function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length, reduce(_pipe, arguments[0], tail(arguments)));
	}
	module.exports = pipe;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _pipeP = /*#__PURE__*/__webpack_require__(337);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	var tail = /*#__PURE__*/__webpack_require__(91);
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	
	
	function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length, reduce(_pipeP, arguments[0], tail(arguments)));
	}
	module.exports = pipeP;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	
	
	var prepend = /*#__PURE__*/_curry2(function prepend(el, list) {
	  return _concat([el], list);
	});
	module.exports = prepend;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to [`reduce`](#reduce), except moves through the input list from the
	 * right to the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *      //    -               -2
	 *      //   / \              / \
	 *      //  1   -            1   3
	 *      //     / \              / \
	 *      //    2   -     ==>    2  -1
	 *      //       / \              / \
	 *      //      3   -            3   4
	 *      //         / \              / \
	 *      //        4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	
	
	var reduceRight = /*#__PURE__*/_curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});
	module.exports = reduceRight;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	
	
	var remove = /*#__PURE__*/_curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});
	module.exports = remove;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var ap = /*#__PURE__*/__webpack_require__(76);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var prepend = /*#__PURE__*/__webpack_require__(169);
	
	var reduceRight = /*#__PURE__*/__webpack_require__(170);
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	
	
	var sequence = /*#__PURE__*/_curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ? traversable.sequence(of) : reduceRight(function (x, acc) {
	    return ap(map(prepend, x), acc);
	  }, of([]), traversable);
	});
	module.exports = sequence;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(52);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	
	
	var sum = /*#__PURE__*/reduce(add, 0);
	module.exports = sum;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var drop = /*#__PURE__*/__webpack_require__(138);
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	
	
	var takeLast = /*#__PURE__*/_curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});
	module.exports = takeLast;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @see R.repeat
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	
	
	var times = /*#__PURE__*/_curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});
	module.exports = times;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var _Set = /*#__PURE__*/__webpack_require__(324);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. [`R.equals`](#equals) is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	
	
	var uniqBy = /*#__PURE__*/_curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = uniqBy;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = /*#__PURE__*/__webpack_require__(55);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig ((a, a) -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	
	
	var uniqWith = /*#__PURE__*/_curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = uniqWith;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	
	
	var useWith = /*#__PURE__*/_curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function () {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});
	module.exports = useWith;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @see R.valuesIn, R.keys
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	
	
	var values = /*#__PURE__*/_curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});
	module.exports = values;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as [`filter`](#filter) and [`find`](#find).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.whereEq
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(R.__, 10),
	 *        y: R.lt(R.__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	
	
	var where = /*#__PURE__*/_curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});
	module.exports = where;

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(1572));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = {
	  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
	  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;
	
	  var proto = obj;
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.REPLACE });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';
	
	  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var store = createStore.apply(undefined, args);
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(undefined, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	function isCrushed() {}
	
	if (false) {
	  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = createStore;
	exports.combineReducers = combineReducers;
	exports.bindActionCreators = bindActionCreators;
	exports.applyMiddleware = applyMiddleware;
	exports.compose = compose;
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;


/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(258);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1495);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(562);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1496);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(186);
	
	var _reactRedux = __webpack_require__(214);
	
	var _updateDictionary = __webpack_require__(617);
	
	var _updateDictionary2 = _interopRequireDefault(_updateDictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return state;
	};
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({
	      updateDictionary: _updateDictionary2.default
	    }, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);
	module.exports = exports["default"];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(186);
	
	var _reactRedux = __webpack_require__(214);
	
	var _updateDictionary = __webpack_require__(624);
	
	var _updateDictionary2 = _interopRequireDefault(_updateDictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return state;
	};
	
	// Actions
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)({
	      updateDictionary: _updateDictionary2.default
	    }, dispatch)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);
	module.exports = exports["default"];

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123),
	    getRawTag = __webpack_require__(259),
	    objectToString = __webpack_require__(260);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(123);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var always = /*#__PURE__*/__webpack_require__(35);
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	
	
	var F = /*#__PURE__*/always(false);
	module.exports = F;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var always = /*#__PURE__*/__webpack_require__(35);
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	
	
	var T = /*#__PURE__*/always(true);
	module.exports = T;

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = { '@@functional/placeholder': true };

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, [`R.map`](#map) function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	
	
	var addIndex = /*#__PURE__*/_curry1(function addIndex(fn) {
	  return curryN(fn.length, function () {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function () {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});
	module.exports = addIndex;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xall = /*#__PURE__*/__webpack_require__(342);
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	
	
	var all = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));
	module.exports = all;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var max = /*#__PURE__*/__webpack_require__(37);
	
	var pluck = /*#__PURE__*/__webpack_require__(44);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	
	
	var allPass = /*#__PURE__*/_curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});
	module.exports = allPass;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var max = /*#__PURE__*/__webpack_require__(37);
	
	var pluck = /*#__PURE__*/__webpack_require__(44);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	
	
	var anyPass = /*#__PURE__*/_curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function () {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});
	module.exports = anyPass;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var _aperture = /*#__PURE__*/__webpack_require__(325);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xaperture = /*#__PURE__*/__webpack_require__(343);
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	
	
	var aperture = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xaperture, _aperture));
	module.exports = aperture;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	
	
	var append = /*#__PURE__*/_curry2(function append(el, list) {
	  return _concat(list, [el]);
	});
	module.exports = append;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var apply = /*#__PURE__*/__webpack_require__(128);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var max = /*#__PURE__*/__webpack_require__(37);
	
	var pluck = /*#__PURE__*/__webpack_require__(44);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	var values = /*#__PURE__*/__webpack_require__(179);
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *        sum: R.add,
	 *        nested: { mul: R.multiply }
	 *      });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	
	
	var applySpec = /*#__PURE__*/_curry1(function applySpec(spec) {
	  spec = map(function (v) {
	    return typeof v == 'function' ? v : applySpec(v);
	  }, spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))), function () {
	    var args = arguments;
	    return map(function (f) {
	      return apply(f, args);
	    }, spec);
	  });
	});
	module.exports = applySpec;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	* Takes a value and applies a function to it.
	*
	* This function is also known as the `thrush` combinator.
	*
	* @func
	* @memberOf R
	 * @since v0.25.0
	* @category Function
	* @sig a -> (a -> b) -> b
	* @param {*} x The value
	* @param {Function} f The function to apply
	* @return {*} The result of applying `f` to `x`
	* @example
	*
	*      var t42 = R.applyTo(42);
	*      t42(R.identity); //=> 42
	*      t42(R.add(1)); //=> 43
	*/
	
	
	var applyTo = /*#__PURE__*/_curry2(function applyTo(x, f) {
	  return f(x);
	});
	module.exports = applyTo;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @see R.descend
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	
	
	var ascend = /*#__PURE__*/_curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});
	module.exports = ascend;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var nAry = /*#__PURE__*/__webpack_require__(64);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @see R.nAry, R.unary
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	
	
	var binary = /*#__PURE__*/_curry1(function binary(fn) {
	  return nAry(2, fn);
	});
	module.exports = binary;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(58);
	
	var and = /*#__PURE__*/__webpack_require__(126);
	
	var lift = /*#__PURE__*/__webpack_require__(62);
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	
	
	var both = /*#__PURE__*/_curry2(function both(f, g) {
	  return _isFunction(f) ? function _both() {
	    return f.apply(this, arguments) && g.apply(this, arguments);
	  } : lift(and)(f, g);
	});
	module.exports = both;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var curry = /*#__PURE__*/__webpack_require__(80);
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * [`R.converge`](#converge): the first branch can produce a function while the
	 * remaining branches produce values to be passed to that function as its
	 * arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.repeat(' '),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	
	
	var call = /*#__PURE__*/curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});
	module.exports = call;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	
	
	var clamp = /*#__PURE__*/_curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min : value > max ? max : value;
	});
	module.exports = clamp;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = /*#__PURE__*/__webpack_require__(142);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	
	
	var clone = /*#__PURE__*/_curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ? value.clone() : _clone(value, [], [], true);
	});
	module.exports = clone;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	
	
	var comparator = /*#__PURE__*/_curry1(function comparator(pred) {
	  return function (a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});
	module.exports = comparator;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var lift = /*#__PURE__*/__webpack_require__(62);
	
	var not = /*#__PURE__*/__webpack_require__(162);
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	
	
	var complement = /*#__PURE__*/lift(not);
	module.exports = complement;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var pipeP = /*#__PURE__*/__webpack_require__(168);
	
	var reverse = /*#__PURE__*/__webpack_require__(67);
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	
	
	function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	}
	module.exports = composeP;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var max = /*#__PURE__*/__webpack_require__(37);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	
	
	var cond = /*#__PURE__*/_curry1(function cond(pairs) {
	  var arity = reduce(max, 0, map(function (pair) {
	    return pair[0].length;
	  }, pairs));
	  return _arity(arity, function () {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});
	module.exports = cond;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var constructN = /*#__PURE__*/__webpack_require__(132);
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @see R.invoker
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	
	
	var construct = /*#__PURE__*/_curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});
	module.exports = construct;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
	 * terms, to at least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	
	
	var contains = /*#__PURE__*/_curry2(_contains);
	module.exports = contains;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = /*#__PURE__*/__webpack_require__(65);
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	
	
	var countBy = /*#__PURE__*/reduceBy(function (acc, elem) {
	  return acc + 1;
	}, 0);
	module.exports = countBy;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(52);
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	
	
	var dec = /*#__PURE__*/add(-1);
	module.exports = dec;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @see R.ascend
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	
	
	var descend = /*#__PURE__*/_curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});
	module.exports = descend;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(86);
	
	var assoc = /*#__PURE__*/__webpack_require__(53);
	
	var dissoc = /*#__PURE__*/__webpack_require__(137);
	
	var remove = /*#__PURE__*/__webpack_require__(171);
	
	var update = /*#__PURE__*/__webpack_require__(95);
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	
	
	var dissocPath = /*#__PURE__*/_curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      if (obj[head] == null) {
	        return obj;
	      } else if (_isInteger(path[0])) {
	        return update(head, dissocPath(tail, obj[head]), obj);
	      } else {
	        return assoc(head, dissocPath(tail, obj[head]), obj);
	      }
	  }
	});
	module.exports = dissocPath;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	
	
	var divide = /*#__PURE__*/_curry2(function divide(a, b) {
	  return a / b;
	});
	module.exports = divide;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _dropLast = /*#__PURE__*/__webpack_require__(327);
	
	var _xdropLast = /*#__PURE__*/__webpack_require__(346);
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	
	
	var dropLast = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropLast, _dropLast));
	module.exports = dropLast;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _dropLastWhile = /*#__PURE__*/__webpack_require__(328);
	
	var _xdropLastWhile = /*#__PURE__*/__webpack_require__(347);
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 *
	 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
	 */
	
	
	var dropLastWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xdropLastWhile, _dropLastWhile));
	module.exports = dropLastWhile;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xdropRepeatsWith = /*#__PURE__*/__webpack_require__(151);
	
	var dropRepeatsWith = /*#__PURE__*/__webpack_require__(139);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns a new list without any consecutively repeating elements.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	
	
	var dropRepeats = /*#__PURE__*/_curry1( /*#__PURE__*/_dispatchable([], /*#__PURE__*/_xdropRepeatsWith(equals), /*#__PURE__*/dropRepeatsWith(equals)));
	module.exports = dropRepeats;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xdropWhile = /*#__PURE__*/__webpack_require__(348);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 *
	 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
	 */
	
	
	var dropWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, xs) {
	  var idx = 0;
	  var len = xs.length;
	  while (idx < len && pred(xs[idx])) {
	    idx += 1;
	  }
	  return slice(idx, Infinity, xs);
	}));
	module.exports = dropWhile;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isFunction = /*#__PURE__*/__webpack_require__(58);
	
	var lift = /*#__PURE__*/__webpack_require__(62);
	
	var or = /*#__PURE__*/__webpack_require__(164);
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	
	
	var either = /*#__PURE__*/_curry2(function either(f, g) {
	  return _isFunction(f) ? function _either() {
	    return f.apply(this, arguments) || g.apply(this, arguments);
	  } : lift(or)(f, g);
	});
	module.exports = either;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	var takeLast = /*#__PURE__*/__webpack_require__(174);
	
	/**
	 * Checks if a list ends with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} suffix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.endsWith('c', 'abc')                //=> true
	 *      R.endsWith('b', 'abc')                //=> false
	 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
	 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	
	
	var endsWith = /*#__PURE__*/_curry2(function (suffix, list) {
	  return equals(takeLast(suffix.length, list), suffix);
	});
	module.exports = endsWith;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	
	
	var eqBy = /*#__PURE__*/_curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});
	module.exports = eqBy;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Reports whether two objects have the same value, in [`R.equals`](#equals)
	 * terms, for the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	
	
	var eqProps = /*#__PURE__*/_curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});
	module.exports = eqProps;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	
	
	var evolve = /*#__PURE__*/_curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
	  }
	  return result;
	});
	module.exports = evolve;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xfind = /*#__PURE__*/__webpack_require__(350);
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var find = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));
	module.exports = find;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xfindIndex = /*#__PURE__*/__webpack_require__(351);
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	
	
	var findIndex = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));
	module.exports = findIndex;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xfindLast = /*#__PURE__*/__webpack_require__(352);
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	
	
	var findLast = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));
	module.exports = findLast;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xfindLastIndex = /*#__PURE__*/__webpack_require__(353);
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	
	
	var findLastIndex = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));
	module.exports = findLastIndex;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _makeFlat = /*#__PURE__*/__webpack_require__(149);
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	
	
	var flatten = /*#__PURE__*/_curry1( /*#__PURE__*/_makeFlat(true));
	module.exports = flatten;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	
	
	var forEach = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));
	module.exports = forEach;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	
	
	var forEachObjIndexed = /*#__PURE__*/_curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});
	module.exports = forEachObjIndexed;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var fromPairs = /*#__PURE__*/_curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});
	module.exports = fromPairs;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var reduceBy = /*#__PURE__*/__webpack_require__(65);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	
	
	var groupBy = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('groupBy', /*#__PURE__*/reduceBy(function (acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));
	module.exports = groupBy;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all satisfied pairwise comparison according to the provided function.
	 * Only adjacent elements are passed to the comparison function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	
	
	var groupWith = /*#__PURE__*/_curry2(function (fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});
	module.exports = groupWith;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	
	
	var gt = /*#__PURE__*/_curry2(function gt(a, b) {
	  return a > b;
	});
	module.exports = gt;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	
	
	var gte = /*#__PURE__*/_curry2(function gte(a, b) {
	  return a >= b;
	});
	module.exports = gte;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	
	
	var has = /*#__PURE__*/_curry2(_has);
	module.exports = has;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	
	
	var hasIn = /*#__PURE__*/_curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});
	module.exports = hasIn;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var nth = /*#__PURE__*/__webpack_require__(43);
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	
	
	var head = /*#__PURE__*/nth(0);
	module.exports = head;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	
	
	var ifElse = /*#__PURE__*/_curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
	    return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	  });
	});
	module.exports = ifElse;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var add = /*#__PURE__*/__webpack_require__(52);
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	
	
	var inc = /*#__PURE__*/add(1);
	module.exports = inc;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {};
	module.exports.F = /*#__PURE__*/__webpack_require__(263);
	module.exports.T = /*#__PURE__*/__webpack_require__(264);
	module.exports.__ = /*#__PURE__*/__webpack_require__(265);
	module.exports.add = /*#__PURE__*/__webpack_require__(52);
	module.exports.addIndex = /*#__PURE__*/__webpack_require__(266);
	module.exports.adjust = /*#__PURE__*/__webpack_require__(125);
	module.exports.all = /*#__PURE__*/__webpack_require__(267);
	module.exports.allPass = /*#__PURE__*/__webpack_require__(268);
	module.exports.always = /*#__PURE__*/__webpack_require__(35);
	module.exports.and = /*#__PURE__*/__webpack_require__(126);
	module.exports.any = /*#__PURE__*/__webpack_require__(127);
	module.exports.anyPass = /*#__PURE__*/__webpack_require__(269);
	module.exports.ap = /*#__PURE__*/__webpack_require__(76);
	module.exports.aperture = /*#__PURE__*/__webpack_require__(270);
	module.exports.append = /*#__PURE__*/__webpack_require__(271);
	module.exports.apply = /*#__PURE__*/__webpack_require__(128);
	module.exports.applySpec = /*#__PURE__*/__webpack_require__(272);
	module.exports.applyTo = /*#__PURE__*/__webpack_require__(273);
	module.exports.ascend = /*#__PURE__*/__webpack_require__(274);
	module.exports.assoc = /*#__PURE__*/__webpack_require__(53);
	module.exports.assocPath = /*#__PURE__*/__webpack_require__(129);
	module.exports.binary = /*#__PURE__*/__webpack_require__(275);
	module.exports.bind = /*#__PURE__*/__webpack_require__(130);
	module.exports.both = /*#__PURE__*/__webpack_require__(276);
	module.exports.call = /*#__PURE__*/__webpack_require__(277);
	module.exports.chain = /*#__PURE__*/__webpack_require__(77);
	module.exports.clamp = /*#__PURE__*/__webpack_require__(278);
	module.exports.clone = /*#__PURE__*/__webpack_require__(279);
	module.exports.comparator = /*#__PURE__*/__webpack_require__(280);
	module.exports.complement = /*#__PURE__*/__webpack_require__(281);
	module.exports.compose = /*#__PURE__*/__webpack_require__(78);
	module.exports.composeK = /*#__PURE__*/__webpack_require__(131);
	module.exports.composeP = /*#__PURE__*/__webpack_require__(282);
	module.exports.concat = /*#__PURE__*/__webpack_require__(79);
	module.exports.cond = /*#__PURE__*/__webpack_require__(283);
	module.exports.construct = /*#__PURE__*/__webpack_require__(284);
	module.exports.constructN = /*#__PURE__*/__webpack_require__(132);
	module.exports.contains = /*#__PURE__*/__webpack_require__(285);
	module.exports.converge = /*#__PURE__*/__webpack_require__(133);
	module.exports.countBy = /*#__PURE__*/__webpack_require__(286);
	module.exports.curry = /*#__PURE__*/__webpack_require__(80);
	module.exports.curryN = /*#__PURE__*/__webpack_require__(11);
	module.exports.dec = /*#__PURE__*/__webpack_require__(287);
	module.exports.defaultTo = /*#__PURE__*/__webpack_require__(134);
	module.exports.descend = /*#__PURE__*/__webpack_require__(288);
	module.exports.difference = /*#__PURE__*/__webpack_require__(135);
	module.exports.differenceWith = /*#__PURE__*/__webpack_require__(136);
	module.exports.dissoc = /*#__PURE__*/__webpack_require__(137);
	module.exports.dissocPath = /*#__PURE__*/__webpack_require__(289);
	module.exports.divide = /*#__PURE__*/__webpack_require__(290);
	module.exports.drop = /*#__PURE__*/__webpack_require__(138);
	module.exports.dropLast = /*#__PURE__*/__webpack_require__(291);
	module.exports.dropLastWhile = /*#__PURE__*/__webpack_require__(292);
	module.exports.dropRepeats = /*#__PURE__*/__webpack_require__(293);
	module.exports.dropRepeatsWith = /*#__PURE__*/__webpack_require__(139);
	module.exports.dropWhile = /*#__PURE__*/__webpack_require__(294);
	module.exports.either = /*#__PURE__*/__webpack_require__(295);
	module.exports.empty = /*#__PURE__*/__webpack_require__(140);
	module.exports.endsWith = /*#__PURE__*/__webpack_require__(296);
	module.exports.eqBy = /*#__PURE__*/__webpack_require__(297);
	module.exports.eqProps = /*#__PURE__*/__webpack_require__(298);
	module.exports.equals = /*#__PURE__*/__webpack_require__(18);
	module.exports.evolve = /*#__PURE__*/__webpack_require__(299);
	module.exports.filter = /*#__PURE__*/__webpack_require__(81);
	module.exports.find = /*#__PURE__*/__webpack_require__(300);
	module.exports.findIndex = /*#__PURE__*/__webpack_require__(301);
	module.exports.findLast = /*#__PURE__*/__webpack_require__(302);
	module.exports.findLastIndex = /*#__PURE__*/__webpack_require__(303);
	module.exports.flatten = /*#__PURE__*/__webpack_require__(304);
	module.exports.flip = /*#__PURE__*/__webpack_require__(54);
	module.exports.forEach = /*#__PURE__*/__webpack_require__(305);
	module.exports.forEachObjIndexed = /*#__PURE__*/__webpack_require__(306);
	module.exports.fromPairs = /*#__PURE__*/__webpack_require__(307);
	module.exports.groupBy = /*#__PURE__*/__webpack_require__(308);
	module.exports.groupWith = /*#__PURE__*/__webpack_require__(309);
	module.exports.gt = /*#__PURE__*/__webpack_require__(310);
	module.exports.gte = /*#__PURE__*/__webpack_require__(311);
	module.exports.has = /*#__PURE__*/__webpack_require__(312);
	module.exports.hasIn = /*#__PURE__*/__webpack_require__(313);
	module.exports.head = /*#__PURE__*/__webpack_require__(314);
	module.exports.identical = /*#__PURE__*/__webpack_require__(141);
	module.exports.identity = /*#__PURE__*/__webpack_require__(82);
	module.exports.ifElse = /*#__PURE__*/__webpack_require__(315);
	module.exports.inc = /*#__PURE__*/__webpack_require__(316);
	module.exports.indexBy = /*#__PURE__*/__webpack_require__(318);
	module.exports.indexOf = /*#__PURE__*/__webpack_require__(319);
	module.exports.init = /*#__PURE__*/__webpack_require__(320);
	module.exports.innerJoin = /*#__PURE__*/__webpack_require__(321);
	module.exports.insert = /*#__PURE__*/__webpack_require__(322);
	module.exports.insertAll = /*#__PURE__*/__webpack_require__(323);
	module.exports.intersection = /*#__PURE__*/__webpack_require__(359);
	module.exports.intersperse = /*#__PURE__*/__webpack_require__(360);
	module.exports.into = /*#__PURE__*/__webpack_require__(361);
	module.exports.invert = /*#__PURE__*/__webpack_require__(362);
	module.exports.invertObj = /*#__PURE__*/__webpack_require__(363);
	module.exports.invoker = /*#__PURE__*/__webpack_require__(42);
	module.exports.is = /*#__PURE__*/__webpack_require__(153);
	module.exports.isEmpty = /*#__PURE__*/__webpack_require__(364);
	module.exports.isNil = /*#__PURE__*/__webpack_require__(154);
	module.exports.join = /*#__PURE__*/__webpack_require__(365);
	module.exports.juxt = /*#__PURE__*/__webpack_require__(155);
	module.exports.keys = /*#__PURE__*/__webpack_require__(23);
	module.exports.keysIn = /*#__PURE__*/__webpack_require__(366);
	module.exports.last = /*#__PURE__*/__webpack_require__(156);
	module.exports.lastIndexOf = /*#__PURE__*/__webpack_require__(367);
	module.exports.length = /*#__PURE__*/__webpack_require__(157);
	module.exports.lens = /*#__PURE__*/__webpack_require__(61);
	module.exports.lensIndex = /*#__PURE__*/__webpack_require__(368);
	module.exports.lensPath = /*#__PURE__*/__webpack_require__(369);
	module.exports.lensProp = /*#__PURE__*/__webpack_require__(370);
	module.exports.lift = /*#__PURE__*/__webpack_require__(62);
	module.exports.liftN = /*#__PURE__*/__webpack_require__(158);
	module.exports.lt = /*#__PURE__*/__webpack_require__(371);
	module.exports.lte = /*#__PURE__*/__webpack_require__(372);
	module.exports.map = /*#__PURE__*/__webpack_require__(16);
	module.exports.mapAccum = /*#__PURE__*/__webpack_require__(373);
	module.exports.mapAccumRight = /*#__PURE__*/__webpack_require__(374);
	module.exports.mapObjIndexed = /*#__PURE__*/__webpack_require__(375);
	module.exports.match = /*#__PURE__*/__webpack_require__(376);
	module.exports.mathMod = /*#__PURE__*/__webpack_require__(377);
	module.exports.max = /*#__PURE__*/__webpack_require__(37);
	module.exports.maxBy = /*#__PURE__*/__webpack_require__(378);
	module.exports.mean = /*#__PURE__*/__webpack_require__(159);
	module.exports.median = /*#__PURE__*/__webpack_require__(379);
	module.exports.memoize = /*#__PURE__*/__webpack_require__(380);
	module.exports.memoizeWith = /*#__PURE__*/__webpack_require__(160);
	module.exports.merge = /*#__PURE__*/__webpack_require__(381);
	module.exports.mergeAll = /*#__PURE__*/__webpack_require__(382);
	module.exports.mergeDeepLeft = /*#__PURE__*/__webpack_require__(383);
	module.exports.mergeDeepRight = /*#__PURE__*/__webpack_require__(384);
	module.exports.mergeDeepWith = /*#__PURE__*/__webpack_require__(385);
	module.exports.mergeDeepWithKey = /*#__PURE__*/__webpack_require__(63);
	module.exports.mergeWith = /*#__PURE__*/__webpack_require__(386);
	module.exports.mergeWithKey = /*#__PURE__*/__webpack_require__(89);
	module.exports.min = /*#__PURE__*/__webpack_require__(387);
	module.exports.minBy = /*#__PURE__*/__webpack_require__(388);
	module.exports.modulo = /*#__PURE__*/__webpack_require__(389);
	module.exports.multiply = /*#__PURE__*/__webpack_require__(161);
	module.exports.nAry = /*#__PURE__*/__webpack_require__(64);
	module.exports.negate = /*#__PURE__*/__webpack_require__(390);
	module.exports.none = /*#__PURE__*/__webpack_require__(391);
	module.exports.not = /*#__PURE__*/__webpack_require__(162);
	module.exports.nth = /*#__PURE__*/__webpack_require__(43);
	module.exports.nthArg = /*#__PURE__*/__webpack_require__(392);
	module.exports.o = /*#__PURE__*/__webpack_require__(393);
	module.exports.objOf = /*#__PURE__*/__webpack_require__(163);
	module.exports.of = /*#__PURE__*/__webpack_require__(394);
	module.exports.omit = /*#__PURE__*/__webpack_require__(395);
	module.exports.once = /*#__PURE__*/__webpack_require__(396);
	module.exports.or = /*#__PURE__*/__webpack_require__(164);
	module.exports.over = /*#__PURE__*/__webpack_require__(165);
	module.exports.pair = /*#__PURE__*/__webpack_require__(397);
	module.exports.partial = /*#__PURE__*/__webpack_require__(398);
	module.exports.partialRight = /*#__PURE__*/__webpack_require__(399);
	module.exports.partition = /*#__PURE__*/__webpack_require__(400);
	module.exports.path = /*#__PURE__*/__webpack_require__(38);
	module.exports.pathEq = /*#__PURE__*/__webpack_require__(401);
	module.exports.pathOr = /*#__PURE__*/__webpack_require__(402);
	module.exports.pathSatisfies = /*#__PURE__*/__webpack_require__(403);
	module.exports.pick = /*#__PURE__*/__webpack_require__(404);
	module.exports.pickAll = /*#__PURE__*/__webpack_require__(166);
	module.exports.pickBy = /*#__PURE__*/__webpack_require__(405);
	module.exports.pipe = /*#__PURE__*/__webpack_require__(167);
	module.exports.pipeK = /*#__PURE__*/__webpack_require__(406);
	module.exports.pipeP = /*#__PURE__*/__webpack_require__(168);
	module.exports.pluck = /*#__PURE__*/__webpack_require__(44);
	module.exports.prepend = /*#__PURE__*/__webpack_require__(169);
	module.exports.product = /*#__PURE__*/__webpack_require__(407);
	module.exports.project = /*#__PURE__*/__webpack_require__(408);
	module.exports.prop = /*#__PURE__*/__webpack_require__(90);
	module.exports.propEq = /*#__PURE__*/__webpack_require__(409);
	module.exports.propIs = /*#__PURE__*/__webpack_require__(410);
	module.exports.propOr = /*#__PURE__*/__webpack_require__(411);
	module.exports.propSatisfies = /*#__PURE__*/__webpack_require__(412);
	module.exports.props = /*#__PURE__*/__webpack_require__(413);
	module.exports.range = /*#__PURE__*/__webpack_require__(414);
	module.exports.reduce = /*#__PURE__*/__webpack_require__(24);
	module.exports.reduceBy = /*#__PURE__*/__webpack_require__(65);
	module.exports.reduceRight = /*#__PURE__*/__webpack_require__(170);
	module.exports.reduceWhile = /*#__PURE__*/__webpack_require__(415);
	module.exports.reduced = /*#__PURE__*/__webpack_require__(416);
	module.exports.reject = /*#__PURE__*/__webpack_require__(66);
	module.exports.remove = /*#__PURE__*/__webpack_require__(171);
	module.exports.repeat = /*#__PURE__*/__webpack_require__(417);
	module.exports.replace = /*#__PURE__*/__webpack_require__(418);
	module.exports.reverse = /*#__PURE__*/__webpack_require__(67);
	module.exports.scan = /*#__PURE__*/__webpack_require__(419);
	module.exports.sequence = /*#__PURE__*/__webpack_require__(172);
	module.exports.set = /*#__PURE__*/__webpack_require__(420);
	module.exports.slice = /*#__PURE__*/__webpack_require__(21);
	module.exports.sort = /*#__PURE__*/__webpack_require__(421);
	module.exports.sortBy = /*#__PURE__*/__webpack_require__(422);
	module.exports.sortWith = /*#__PURE__*/__webpack_require__(423);
	module.exports.split = /*#__PURE__*/__webpack_require__(424);
	module.exports.splitAt = /*#__PURE__*/__webpack_require__(425);
	module.exports.splitEvery = /*#__PURE__*/__webpack_require__(426);
	module.exports.splitWhen = /*#__PURE__*/__webpack_require__(427);
	module.exports.startsWith = /*#__PURE__*/__webpack_require__(428);
	module.exports.subtract = /*#__PURE__*/__webpack_require__(429);
	module.exports.sum = /*#__PURE__*/__webpack_require__(173);
	module.exports.symmetricDifference = /*#__PURE__*/__webpack_require__(430);
	module.exports.symmetricDifferenceWith = /*#__PURE__*/__webpack_require__(431);
	module.exports.tail = /*#__PURE__*/__webpack_require__(91);
	module.exports.take = /*#__PURE__*/__webpack_require__(92);
	module.exports.takeLast = /*#__PURE__*/__webpack_require__(174);
	module.exports.takeLastWhile = /*#__PURE__*/__webpack_require__(432);
	module.exports.takeWhile = /*#__PURE__*/__webpack_require__(433);
	module.exports.tap = /*#__PURE__*/__webpack_require__(434);
	module.exports.test = /*#__PURE__*/__webpack_require__(435);
	module.exports.times = /*#__PURE__*/__webpack_require__(175);
	module.exports.toLower = /*#__PURE__*/__webpack_require__(436);
	module.exports.toPairs = /*#__PURE__*/__webpack_require__(437);
	module.exports.toPairsIn = /*#__PURE__*/__webpack_require__(438);
	module.exports.toString = /*#__PURE__*/__webpack_require__(45);
	module.exports.toUpper = /*#__PURE__*/__webpack_require__(439);
	module.exports.transduce = /*#__PURE__*/__webpack_require__(440);
	module.exports.transpose = /*#__PURE__*/__webpack_require__(441);
	module.exports.traverse = /*#__PURE__*/__webpack_require__(442);
	module.exports.trim = /*#__PURE__*/__webpack_require__(443);
	module.exports.tryCatch = /*#__PURE__*/__webpack_require__(444);
	module.exports.type = /*#__PURE__*/__webpack_require__(93);
	module.exports.unapply = /*#__PURE__*/__webpack_require__(445);
	module.exports.unary = /*#__PURE__*/__webpack_require__(446);
	module.exports.uncurryN = /*#__PURE__*/__webpack_require__(447);
	module.exports.unfold = /*#__PURE__*/__webpack_require__(448);
	module.exports.union = /*#__PURE__*/__webpack_require__(449);
	module.exports.unionWith = /*#__PURE__*/__webpack_require__(450);
	module.exports.uniq = /*#__PURE__*/__webpack_require__(94);
	module.exports.uniqBy = /*#__PURE__*/__webpack_require__(176);
	module.exports.uniqWith = /*#__PURE__*/__webpack_require__(177);
	module.exports.unless = /*#__PURE__*/__webpack_require__(451);
	module.exports.unnest = /*#__PURE__*/__webpack_require__(452);
	module.exports.until = /*#__PURE__*/__webpack_require__(453);
	module.exports.update = /*#__PURE__*/__webpack_require__(95);
	module.exports.useWith = /*#__PURE__*/__webpack_require__(178);
	module.exports.values = /*#__PURE__*/__webpack_require__(179);
	module.exports.valuesIn = /*#__PURE__*/__webpack_require__(454);
	module.exports.view = /*#__PURE__*/__webpack_require__(455);
	module.exports.when = /*#__PURE__*/__webpack_require__(456);
	module.exports.where = /*#__PURE__*/__webpack_require__(180);
	module.exports.whereEq = /*#__PURE__*/__webpack_require__(457);
	module.exports.without = /*#__PURE__*/__webpack_require__(458);
	module.exports.xprod = /*#__PURE__*/__webpack_require__(459);
	module.exports.zip = /*#__PURE__*/__webpack_require__(460);
	module.exports.zipObj = /*#__PURE__*/__webpack_require__(461);
	module.exports.zipWith = /*#__PURE__*/__webpack_require__(462);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var reduceBy = /*#__PURE__*/__webpack_require__(65);
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	
	
	var indexBy = /*#__PURE__*/reduceBy(function (acc, elem) {
	  return elem;
	}, null);
	module.exports = indexBy;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _indexOf = /*#__PURE__*/__webpack_require__(146);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	
	
	var indexOf = /*#__PURE__*/_curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ? xs.indexOf(target) : _indexOf(xs, target, 0);
	});
	module.exports = indexOf;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	
	
	var init = /*#__PURE__*/slice(0, -1);
	module.exports = init;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var _containsWith = /*#__PURE__*/__webpack_require__(55);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _filter = /*#__PURE__*/__webpack_require__(84);
	
	/**
	 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
	 * `xs'` comprising each of the elements of `xs` which is equal to one or more
	 * elements of `ys` according to `pred`.
	 *
	 * `pred` must be a binary function expecting an element from each list.
	 *
	 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
	 * not be significant, but since `xs'` is ordered the implementation guarantees
	 * that its values are in the same order as they appear in `xs`. Duplicates are
	 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Relation
	 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
	 * @param {Function} pred
	 * @param {Array} xs
	 * @param {Array} ys
	 * @return {Array}
	 * @see R.intersection
	 * @example
	 *
	 *      R.innerJoin(
	 *        (record, id) => record.id === id,
	 *        [{id: 824, name: 'Richie Furay'},
	 *         {id: 956, name: 'Dewey Martin'},
	 *         {id: 313, name: 'Bruce Palmer'},
	 *         {id: 456, name: 'Stephen Stills'},
	 *         {id: 177, name: 'Neil Young'}],
	 *        [177, 456, 999]
	 *      );
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	
	
	var innerJoin = /*#__PURE__*/_curry3(function innerJoin(pred, xs, ys) {
	  return _filter(function (x) {
	    return _containsWith(pred, x, ys);
	  }, xs);
	});
	module.exports = innerJoin;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Inserts the supplied element into the list, at the specified `index`. _Note that
	
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	
	
	var insert = /*#__PURE__*/_curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});
	module.exports = insert;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	
	
	var insertAll = /*#__PURE__*/_curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
	});
	module.exports = insertAll;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _Set = /*#__PURE__*/function () {
	
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function (item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function (item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  return _Set;
	}();
	
	function hasOrAdd(item, shouldAdd, set) {
	  var type = typeof item;
	  var prevSize, newSize;
	  switch (type) {
	    case 'string':
	    case 'number':
	      // distinguish between +0 and -0
	      if (item === 0 && 1 / item === -Infinity) {
	        if (set._items['-0']) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items['-0'] = true;
	          }
	          return false;
	        }
	      }
	      // these types can all utilise the native Set
	      if (set._nativeSet !== null) {
	        if (shouldAdd) {
	          prevSize = set._nativeSet.size;
	          set._nativeSet.add(item);
	          newSize = set._nativeSet.size;
	          return newSize === prevSize;
	        } else {
	          return set._nativeSet.has(item);
	        }
	      } else {
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = {};
	            set._items[type][item] = true;
	          }
	          return false;
	        } else if (item in set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type][item] = true;
	          }
	          return false;
	        }
	      }
	
	    case 'boolean':
	      // set._items['boolean'] holds a two element array
	      // representing [ falseExists, trueExists ]
	      if (type in set._items) {
	        var bIdx = item ? 1 : 0;
	        if (set._items[type][bIdx]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type][bIdx] = true;
	          }
	          return false;
	        }
	      } else {
	        if (shouldAdd) {
	          set._items[type] = item ? [false, true] : [true, false];
	        }
	        return false;
	      }
	
	    case 'function':
	      // compare functions for reference equality
	      if (set._nativeSet !== null) {
	        if (shouldAdd) {
	          prevSize = set._nativeSet.size;
	          set._nativeSet.add(item);
	          newSize = set._nativeSet.size;
	          return newSize === prevSize;
	        } else {
	          return set._nativeSet.has(item);
	        }
	      } else {
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	      }
	
	    case 'undefined':
	      if (set._items[type]) {
	        return true;
	      } else {
	        if (shouldAdd) {
	          set._items[type] = true;
	        }
	        return false;
	      }
	
	    case 'object':
	      if (item === null) {
	        if (!set._items['null']) {
	          if (shouldAdd) {
	            set._items['null'] = true;
	          }
	          return false;
	        }
	        return true;
	      }
	    /* falls through */
	    default:
	      // reduce the search size of heterogeneous sets by creating buckets
	      // for each type.
	      type = Object.prototype.toString.call(item);
	      if (!(type in set._items)) {
	        if (shouldAdd) {
	          set._items[type] = [item];
	        }
	        return false;
	      }
	      // scan through all previously applied items
	      if (!_contains(item, set._items[type])) {
	        if (shouldAdd) {
	          set._items[type].push(item);
	        }
	        return false;
	      }
	      return true;
	  }
	}
	
	// A simple Set type that honours R.equals semantics
	module.exports = _Set;

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	}
	module.exports = _aperture;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	}
	module.exports = _arrayFromIterator;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var take = /*#__PURE__*/__webpack_require__(92);
	
	function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	}
	module.exports = dropLast;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = /*#__PURE__*/__webpack_require__(21);
	
	function dropLastWhile(pred, xs) {
	  var idx = xs.length - 1;
	  while (idx >= 0 && pred(xs[idx])) {
	    idx -= 1;
	  }
	  return slice(0, idx + 1, xs);
	}
	module.exports = dropLastWhile;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var _arrayFromIterator = /*#__PURE__*/__webpack_require__(326);
	
	var _containsWith = /*#__PURE__*/__webpack_require__(55);
	
	var _functionName = /*#__PURE__*/__webpack_require__(332);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var identical = /*#__PURE__*/__webpack_require__(141);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	var type = /*#__PURE__*/__webpack_require__(93);
	
	/**
	 * private _uniqContentEquals function.
	 * That function is checking equality of 2 iterator contents with 2 assumptions
	 * - iterators lengths are the same
	 * - iterators values are unique
	 *
	 * false-positive result will be returned for comparision of, e.g.
	 * - [1,2,3] and [1,2,3,4]
	 * - [1,1,1] and [1,2,3]
	 * */
	
	function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
	  var a = _arrayFromIterator(aIterator);
	  var b = _arrayFromIterator(bIterator);
	
	  function eq(_a, _b) {
	    return _equals(_a, _b, stackA.slice(), stackB.slice());
	  }
	
	  // if *a* array contains any element that is not included in *b*
	  return !_containsWith(function (b, aItem) {
	    return !_containsWith(eq, aItem, b);
	  }, b, a);
	}
	
	function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  var typeA = type(a);
	
	  if (typeA !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
	    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (typeA) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  switch (typeA) {
	    case 'Map':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
	    case 'Set':
	      if (a.size !== b.size) {
	        return false;
	      }
	
	      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	    case 'Date':
	    case 'Error':
	    case 'RegExp':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var extendedStackA = stackA.concat([a]);
	  var extendedStackB = stackB.concat([b]);
	
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  return true;
	}
	module.exports = _equals;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var _forceReduced = /*#__PURE__*/__webpack_require__(331);
	
	var _isArrayLike = /*#__PURE__*/__webpack_require__(57);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var preservingReduced = function (xf) {
	  return {
	    '@@transducer/init': _xfBase.init,
	    '@@transducer/result': function (result) {
	      return xf['@@transducer/result'](result);
	    },
	    '@@transducer/step': function (result, input) {
	      var ret = xf['@@transducer/step'](result, input);
	      return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	    }
	  };
	};
	
	var _flatCat = function _xcat(xf) {
	  var rxf = preservingReduced(xf);
	  return {
	    '@@transducer/init': _xfBase.init,
	    '@@transducer/result': function (result) {
	      return rxf['@@transducer/result'](result);
	    },
	    '@@transducer/step': function (result, input) {
	      return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	    }
	  };
	};
	
	module.exports = _flatCat;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	}
	module.exports = _forceReduced;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	}
	module.exports = _functionName;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	}
	module.exports = _isRegExp;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = /*#__PURE__*/__webpack_require__(12);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
	
	function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	}
	module.exports = _objectAssign;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	function _of(x) {
	  return [x];
	}
	module.exports = _of;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	function _pipe(f, g) {
	  return function () {
	    return g.call(this, f.apply(this, arguments));
	  };
	}
	module.exports = _pipe;

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	function _pipeP(f, g) {
	  return function () {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function (x) {
	      return g.call(ctx, x);
	    });
	  };
	}
	module.exports = _pipeP;

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	function _quote(s) {
	  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
	  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	}
	module.exports = _quote;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = /*#__PURE__*/__webpack_require__(83);
	
	var _identity = /*#__PURE__*/__webpack_require__(85);
	
	var _isArrayLike = /*#__PURE__*/__webpack_require__(57);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(88);
	
	var objOf = /*#__PURE__*/__webpack_require__(163);
	
	var _stepCatArray = {
	  '@@transducer/init': Array,
	  '@@transducer/step': function (xs, x) {
	    xs.push(x);
	    return xs;
	  },
	  '@@transducer/result': _identity
	};
	var _stepCatString = {
	  '@@transducer/init': String,
	  '@@transducer/step': function (a, b) {
	    return a + b;
	  },
	  '@@transducer/result': _identity
	};
	var _stepCatObject = {
	  '@@transducer/init': Object,
	  '@@transducer/step': function (result, input) {
	    return _assign(result, _isArrayLike(input) ? objOf(input[0], input[1]) : input);
	  },
	  '@@transducer/result': _identity
	};
	
	function _stepCat(obj) {
	  if (_isTransformer(obj)) {
	    return obj;
	  }
	  if (_isArrayLike(obj)) {
	    return _stepCatArray;
	  }
	  if (typeof obj === 'string') {
	    return _stepCatString;
	  }
	  if (typeof obj === 'object') {
	    return _stepCatObject;
	  }
	  throw new Error('Cannot create transformer for ' + obj);
	}
	module.exports = _stepCat;

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	var pad = function pad(n) {
	  return (n < 10 ? '0' : '') + n;
	};
	
	var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
	  return d.toISOString();
	} : function _toISOString(d) {
	  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
	};
	
	module.exports = _toISOString;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _map = /*#__PURE__*/__webpack_require__(60);
	
	var _quote = /*#__PURE__*/__webpack_require__(338);
	
	var _toISOString = /*#__PURE__*/__webpack_require__(340);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	var reject = /*#__PURE__*/__webpack_require__(66);
	
	function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function (obj, keys) {
	    return _map(function (k) {
	      return _quote(k) + ': ' + recur(obj[k]);
	    }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
	        return (/^\d+$/.test(k)
	        );
	      }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	}
	module.exports = _toString;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XAll = /*#__PURE__*/function () {
	
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function (result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function (result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return XAll;
	}();
	
	var _xall = /*#__PURE__*/_curry2(function _xall(f, xf) {
	  return new XAll(f, xf);
	});
	module.exports = _xall;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XAperture = /*#__PURE__*/function () {
	
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function (result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function (result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function (input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function () {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return XAperture;
	}();
	
	var _xaperture = /*#__PURE__*/_curry2(function _xaperture(n, xf) {
	  return new XAperture(n, xf);
	});
	module.exports = _xaperture;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _flatCat = /*#__PURE__*/__webpack_require__(330);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});
	module.exports = _xchain;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XDrop = /*#__PURE__*/function () {
	
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function (result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDrop;
	}();
	
	var _xdrop = /*#__PURE__*/_curry2(function _xdrop(n, xf) {
	  return new XDrop(n, xf);
	});
	module.exports = _xdrop;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XDropLast = /*#__PURE__*/function () {
	
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] = function (result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function (result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function (input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return XDropLast;
	}();
	
	var _xdropLast = /*#__PURE__*/_curry2(function _xdropLast(n, xf) {
	  return new XDropLast(n, xf);
	});
	module.exports = _xdropLast;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XDropLastWhile = /*#__PURE__*/function () {
	
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function (result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.retain(result, input) : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function (result, input) {
	    result = _reduce(this.xf['@@transducer/step'], result, this.retained);
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function (result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return XDropLastWhile;
	}();
	
	var _xdropLastWhile = /*#__PURE__*/_curry2(function _xdropLastWhile(fn, xf) {
	  return new XDropLastWhile(fn, xf);
	});
	module.exports = _xdropLastWhile;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XDropWhile = /*#__PURE__*/function () {
	
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XDropWhile;
	}();
	
	var _xdropWhile = /*#__PURE__*/_curry2(function _xdropWhile(f, xf) {
	  return new XDropWhile(f, xf);
	});
	module.exports = _xdropWhile;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XFilter = /*#__PURE__*/function () {
	
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return XFilter;
	}();
	
	var _xfilter = /*#__PURE__*/_curry2(function _xfilter(f, xf) {
	  return new XFilter(f, xf);
	});
	module.exports = _xfilter;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XFind = /*#__PURE__*/function () {
	
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return XFind;
	}();
	
	var _xfind = /*#__PURE__*/_curry2(function _xfind(f, xf) {
	  return new XFind(f, xf);
	});
	module.exports = _xfind;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XFindIndex = /*#__PURE__*/function () {
	
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function (result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function (result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return XFindIndex;
	}();
	
	var _xfindIndex = /*#__PURE__*/_curry2(function _xfindIndex(f, xf) {
	  return new XFindIndex(f, xf);
	});
	module.exports = _xfindIndex;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XFindLast = /*#__PURE__*/function () {
	
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function (result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function (result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return XFindLast;
	}();
	
	var _xfindLast = /*#__PURE__*/_curry2(function _xfindLast(f, xf) {
	  return new XFindLast(f, xf);
	});
	module.exports = _xfindLast;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XFindLastIndex = /*#__PURE__*/function () {
	
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function (result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function (result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return XFindLastIndex;
	}();
	
	var _xfindLastIndex = /*#__PURE__*/_curry2(function _xfindLastIndex(f, xf) {
	  return new XFindLastIndex(f, xf);
	});
	module.exports = _xfindLastIndex;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XMap = /*#__PURE__*/function () {
	
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function (result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return XMap;
	}();
	
	var _xmap = /*#__PURE__*/_curry2(function _xmap(f, xf) {
	  return new XMap(f, xf);
	});
	module.exports = _xmap;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(56);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XReduceBy = /*#__PURE__*/function () {
	
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function (result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function (result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return XReduceBy;
	}();
	
	var _xreduceBy = /*#__PURE__*/_curryN(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	  return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	});
	module.exports = _xreduceBy;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XTake = /*#__PURE__*/function () {
	
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function (result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return XTake;
	}();
	
	var _xtake = /*#__PURE__*/_curry2(function _xtake(n, xf) {
	  return new XTake(n, xf);
	});
	module.exports = _xtake;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XTakeWhile = /*#__PURE__*/function () {
	
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function (result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return XTakeWhile;
	}();
	
	var _xtakeWhile = /*#__PURE__*/_curry2(function _xtakeWhile(f, xf) {
	  return new XTakeWhile(f, xf);
	});
	module.exports = _xtakeWhile;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _xfBase = /*#__PURE__*/__webpack_require__(8);
	
	var XTap = /*#__PURE__*/function () {
	
	  function XTap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTap.prototype['@@transducer/init'] = _xfBase.init;
	  XTap.prototype['@@transducer/result'] = _xfBase.result;
	  XTap.prototype['@@transducer/step'] = function (result, input) {
	    this.f(input);
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return XTap;
	}();
	
	var _xtap = /*#__PURE__*/_curry2(function _xtap(f, xf) {
	  return new XTap(f, xf);
	});
	module.exports = _xtap;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _filter = /*#__PURE__*/__webpack_require__(84);
	
	var flip = /*#__PURE__*/__webpack_require__(54);
	
	var uniq = /*#__PURE__*/__webpack_require__(94);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.innerJoin
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	
	
	var intersection = /*#__PURE__*/_curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});
	module.exports = intersection;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = /*#__PURE__*/__webpack_require__(40);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	
	
	var intersperse = /*#__PURE__*/_curry2( /*#__PURE__*/_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));
	module.exports = intersperse;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var _clone = /*#__PURE__*/__webpack_require__(142);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _isTransformer = /*#__PURE__*/__webpack_require__(88);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _stepCat = /*#__PURE__*/__webpack_require__(339);
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
	 * transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	
	
	var into = /*#__PURE__*/_curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ? _reduce(xf(acc), acc['@@transducer/init'](), list) : _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});
	module.exports = into;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
	 * duplicate values by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys in an array.
	 * @see R.invertObj
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	
	
	var invert = /*#__PURE__*/_curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : out[val] = [];
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});
	module.exports = invert;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @see R.invert
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	
	
	var invertObj = /*#__PURE__*/_curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});
	module.exports = invertObj;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var empty = /*#__PURE__*/__webpack_require__(140);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	
	
	var isEmpty = /*#__PURE__*/_curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});
	module.exports = isEmpty;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	
	
	var join = /*#__PURE__*/invoker(1, 'join');
	module.exports = join;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @see R.keys, R.valuesIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	
	
	var keysIn = /*#__PURE__*/_curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});
	module.exports = keysIn;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isArray = /*#__PURE__*/__webpack_require__(29);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. [`R.equals`](#equals) is used to
	 * determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	
	
	var lastIndexOf = /*#__PURE__*/_curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});
	module.exports = lastIndexOf;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var lens = /*#__PURE__*/__webpack_require__(61);
	
	var nth = /*#__PURE__*/__webpack_require__(43);
	
	var update = /*#__PURE__*/__webpack_require__(95);
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	
	
	var lensIndex = /*#__PURE__*/_curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});
	module.exports = lensIndex;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var assocPath = /*#__PURE__*/__webpack_require__(129);
	
	var lens = /*#__PURE__*/__webpack_require__(61);
	
	var path = /*#__PURE__*/__webpack_require__(38);
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	
	
	var lensPath = /*#__PURE__*/_curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});
	module.exports = lensPath;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var assoc = /*#__PURE__*/__webpack_require__(53);
	
	var lens = /*#__PURE__*/__webpack_require__(61);
	
	var prop = /*#__PURE__*/__webpack_require__(90);
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	
	
	var lensProp = /*#__PURE__*/_curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});
	module.exports = lensProp;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	
	
	var lt = /*#__PURE__*/_curry2(function lt(a, b) {
	  return a < b;
	});
	module.exports = lt;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	
	
	var lte = /*#__PURE__*/_curry2(function lte(a, b) {
	  return a <= b;
	});
	module.exports = lte;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * The `mapAccum` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	
	
	var mapAccum = /*#__PURE__*/_curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});
	module.exports = mapAccum;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * The `mapAccumRight` function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
	 * the right to the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((x, acc) -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	
	
	var mapAccumRight = /*#__PURE__*/_curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});
	module.exports = mapAccumRight;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var keys = /*#__PURE__*/__webpack_require__(23);
	
	/**
	 * An Object-specific version of [`map`](#map). The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * [`map`](#map) instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	
	
	var mapObjIndexed = /*#__PURE__*/_curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function (acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});
	module.exports = mapObjIndexed;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	
	
	var match = /*#__PURE__*/_curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});
	module.exports = match;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isInteger = /*#__PURE__*/__webpack_require__(86);
	
	/**
	 * `mathMod` behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
	 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
	 * arguments, and returns NaN when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @see R.modulo
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	
	
	var mathMod = /*#__PURE__*/_curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) {
	    return NaN;
	  }
	  if (!_isInteger(p) || p < 1) {
	    return NaN;
	  }
	  return (m % p + p) % p;
	});
	module.exports = mathMod;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	
	
	var maxBy = /*#__PURE__*/_curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});
	module.exports = maxBy;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var mean = /*#__PURE__*/__webpack_require__(159);
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @see R.mean
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	
	
	var median = /*#__PURE__*/_curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});
	module.exports = median;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeWith = /*#__PURE__*/__webpack_require__(160);
	
	var toString = /*#__PURE__*/__webpack_require__(45);
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @see R.memoizeWith
	 * @deprecated since v0.25.0
	 * @example
	 *
	 *      let count = 0;
	 *      const factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	
	
	var memoize = /*#__PURE__*/memoizeWith(function () {
	  return toString(arguments);
	});
	module.exports = memoize;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	
	
	var merge = /*#__PURE__*/_curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});
	module.exports = merge;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var _assign = /*#__PURE__*/__webpack_require__(83);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	
	
	var mergeAll = /*#__PURE__*/_curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});
	module.exports = mergeAll;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(63);
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the first object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                      { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
	 */
	
	
	var mergeDeepLeft = /*#__PURE__*/_curry2(function mergeDeepLeft(lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return lVal;
	  }, lObj, rObj);
	});
	module.exports = mergeDeepLeft;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(63);
	
	/**
	 * Creates a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects:
	 * - and both values are objects, the two values will be recursively merged
	 * - otherwise the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig {a} -> {a} -> {a}
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
	 *                       { age: 40, contact: { email: 'baa@example.com' }});
	 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
	 */
	
	
	var mergeDeepRight = /*#__PURE__*/_curry2(function mergeDeepRight(lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return rVal;
	  }, lObj, rObj);
	});
	module.exports = mergeDeepRight;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var mergeDeepWithKey = /*#__PURE__*/__webpack_require__(63);
	
	/**
	 * Creates a new object with the own properties of the two provided objects.
	 * If a key exists in both objects:
	 * - and both associated values are also objects then the values will be
	 *   recursively merged.
	 * - otherwise the provided function is applied to associated values using the
	 *   resulting value as the new value associated with the key.
	 * If a key only exists in one object, the value will be associated with the key
	 * of the resulting object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Object
	 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} lObj
	 * @param {Object} rObj
	 * @return {Object}
	 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
	 * @example
	 *
	 *      R.mergeDeepWith(R.concat,
	 *                      { a: true, c: { values: [10, 20] }},
	 *                      { b: true, c: { values: [15, 35] }});
	 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
	 */
	
	
	var mergeDeepWith = /*#__PURE__*/_curry3(function mergeDeepWith(fn, lObj, rObj) {
	  return mergeDeepWithKey(function (k, lVal, rVal) {
	    return fn(lVal, rVal);
	  }, lObj, rObj);
	});
	module.exports = mergeDeepWith;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var mergeWithKey = /*#__PURE__*/__webpack_require__(89);
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	
	
	var mergeWith = /*#__PURE__*/_curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function (_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});
	module.exports = mergeWith;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	
	
	var min = /*#__PURE__*/_curry2(function min(a, b) {
	  return b < a ? b : a;
	});
	module.exports = min;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	
	
	var minBy = /*#__PURE__*/_curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});
	module.exports = minBy;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see [`mathMod`](#mathMod).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	
	
	var modulo = /*#__PURE__*/_curry2(function modulo(a, b) {
	  return a % b;
	});
	module.exports = modulo;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	
	
	var negate = /*#__PURE__*/_curry1(function negate(n) {
	  return -n;
	});
	module.exports = negate;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var _complement = /*#__PURE__*/__webpack_require__(144);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xany = /*#__PURE__*/__webpack_require__(150);
	
	var any = /*#__PURE__*/__webpack_require__(127);
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *      var isOdd = n => n % 2 === 1;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	
	
	var none = /*#__PURE__*/_curry2( /*#__PURE__*/_complement( /*#__PURE__*/_dispatchable(['any'], _xany, any)));
	module.exports = none;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	var nth = /*#__PURE__*/__webpack_require__(43);
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	
	
	var nthArg = /*#__PURE__*/_curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function () {
	    return nth(n, arguments);
	  });
	});
	module.exports = nthArg;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * `o` is a curried composition function that returns a unary function.
	 * Like [`compose`](#compose), `o` performs right-to-left function composition.
	 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
	 * invoked with only one argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category Function
	 * @sig (b -> c) -> (a -> b) -> a -> c
	 * @param {Function} f
	 * @param {Function} g
	 * @return {Function}
	 * @see R.compose, R.pipe
	 * @example
	 *
	 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
	 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
	 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
	 *
	 * @symb R.o(f, g, x) = f(g(x))
	 */
	
	
	var o = /*#__PURE__*/_curry3(function o(f, g, x) {
	  return f(g(x));
	});
	module.exports = o;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _of = /*#__PURE__*/__webpack_require__(335);
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	
	
	var of = /*#__PURE__*/_curry1(_of);
	module.exports = of;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	
	
	var omit = /*#__PURE__*/_curry2(function omit(names, obj) {
	  var result = {};
	  var index = {};
	  var idx = 0;
	  var len = names.length;
	
	  while (idx < len) {
	    index[names[idx]] = 1;
	    idx += 1;
	  }
	
	  for (var prop in obj) {
	    if (!index.hasOwnProperty(prop)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});
	module.exports = omit;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	
	
	var once = /*#__PURE__*/_curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function () {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});
	module.exports = once;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	
	
	var pair = /*#__PURE__*/_curry2(function pair(fst, snd) {
	  return [fst, snd];
	});
	module.exports = pair;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _createPartialApplicator = /*#__PURE__*/__webpack_require__(145);
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	
	
	var partial = /*#__PURE__*/_createPartialApplicator(_concat);
	module.exports = partial;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _createPartialApplicator = /*#__PURE__*/__webpack_require__(145);
	
	var flip = /*#__PURE__*/__webpack_require__(54);
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	
	
	var partialRight = /*#__PURE__*/_createPartialApplicator( /*#__PURE__*/flip(_concat));
	module.exports = partialRight;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var filter = /*#__PURE__*/__webpack_require__(81);
	
	var juxt = /*#__PURE__*/__webpack_require__(155);
	
	var reject = /*#__PURE__*/__webpack_require__(66);
	
	/**
	 * Takes a predicate and a list or other `Filterable` object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
	 * that has a filter method such as `Array`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	
	
	var partition = /*#__PURE__*/juxt([filter, reject]);
	module.exports = partition;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	var path = /*#__PURE__*/__webpack_require__(38);
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * [`R.equals`](#equals) terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	
	
	var pathEq = /*#__PURE__*/_curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});
	module.exports = pathEq;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var defaultTo = /*#__PURE__*/__webpack_require__(134);
	
	var path = /*#__PURE__*/__webpack_require__(38);
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	
	
	var pathOr = /*#__PURE__*/_curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});
	module.exports = pathOr;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var path = /*#__PURE__*/__webpack_require__(38);
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	
	
	var pathSatisfies = /*#__PURE__*/_curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});
	module.exports = pathSatisfies;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	
	
	var pick = /*#__PURE__*/_curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = pick;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	
	
	var pickBy = /*#__PURE__*/_curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});
	module.exports = pickBy;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var composeK = /*#__PURE__*/__webpack_require__(131);
	
	var reverse = /*#__PURE__*/__webpack_require__(67);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(f, R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	
	
	function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	}
	module.exports = pipeK;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var multiply = /*#__PURE__*/__webpack_require__(161);
	
	var reduce = /*#__PURE__*/__webpack_require__(24);
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	
	
	var product = /*#__PURE__*/reduce(multiply, 1);
	module.exports = product;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var _map = /*#__PURE__*/__webpack_require__(60);
	
	var identity = /*#__PURE__*/__webpack_require__(82);
	
	var pickAll = /*#__PURE__*/__webpack_require__(166);
	
	var useWith = /*#__PURE__*/__webpack_require__(178);
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	
	
	var project = /*#__PURE__*/useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity
	module.exports = project;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	/**
	 * Returns `true` if the specified object property is equal, in
	 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
	 * You can test multiple properties with [`R.where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.whereEq, R.propSatisfies, R.equals
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	
	
	var propEq = /*#__PURE__*/_curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});
	module.exports = propEq;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var is = /*#__PURE__*/__webpack_require__(153);
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	
	
	var propIs = /*#__PURE__*/_curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});
	module.exports = propIs;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	
	
	var propOr = /*#__PURE__*/_curry3(function propOr(val, p, obj) {
	  return obj != null && _has(p, obj) ? obj[p] : val;
	});
	module.exports = propOr;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise. You can test multiple properties with
	 * [`R.where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.where, R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	
	
	var propSatisfies = /*#__PURE__*/_curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});
	module.exports = propSatisfies;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	
	
	var props = /*#__PURE__*/_curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});
	module.exports = props;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isNumber = /*#__PURE__*/__webpack_require__(148);
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	
	
	var range = /*#__PURE__*/_curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});
	module.exports = range;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var _curryN = /*#__PURE__*/__webpack_require__(56);
	
	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	/**
	 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
	 * through the list, successively calling the iterator function. `reduceWhile`
	 * also takes a predicate that is evaluated before each step. If the predicate
	 * returns `false`, it "short-circuits" the iteration and returns the current
	 * value of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	
	
	var reduceWhile = /*#__PURE__*/_curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function (acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});
	module.exports = reduceWhile;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _reduced = /*#__PURE__*/__webpack_require__(30);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by
	 * [`reduceRight`](#reduceRight).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *     R.reduce(
	 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
	 *       [],
	 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
	 */
	
	
	var reduced = /*#__PURE__*/_curry1(_reduced);
	module.exports = reduced;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var always = /*#__PURE__*/__webpack_require__(35);
	
	var times = /*#__PURE__*/__webpack_require__(175);
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @see R.times
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	
	
	var repeat = /*#__PURE__*/_curry2(function repeat(value, n) {
	  return times(always(value), n);
	});
	module.exports = repeat;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	
	
	var replace = /*#__PURE__*/_curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});
	module.exports = replace;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
	 * reduced values from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @see R.reduce
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	
	
	var scan = /*#__PURE__*/_curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});
	module.exports = scan;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var always = /*#__PURE__*/__webpack_require__(35);
	
	var over = /*#__PURE__*/__webpack_require__(165);
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	
	
	var set = /*#__PURE__*/_curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});
	module.exports = set;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, a) -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	
	
	var sort = /*#__PURE__*/_curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});
	module.exports = sort;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	
	
	var sortBy = /*#__PURE__*/_curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});
	module.exports = sortBy;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [(a, a) -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	
	
	var sortWith = /*#__PURE__*/_curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});
	module.exports = sortWith;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	
	
	var split = /*#__PURE__*/invoker(1, 'split');
	module.exports = split;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var length = /*#__PURE__*/__webpack_require__(157);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	
	
	var splitAt = /*#__PURE__*/_curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});
	module.exports = splitAt;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	
	
	var splitEvery = /*#__PURE__*/_curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});
	module.exports = splitEvery;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	
	
	var splitWhen = /*#__PURE__*/_curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});
	module.exports = splitWhen;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	var take = /*#__PURE__*/__webpack_require__(92);
	
	/**
	 * Checks if a list starts with the provided values
	 *
	 * @func
	 * @memberOf R
	 * @since v0.24.0
	 * @category List
	 * @sig [a] -> Boolean
	 * @sig String -> Boolean
	 * @param {*} prefix
	 * @param {*} list
	 * @return {Boolean}
	 * @example
	 *
	 *      R.startsWith('a', 'abc')                //=> true
	 *      R.startsWith('b', 'abc')                //=> false
	 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
	 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
	 */
	
	
	var startsWith = /*#__PURE__*/_curry2(function (prefix, list) {
	  return equals(take(prefix.length, list), prefix);
	});
	module.exports = startsWith;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	
	
	var subtract = /*#__PURE__*/_curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});
	module.exports = subtract;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var concat = /*#__PURE__*/__webpack_require__(79);
	
	var difference = /*#__PURE__*/__webpack_require__(135);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	
	
	var symmetricDifference = /*#__PURE__*/_curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});
	module.exports = symmetricDifference;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var concat = /*#__PURE__*/__webpack_require__(79);
	
	var differenceWith = /*#__PURE__*/__webpack_require__(136);
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	
	
	var symmetricDifferenceWith = /*#__PURE__*/_curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});
	module.exports = symmetricDifferenceWith;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 *
	 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
	 */
	
	
	var takeLastWhile = /*#__PURE__*/_curry2(function takeLastWhile(fn, xs) {
	  var idx = xs.length - 1;
	  while (idx >= 0 && fn(xs[idx])) {
	    idx -= 1;
	  }
	  return slice(idx + 1, Infinity, xs);
	});
	module.exports = takeLastWhile;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xtakeWhile = /*#__PURE__*/__webpack_require__(357);
	
	var slice = /*#__PURE__*/__webpack_require__(21);
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @sig (a -> Boolean) -> String -> String
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} xs The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 *
	 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
	 */
	
	
	var takeWhile = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, xs) {
	  var idx = 0;
	  var len = xs.length;
	  while (idx < len && fn(xs[idx])) {
	    idx += 1;
	  }
	  return slice(0, idx, xs);
	}));
	module.exports = takeWhile;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _dispatchable = /*#__PURE__*/__webpack_require__(6);
	
	var _xtap = /*#__PURE__*/__webpack_require__(358);
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * Acts as a transducer if a transformer is given as second parameter.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	
	
	var tap = /*#__PURE__*/_curry2( /*#__PURE__*/_dispatchable([], _xtap, function tap(fn, x) {
	  fn(x);
	  return x;
	}));
	module.exports = tap;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var _cloneRegExp = /*#__PURE__*/__webpack_require__(143);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var _isRegExp = /*#__PURE__*/__webpack_require__(333);
	
	var toString = /*#__PURE__*/__webpack_require__(45);
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	
	
	var test = /*#__PURE__*/_curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});
	module.exports = test;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	
	
	var toLower = /*#__PURE__*/invoker(0, 'toLowerCase');
	module.exports = toLower;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var _has = /*#__PURE__*/__webpack_require__(12);
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	
	
	var toPairs = /*#__PURE__*/_curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});
	module.exports = toPairs;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	
	
	var toPairsIn = /*#__PURE__*/_curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});
	module.exports = toPairsIn;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var invoker = /*#__PURE__*/__webpack_require__(42);
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	
	
	var toUpper = /*#__PURE__*/invoker(0, 'toUpperCase');
	module.exports = toUpper;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var _reduce = /*#__PURE__*/__webpack_require__(19);
	
	var _xwrap = /*#__PURE__*/__webpack_require__(152);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the [`R.reduced`](#reduced) function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is
	 * [`R.identity`](#identity). The init function can be used to provide an
	 * initial accumulator, but is ignored by transduce.
	 *
	 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 *
	 *      var isOdd = (x) => x % 2 === 1;
	 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
	 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
	 */
	
	
	var transduce = /*#__PURE__*/curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});
	module.exports = transduce;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 *      // If some of the rows are shorter than the following rows, their elements are skipped:
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	
	
	var transpose = /*#__PURE__*/_curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});
	module.exports = transpose;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var sequence = /*#__PURE__*/__webpack_require__(172);
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `traverse` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	
	
	var traverse = /*#__PURE__*/_curry3(function traverse(of, f, traversable) {
	  return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : sequence(of, map(f, traversable));
	});
	module.exports = traverse;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' + '\u2029\uFEFF';
	var zeroWidth = '\u200b';
	var hasProtoTrim = typeof String.prototype.trim === 'function';
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	var _trim = !hasProtoTrim || /*#__PURE__*/ws.trim() || ! /*#__PURE__*/zeroWidth.trim() ? function trim(str) {
	  var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	  var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	  return str.replace(beginRx, '').replace(endRx, '');
	} : function trim(str) {
	  return str.trim();
	};
	var trim = /*#__PURE__*/_curry1(_trim);
	module.exports = trim;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = /*#__PURE__*/__webpack_require__(22);
	
	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	
	
	var tryCatch = /*#__PURE__*/_curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function () {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});
	module.exports = tryCatch;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, `R.unapply` derives a variadic function from a function which
	 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	
	
	var unapply = /*#__PURE__*/_curry1(function unapply(fn) {
	  return function () {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});
	module.exports = unapply;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	var nAry = /*#__PURE__*/__webpack_require__(64);
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @see R.binary, R.nAry
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	
	
	var unary = /*#__PURE__*/_curry1(function unary(fn) {
	  return nAry(1, fn);
	});
	module.exports = unary;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var curryN = /*#__PURE__*/__webpack_require__(11);
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	
	
	var uncurryN = /*#__PURE__*/_curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function () {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});
	module.exports = uncurryN;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	
	
	var unfold = /*#__PURE__*/_curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});
	module.exports = unfold;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var compose = /*#__PURE__*/__webpack_require__(78);
	
	var uniq = /*#__PURE__*/__webpack_require__(94);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	
	
	var union = /*#__PURE__*/_curry2( /*#__PURE__*/compose(uniq, _concat));
	module.exports = union;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var _concat = /*#__PURE__*/__webpack_require__(20);
	
	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	var uniqWith = /*#__PURE__*/__webpack_require__(177);
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	
	
	var unionWith = /*#__PURE__*/_curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});
	module.exports = unionWith;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      let safeInc = R.unless(R.isNil, R.inc);
	 *      safeInc(null); //=> null
	 *      safeInc(1); //=> 2
	 */
	
	
	var unless = /*#__PURE__*/_curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});
	module.exports = unless;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var _identity = /*#__PURE__*/__webpack_require__(85);
	
	var chain = /*#__PURE__*/__webpack_require__(77);
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	
	
	var unnest = /*#__PURE__*/chain(_identity);
	module.exports = unnest;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	
	
	var until = /*#__PURE__*/_curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});
	module.exports = until;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = /*#__PURE__*/__webpack_require__(4);
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @see R.values, R.keysIn
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	
	
	var valuesIn = /*#__PURE__*/_curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});
	module.exports = valuesIn;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	// `Const` is a functor that effectively ignores the function given to `map`.
	
	
	var Const = function (x) {
	  return { value: x, 'fantasy-land/map': function () {
	      return this;
	    } };
	};
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	var view = /*#__PURE__*/_curry2(function view(lens, x) {
	  // Using `Const` effectively ignores the setter function of the `lens`,
	  // leaving the value returned by the getter function unmodified.
	  return lens(Const)(x).value;
	});
	module.exports = view;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	
	
	var when = /*#__PURE__*/_curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});
	module.exports = when;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var equals = /*#__PURE__*/__webpack_require__(18);
	
	var map = /*#__PURE__*/__webpack_require__(16);
	
	var where = /*#__PURE__*/__webpack_require__(180);
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in [`R.equals`](#equals) terms) as accessing that property of the
	 * spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.propEq, R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	
	
	var whereEq = /*#__PURE__*/_curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});
	module.exports = whereEq;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var _contains = /*#__PURE__*/__webpack_require__(36);
	
	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	var flip = /*#__PURE__*/__webpack_require__(54);
	
	var reject = /*#__PURE__*/__webpack_require__(66);
	
	/**
	 * Returns a new list without values in the first argument.
	 * [`R.equals`](#equals) is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce, R.difference
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	
	
	var without = /*#__PURE__*/_curry2(function (xs, list) {
	  return reject(flip(_contains)(xs), list);
	});
	module.exports = without;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	
	
	var xprod = /*#__PURE__*/_curry2(function xprod(a, b) {
	  // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});
	module.exports = xprod;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	
	
	var zip = /*#__PURE__*/_curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});
	module.exports = zip;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = /*#__PURE__*/__webpack_require__(2);
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	
	
	var zipObj = /*#__PURE__*/_curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});
	module.exports = zipObj;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = /*#__PURE__*/__webpack_require__(5);
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	
	
	var zipWith = /*#__PURE__*/_curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});
	module.exports = zipWith;

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ramda = __webpack_require__(317);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Transforms a markdown string into a string with basic html tags.
	// String -> String
	exports.default = _ramda2.default.pipe(_ramda2.default.replace(/\*\*(.*?)\*\*/gi, '<span style="color: #999999; text-transform: uppercase; font-size: 12px; letter-spacing: .5px; margin-right: 5px;">$1</span>'), _ramda2.default.replace(/\*(.*?)\*/gi, "<em>$1</em>"), _ramda2.default.replace(/__(.*?)__/gi, '<span style="text-decoration: underline;">$1</span>'), _ramda2.default.replace(/<script.*?\/script>/gi, ""));
	module.exports = exports["default"];

/***/ }),
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(255);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(3);
	
	var _Subscription = __webpack_require__(1502);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(565);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(1404);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(479);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 10px 0;\n  width: 100%;\n  > div {\n    margin: 10px 0;\n  }\n"], ["\n  display: block;\n  padding: 10px 0;\n  width: 100%;\n  > div {\n    margin: 10px 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 17.6px;\n  color: ", ";\n  letter-spacing: 2px;\n  -webkit-font-variant-ligatures: no-common-ligatures;\n"], ["\n  font-size: 17.6px;\n  color: ", ";\n  letter-spacing: 2px;\n  -webkit-font-variant-ligatures: no-common-ligatures;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-transform: uppercase;\n  font-size: 11.2px;\n  letter-spacing: 0.5px;\n"], ["\n  color: ", ";\n  text-transform: uppercase;\n  font-size: 11.2px;\n  letter-spacing: 0.5px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14.4px;\n  > div {\n    line-height: 1.7;\n  }\n"], ["\n  color: ", ";\n  font-size: 14.4px;\n  > div {\n    line-height: 1.7;\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _connect = __webpack_require__(222);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _markdown = __webpack_require__(494);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ResultContainer = _styledComponents2.default.div(_templateObject);
	
	var Greek = _styledComponents2.default.span(_templateObject2, _colors2.default.accent);
	
	var Info = _styledComponents2.default.span(_templateObject3, _colors2.default.main);
	
	var Definitions = _styledComponents2.default.div(_templateObject4, _colors2.default.main);
	
	var mapDefinitions = function mapDefinitions(defs) {
	  return defs.map(function (def, i) {
	    return _react2.default.createElement("div", {
	      dangerouslySetInnerHTML: {
	        __html: (defs.length < 2 ? "" : ++i + ".&nbsp;") + " " + (0, _markdown2.default)(def)
	      },
	      key: i
	    });
	  });
	};
	
	var Result = function (_Component) {
	  _inherits(Result, _Component);
	
	  function Result(props) {
	    _classCallCheck(this, Result);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Result.prototype.render = function render() {
	    var _props$word = this.props.word,
	        chapter = _props$word.chapter,
	        definitions = _props$word.definitions,
	        info = _props$word.info,
	        latin = _props$word.latin;
	
	    return _react2.default.createElement(
	      ResultContainer,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          Greek,
	          null,
	          latin + " "
	        ),
	        _react2.default.createElement(
	          Info,
	          null,
	          info
	        )
	      ),
	      _react2.default.createElement(
	        Definitions,
	        null,
	        mapDefinitions(definitions)
	      )
	    );
	  };
	
	  return Result;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(Result);
	module.exports = exports["default"];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 10px;\n  border: 1px solid ", ";\n  width: 100%;\n  font-size: 20px;\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"], ["\n  display: block;\n  padding: 10px;\n  border: 1px solid ", ";\n  width: 100%;\n  font-size: 20px;\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _connect = __webpack_require__(222);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledInput = _styledComponents2.default.input(_templateObject, _colors2.default.border, _colors2.default.accent);
	
	var search = function search(action) {
	  return function (e) {
	    var value = e.target.value;
	
	    if (value !== "") {
	      action(value);
	    } else {
	      action("");
	    }
	  };
	};
	
	var WordSearch = function (_Component) {
	  _inherits(WordSearch, _Component);
	
	  function WordSearch(props) {
	    _classCallCheck(this, WordSearch);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  WordSearch.prototype.render = function render() {
	    var updateDictionary = this.props.actions.updateDictionary;
	
	    return _react2.default.createElement(StyledInput, {
	      type: "text",
	      placeholder: "Zoek een woord",
	      onChange: search(updateDictionary)
	    });
	  };
	
	  return WordSearch;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(WordSearch);
	module.exports = exports["default"];

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ACTION = exports.ACTION = 'UPDATE_DICTIONARY';
	
	exports.default = function (payload) {
	  return { type: ACTION, payload: payload };
	};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _words = __webpack_require__(620);
	
	var _words2 = _interopRequireDefault(_words);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	var dictionaryReducer = function dictionaryReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "UPDATE_DICTIONARY":
	      if (action.payload === "") {
	        return [];
	      } else {
	        var regex = new RegExp("^" + action.payload.toLowerCase() + ".*");
	        return _words2.default.filter(function (x) {
	          return regex.test(x.searchForm);
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = dictionaryReducer;
	module.exports = exports["default"];

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(186);
	
	var _dictionary = __webpack_require__(618);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Create store
	// Import main dependencies
	var store = (0, _redux.createStore)((0, _redux.combineReducers)({
	  dictionary: _dictionary2.default
	}));
	
	// Import reducers
	
	exports.default = store;
	module.exports = exports["default"];

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	"use strict";
	
	var dictionaryData = [{
	  "latin": "ἀγαθός, -ή, -όν",
	  "info": "",
	  "definitions": ["goed"],
	  "chapter": 21,
	  "searchForm": "agathos, -e, -on"
	}, {
	  "latin": "ἄγαν",
	  "info": "bijw",
	  "definitions": ["teveel"],
	  "chapter": 42,
	  "searchForm": "agan"
	}, {
	  "latin": "ἀγανακτέω",
	  "info": "",
	  "definitions": ["boos worden, boos zijn"],
	  "chapter": 11,
	  "searchForm": "aganakteo"
	}, {
	  "latin": "ἀγγέλλω",
	  "info": "",
	  "definitions": ["berichten"],
	  "chapter": 19,
	  "searchForm": "aggello"
	}, {
	  "latin": "ἀγείρω",
	  "info": "",
	  "definitions": ["verzamelen, bijeenroepen"],
	  "chapter": 28,
	  "searchForm": "ageiro"
	}, {
	  "latin": "ἀγνοέω",
	  "info": "",
	  "definitions": ["niet begrijpen, niet weten"],
	  "chapter": 17,
	  "searchForm": "agnoeo"
	}, {
	  "latin": "ἡ ἀγορά",
	  "info": "",
	  "definitions": ["markt"],
	  "chapter": 19,
	  "searchForm": "agora"
	}, {
	  "latin": "ὁ ἀγρός",
	  "info": "",
	  "definitions": ["veld, akker"],
	  "chapter": 38,
	  "searchForm": "agros"
	}, {
	  "latin": "ἄγω",
	  "info": "",
	  "definitions": ["leiden, brengen"],
	  "chapter": 3,
	  "searchForm": "ago"
	}, {
	  "latin": "ὁ ἀγών, ἀγῶνος",
	  "info": "",
	  "definitions": ["wedstrijd, strijd"],
	  "chapter": 31,
	  "searchForm": "agon, agonos"
	}, {
	  "latin": "ἀγωνίζομαι",
	  "info": "",
	  "definitions": ["strijden, een wedstrijd houden (tegen)"],
	  "chapter": 31,
	  "searchForm": "agonizomai"
	}, {
	  "latin": "ἡ ἀδελφή",
	  "info": "",
	  "definitions": ["zus"],
	  "chapter": 4,
	  "searchForm": "adelfe"
	}, {
	  "latin": "ὁ ἀδελφός",
	  "info": "",
	  "definitions": ["broer"],
	  "chapter": 4,
	  "searchForm": "adelfos"
	}, {
	  "latin": "ἄδικος, -ον",
	  "info": "",
	  "definitions": ["onrechtvaardig"],
	  "chapter": 27,
	  "searchForm": "adikos, -on"
	}, {
	  "latin": "ἀδύνατος, -ον",
	  "info": "",
	  "definitions": ["niet in staat", "onmogelijk"],
	  "chapter": 26,
	  "searchForm": "adunatos, -on"
	}, {
	  "latin": "ἀεί",
	  "info": "bijw",
	  "definitions": ["altijd, steeds"],
	  "chapter": 3,
	  "searchForm": "aei"
	}, {
	  "latin": "αἱ Ἀθῆναι",
	  "info": "",
	  "definitions": ["(de stad) Athene"],
	  "chapter": 19,
	  "searchForm": "Athenai"
	}, {
	  "latin": "ὁ Ἀθηναῖος",
	  "info": "",
	  "definitions": ["Athener"],
	  "chapter": 19,
	  "searchForm": "athenaios"
	}, {
	  "latin": "ἄθλιος, -α, -ον",
	  "info": "",
	  "definitions": ["ongelukkig"],
	  "chapter": 21,
	  "searchForm": "athlios, -a, -on"
	}, {
	  "latin": "τὸ ἆθλον",
	  "info": "",
	  "definitions": ["(wedstrijs)prijs"],
	  "chapter": 34,
	  "searchForm": "athlon"
	}, {
	  "latin": "ᾄδω",
	  "info": "",
	  "definitions": ["(be)zingen"],
	  "chapter": 23,
	  "searchForm": "aido"
	}, {
	  "latin": "αἴρω",
	  "info": "",
	  "definitions": ["optillen"],
	  "chapter": 32,
	  "searchForm": "airo"
	}, {
	  "latin": "αἰσθάνομαι",
	  "info": "",
	  "definitions": ["waarnemen, (be)merken"],
	  "chapter": 36,
	  "searchForm": "aisthanomai"
	}, {
	  "latin": "αἰσχρός, -ά, -όν",
	  "info": "",
	  "definitions": ["lelijk, schandelijk"],
	  "chapter": 21,
	  "searchForm": "aischros, -a, -on"
	}, {
	  "latin": "ἡ αἰσχύνη",
	  "info": "",
	  "definitions": ["schande"],
	  "chapter": 38,
	  "searchForm": "aischune"
	}, {
	  "latin": "αἰτέω",
	  "info": "(+ acc + acc)",
	  "definitions": ["(iemand om iets) vragen, eisen"],
	  "chapter": 31,
	  "searchForm": "aiteo"
	}, {
	  "latin": "αἰτιάομαι",
	  "info": "",
	  "definitions": ["beschuldigen"],
	  "chapter": 44,
	  "searchForm": "aitiaomai"
	}, {
	  "latin": "ἀκολουθέω",
	  "info": "+ dat",
	  "definitions": ["volgen"],
	  "chapter": 29,
	  "searchForm": "akoloutheo"
	}, {
	  "latin": "ἀκούω",
	  "info": "+ gen/acc",
	  "definitions": ["luisteren (naar), horen"],
	  "chapter": 11,
	  "searchForm": "akouo"
	}, {
	  "latin": "ἀκριβής, -ές",
	  "info": "",
	  "definitions": ["nauwkeurig, precies"],
	  "chapter": 37,
	  "searchForm": "akribes, -es"
	}, {
	  "latin": "ἄκων, ἄκουσα, ἆκον, ἄκοντος ",
	  "info": "",
	  "definitions": ["onvrijwillig, tegen de zin"],
	  "chapter": 26,
	  "searchForm": "akon, akousa, akon, akontos "
	}, {
	  "latin": "ἡ ἀλήθεια",
	  "info": "",
	  "definitions": ["de waarheid"],
	  "chapter": 17,
	  "searchForm": "aletheia"
	}, {
	  "latin": "ἀληθής, -ές",
	  "info": "",
	  "definitions": ["echt, waar, werkelijk"],
	  "chapter": 37,
	  "searchForm": "alethes, -es"
	}, {
	  "latin": "ἀλλ’ ",
	  "info": "",
	  "definitions": ["maar"],
	  "chapter": 3,
	  "searchForm": "all’ "
	}, {
	  "latin": "ἀλλά",
	  "info": "",
	  "definitions": ["maar"],
	  "chapter": 3,
	  "searchForm": "alla"
	}, {
	  "latin": "ἀλλήλων, -οις, -ους",
	  "info": "mv",
	  "definitions": ["elkaar"],
	  "chapter": 24,
	  "searchForm": "allelon, -ois, -ous"
	}, {
	  "latin": "ἄλλος, -η, -ο",
	  "info": "",
	  "definitions": ["ander, overig"],
	  "chapter": 22,
	  "searchForm": "allos, -e, -o"
	}, {
	  "latin": "ἆμα μή;",
	  "info": "",
	  "definitions": ["toch (zeker) niet?"],
	  "chapter": 19,
	  "searchForm": "ama me;"
	}, {
	  "latin": "ἀμείνων, -ον",
	  "info": "",
	  "definitions": ["beter"],
	  "chapter": 42,
	  "searchForm": "ameinon, -on"
	}, {
	  "latin": "ἀμύνομαι",
	  "info": "(+ acc)",
	  "definitions": ["zich verdedigen (tegen)"],
	  "chapter": 32,
	  "searchForm": "amunomai"
	}, {
	  "latin": "ἀμφότεροι, -αι, -α",
	  "info": "mv",
	  "definitions": ["beide"],
	  "chapter": 37,
	  "searchForm": "amfoteroi, -ai, -a"
	}, {
	  "latin": "ἄν",
	  "info": "+ con",
	  "definitions": ["*gebeurtenis in de toekomst*", "*algemeen of herhaald feit*"],
	  "chapter": 41,
	  "searchForm": "an"
	}, {
	  "latin": "ἄν",
	  "info": "+ opt",
	  "definitions": ["*mogelijkheid, waarschijnlijkheid*"],
	  "chapter": 42,
	  "searchForm": "an"
	}, {
	  "latin": "ἀν-",
	  "info": "voorvoegsel",
	  "definitions": ["omhoog-, -op"],
	  "chapter": 26,
	  "searchForm": "an-"
	}, {
	  "latin": "ἀνα-",
	  "info": "voorvoegsel",
	  "definitions": ["omhoog-, -op"],
	  "chapter": 26,
	  "searchForm": "ana-"
	}, {
	  "latin": "ἀναγιγνώσκω",
	  "info": "",
	  "definitions": ["herkennen"],
	  "chapter": 19,
	  "searchForm": "anagignosko"
	}, {
	  "latin": "ἀναγκάζω",
	  "info": "",
	  "definitions": ["noodzaken, dwingen"],
	  "chapter": 33,
	  "searchForm": "anagkazo"
	}, {
	  "latin": "ἀνάγω",
	  "info": "",
	  "definitions": ["omhoog leiden"],
	  "chapter": 27,
	  "searchForm": "anago"
	}, {
	  "latin": "ἀναιρέω",
	  "info": "",
	  "definitions": ["oppakken, opnemen"],
	  "chapter": 38,
	  "searchForm": "anaireo"
	}, {
	  "latin": "ἀνδρεῖος, -α, -ον",
	  "info": "",
	  "definitions": ["dapper"],
	  "chapter": 21,
	  "searchForm": "andreios, -a, -on"
	}, {
	  "latin": "ὁ ἄνεμος",
	  "info": "",
	  "definitions": ["wind"],
	  "chapter": 31,
	  "searchForm": "anemos"
	}, {
	  "latin": "ἄνευ",
	  "info": "+ gen",
	  "definitions": ["zonder"],
	  "chapter": 43,
	  "searchForm": "aneu"
	}, {
	  "latin": "ἀνέχομαι",
	  "info": "",
	  "definitions": ["uithouden, verdragen"],
	  "chapter": 43,
	  "searchForm": "anechomai"
	}, {
	  "latin": "ὁ ἀνήρ, ἀνδρός",
	  "info": "",
	  "definitions": ["man"],
	  "chapter": 7,
	  "searchForm": "aner, andros"
	}, {
	  "latin": "ἀνθ’",
	  "info": "+ gen",
	  "definitions": ["in ruil voor, in plaats van"],
	  "chapter": 7,
	  "searchForm": "anth’"
	}, {
	  "latin": "ὁ ἄνθρωπος ",
	  "info": "",
	  "definitions": ["mens"],
	  "chapter": 2,
	  "searchForm": "anthropos "
	}, {
	  "latin": "ἀνοίγω",
	  "info": "",
	  "definitions": ["openen"],
	  "chapter": 32,
	  "searchForm": "anoigo"
	}, {
	  "latin": "ἀντ’",
	  "info": "+ gen",
	  "definitions": ["in ruil voor, in plaats van"],
	  "chapter": 7,
	  "searchForm": "ant’"
	}, {
	  "latin": "ἀντί",
	  "info": "+ gen",
	  "definitions": ["in ruil voor, in plaats van"],
	  "chapter": 7,
	  "searchForm": "anti"
	}, {
	  "latin": "ἄνω",
	  "info": "bijw",
	  "definitions": ["omhoog, boven"],
	  "chapter": 28,
	  "searchForm": "ano"
	}, {
	  "latin": "ἄξιος, -α, -ον",
	  "info": "+ gen",
	  "definitions": ["(iets) waard, waardig"],
	  "chapter": 34,
	  "searchForm": "axios, -a, -on"
	}, {
	  "latin": "ἀπ’",
	  "info": "+ gen",
	  "definitions": ["van … vandaan, vanaf", "sinds"],
	  "chapter": 12,
	  "searchForm": "ap’"
	}, {
	  "latin": "ἀπατάω",
	  "info": "",
	  "definitions": ["bedriegen, misleiden"],
	  "chapter": 28,
	  "searchForm": "apatao"
	}, {
	  "latin": "ἄπειμι",
	  "info": "",
	  "definitions": ["afwezig zijn"],
	  "chapter": 41,
	  "searchForm": "apeimi"
	}, {
	  "latin": "ἀπό",
	  "info": "+ gen",
	  "definitions": ["van … vandaan, vanaf", "sinds"],
	  "chapter": 12,
	  "searchForm": "apo"
	}, {
	  "latin": "ἀπο-",
	  "info": "voorvoegsel",
	  "definitions": ["weg-, af-"],
	  "chapter": 23,
	  "searchForm": "apo-"
	}, {
	  "latin": "ἀπο-θνῄσκω",
	  "info": "",
	  "definitions": ["sterven, omkomen"],
	  "chapter": 13,
	  "searchForm": "apothneisko"
	}, {
	  "latin": "ἀποκρίνομαι",
	  "info": "",
	  "definitions": ["antwoorden"],
	  "chapter": 36,
	  "searchForm": "apokrinomai"
	}, {
	  "latin": "ἀπο-κτείνω",
	  "info": "",
	  "definitions": ["doden"],
	  "chapter": 13,
	  "searchForm": "apokteino"
	}, {
	  "latin": "ἀπολογέομαι",
	  "info": "",
	  "definitions": ["zich verdedigen"],
	  "chapter": 44,
	  "searchForm": "apologeomai"
	}, {
	  "latin": "ἀπορέω",
	  "info": "",
	  "definitions": ["in onzekerheid verkeren, zich geen raad weten"],
	  "chapter": 39,
	  "searchForm": "aporeo"
	}, {
	  "latin": "ἀποφαίνω",
	  "info": "",
	  "definitions": ["aantonen, bewijzen", "openbaar maken"],
	  "chapter": 33,
	  "searchForm": "apofaino"
	}, {
	  "latin": "ἆρ’ οὐ;",
	  "info": "",
	  "definitions": ["toch zeker, toch wel"],
	  "chapter": 19,
	  "searchForm": "ar’ ou;"
	}, {
	  "latin": "ἆρ’ οὐκ;",
	  "info": "",
	  "definitions": ["toch zeker, toch wel"],
	  "chapter": 19,
	  "searchForm": "ar’ ouk;"
	}, {
	  "latin": "ἆρα",
	  "info": "",
	  "definitions": ["*leidt vraagzin in; niet vertalen*"],
	  "chapter": 14,
	  "searchForm": "ara"
	}, {
	  "latin": "ἄρα",
	  "info": "",
	  "definitions": ["dus"],
	  "chapter": 22,
	  "searchForm": "ara"
	}, {
	  "latin": "τὸ ἀργύριον",
	  "info": "",
	  "definitions": ["zilver, geld"],
	  "chapter": 37,
	  "searchForm": "argurion"
	}, {
	  "latin": "ἀρέσκω",
	  "info": "+ dat",
	  "definitions": ["bevallen, in de smaak vallen bij"],
	  "chapter": 37,
	  "searchForm": "aresko"
	}, {
	  "latin": "ἡ ἀρετή",
	  "info": "",
	  "definitions": ["dapperheid, voortreffelijkheid"],
	  "chapter": 7,
	  "searchForm": "arete"
	}, {
	  "latin": "ἄριστος, -η, -ον",
	  "info": "",
	  "definitions": ["best"],
	  "chapter": 23,
	  "searchForm": "aristos, -e, -on"
	}, {
	  "latin": "ἡ ἀρχή",
	  "info": "",
	  "definitions": ["begin", "heerschappij, rijk"],
	  "chapter": 17,
	  "searchForm": "arche"
	}, {
	  "latin": "ἄρχω",
	  "info": "",
	  "definitions": ["beginnen", "**+ gen** heersen (over)"],
	  "chapter": 27,
	  "searchForm": "archo"
	}, {
	  "latin": "ὁ ἄρχων, ἄρχοντος",
	  "info": "",
	  "definitions": ["leider, heerser"],
	  "chapter": 33,
	  "searchForm": "archon, archontos"
	}, {
	  "latin": "ἡ ἀσπίς, ἀσπίδος",
	  "info": "",
	  "definitions": ["schild"],
	  "chapter": 6,
	  "searchForm": "aspis, aspidos"
	}, {
	  "latin": "τὸ ἄστυ, ἄστεως",
	  "info": "",
	  "definitions": ["stad (*de gebouwen*)"],
	  "chapter": 42,
	  "searchForm": "astu, asteos"
	}, {
	  "latin": "αὖθις",
	  "info": "bijw",
	  "definitions": ["opnieuw, weer"],
	  "chapter": 32,
	  "searchForm": "authis"
	}, {
	  "latin": "αὐξάνομαι",
	  "info": "",
	  "definitions": ["groeien"],
	  "chapter": 34,
	  "searchForm": "auxanomai"
	}, {
	  "latin": "αὐτῆς",
	  "info": "",
	  "definitions": ["van haar"],
	  "chapter": 8,
	  "searchForm": "autes"
	}, {
	  "latin": "αὐτίκα",
	  "info": "bijw",
	  "definitions": ["meteen"],
	  "chapter": 3,
	  "searchForm": "autika"
	}, {
	  "latin": "αὐτός, -ή, -όν",
	  "info": "",
	  "definitions": ["*αὐτός (ὁ)* zelf", "*ὁ αὐτός (καί)* dezelfde, hetzelfde (als)", "*gen/dat/acc* hij, zij, het"],
	  "chapter": 22,
	  "searchForm": "autos, -e, -on"
	}, {
	  "latin": "αὐτοῦ",
	  "info": "",
	  "definitions": ["van hem, van het"],
	  "chapter": 8,
	  "searchForm": "autou"
	}, {
	  "latin": "ἀφ’",
	  "info": "+ gen",
	  "definitions": ["van … vandaan, vanaf", "sinds"],
	  "chapter": 12,
	  "searchForm": "af’"
	}, {
	  "latin": "ἀφαιρέω",
	  "info": "+ acc + acc",
	  "definitions": ["wegnemen, afpakken"],
	  "chapter": 18,
	  "searchForm": "afaireo"
	}, {
	  "latin": "ἀφικνέομαι",
	  "info": "",
	  "definitions": ["aankomen"],
	  "chapter": 33,
	  "searchForm": "afikneomai"
	}, {
	  "latin": "βαθύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["diep"],
	  "chapter": 23,
	  "searchForm": "bathus, -eia, -u"
	}, {
	  "latin": "βαίνω",
	  "info": "",
	  "definitions": ["gaan, stappen"],
	  "chapter": 14,
	  "searchForm": "baino"
	}, {
	  "latin": "βάλλω",
	  "info": "",
	  "definitions": ["gooien"],
	  "chapter": 13,
	  "searchForm": "ballo"
	}, {
	  "latin": "ὁ βάρβαρος",
	  "info": "",
	  "definitions": ["niet-Griek, vreemdeling"],
	  "chapter": 39,
	  "searchForm": "barbaros"
	}, {
	  "latin": "βάρβαρος, -α, -ον",
	  "info": "",
	  "definitions": ["niet-Grieks, vreemd"],
	  "chapter": 39,
	  "searchForm": "barbaros, -a, -on"
	}, {
	  "latin": "βαρύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["zwaar, ernstig"],
	  "chapter": 23,
	  "searchForm": "barus, -eia, -u"
	}, {
	  "latin": "ὁ βασιλεύς, -εως",
	  "info": "",
	  "definitions": ["koning"],
	  "chapter": 39,
	  "searchForm": "basileus, -eos"
	}, {
	  "latin": "βέλτιστος, -η, -ον",
	  "info": "",
	  "definitions": ["best, zeer goed"],
	  "chapter": 43,
	  "searchForm": "beltistos, -e, -on"
	}, {
	  "latin": "βελτίων, -ον",
	  "info": "",
	  "definitions": ["beter"],
	  "chapter": 43,
	  "searchForm": "beltion, -on"
	}, {
	  "latin": "ὁ βίος",
	  "info": "",
	  "definitions": ["het leven"],
	  "chapter": 3,
	  "searchForm": "bios"
	}, {
	  "latin": "βλάπτω",
	  "info": "",
	  "definitions": ["schade toebrengen"],
	  "chapter": 42,
	  "searchForm": "blapto"
	}, {
	  "latin": "βλέπω",
	  "info": "",
	  "definitions": ["kijken"],
	  "chapter": 6,
	  "searchForm": "blepo"
	}, {
	  "latin": "ἡ βοήθεια",
	  "info": "",
	  "definitions": ["hulp"],
	  "chapter": 7,
	  "searchForm": "boetheia"
	}, {
	  "latin": "βοηθέω",
	  "info": "+ dat",
	  "definitions": ["helpen"],
	  "chapter": 7,
	  "searchForm": "boetheo"
	}, {
	  "latin": "βουλεύω",
	  "info": "",
	  "definitions": ["beraadslagen", "**aor** besluiten"],
	  "chapter": 18,
	  "searchForm": "bouleuo"
	}, {
	  "latin": "ἡ βουλή",
	  "info": "",
	  "definitions": ["besluit, plan", "advies, raad"],
	  "chapter": 33,
	  "searchForm": "boule"
	}, {
	  "latin": "βούλομαι",
	  "info": "",
	  "definitions": ["(graag) willen"],
	  "chapter": 31,
	  "searchForm": "boulomai"
	}, {
	  "latin": "βραχύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["kort"],
	  "chapter": 23,
	  "searchForm": "brachus, -eia, -u"
	}, {
	  "latin": "γαμέω",
	  "info": "(+ acc)",
	  "definitions": ["trouwen (met) *(ow is een man)*"],
	  "chapter": 26,
	  "searchForm": "gameo"
	}, {
	  "latin": "ὁ γάμος",
	  "info": "",
	  "definitions": ["huwelijk"],
	  "chapter": 26,
	  "searchForm": "gamos"
	}, {
	  "latin": "γάρ",
	  "info": "",
	  "definitions": ["want, immers, namelijk"],
	  "chapter": 2,
	  "searchForm": "gar"
	}, {
	  "latin": "γε",
	  "info": "",
	  "definitions": ["*versterkt het vorige woord*"],
	  "chapter": 28,
	  "searchForm": "ge"
	}, {
	  "latin": "γελάω",
	  "info": "",
	  "definitions": ["lachen"],
	  "chapter": 16,
	  "searchForm": "gelao"
	}, {
	  "latin": "τὸ γένος, γένους",
	  "info": "",
	  "definitions": ["geslacht, afkomst", "soort, klasse"],
	  "chapter": 37,
	  "searchForm": "genos, genous"
	}, {
	  "latin": "ὁ γέρων, γέροντος",
	  "info": "",
	  "definitions": ["oude man"],
	  "chapter": 9,
	  "searchForm": "geron, gerontos"
	}, {
	  "latin": "ἡ γῆ",
	  "info": "",
	  "definitions": ["land, aarde"],
	  "chapter": 2,
	  "searchForm": "ge"
	}, {
	  "latin": "γίγνομαι",
	  "info": "",
	  "definitions": ["geboren worden, ontstaan", "worden", "gebeuren"],
	  "chapter": 32,
	  "searchForm": "gignomai"
	}, {
	  "latin": "γιγνώσκω",
	  "info": "",
	  "definitions": ["begrijpen, (leren) kennen"],
	  "chapter": 11,
	  "searchForm": "gignosko"
	}, {
	  "latin": "γλυκύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["zoet, lief"],
	  "chapter": 28,
	  "searchForm": "glukus, -eia, -u"
	}, {
	  "latin": "ἡ γνώμη",
	  "info": "",
	  "definitions": ["inzicht, oordeel, mening"],
	  "chapter": 42,
	  "searchForm": "gnome"
	}, {
	  "latin": "γράφω",
	  "info": "",
	  "definitions": ["schrijven"],
	  "chapter": 29,
	  "searchForm": "grafo"
	}, {
	  "latin": "γυμνάζω",
	  "info": "",
	  "definitions": ["oefenen, trainen"],
	  "chapter": 34,
	  "searchForm": "gumnazo"
	}, {
	  "latin": "γυμνός, -ή, -όν",
	  "info": "",
	  "definitions": ["bloot, naakt"],
	  "chapter": 33,
	  "searchForm": "gumnos, -e, -on"
	}, {
	  "latin": "ἡ γυνή, γυναικός",
	  "info": "",
	  "definitions": ["vrouw"],
	  "chapter": 6,
	  "searchForm": "gune, gunaikos"
	}, {
	  "latin": "δ’ ",
	  "info": "",
	  "definitions": ["en, maar"],
	  "chapter": 2,
	  "searchForm": "d’ "
	}, {
	  "latin": "δακρύω",
	  "info": "(+ acc)",
	  "definitions": ["huilen (over)"],
	  "chapter": 26,
	  "searchForm": "dakruo"
	}, {
	  "latin": "δέ",
	  "info": "",
	  "definitions": ["en, maar"],
	  "chapter": 2,
	  "searchForm": "de"
	}, {
	  "latin": "δεῖ",
	  "info": "",
	  "definitions": ["**+ inf** het is nodig om", "**+ acc + inf** (iemand) moet"],
	  "chapter": 31,
	  "searchForm": "dei"
	}, {
	  "latin": "δείδω",
	  "info": "",
	  "definitions": ["vrezen"],
	  "chapter": 27,
	  "searchForm": "deido"
	}, {
	  "latin": "δεινός, -ή, -όν",
	  "info": "",
	  "definitions": ["angstaanjagend, vreselijk", "indrukwekkend"],
	  "chapter": 26,
	  "searchForm": "deinos, -e, -on"
	}, {
	  "latin": "τὸ δεῖπνον",
	  "info": "",
	  "definitions": ["maaltijd"],
	  "chapter": 9,
	  "searchForm": "deipnon"
	}, {
	  "latin": "δέκα",
	  "info": "telwoord",
	  "definitions": ["tien"],
	  "chapter": 38,
	  "searchForm": "deka"
	}, {
	  "latin": "τὸ δένδρον",
	  "info": "",
	  "definitions": ["boom"],
	  "chapter": 2,
	  "searchForm": "dendron"
	}, {
	  "latin": "ὁ δεσπότης, -ου",
	  "info": "",
	  "definitions": ["meester, heer des huizes"],
	  "chapter": 44,
	  "searchForm": "despotes, -ou"
	}, {
	  "latin": "δεῦρο",
	  "info": "bijw",
	  "definitions": ["hierheen"],
	  "chapter": 17,
	  "searchForm": "deuro"
	}, {
	  "latin": "δέχομαι",
	  "info": "",
	  "definitions": ["aannemen, ontvangen"],
	  "chapter": 31,
	  "searchForm": "dechomai"
	}, {
	  "latin": "δή",
	  "info": "",
	  "definitions": ["dus, dan, natuurlijk"],
	  "chapter": 16,
	  "searchForm": "de"
	}, {
	  "latin": "ὁ δῆμος",
	  "info": "",
	  "definitions": ["volk"],
	  "chapter": 21,
	  "searchForm": "demos"
	}, {
	  "latin": "δι’",
	  "info": "+ acc",
	  "definitions": ["wegens", "door toedoen van"],
	  "chapter": 12,
	  "searchForm": "di’"
	}, {
	  "latin": "δι’ ",
	  "info": "+ gen",
	  "definitions": ["door … heen", "gedurende"],
	  "chapter": 6,
	  "searchForm": "di’ "
	}, {
	  "latin": "διά",
	  "info": "+ gen",
	  "definitions": ["door … heen", "gedurende"],
	  "chapter": 6,
	  "searchForm": "dia"
	}, {
	  "latin": "διά",
	  "info": "+ acc",
	  "definitions": ["wegens", "door toedoen van"],
	  "chapter": 12,
	  "searchForm": "dia"
	}, {
	  "latin": "διαβαίνω",
	  "info": "",
	  "definitions": ["oversteken"],
	  "chapter": 27,
	  "searchForm": "diabaino"
	}, {
	  "latin": "διαλέγομαι",
	  "info": "(+ dat)",
	  "definitions": ["een gesprek voeren (met)"],
	  "chapter": 41,
	  "searchForm": "dialegomai"
	}, {
	  "latin": "διατελέω",
	  "info": "",
	  "definitions": ["voltooien"],
	  "chapter": 43,
	  "searchForm": "diateleo"
	}, {
	  "latin": "διατρίβω",
	  "info": "",
	  "definitions": ["(tijd) doorbrengen"],
	  "chapter": 24,
	  "searchForm": "diatribo"
	}, {
	  "latin": "διαφθείρω",
	  "info": "",
	  "definitions": ["vernietigen, bederven"],
	  "chapter": 9,
	  "searchForm": "diaftheiro"
	}, {
	  "latin": "δικάζω",
	  "info": "",
	  "definitions": ["rechtspreken, beslissen"],
	  "chapter": 44,
	  "searchForm": "dikazo"
	}, {
	  "latin": "ὁ δικαστής, -οῦ",
	  "info": "",
	  "definitions": ["rechter"],
	  "chapter": 44,
	  "searchForm": "dikastes, -ou"
	}, {
	  "latin": "ἡ δίκη",
	  "info": "",
	  "definitions": ["recht(spraak)", "rechtszaak", "vonnis, straf"],
	  "chapter": 44,
	  "searchForm": "dike"
	}, {
	  "latin": "διό",
	  "info": "bijw",
	  "definitions": ["daarom, daardoor"],
	  "chapter": 29,
	  "searchForm": "dio"
	}, {
	  "latin": "διότι",
	  "info": "",
	  "definitions": ["omdat, doordat"],
	  "chapter": 17,
	  "searchForm": "dioti"
	}, {
	  "latin": "διώκω",
	  "info": "",
	  "definitions": ["achtervolgen, wegjagen"],
	  "chapter": 9,
	  "searchForm": "dioko"
	}, {
	  "latin": "δοκέω",
	  "info": "",
	  "definitions": ["lijken, de indruk wekken", "menen"],
	  "chapter": 16,
	  "searchForm": "dokeo"
	}, {
	  "latin": "ὁ δόλος",
	  "info": "",
	  "definitions": ["list, bedrog"],
	  "chapter": 4,
	  "searchForm": "dolos"
	}, {
	  "latin": "τὸ δόρυ, δόρατος",
	  "info": "",
	  "definitions": ["lans"],
	  "chapter": 6,
	  "searchForm": "doru, doratos"
	}, {
	  "latin": "ὁ δοῦλος",
	  "info": "",
	  "definitions": ["slaaf"],
	  "chapter": 22,
	  "searchForm": "doulos"
	}, {
	  "latin": "δράω",
	  "info": "",
	  "definitions": ["doen, handelen"],
	  "chapter": 19,
	  "searchForm": "drao"
	}, {
	  "latin": "δυνατός",
	  "info": "",
	  "definitions": ["in staat", "mogelijk"],
	  "chapter": 23,
	  "searchForm": "dunatos"
	}, {
	  "latin": "δύο",
	  "info": "telwoord",
	  "definitions": ["twee"],
	  "chapter": 14,
	  "searchForm": "duo"
	}, {
	  "latin": "δύομαι",
	  "info": "",
	  "definitions": ["duiken (in), ondergaan", "aantrekken"],
	  "chapter": 33,
	  "searchForm": "duomai"
	}, {
	  "latin": "τὸ δῶρον",
	  "info": "",
	  "definitions": ["geschenk"],
	  "chapter": 7,
	  "searchForm": "doron"
	}, {
	  "latin": "ἐάν (εἰ ἄν)",
	  "info": "+ con",
	  "definitions": ["als, indien"],
	  "chapter": 41,
	  "searchForm": "ean (ei an)"
	}, {
	  "latin": "ἐάω",
	  "info": "",
	  "definitions": ["(toe)laten, toestaan"],
	  "chapter": 19,
	  "searchForm": "eao"
	}, {
	  "latin": "ἐγγύς",
	  "info": "(+ gen)",
	  "definitions": ["dichtbij"],
	  "chapter": 6,
	  "searchForm": "eggus"
	}, {
	  "latin": "ἐγω",
	  "info": "",
	  "definitions": ["ik"],
	  "chapter": 8,
	  "searchForm": "ego"
	}, {
	  "latin": "ἔδεισα",
	  "info": "aor",
	  "definitions": ["ik werd bang (voor)"],
	  "chapter": 27,
	  "searchForm": "edeisa"
	}, {
	  "latin": "εἷς, μία, ἑν, ἑνός",
	  "info": "",
	  "definitions": ["één"],
	  "chapter": 34,
	  "searchForm": "heis, mia, hen, henos"
	}, {
	  "latin": "εὑρίσκω",
	  "info": "",
	  "definitions": ["vinden"],
	  "chapter": 12,
	  "searchForm": "heurisko"
	}, {
	  "latin": "ἐθέλω",
	  "info": "",
	  "definitions": ["willen"],
	  "chapter": 7,
	  "searchForm": "ethelo"
	}, {
	  "latin": "τὸ ἔθνος, ἔθνους",
	  "info": "",
	  "definitions": ["volk"],
	  "chapter": 36,
	  "searchForm": "ethnos, ethnous"
	}, {
	  "latin": "τὸ ἔθος, ἔθους",
	  "info": "",
	  "definitions": ["gewoonte"],
	  "chapter": 36,
	  "searchForm": "ethos, ethous"
	}, {
	  "latin": "εἰ",
	  "info": "voegwoord",
	  "definitions": ["als, indien", "**indirecte vraag** of"],
	  "chapter": 42,
	  "searchForm": "ei"
	}, {
	  "latin": "τὸ εἶδος, εἶδους",
	  "info": "",
	  "definitions": ["gestalte, uiterlijk, vorm, soort"],
	  "chapter": 37,
	  "searchForm": "eidos, eidous"
	}, {
	  "latin": "εἴθε",
	  "info": "+ opt",
	  "definitions": ["moge(n) … (*leidt een wens in*)"],
	  "chapter": 42,
	  "searchForm": "eithe"
	}, {
	  "latin": "εἰκός (ἐστι)",
	  "info": "",
	  "definitions": ["het is hoogstwaarschijnlijk", "het is passend"],
	  "chapter": 44,
	  "searchForm": "eikos (esti)"
	}, {
	  "latin": "ἡ εἰκών, εἰκόνος",
	  "info": "",
	  "definitions": ["beeld, afbeelding"],
	  "chapter": 23,
	  "searchForm": "eikon, eikonos"
	}, {
	  "latin": "εἰμί",
	  "info": "",
	  "definitions": ["zijn, bestaan"],
	  "chapter": 11,
	  "searchForm": "eimi"
	}, {
	  "latin": "εἰς",
	  "info": "+ acc",
	  "definitions": ["naar (binnen)"],
	  "chapter": 4,
	  "searchForm": "eis"
	}, {
	  "latin": "εἰσί(ν)",
	  "info": "",
	  "definitions": ["(zij/er) zijn, bestaan"],
	  "chapter": 2,
	  "searchForm": "eisi(n)"
	}, {
	  "latin": "εἴτε … εἵτε",
	  "info": "",
	  "definitions": ["of … of, hetzij … hetzij"],
	  "chapter": 42,
	  "searchForm": "eite … heite"
	}, {
	  "latin": "ἐκ",
	  "info": "+ gen",
	  "definitions": ["uit"],
	  "chapter": 6,
	  "searchForm": "ek"
	}, {
	  "latin": "ἐκεῖνος, -η, -ο",
	  "info": "",
	  "definitions": ["die, dat"],
	  "chapter": 22,
	  "searchForm": "ekeinos, -e, -o"
	}, {
	  "latin": "ἡ ἐκκλησία",
	  "info": "",
	  "definitions": ["(volks)vergadering"],
	  "chapter": 41,
	  "searchForm": "ekklesia"
	}, {
	  "latin": "ἐλαύνω",
	  "info": "",
	  "definitions": ["(voort)drijven"],
	  "chapter": 39,
	  "searchForm": "elauno"
	}, {
	  "latin": "ἐλπίζω",
	  "info": "",
	  "definitions": ["hopen (op), verwachten"],
	  "chapter": 13,
	  "searchForm": "elpizo"
	}, {
	  "latin": "ἐμέ",
	  "info": "",
	  "definitions": ["me"],
	  "chapter": 8,
	  "searchForm": "eme"
	}, {
	  "latin": "ἐμοί",
	  "info": "",
	  "definitions": ["aan/voor mij"],
	  "chapter": 8,
	  "searchForm": "emoi"
	}, {
	  "latin": "ἐμός, -ή, -όν",
	  "info": "",
	  "definitions": ["mijn, van mij"],
	  "chapter": 41,
	  "searchForm": "emos, -e, -on"
	}, {
	  "latin": "ἐμοῦ",
	  "info": "",
	  "definitions": ["van mij"],
	  "chapter": 8,
	  "searchForm": "emou"
	}, {
	  "latin": "ἐν",
	  "info": "+ dat",
	  "definitions": ["in, op, bij"],
	  "chapter": 7,
	  "searchForm": "en"
	}, {
	  "latin": "ἐν νῷ ἔχω",
	  "info": "",
	  "definitions": ["van plan zijn"],
	  "chapter": 37,
	  "searchForm": "en noi echo"
	}, {
	  "latin": "ἐνθάδε",
	  "info": "",
	  "definitions": ["hier"],
	  "chapter": 39,
	  "searchForm": "enthade"
	}, {
	  "latin": "ὁ ἐνιαυτός",
	  "info": "",
	  "definitions": ["jaar"],
	  "chapter": 26,
	  "searchForm": "eniautos"
	}, {
	  "latin": "ἐνίοτε",
	  "info": "",
	  "definitions": ["soms"],
	  "chapter": 24,
	  "searchForm": "eniote"
	}, {
	  "latin": "ἐνταῦθα",
	  "info": "bijw",
	  "definitions": ["daar"],
	  "chapter": 2,
	  "searchForm": "entautha"
	}, {
	  "latin": "ἐντυγχάνω",
	  "info": "+ dat",
	  "definitions": ["tegenkomen, ontmoeten"],
	  "chapter": 27,
	  "searchForm": "entugchano"
	}, {
	  "latin": "ἐξ",
	  "info": "+ gen",
	  "definitions": ["uit"],
	  "chapter": 6,
	  "searchForm": "ex"
	}, {
	  "latin": "ἐξαίφνης",
	  "info": "bijw",
	  "definitions": ["plotseling"],
	  "chapter": 14,
	  "searchForm": "exaifnes"
	}, {
	  "latin": "ἔξεστι(ν)",
	  "info": "+ inf",
	  "definitions": ["het is mogelijk om"],
	  "chapter": 17,
	  "searchForm": "exesti(n)"
	}, {
	  "latin": "ἔξω",
	  "info": "+ gen",
	  "definitions": ["buiten"],
	  "chapter": 38,
	  "searchForm": "exo"
	}, {
	  "latin": "ἐπ’",
	  "info": "+ dat",
	  "definitions": ["aan, bij"],
	  "chapter": 8,
	  "searchForm": "ep’"
	}, {
	  "latin": "ἐπ’",
	  "info": "+ gen",
	  "definitions": ["op", "tijdens"],
	  "chapter": 12,
	  "searchForm": "ep’"
	}, {
	  "latin": "ἐπ’",
	  "info": "+ acc",
	  "definitions": ["op … af, naar", "gedurende"],
	  "chapter": 31,
	  "searchForm": "ep’"
	}, {
	  "latin": "ἐπεί",
	  "info": "voegwoord",
	  "definitions": ["toen, nadat", "omdat, aangezien"],
	  "chapter": 12,
	  "searchForm": "epei"
	}, {
	  "latin": "ἐπειδάν",
	  "info": "+ con",
	  "definitions": ["nadat"],
	  "chapter": 41,
	  "searchForm": "epeidan"
	}, {
	  "latin": "ἐπειδή",
	  "info": "voegwoord",
	  "definitions": ["toen, nadat", "omdat, aangezien"],
	  "chapter": 12,
	  "searchForm": "epeide"
	}, {
	  "latin": "ἔπειτα",
	  "info": "bijw",
	  "definitions": ["daarna"],
	  "chapter": 2,
	  "searchForm": "epeita"
	}, {
	  "latin": "ἐπί",
	  "info": "+ dat",
	  "definitions": ["aan, bij"],
	  "chapter": 8,
	  "searchForm": "epi"
	}, {
	  "latin": "ἐπί",
	  "info": "+ gen",
	  "definitions": ["op", "tijdens"],
	  "chapter": 12,
	  "searchForm": "epi"
	}, {
	  "latin": "ἐπί",
	  "info": "+ acc",
	  "definitions": ["op … af, naar", "gedurende"],
	  "chapter": 31,
	  "searchForm": "epi"
	}, {
	  "latin": "ἐπιθυμέω",
	  "info": "",
	  "definitions": ["**+ gen** verlangen naar", "**+ inf** ernaar verlangen om"],
	  "chapter": 17,
	  "searchForm": "epithumeo"
	}, {
	  "latin": "ἡ ἐπιμέλεια",
	  "info": "",
	  "definitions": ["zorg, aandacht"],
	  "chapter": 38,
	  "searchForm": "epimeleia"
	}, {
	  "latin": "ἡ ἐπιστολή",
	  "info": "",
	  "definitions": ["brief"],
	  "chapter": 29,
	  "searchForm": "epistole"
	}, {
	  "latin": "ἐπιχειρέω",
	  "info": "+ dat",
	  "definitions": ["aanvallen"],
	  "chapter": 39,
	  "searchForm": "epicheireo"
	}, {
	  "latin": "τὸ ἔπος, ἔπους",
	  "info": "",
	  "definitions": ["woord, uitspraak, verhaal"],
	  "chapter": 38,
	  "searchForm": "epos, epous"
	}, {
	  "latin": "τὸ ἔργον",
	  "info": "",
	  "definitions": ["werk, taak", "daad"],
	  "chapter": 2,
	  "searchForm": "ergon"
	}, {
	  "latin": "ἔρημος, -ον",
	  "info": "",
	  "definitions": ["eenzaam, verlaten", "**+ gen** beroofd van, zonder"],
	  "chapter": 29,
	  "searchForm": "eremos, -on"
	}, {
	  "latin": "ἔρχομαι",
	  "info": "",
	  "definitions": ["gaan, komen"],
	  "chapter": 31,
	  "searchForm": "erchomai"
	}, {
	  "latin": "ὁ ἔρως, ἔρωτος",
	  "info": "",
	  "definitions": ["liefde, begeerte"],
	  "chapter": 27,
	  "searchForm": "eros, erotos"
	}, {
	  "latin": "ἐρωτάω",
	  "info": "",
	  "definitions": ["vragen"],
	  "chapter": 16,
	  "searchForm": "erotao"
	}, {
	  "latin": "ἡ ἐσθής, ἐσθῆτος",
	  "info": "",
	  "definitions": ["kleding(stuk)"],
	  "chapter": 6,
	  "searchForm": "esthes, esthetos"
	}, {
	  "latin": "ἐσθίω",
	  "info": "",
	  "definitions": ["eten"],
	  "chapter": 18,
	  "searchForm": "esthio"
	}, {
	  "latin": "ἐστί(ν)",
	  "info": "",
	  "definitions": ["(hij/zij/het/er) is, bestaat"],
	  "chapter": 2,
	  "searchForm": "esti(n)"
	}, {
	  "latin": "ἔτι",
	  "info": "",
	  "definitions": ["nog"],
	  "chapter": 11,
	  "searchForm": "eti"
	}, {
	  "latin": "τὸ ἔτος, ἔτους",
	  "info": "",
	  "definitions": ["jaar"],
	  "chapter": 38,
	  "searchForm": "etos, etous"
	}, {
	  "latin": "εὖ",
	  "info": "bijw",
	  "definitions": ["goed"],
	  "chapter": 32,
	  "searchForm": "eu"
	}, {
	  "latin": "εὐδαίμων, -ον",
	  "info": "",
	  "definitions": ["gelukkig"],
	  "chapter": 44,
	  "searchForm": "eudaimon, -on"
	}, {
	  "latin": "εὐθύς",
	  "info": "bijw",
	  "definitions": ["onmiddellijk"],
	  "chapter": 18,
	  "searchForm": "euthus"
	}, {
	  "latin": "ἡ εὔνοια",
	  "info": "",
	  "definitions": ["welwillendheid, goede wil"],
	  "chapter": 42,
	  "searchForm": "eunoia"
	}, {
	  "latin": "εὐρύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["breed"],
	  "chapter": 23,
	  "searchForm": "eurus, -eia, -u"
	}, {
	  "latin": "εὔχομαι",
	  "info": "",
	  "definitions": ["bidden, wensen"],
	  "chapter": 36,
	  "searchForm": "euchomai"
	}, {
	  "latin": "ἐφ’",
	  "info": "+ dat",
	  "definitions": ["aan, bij"],
	  "chapter": 8,
	  "searchForm": "ef’"
	}, {
	  "latin": "ἐφ’",
	  "info": "+ gen",
	  "definitions": ["op", "tijdens"],
	  "chapter": 12,
	  "searchForm": "ef’"
	}, {
	  "latin": "ἐφ’",
	  "info": "+ acc",
	  "definitions": ["op … af, naar", "gedurende"],
	  "chapter": 31,
	  "searchForm": "ef’"
	}, {
	  "latin": "ἔχω",
	  "info": "",
	  "definitions": ["hebben, houden"],
	  "chapter": 4,
	  "searchForm": "echo"
	}, {
	  "latin": "ζητέω",
	  "info": "",
	  "definitions": ["zoeken"],
	  "chapter": 16,
	  "searchForm": "zeteo"
	}, {
	  "latin": "ἤ",
	  "info": "",
	  "definitions": ["of", "**vergelijking** dan"],
	  "chapter": 22,
	  "searchForm": "e"
	}, {
	  "latin": "ἤδη",
	  "info": "bijw",
	  "definitions": ["al, reeds", "(vanaf) nu"],
	  "chapter": 6,
	  "searchForm": "ede"
	}, {
	  "latin": "ἦλθον",
	  "info": "aor",
	  "definitions": ["ik kwam, ik ging"],
	  "chapter": 27,
	  "searchForm": "elthon"
	}, {
	  "latin": "αἱρέομαι",
	  "info": "",
	  "definitions": ["kiezen"],
	  "chapter": 32,
	  "searchForm": "haireomai"
	}, {
	  "latin": "αἱρέω",
	  "info": "",
	  "definitions": ["grijpen, pakken"],
	  "chapter": 14,
	  "searchForm": "aἱreo"
	}, {
	  "latin": "ἁλίσκομαι",
	  "info": "",
	  "definitions": ["gevangen genomen worden", "betrapt worden"],
	  "chapter": 33,
	  "searchForm": "haliskomai"
	}, {
	  "latin": "ἅμ’",
	  "info": "(+ dat)",
	  "definitions": ["tegelijk (met)"],
	  "chapter": 32,
	  "searchForm": "ham’"
	}, {
	  "latin": "ἅμα",
	  "info": "(+ dat)",
	  "definitions": ["tegelijk (met)"],
	  "chapter": 32,
	  "searchForm": "hama"
	}, {
	  "latin": "ἁμαρτάνω",
	  "info": "",
	  "definitions": ["**+ gen** (het doel) missen", "zich vergissen"],
	  "chapter": 22,
	  "searchForm": "hamartano"
	}, {
	  "latin": "ἅπτομαι",
	  "info": "+ gen",
	  "definitions": ["vastpakken, aanraken"],
	  "chapter": 32,
	  "searchForm": "haptomai"
	}, {
	  "latin": "τὸ ἅρμα, ἅρματος",
	  "info": "",
	  "definitions": ["(strijd)wagen"],
	  "chapter": 31,
	  "searchForm": "harma, harmatos"
	}, {
	  "latin": "ἁρπάζω",
	  "info": "",
	  "definitions": ["roven"],
	  "chapter": 9,
	  "searchForm": "harpazo"
	}, {
	  "latin": "ἅτε",
	  "info": "+ ptc",
	  "definitions": ["omdat, aangezien"],
	  "chapter": 26,
	  "searchForm": "hate"
	}, {
	  "latin": "ἑαυτοῦ, ἑαυτῆς, ἑαυτοῦ",
	  "info": "",
	  "definitions": ["*gen/dat/acc* zichzelf"],
	  "chapter": 28,
	  "searchForm": "heautou, heautes, heautou"
	}, {
	  "latin": "ἕκαστος, -η, -ον",
	  "info": "",
	  "definitions": ["ieder, elk"],
	  "chapter": 22,
	  "searchForm": "hekastos, -e, -on"
	}, {
	  "latin": "ἑκών, ἑκοῦσα, ἑκόν, ἑκόντος",
	  "info": "",
	  "definitions": ["vrijwillig, expres"],
	  "chapter": 23,
	  "searchForm": "hekon, hekousa, hekon, hekontos"
	}, {
	  "latin": "ἡ Ἑλλάς, Ἑλλάδος ",
	  "info": "",
	  "definitions": ["Griekenland"],
	  "chapter": 8,
	  "searchForm": "Hellas, Hellados "
	}, {
	  "latin": "ὁ Ἕλλην, Ἕλληνος",
	  "info": "",
	  "definitions": ["Griek"],
	  "chapter": 6,
	  "searchForm": "Hellen, Hellenos"
	}, {
	  "latin": "Ἑλληνικός, -ή, -όν",
	  "info": "",
	  "definitions": ["Grieks"],
	  "chapter": 39,
	  "searchForm": "Hellenikos, -e, -on"
	}, {
	  "latin": "ἕνεκα",
	  "info": "+ gen",
	  "definitions": ["wegens, omwille van"],
	  "chapter": 43,
	  "searchForm": "heneka"
	}, {
	  "latin": "ἕξ",
	  "info": "telwoord",
	  "definitions": ["zes"],
	  "chapter": 26,
	  "searchForm": "hex"
	}, {
	  "latin": "ἕπομαι",
	  "info": "+ dat",
	  "definitions": ["volgen, meegaan met"],
	  "chapter": 31,
	  "searchForm": "hepomai"
	}, {
	  "latin": "ἡ ἑσπέρα",
	  "info": "",
	  "definitions": ["avond"],
	  "chapter": 36,
	  "searchForm": "hespera"
	}, {
	  "latin": "ὁ ἑταῖρος ",
	  "info": "",
	  "definitions": ["makker, vriend"],
	  "chapter": 24,
	  "searchForm": "hetairos "
	}, {
	  "latin": "ἕτοιμος, -η, -ον",
	  "info": "",
	  "definitions": ["gereed, bereid"],
	  "chapter": 28,
	  "searchForm": "hetoimos, -e, -on"
	}, {
	  "latin": "ἡ",
	  "info": "",
	  "definitions": ["de, het"],
	  "chapter": 2,
	  "searchForm": "he"
	}, {
	  "latin": "ὁ ἡγεμών, ἡγεμόνος",
	  "info": "",
	  "definitions": ["leider, aanvoerder"],
	  "chapter": 6,
	  "searchForm": "hegemon, hegemonos"
	}, {
	  "latin": "ἡγέομαι",
	  "info": "",
	  "definitions": ["menen, beschouwen als"],
	  "chapter": 36,
	  "searchForm": "hegeomai"
	}, {
	  "latin": "ἡδέως",
	  "info": "bijw",
	  "definitions": ["graag"],
	  "chapter": 37,
	  "searchForm": "hedeos"
	}, {
	  "latin": "ἥδομαι",
	  "info": "(+ dat)",
	  "definitions": ["zich verheugen (over)"],
	  "chapter": 33,
	  "searchForm": "hedomai"
	}, {
	  "latin": "ἡ ἡδονή",
	  "info": "",
	  "definitions": ["genot, vreugde"],
	  "chapter": 24,
	  "searchForm": "hedone"
	}, {
	  "latin": "ἡδύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["aangenaam, fijn"],
	  "chapter": 23,
	  "searchForm": "hedus, -eia, -u"
	}, {
	  "latin": "ἥκω",
	  "info": "",
	  "definitions": ["komen, gekomen zijn"],
	  "chapter": 9,
	  "searchForm": "heko"
	}, {
	  "latin": "ὁ ἥλιος",
	  "info": "",
	  "definitions": ["zon"],
	  "chapter": 3,
	  "searchForm": "helios"
	}, {
	  "latin": "ἧμαι",
	  "info": "",
	  "definitions": ["zitten"],
	  "chapter": 38,
	  "searchForm": "hemai"
	}, {
	  "latin": "ἡμᾶς",
	  "info": "",
	  "definitions": ["ons"],
	  "chapter": 8,
	  "searchForm": "hemas"
	}, {
	  "latin": "ἡμεῖς",
	  "info": "",
	  "definitions": ["wij"],
	  "chapter": 8,
	  "searchForm": "hemeis"
	}, {
	  "latin": "ἡ ἡμέρα",
	  "info": "",
	  "definitions": ["dag"],
	  "chapter": 24,
	  "searchForm": "hemera"
	}, {
	  "latin": "ἡμέτερος, -α, -ον",
	  "info": "",
	  "definitions": ["onze, van ons"],
	  "chapter": 21,
	  "searchForm": "hemeteros, -a, -on"
	}, {
	  "latin": "ἡμῖν",
	  "info": "",
	  "definitions": ["aan/voor ons"],
	  "chapter": 8,
	  "searchForm": "hemin"
	}, {
	  "latin": "τὸ ἥμισυ",
	  "info": "",
	  "definitions": ["de helft"],
	  "chapter": 26,
	  "searchForm": "hemisu"
	}, {
	  "latin": "ἡμῶν",
	  "info": "",
	  "definitions": ["van ons"],
	  "chapter": 8,
	  "searchForm": "hemon"
	}, {
	  "latin": "ὁ ἥρως, ἥρωος",
	  "info": "",
	  "definitions": ["held"],
	  "chapter": 7,
	  "searchForm": "heros, heroos"
	}, {
	  "latin": "ἥττων, ἥττονος",
	  "info": "",
	  "definitions": ["zwakker, minder"],
	  "chapter": 32,
	  "searchForm": "hetton, hettonos"
	}, {
	  "latin": "τὸ ἱερόν",
	  "info": "",
	  "definitions": ["heiligdom"],
	  "chapter": 43,
	  "searchForm": "hieron"
	}, {
	  "latin": "ἱκανός, -ή, -όν",
	  "info": "",
	  "definitions": ["voldoende, geschikt"],
	  "chapter": 38,
	  "searchForm": "hikanos, -e, -on"
	}, {
	  "latin": "ἱκετεύω",
	  "info": "",
	  "definitions": ["smeken"],
	  "chapter": 23,
	  "searchForm": "hiketeuo"
	}, {
	  "latin": "ἵνα",
	  "info": "+ con",
	  "definitions": ["(met de bedoeling) dat, om te"],
	  "chapter": 41,
	  "searchForm": "hina"
	}, {
	  "latin": "ὁ ἵππος ",
	  "info": "",
	  "definitions": ["paard"],
	  "chapter": 3,
	  "searchForm": "hippos"
	}, {
	  "latin": "ὁ",
	  "info": "",
	  "definitions": ["de, het"],
	  "chapter": 2,
	  "searchForm": "ho"
	}, {
	  "latin": "ὅδε, ἥδε, τόδε",
	  "info": "",
	  "definitions": ["deze, dit"],
	  "chapter": 22,
	  "searchForm": "hode, hede, tode"
	}, {
	  "latin": "ἡ ὁδός",
	  "info": "",
	  "definitions": ["weg", "tocht"],
	  "chapter": 9,
	  "searchForm": "hodos"
	}, {
	  "latin": "οἱ μέν … οἱ δέ …",
	  "info": "mv",
	  "definitions": ["sommigen … anderen …"],
	  "chapter": 14,
	  "searchForm": "hoi men … hoi de …"
	}, {
	  "latin": "ὅλος, -η, -ον",
	  "info": "",
	  "definitions": ["(ge)heel, volledig"],
	  "chapter": 34,
	  "searchForm": "holos, -e, -on"
	}, {
	  "latin": "ὅμοιος",
	  "info": "",
	  "definitions": ["lijkend op, gelijk aan"],
	  "chapter": 24,
	  "searchForm": "homoios"
	}, {
	  "latin": "ὁμολογέω",
	  "info": "(+ dat)",
	  "definitions": ["het eens zijn (met)"],
	  "chapter": 23,
	  "searchForm": "homologeo"
	}, {
	  "latin": "ὅμως",
	  "info": "bijw",
	  "definitions": ["toch"],
	  "chapter": 29,
	  "searchForm": "homos"
	}, {
	  "latin": "ὁπόταν (ὁπότε ἄν)",
	  "info": "+ con",
	  "definitions": ["(telkens) wanneer"],
	  "chapter": 44,
	  "searchForm": "hopotan"
	}, {
	  "latin": "ὁπότε",
	  "info": "",
	  "definitions": ["wanneer, toen"],
	  "chapter": 44,
	  "searchForm": "hopote"
	}, {
	  "latin": "ὅπως",
	  "info": "+ con",
	  "definitions": ["(met de bedoeling) dat, om te"],
	  "chapter": 41,
	  "searchForm": "hopos"
	}, {
	  "latin": "ὁράω",
	  "info": "",
	  "definitions": ["zien"],
	  "chapter": 12,
	  "searchForm": "horao"
	}, {
	  "latin": "ὅς, ἥ, ὅ",
	  "info": "",
	  "definitions": ["die, dat"],
	  "chapter": 38,
	  "searchForm": "hos, he, ho"
	}, {
	  "latin": "ὅταν (ὅτε ἄν)",
	  "info": "+ con",
	  "definitions": ["(telkens) wanneer"],
	  "chapter": 41,
	  "searchForm": "hotan (hote an)"
	}, {
	  "latin": "ὅτε",
	  "info": "voegwoord",
	  "definitions": ["wanneer, toen, nu"],
	  "chapter": 24,
	  "searchForm": "hote"
	}, {
	  "latin": "ὅτι",
	  "info": "",
	  "definitions": ["dat", "omdat"],
	  "chapter": 11,
	  "searchForm": "hoti"
	}, {
	  "latin": "ὑγιής, -ές",
	  "info": "",
	  "definitions": ["gezond"],
	  "chapter": 42,
	  "searchForm": "hugies, -es"
	}, {
	  "latin": "τὸ ὕδωρ, ὕδατος",
	  "info": "",
	  "definitions": ["water"],
	  "chapter": 14,
	  "searchForm": "hudor, hudatos"
	}, {
	  "latin": "ὑμᾶς",
	  "info": "",
	  "definitions": ["jullie"],
	  "chapter": 8,
	  "searchForm": "humas"
	}, {
	  "latin": "ὑμεῖς",
	  "info": "",
	  "definitions": ["jullie"],
	  "chapter": 8,
	  "searchForm": "humeis"
	}, {
	  "latin": "ὑμέτερος, -α, -ον",
	  "info": "",
	  "definitions": ["jullie, van jullie"],
	  "chapter": 38,
	  "searchForm": "humeteros, -a, -on"
	}, {
	  "latin": "ὑμῖν",
	  "info": "",
	  "definitions": ["aan/voor jullie"],
	  "chapter": 8,
	  "searchForm": "humin"
	}, {
	  "latin": "ὑμῶν",
	  "info": "",
	  "definitions": ["van jullie"],
	  "chapter": 8,
	  "searchForm": "humon"
	}, {
	  "latin": "ὑπ’",
	  "info": "+ gen",
	  "definitions": ["onder", "**+ pass** door"],
	  "chapter": 32,
	  "searchForm": "hup’"
	}, {
	  "latin": "ὑπέρ",
	  "info": "+ gen",
	  "definitions": ["boven"],
	  "chapter": 16,
	  "searchForm": "huper"
	}, {
	  "latin": "ὑπέρ",
	  "info": "+ acc",
	  "definitions": ["over, aan de overzijde van", "boven, te boven gaand"],
	  "chapter": 27,
	  "searchForm": "huper"
	}, {
	  "latin": "ὑπερβάλλω",
	  "info": "",
	  "definitions": ["overtreffen"],
	  "chapter": 38,
	  "searchForm": "huperballo"
	}, {
	  "latin": "ὑπισχνέομαι",
	  "info": "",
	  "definitions": ["beloven"],
	  "chapter": 31,
	  "searchForm": "hupischneomai"
	}, {
	  "latin": "ὁ ὕπνος",
	  "info": "",
	  "definitions": ["slaap"],
	  "chapter": 44,
	  "searchForm": "hupnos"
	}, {
	  "latin": "ὑπό",
	  "info": "+ gen",
	  "definitions": ["onder", "**+ pass** door"],
	  "chapter": 32,
	  "searchForm": "hupo"
	}, {
	  "latin": "ὑστερον",
	  "info": "bijw",
	  "definitions": ["later"],
	  "chapter": 36,
	  "searchForm": "husteron"
	}, {
	  "latin": "ὑφ’",
	  "info": "+ gen",
	  "definitions": ["onder", "**+ pass** door"],
	  "chapter": 32,
	  "searchForm": "huf’"
	}, {
	  "latin": "ὑψηλός, -ή, -όν",
	  "info": "",
	  "definitions": ["hoog"],
	  "chapter": 21,
	  "searchForm": "hupselos, -e, -on"
	}, {
	  "latin": "ἡ ὥρα",
	  "info": "",
	  "definitions": ["seizoen", "uur, tijd van de dag"],
	  "chapter": 41,
	  "searchForm": "hora"
	}, {
	  "latin": "ὡς",
	  "info": "",
	  "definitions": ["zo(als)", "hoe, wat (*in een uitroep*)"],
	  "chapter": 22,
	  "searchForm": "hos"
	}, {
	  "latin": "ὡς",
	  "info": "voegwoord",
	  "definitions": ["dat"],
	  "chapter": 34,
	  "searchForm": "hos"
	}, {
	  "latin": "ὡς τάχιστα",
	  "info": "",
	  "definitions": ["**bijw** zo snel mogelijk", "**voegw** zodra"],
	  "chapter": 7,
	  "searchForm": "hos tachista"
	}, {
	  "latin": "ὥσπερ",
	  "info": "",
	  "definitions": ["(net) zoals", "net alsof"],
	  "chapter": 32,
	  "searchForm": "hosper"
	}, {
	  "latin": "ἡ θάλαττα",
	  "info": "",
	  "definitions": ["zee"],
	  "chapter": 8,
	  "searchForm": "thalatta"
	}, {
	  "latin": "ὁ θάνατος",
	  "info": "",
	  "definitions": ["de dood"],
	  "chapter": 14,
	  "searchForm": "thanatos"
	}, {
	  "latin": "θάπτω",
	  "info": "",
	  "definitions": ["begraven"],
	  "chapter": 29,
	  "searchForm": "thapto"
	}, {
	  "latin": "θαυμάζω",
	  "info": "",
	  "definitions": ["bewonderen", "zich verwonderen over"],
	  "chapter": 14,
	  "searchForm": "thaumazo"
	}, {
	  "latin": "θαυμαστός, -ή, -όν",
	  "info": "",
	  "definitions": ["wonderlijk, bijzonder"],
	  "chapter": 21,
	  "searchForm": "thaumastos, -e, -on"
	}, {
	  "latin": "ἡ θεά",
	  "info": "",
	  "definitions": ["godin"],
	  "chapter": 2,
	  "searchForm": "thea"
	}, {
	  "latin": "θεάομαι",
	  "info": "",
	  "definitions": ["bekijken, beschouwen"],
	  "chapter": 32,
	  "searchForm": "theaomai"
	}, {
	  "latin": "ὁ θεός",
	  "info": "",
	  "definitions": ["god"],
	  "chapter": 2,
	  "searchForm": "theos"
	}, {
	  "latin": "θερμός, -ή, -όν",
	  "info": "",
	  "definitions": ["warm"],
	  "chapter": 24,
	  "searchForm": "thermos, -e, -on"
	}, {
	  "latin": "τὸ θηρίον",
	  "info": "",
	  "definitions": ["(wild) dier"],
	  "chapter": 3,
	  "searchForm": "therion"
	}, {
	  "latin": "θνῄσκω",
	  "info": "",
	  "definitions": ["sterven, omkomen"],
	  "chapter": 12,
	  "searchForm": "thneisko"
	}, {
	  "latin": "ὁ θρόνος ",
	  "info": "",
	  "definitions": ["troon"],
	  "chapter": 4,
	  "searchForm": "thronos "
	}, {
	  "latin": "ἡ θυγάτηρ, θυγατρός",
	  "info": "",
	  "definitions": ["dochter"],
	  "chapter": 6,
	  "searchForm": "thugater, thugatros"
	}, {
	  "latin": "θύω",
	  "info": "",
	  "definitions": ["offeren"],
	  "chapter": 17,
	  "searchForm": "thuo"
	}, {
	  "latin": "ἴδιος, -α, -ον",
	  "info": "",
	  "definitions": ["eigen"],
	  "chapter": 39,
	  "searchForm": "idios, -a, -on"
	}, {
	  "latin": "ἰδού",
	  "info": "",
	  "definitions": ["zie daar"],
	  "chapter": 32,
	  "searchForm": "idou"
	}, {
	  "latin": "ἰσχυρός, -ά, -όν",
	  "info": "",
	  "definitions": ["krachtig, sterk"],
	  "chapter": 22,
	  "searchForm": "ischuros, -a, -on"
	}, {
	  "latin": "ἡ ἰσχύς, ἰσχύος",
	  "info": "",
	  "definitions": ["kracht"],
	  "chapter": 34,
	  "searchForm": "ischus, ischuos"
	}, {
	  "latin": "ἴσως",
	  "info": "bijw",
	  "definitions": ["misschien"],
	  "chapter": 34,
	  "searchForm": "isos"
	}, {
	  "latin": "καθ’",
	  "info": "+ acc",
	  "definitions": ["(verspreid) over", "overeenkomstig"],
	  "chapter": 9,
	  "searchForm": "kath’"
	}, {
	  "latin": "καθαρός, -ά, -όν",
	  "info": "",
	  "definitions": ["schoon, zuiver"],
	  "chapter": 22,
	  "searchForm": "katharos, -a, -on"
	}, {
	  "latin": "καί",
	  "info": "",
	  "definitions": ["en", "ook, zelfs"],
	  "chapter": 2,
	  "searchForm": "kai"
	}, {
	  "latin": "καί … καί",
	  "info": "",
	  "definitions": ["zowel … als"],
	  "chapter": 31,
	  "searchForm": "kai … kai"
	}, {
	  "latin": "καὶ δὴ καί",
	  "info": "",
	  "definitions": ["en ook, en vooral"],
	  "chapter": 16,
	  "searchForm": "kai de kai"
	}, {
	  "latin": "καινός, -ή, -όν",
	  "info": "",
	  "definitions": ["nieuw"],
	  "chapter": 33,
	  "searchForm": "kainos, -e, -on"
	}, {
	  "latin": "καίπερ",
	  "info": "+ ptc",
	  "definitions": ["hoewel, ook al"],
	  "chapter": 28,
	  "searchForm": "kaiper"
	}, {
	  "latin": "τὸ κακόν",
	  "info": "",
	  "definitions": ["(het) kwaad, ramp"],
	  "chapter": 38,
	  "searchForm": "kakon"
	}, {
	  "latin": "κακός, -ή, -όν",
	  "info": "",
	  "definitions": ["slecht, laf"],
	  "chapter": 21,
	  "searchForm": "kakos, -e, -on"
	}, {
	  "latin": "καλέω",
	  "info": "",
	  "definitions": ["roepen, noemen"],
	  "chapter": 16,
	  "searchForm": "kaleo"
	}, {
	  "latin": "καλός, -ή, -όν",
	  "info": "",
	  "definitions": ["mooi, goed"],
	  "chapter": 21,
	  "searchForm": "kalos, -e, -on"
	}, {
	  "latin": "ὁ καρπός ",
	  "info": "",
	  "definitions": ["vrucht", "gewas", "opbrengst"],
	  "chapter": 26,
	  "searchForm": "karpos "
	}, {
	  "latin": "καρτερός, -ά, -όν",
	  "info": "",
	  "definitions": ["sterk, krachtig"],
	  "chapter": 34,
	  "searchForm": "karteros, -a, -on"
	}, {
	  "latin": "κατ’",
	  "info": "+ acc",
	  "definitions": ["(verspreid) over", "overeenkomstig"],
	  "chapter": 9,
	  "searchForm": "kat’"
	}, {
	  "latin": "κατ’",
	  "info": "+ gen",
	  "definitions": ["van … af (naar beneden)"],
	  "chapter": 16,
	  "searchForm": "kat’"
	}, {
	  "latin": "κατά",
	  "info": "+ acc",
	  "definitions": ["(verspreid) over", "overeenkomstig"],
	  "chapter": 9,
	  "searchForm": "kata"
	}, {
	  "latin": "κατά",
	  "info": "+ gen",
	  "definitions": ["van … af (naar beneden)"],
	  "chapter": 16,
	  "searchForm": "kata"
	}, {
	  "latin": "κατα-",
	  "info": "voorvoegsel",
	  "definitions": ["naar beneden, neer-"],
	  "chapter": 16,
	  "searchForm": "kata-"
	}, {
	  "latin": "κατέχω",
	  "info": "",
	  "definitions": ["vasthouden, tegenhouden", "in zijn macht houden, beheersen"],
	  "chapter": 27,
	  "searchForm": "katecho"
	}, {
	  "latin": "κατθ’",
	  "info": "+ gen",
	  "definitions": ["van … af (naar beneden)"],
	  "chapter": 16,
	  "searchForm": "katth’"
	}, {
	  "latin": "κατοικέω",
	  "info": "",
	  "definitions": ["gaan (be)wonen"],
	  "chapter": 43,
	  "searchForm": "katoikeo"
	}, {
	  "latin": "κεῖμαι",
	  "info": "",
	  "definitions": ["liggen"],
	  "chapter": 39,
	  "searchForm": "keimai"
	}, {
	  "latin": "κελεύω",
	  "info": "",
	  "definitions": ["bevelen, verzoeken"],
	  "chapter": 18,
	  "searchForm": "keleuo"
	}, {
	  "latin": "κενός, -ή, -όν",
	  "info": "",
	  "definitions": ["leeg"],
	  "chapter": 22,
	  "searchForm": "kenos, -e, -on"
	}, {
	  "latin": "ἡ κεφαλή",
	  "info": "",
	  "definitions": ["hoofd"],
	  "chapter": 6,
	  "searchForm": "kefale"
	}, {
	  "latin": "ὁ κίνδυνος",
	  "info": "",
	  "definitions": ["gevaar"],
	  "chapter": 8,
	  "searchForm": "kindunos"
	}, {
	  "latin": "κινέω",
	  "info": "",
	  "definitions": ["bewegen"],
	  "chapter": 24,
	  "searchForm": "kineo"
	}, {
	  "latin": "κλέπτω",
	  "info": "",
	  "definitions": ["stelen"],
	  "chapter": 18,
	  "searchForm": "klepto"
	}, {
	  "latin": "ἡ κόρη",
	  "info": "",
	  "definitions": ["meisje"],
	  "chapter": 4,
	  "searchForm": "kore"
	}, {
	  "latin": "ὁ κόσμος",
	  "info": "",
	  "definitions": ["wereld(orde)", "sier, opsmuk"],
	  "chapter": 37,
	  "searchForm": "kosmos"
	}, {
	  "latin": "κρατέω",
	  "info": "",
	  "definitions": ["de sterkste zijn", "**+ gen** heersen over"],
	  "chapter": 19,
	  "searchForm": "krateo"
	}, {
	  "latin": "κράτιστος, -η, -ον",
	  "info": "",
	  "definitions": ["sterkst, best"],
	  "chapter": 34,
	  "searchForm": "kratistos, -e, -on"
	}, {
	  "latin": "κρείττων, κρείττονος",
	  "info": "",
	  "definitions": ["sterker, beter"],
	  "chapter": 29,
	  "searchForm": "kreitton, kreittonos"
	}, {
	  "latin": "ἡ κρίσις, κρίσεως",
	  "info": "",
	  "definitions": ["beslissing, oordeel, uitspraak"],
	  "chapter": 41,
	  "searchForm": "krisis, kriseos"
	}, {
	  "latin": "κρύπτω",
	  "info": "",
	  "definitions": ["verbergen"],
	  "chapter": 17,
	  "searchForm": "krupto"
	}, {
	  "latin": "κτάομαι",
	  "info": "",
	  "definitions": ["verwerven"],
	  "chapter": 31,
	  "searchForm": "ktaomai"
	}, {
	  "latin": "κτείνω",
	  "info": "",
	  "definitions": ["doden"],
	  "chapter": 7,
	  "searchForm": "kteino"
	}, {
	  "latin": "ὁ κύων, κυνός",
	  "info": "",
	  "definitions": ["hond"],
	  "chapter": 27,
	  "searchForm": "kuon, kunos"
	}, {
	  "latin": "κωλύω",
	  "info": "",
	  "definitions": ["tegenhouden, verhinderen"],
	  "chapter": 11,
	  "searchForm": "koluo"
	}, {
	  "latin": "λαμβάνω",
	  "info": "",
	  "definitions": ["nemen, krijgen"],
	  "chapter": 11,
	  "searchForm": "lambano"
	}, {
	  "latin": "λαμπρός, -ά, -όν",
	  "info": "",
	  "definitions": ["schitterend"],
	  "chapter": 29,
	  "searchForm": "lampros, -a, -on"
	}, {
	  "latin": "λανθάνω",
	  "info": "",
	  "definitions": ["**+ acc** verborgen zijn voor", "**+ ptc** verborgen blijven bij het …"],
	  "chapter": 38,
	  "searchForm": "lanthano"
	}, {
	  "latin": "λέγω",
	  "info": "",
	  "definitions": ["zeggen, spreken"],
	  "chapter": 3,
	  "searchForm": "lego"
	}, {
	  "latin": "λείπω",
	  "info": "",
	  "definitions": ["verlaten, achterlaten"],
	  "chapter": 12,
	  "searchForm": "leipo"
	}, {
	  "latin": "ὁ λιμήν, λιμένος",
	  "info": "",
	  "definitions": ["haven"],
	  "chapter": 8,
	  "searchForm": "limen, limenos"
	}, {
	  "latin": "λογίζομαι",
	  "info": "",
	  "definitions": ["(be)rekenen", "overwegen, overdenken"],
	  "chapter": 38,
	  "searchForm": "logizomai"
	}, {
	  "latin": "ὁ λόγος",
	  "info": "",
	  "definitions": ["woord, verhaal"],
	  "chapter": 9,
	  "searchForm": "logos"
	}, {
	  "latin": "λυπέω",
	  "info": "",
	  "definitions": ["pijn doen, verdriet doen"],
	  "chapter": 19,
	  "searchForm": "lupeo"
	}, {
	  "latin": "λύω",
	  "info": "",
	  "definitions": ["losmaken, bevrijden"],
	  "chapter": 11,
	  "searchForm": "luo"
	}, {
	  "latin": "μακρός, -ά, -όν",
	  "info": "",
	  "definitions": ["lang"],
	  "chapter": 21,
	  "searchForm": "makros, -a, -on"
	}, {
	  "latin": "μάλ’",
	  "info": "",
	  "definitions": ["zeer, erg"],
	  "chapter": 6,
	  "searchForm": "mal’"
	}, {
	  "latin": "μάλα",
	  "info": "",
	  "definitions": ["zeer, erg"],
	  "chapter": 6,
	  "searchForm": "mala"
	}, {
	  "latin": "μάλιστα",
	  "info": "bijw",
	  "definitions": ["vooral, het meest"],
	  "chapter": 17,
	  "searchForm": "malista"
	}, {
	  "latin": "μᾶλλον",
	  "info": "bijw",
	  "definitions": ["meer, liever, eerder"],
	  "chapter": 41,
	  "searchForm": "mallon"
	}, {
	  "latin": "μανθάνω",
	  "info": "",
	  "definitions": ["leren (kennen), vernemen"],
	  "chapter": 13,
	  "searchForm": "manthano"
	}, {
	  "latin": "ἡ μανία",
	  "info": "",
	  "definitions": ["waanzin, razernij"],
	  "chapter": 44,
	  "searchForm": "mania"
	}, {
	  "latin": "μαρτυρέω",
	  "info": "",
	  "definitions": ["getuigenis afleggen"],
	  "chapter": 44,
	  "searchForm": "martureo"
	}, {
	  "latin": "ἡ μάχη",
	  "info": "",
	  "definitions": ["strijd, gevecht"],
	  "chapter": 2,
	  "searchForm": "mache"
	}, {
	  "latin": "μάχομαι",
	  "info": "(+ dat)",
	  "definitions": ["strijden (met/tegen)"],
	  "chapter": 33,
	  "searchForm": "machomai"
	}, {
	  "latin": "τὸ μέγαρον",
	  "info": "",
	  "definitions": ["(grote) kamer"],
	  "chapter": 29,
	  "searchForm": "megaron"
	}, {
	  "latin": "μέγας, μεγάλη, μέγα",
	  "info": "",
	  "definitions": ["groot"],
	  "chapter": 21,
	  "searchForm": "megas, megale, mega"
	}, {
	  "latin": "τὸ μέγεθος, -ους",
	  "info": "",
	  "definitions": ["grootte, grootheid"],
	  "chapter": 43,
	  "searchForm": "megethos, -ous"
	}, {
	  "latin": "μέγιστος, -η, -ον",
	  "info": "",
	  "definitions": ["het grootste, zeer groot"],
	  "chapter": 24,
	  "searchForm": "megistos, -e, -on"
	}, {
	  "latin": "μεθ’",
	  "info": "+ gen",
	  "definitions": ["(samen) met"],
	  "chapter": 14,
	  "searchForm": "meth’"
	}, {
	  "latin": "μεθ’",
	  "info": "+ acc",
	  "definitions": ["na"],
	  "chapter": 23,
	  "searchForm": "meth’"
	}, {
	  "latin": "μείζων, μείζονος",
	  "info": "",
	  "definitions": ["groter"],
	  "chapter": 32,
	  "searchForm": "meizon, meizonos"
	}, {
	  "latin": "μέλλω",
	  "info": "",
	  "definitions": ["zullen, van plan zijn, op het punt staan"],
	  "chapter": 11,
	  "searchForm": "mello"
	}, {
	  "latin": "μέν … δέ",
	  "info": "",
	  "definitions": ["(weliswaar) … maar", "… en"],
	  "chapter": 3,
	  "searchForm": "men … de"
	}, {
	  "latin": "μέντοι",
	  "info": "",
	  "definitions": ["echter, maar"],
	  "chapter": 28,
	  "searchForm": "mentoi"
	}, {
	  "latin": "μένω",
	  "info": "",
	  "definitions": ["blijven, wachten (op)"],
	  "chapter": 12,
	  "searchForm": "meno"
	}, {
	  "latin": "μέσος, -η, -ον",
	  "info": "",
	  "definitions": ["middelste", "*μέσος ὁ* … het midden van …"],
	  "chapter": 42,
	  "searchForm": "mesos, -e, -on"
	}, {
	  "latin": "μετ’",
	  "info": "+ gen",
	  "definitions": ["(samen) met"],
	  "chapter": 14,
	  "searchForm": "met’"
	}, {
	  "latin": "μετ’",
	  "info": "+ acc",
	  "definitions": ["na"],
	  "chapter": 23,
	  "searchForm": "met’"
	}, {
	  "latin": "μετά",
	  "info": "+ gen",
	  "definitions": ["(samen) met"],
	  "chapter": 14,
	  "searchForm": "meta"
	}, {
	  "latin": "μετά",
	  "info": "+ acc",
	  "definitions": ["na"],
	  "chapter": 23,
	  "searchForm": "meta"
	}, {
	  "latin": "μεταβάλλω",
	  "info": "",
	  "definitions": ["verplaatsen", "veranderen"],
	  "chapter": 26,
	  "searchForm": "metaballo"
	}, {
	  "latin": "μετέχω",
	  "info": "",
	  "definitions": ["deelnemen aan"],
	  "chapter": 11,
	  "searchForm": "metecho"
	}, {
	  "latin": "μέχρι",
	  "info": "+ gen",
	  "definitions": ["tot aan"],
	  "chapter": 27,
	  "searchForm": "mechri"
	}, {
	  "latin": "μή",
	  "info": "+ con",
	  "definitions": ["niet", "(op)dat niet", "**na ww van vrezen** dat"],
	  "chapter": 41,
	  "searchForm": "me"
	}, {
	  "latin": "μηδέ",
	  "info": "+ con/opt",
	  "definitions": ["en niet"],
	  "chapter": 42,
	  "searchForm": "mede"
	}, {
	  "latin": "ἡ μήτηρ, μητρός",
	  "info": "",
	  "definitions": ["moeder"],
	  "chapter": 6,
	  "searchForm": "meter, metros"
	}, {
	  "latin": "μικρός, -ά, -όν",
	  "info": "",
	  "definitions": ["klein"],
	  "chapter": 24,
	  "searchForm": "mikros, -a, -on"
	}, {
	  "latin": "ὁ μισθός",
	  "info": "",
	  "definitions": ["loon, soldij"],
	  "chapter": 31,
	  "searchForm": "misthos"
	}, {
	  "latin": "μόνον",
	  "info": "bijw",
	  "definitions": ["alleen (maar)"],
	  "chapter": 6,
	  "searchForm": "monon"
	}, {
	  "latin": "μόνος, -η, -ον",
	  "info": "",
	  "definitions": ["alleen"],
	  "chapter": 29,
	  "searchForm": "monos, -e, -on"
	}, {
	  "latin": "ὁ μῦθος",
	  "info": "",
	  "definitions": ["verhaal, mythe"],
	  "chapter": 43,
	  "searchForm": "muthos"
	}, {
	  "latin": "ὁ ναός",
	  "info": "",
	  "definitions": ["tempel"],
	  "chapter": 43,
	  "searchForm": "naos"
	}, {
	  "latin": "ἡ ναῦς, νεώς",
	  "info": "",
	  "definitions": ["schip"],
	  "chapter": 36,
	  "searchForm": "naus, neos"
	}, {
	  "latin": "ὁ ναύτης, ναύτου",
	  "info": "",
	  "definitions": ["zeeman"],
	  "chapter": 23,
	  "searchForm": "nautes, nautou"
	}, {
	  "latin": "ὁ νεανίας, -ου",
	  "info": "",
	  "definitions": ["jongeman"],
	  "chapter": 34,
	  "searchForm": "neanias, -ou"
	}, {
	  "latin": "ὁ νεκρός",
	  "info": "",
	  "definitions": ["dode, lijk"],
	  "chapter": 27,
	  "searchForm": "nekros"
	}, {
	  "latin": "νέμω",
	  "info": "",
	  "definitions": ["verdelen, toekennen"],
	  "chapter": 18,
	  "searchForm": "nemo"
	}, {
	  "latin": "νέος, -α, -ον",
	  "info": "",
	  "definitions": ["nieuw, jong"],
	  "chapter": 21,
	  "searchForm": "neos, -a, -on"
	}, {
	  "latin": "νικάω",
	  "info": "",
	  "definitions": ["overwinnen"],
	  "chapter": 17,
	  "searchForm": "nikao"
	}, {
	  "latin": "ἡ νίκη",
	  "info": "",
	  "definitions": ["overwinning"],
	  "chapter": 13,
	  "searchForm": "nike"
	}, {
	  "latin": "νοέω",
	  "info": "",
	  "definitions": ["waarnemen, opmerken"],
	  "chapter": 3,
	  "searchForm": "noeo"
	}, {
	  "latin": "νομίζω",
	  "info": "",
	  "definitions": ["menen", "beschouwen als"],
	  "chapter": 13,
	  "searchForm": "nomizo"
	}, {
	  "latin": "ὁ νόμος",
	  "info": "",
	  "definitions": ["gewoonte, gebruik", "wet"],
	  "chapter": 18,
	  "searchForm": "nomos"
	}, {
	  "latin": "ὁ νοῦς, νοῦ",
	  "info": "",
	  "definitions": ["geest, verstand"],
	  "chapter": 37,
	  "searchForm": "nous, nou"
	}, {
	  "latin": "νυκτός",
	  "info": "gen",
	  "definitions": ["s nachts"],
	  "chapter": 31,
	  "searchForm": "nuktos"
	}, {
	  "latin": "νῦν",
	  "info": "bijw",
	  "definitions": ["nu, op dit moment"],
	  "chapter": 3,
	  "searchForm": "nun"
	}, {
	  "latin": "ἡ νύξ, νυκτός",
	  "info": "",
	  "definitions": ["nacht"],
	  "chapter": 21,
	  "searchForm": "nux, nuktos"
	}, {
	  "latin": "ὁ ξένος ",
	  "info": "",
	  "definitions": ["vreemdeling", "gast", "gastheer"],
	  "chapter": 28,
	  "searchForm": "xenos "
	}, {
	  "latin": "τὸ ξύλον",
	  "info": "",
	  "definitions": ["(voorwerp van) hout"],
	  "chapter": 34,
	  "searchForm": "xulon"
	}, {
	  "latin": "οἷος, -α, -ον τ’ εἰμί",
	  "info": "",
	  "definitions": ["in staat zijn"],
	  "chapter": 34,
	  "searchForm": "hoios, -a, -on t’ eimi"
	}, {
	  "latin": "οὗ",
	  "info": "voegwoord",
	  "definitions": ["waar"],
	  "chapter": 9,
	  "searchForm": "hou"
	}, {
	  "latin": "οὗτος, αὕτη, τοῦτο",
	  "info": "",
	  "definitions": ["die, dat"],
	  "chapter": 22,
	  "searchForm": "houtos, haute, touto"
	}, {
	  "latin": "οὕτω",
	  "info": "",
	  "definitions": ["zo, op deze manier"],
	  "chapter": 4,
	  "searchForm": "houto"
	}, {
	  "latin": "οὕτως ",
	  "info": "",
	  "definitions": ["zo, op deze manier"],
	  "chapter": 4,
	  "searchForm": "houtos "
	}, {
	  "latin": "οἴκαδε",
	  "info": "",
	  "definitions": ["naar huis"],
	  "chapter": 34,
	  "searchForm": "oikade"
	}, {
	  "latin": "ὁ οἰκέτης, -ου",
	  "info": "",
	  "definitions": ["(huis)slaaf"],
	  "chapter": 44,
	  "searchForm": "oiketes, -ou"
	}, {
	  "latin": "οἰκέω",
	  "info": "",
	  "definitions": ["wonen, bewonen"],
	  "chapter": 16,
	  "searchForm": "oikeo"
	}, {
	  "latin": "ἡ οἰκία",
	  "info": "",
	  "definitions": ["huis"],
	  "chapter": 28,
	  "searchForm": "oikia"
	}, {
	  "latin": "ὁ οἶκος",
	  "info": "",
	  "definitions": ["huis, woning, erf"],
	  "chapter": 11,
	  "searchForm": "oikos"
	}, {
	  "latin": "ὁ οἶνος",
	  "info": "",
	  "definitions": ["wijn"],
	  "chapter": 11,
	  "searchForm": "oinos"
	}, {
	  "latin": "οἴομαι",
	  "info": "",
	  "definitions": ["menen, vermoeden"],
	  "chapter": 31,
	  "searchForm": "oiomai"
	}, {
	  "latin": "ὀλίγος, -η, -ον",
	  "info": "",
	  "definitions": ["weinig, gering"],
	  "chapter": 27,
	  "searchForm": "oligos, -e, -on"
	}, {
	  "latin": "τὸ ὄνομα, ὀνόματος",
	  "info": "",
	  "definitions": ["naam"],
	  "chapter": 6,
	  "searchForm": "onoma, onomatos"
	}, {
	  "latin": "ὀνομάζω",
	  "info": "",
	  "definitions": ["noemen"],
	  "chapter": 3,
	  "searchForm": "onomazo"
	}, {
	  "latin": "ὀξύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["scherp, fel"],
	  "chapter": 24,
	  "searchForm": "oxus, -eia, -u"
	}, {
	  "latin": "ἡ ὀργή",
	  "info": "",
	  "definitions": ["woede, drift"],
	  "chapter": 28,
	  "searchForm": "orge"
	}, {
	  "latin": "ὀργίζομαι",
	  "info": "(+ dat)",
	  "definitions": ["boos worden (op/over)"],
	  "chapter": 32,
	  "searchForm": "orgizomai"
	}, {
	  "latin": "ὀργίζω",
	  "info": "",
	  "definitions": ["boos maken"],
	  "chapter": 28,
	  "searchForm": "orgizo"
	}, {
	  "latin": "τὸ ὄρος, -ους",
	  "info": "",
	  "definitions": ["berg, gebergte"],
	  "chapter": 39,
	  "searchForm": "oros, -ous"
	}, {
	  "latin": "οὐ",
	  "info": "",
	  "definitions": ["niet"],
	  "chapter": 2,
	  "searchForm": "ou"
	}, {
	  "latin": "οὐδαμοῦ",
	  "info": "",
	  "definitions": ["nergens"],
	  "chapter": 37,
	  "searchForm": "oudamou"
	}, {
	  "latin": "οὐδαμῶς",
	  "info": "bijw",
	  "definitions": ["volstrekt niet"],
	  "chapter": 36,
	  "searchForm": "oudamos"
	}, {
	  "latin": "οὐδέ",
	  "info": "",
	  "definitions": ["en niet, ook niet, maar niet", "zelfs niet"],
	  "chapter": 24,
	  "searchForm": "oude"
	}, {
	  "latin": "οὐδείς, οὐδενός",
	  "info": "",
	  "definitions": ["niemand"],
	  "chapter": 17,
	  "searchForm": "oudeis, oudenos"
	}, {
	  "latin": "οὐδέν, οὐδενός",
	  "info": "",
	  "definitions": ["niets"],
	  "chapter": 17,
	  "searchForm": "ouden, oudenos"
	}, {
	  "latin": "οὐκ",
	  "info": "",
	  "definitions": ["niet"],
	  "chapter": 2,
	  "searchForm": "ouk"
	}, {
	  "latin": "οὐκέτι",
	  "info": "bijw",
	  "definitions": ["niet meer"],
	  "chapter": 9,
	  "searchForm": "ouketi"
	}, {
	  "latin": "οὖν",
	  "info": "",
	  "definitions": ["dus, dan, nu"],
	  "chapter": 4,
	  "searchForm": "oun"
	}, {
	  "latin": "οὔποτε",
	  "info": "",
	  "definitions": ["nooit"],
	  "chapter": 11,
	  "searchForm": "oupote"
	}, {
	  "latin": "οὔπω",
	  "info": "",
	  "definitions": ["nog niet"],
	  "chapter": 27,
	  "searchForm": "oupo"
	}, {
	  "latin": "ὁ οὐρανός",
	  "info": "",
	  "definitions": ["hemel"],
	  "chapter": 21,
	  "searchForm": "ouranos"
	}, {
	  "latin": "οὐχ",
	  "info": "",
	  "definitions": ["niet"],
	  "chapter": 2,
	  "searchForm": "ouch"
	}, {
	  "latin": "ὀφείλω",
	  "info": "+ inf",
	  "definitions": ["verplicht zijn te"],
	  "chapter": 13,
	  "searchForm": "ofeilo"
	}, {
	  "latin": "ὁ ὀφθαλμός",
	  "info": "",
	  "definitions": ["oog"],
	  "chapter": 24,
	  "searchForm": "ofthalmos"
	}, {
	  "latin": "παιδεύω",
	  "info": "",
	  "definitions": ["opvoeden, opleiden"],
	  "chapter": 38,
	  "searchForm": "paideuo"
	}, {
	  "latin": "ὁ/ἡ παῖς, παιδός",
	  "info": "",
	  "definitions": ["kind"],
	  "chapter": 7,
	  "searchForm": "ho/pais, paidos"
	}, {
	  "latin": "πανταχοῦ",
	  "info": "",
	  "definitions": ["overal"],
	  "chapter": 32,
	  "searchForm": "pantachou"
	}, {
	  "latin": "πάντως",
	  "info": "bijw",
	  "definitions": ["geheel en al, volledig"],
	  "chapter": 37,
	  "searchForm": "pantos"
	}, {
	  "latin": "πάνυ",
	  "info": "bijw",
	  "definitions": ["heel, zeker, volkomen"],
	  "chapter": 37,
	  "searchForm": "panu"
	}, {
	  "latin": "πάρ-ειμι",
	  "info": "",
	  "definitions": ["aanwezig zijn"],
	  "chapter": 14,
	  "searchForm": "par-eimi"
	}, {
	  "latin": "παρ’",
	  "info": "+ dat",
	  "definitions": ["bij, naast"],
	  "chapter": 29,
	  "searchForm": "par’"
	}, {
	  "latin": "παρά",
	  "info": "+ gen",
	  "definitions": ["van (de kant van)"],
	  "chapter": 23,
	  "searchForm": "para"
	}, {
	  "latin": "παρά",
	  "info": "+ dat",
	  "definitions": ["bij, naast"],
	  "chapter": 29,
	  "searchForm": "para"
	}, {
	  "latin": "παραγίγνομαι",
	  "info": "+ dat",
	  "definitions": ["komen bij", "bijstaan"],
	  "chapter": 42,
	  "searchForm": "paragignomai"
	}, {
	  "latin": "παραινέω",
	  "info": "+ dat",
	  "definitions": ["aansporen"],
	  "chapter": 38,
	  "searchForm": "paraineo"
	}, {
	  "latin": "παρακαλέω",
	  "info": "",
	  "definitions": ["erbij roepen, laten komen"],
	  "chapter": 42,
	  "searchForm": "parakaleo"
	}, {
	  "latin": "παρασκευάζω",
	  "info": "",
	  "definitions": ["klaarmaken"],
	  "chapter": 9,
	  "searchForm": "paraskeuazo"
	}, {
	  "latin": "παρέχω",
	  "info": "",
	  "definitions": ["geven, verschaffen"],
	  "chapter": 7,
	  "searchForm": "parecho"
	}, {
	  "latin": "ἡ παρθένος",
	  "info": "",
	  "definitions": ["maagd, ongetrouwde vrouw"],
	  "chapter": 43,
	  "searchForm": "parthenos"
	}, {
	  "latin": "πᾶς, πᾶσα, πᾶν, παντός",
	  "info": "",
	  "definitions": ["**ev** ieder, elk<br>2.* *ev** (ge)heel, al", "**mv** alle(n), alles"],
	  "chapter": 23,
	  "searchForm": "pas, pasa, pan, pantos"
	}, {
	  "latin": "πάσχω",
	  "info": "",
	  "definitions": ["lijden, ondervinden"],
	  "chapter": 13,
	  "searchForm": "pascho"
	}, {
	  "latin": "ὁ πατήρ, πατρός",
	  "info": "",
	  "definitions": ["vader"],
	  "chapter": 6,
	  "searchForm": "pater, patros"
	}, {
	  "latin": "παύομαι",
	  "info": "",
	  "definitions": ["**+ gen** ophouden met", "**+ ptc prs** ophouden te/met"],
	  "chapter": 32,
	  "searchForm": "pauomai"
	}, {
	  "latin": "παύω",
	  "info": "",
	  "definitions": ["doen stoppen, een einde maken aan"],
	  "chapter": 21,
	  "searchForm": "pauo"
	}, {
	  "latin": "τὸ πεδίον",
	  "info": "",
	  "definitions": ["vlakte"],
	  "chapter": 3,
	  "searchForm": "pedion"
	}, {
	  "latin": "πείθομαι",
	  "info": "(+ dat)",
	  "definitions": ["gehoorzamen, geloven"],
	  "chapter": 31,
	  "searchForm": "peithomai"
	}, {
	  "latin": "πείθω",
	  "info": "",
	  "definitions": ["overtuigen, overhalen"],
	  "chapter": 19,
	  "searchForm": "peitho"
	}, {
	  "latin": "πειράομαι",
	  "info": "",
	  "definitions": ["proberen"],
	  "chapter": 44,
	  "searchForm": "peiraomai"
	}, {
	  "latin": "πέμπω",
	  "info": "",
	  "definitions": ["zenden, sturen"],
	  "chapter": 9,
	  "searchForm": "pempo"
	}, {
	  "latin": "πέντε",
	  "info": "telwoord",
	  "definitions": ["vijf"],
	  "chapter": 42,
	  "searchForm": "pente"
	}, {
	  "latin": "περί",
	  "info": "+ gen",
	  "definitions": ["over, om"],
	  "chapter": 9,
	  "searchForm": "peri"
	}, {
	  "latin": "περί",
	  "info": "+ acc",
	  "definitions": ["rondom, om"],
	  "chapter": 13,
	  "searchForm": "peri"
	}, {
	  "latin": "ἡ πέτρα",
	  "info": "",
	  "definitions": ["rots, rotsblok"],
	  "chapter": 2,
	  "searchForm": "petra"
	}, {
	  "latin": "πίνω",
	  "info": "",
	  "definitions": ["drinken"],
	  "chapter": 11,
	  "searchForm": "pino"
	}, {
	  "latin": "πίπτω",
	  "info": "",
	  "definitions": ["vallen"],
	  "chapter": 13,
	  "searchForm": "pipto"
	}, {
	  "latin": "πιστεύω",
	  "info": "+ dat",
	  "definitions": ["geloven, vertrouwen op"],
	  "chapter": 14,
	  "searchForm": "pisteuo"
	}, {
	  "latin": "πλεῖστος, -η, -ον",
	  "info": "",
	  "definitions": ["meest, zeer veel"],
	  "chapter": 39,
	  "searchForm": "pleistos, -e, -on"
	}, {
	  "latin": "πλέω",
	  "info": "",
	  "definitions": ["varen"],
	  "chapter": 36,
	  "searchForm": "pleo"
	}, {
	  "latin": "τὸ πλῆθος, -ους",
	  "info": "",
	  "definitions": ["menigte, massa"],
	  "chapter": 42,
	  "searchForm": "plethos, -ous"
	}, {
	  "latin": "πλήν",
	  "info": "+ gen",
	  "definitions": ["behalve, afgezien van"],
	  "chapter": 28,
	  "searchForm": "plen"
	}, {
	  "latin": "τὸ πλοῖον",
	  "info": "",
	  "definitions": ["vaartuig, schip"],
	  "chapter": 8,
	  "searchForm": "ploion"
	}, {
	  "latin": "πλούσιος, -α, -ον",
	  "info": "",
	  "definitions": ["rijk"],
	  "chapter": 37,
	  "searchForm": "plousios, -a, -on"
	}, {
	  "latin": "τὸ πνεῦμα, πνεύματος",
	  "info": "",
	  "definitions": ["lucht, adem"],
	  "chapter": 16,
	  "searchForm": "pneuma, pneumatos"
	}, {
	  "latin": "ποιέω",
	  "info": "",
	  "definitions": ["maken, doen"],
	  "chapter": 8,
	  "searchForm": "poieo"
	}, {
	  "latin": "ποῖος, -α, -ον",
	  "info": "",
	  "definitions": ["hoedanig, wat voor"],
	  "chapter": 43,
	  "searchForm": "poios, -a, -on"
	}, {
	  "latin": "πολεμέω",
	  "info": "(+ dat)",
	  "definitions": ["oorlog voeren (tegen)"],
	  "chapter": 17,
	  "searchForm": "polemeo"
	}, {
	  "latin": "ὁ πολέμιος",
	  "info": "",
	  "definitions": ["vijand"],
	  "chapter": 39,
	  "searchForm": "polemios"
	}, {
	  "latin": "πολέμιος, -α, -ον",
	  "info": "",
	  "definitions": ["vijandig"],
	  "chapter": 39,
	  "searchForm": "polemios, -a, -on"
	}, {
	  "latin": "ὁ πόλεμος",
	  "info": "",
	  "definitions": ["oorlog"],
	  "chapter": 13,
	  "searchForm": "polemos"
	}, {
	  "latin": "ἡ πόλις, πόλεως",
	  "info": "",
	  "definitions": ["stad, stadstaat"],
	  "chapter": 36,
	  "searchForm": "polis, poleos"
	}, {
	  "latin": "ὁ πολίτης, -ου",
	  "info": "",
	  "definitions": ["burger, medeburger"],
	  "chapter": 34,
	  "searchForm": "polites, -ou"
	}, {
	  "latin": "πολιτικός, -ή, -όν",
	  "info": "",
	  "definitions": ["de burger(s) betreffend, politiek"],
	  "chapter": 41,
	  "searchForm": "politikos, -e, -on"
	}, {
	  "latin": "πολλάκις",
	  "info": "",
	  "definitions": ["vaak"],
	  "chapter": 16,
	  "searchForm": "pollakis"
	}, {
	  "latin": "πολύ",
	  "info": "bijw",
	  "definitions": ["veel"],
	  "chapter": 32,
	  "searchForm": "polu"
	}, {
	  "latin": "πολύς, πολλή, πολύ",
	  "info": "",
	  "definitions": ["veel"],
	  "chapter": 21,
	  "searchForm": "polus, polle, polu"
	}, {
	  "latin": "πονέω",
	  "info": "",
	  "definitions": ["werken, zich inspannen", "pijn hebben, het zwaar hebben"],
	  "chapter": 38,
	  "searchForm": "poneo"
	}, {
	  "latin": "ὁ πόνος",
	  "info": "",
	  "definitions": ["inspanning, moeite", "pijn, nood"],
	  "chapter": 36,
	  "searchForm": "ponos"
	}, {
	  "latin": "πορεύομαι",
	  "info": "",
	  "definitions": ["reizen"],
	  "chapter": 42,
	  "searchForm": "poreuomai"
	}, {
	  "latin": "ὁ ποταμός  ",
	  "info": "",
	  "definitions": ["rivier"],
	  "chapter": 2,
	  "searchForm": "potamos  "
	}, {
	  "latin": "ποτε",
	  "info": "bijw",
	  "definitions": ["eens, ooit"],
	  "chapter": 14,
	  "searchForm": "pote"
	}, {
	  "latin": "ποτός, -ή, -όν",
	  "info": "",
	  "definitions": ["drinkbaar"],
	  "chapter": 43,
	  "searchForm": "potos, -e, -on"
	}, {
	  "latin": "ὁ πούς, ποδός",
	  "info": "",
	  "definitions": ["voet"],
	  "chapter": 21,
	  "searchForm": "pous, podos"
	}, {
	  "latin": "τὸ πρᾶγμα, πράγματος",
	  "info": "",
	  "definitions": ["zaak, gebeurtenis"],
	  "chapter": 6,
	  "searchForm": "pragma, pragmatos"
	}, {
	  "latin": "πράττω",
	  "info": "",
	  "definitions": ["doen, handelen"],
	  "chapter": 11,
	  "searchForm": "pratto"
	}, {
	  "latin": "πρό",
	  "info": "+ gen",
	  "definitions": ["voor (*tijd en plaats*)"],
	  "chapter": 42,
	  "searchForm": "pro"
	}, {
	  "latin": "προάγω",
	  "info": "",
	  "definitions": ["(naar voren) leiden, verder leiden"],
	  "chapter": 42,
	  "searchForm": "proago"
	}, {
	  "latin": "πρός",
	  "info": "+ acc",
	  "definitions": ["naar (toe), tot, tegen"],
	  "chapter": 4,
	  "searchForm": "pros"
	}, {
	  "latin": "πρός",
	  "info": "+ dat",
	  "definitions": ["tegen … aan, dichtbij"],
	  "chapter": 18,
	  "searchForm": "pros"
	}, {
	  "latin": "προσαγορεύω",
	  "info": "",
	  "definitions": ["begroeten, aanspreken"],
	  "chapter": 28,
	  "searchForm": "prosagoreuo"
	}, {
	  "latin": "προσέρχομαι",
	  "info": "(+ dat)",
	  "definitions": ["naderen"],
	  "chapter": 39,
	  "searchForm": "proserchomai"
	}, {
	  "latin": "προσέχω",
	  "info": "",
	  "definitions": ["richten op"],
	  "chapter": 29,
	  "searchForm": "prosecho"
	}, {
	  "latin": "προστάττω",
	  "info": "(+ dat + inf)",
	  "definitions": ["(iemand) opdragen (om)"],
	  "chapter": 38,
	  "searchForm": "prostatto"
	}, {
	  "latin": "τὸ πρόσωπον",
	  "info": "",
	  "definitions": ["gezicht"],
	  "chapter": 32,
	  "searchForm": "prosopon"
	}, {
	  "latin": "πρότερον",
	  "info": "bijw",
	  "definitions": ["eerder"],
	  "chapter": 37,
	  "searchForm": "proteron"
	}, {
	  "latin": "πρῶτον",
	  "info": "bijw",
	  "definitions": ["eerst"],
	  "chapter": 2,
	  "searchForm": "proton"
	}, {
	  "latin": "πρῶτος, -η, -ον",
	  "info": "",
	  "definitions": ["eerste"],
	  "chapter": 29,
	  "searchForm": "protos, -e, -on"
	}, {
	  "latin": "πυνθάνομαι",
	  "info": "",
	  "definitions": ["vernemen", "**prs** vragen naar, informeren naar"],
	  "chapter": 34,
	  "searchForm": "punthanomai"
	}, {
	  "latin": "τὸ πῦρ, πυρός",
	  "info": "",
	  "definitions": ["vuur"],
	  "chapter": 6,
	  "searchForm": "pur, puros"
	}, {
	  "latin": "πωλέω",
	  "info": "",
	  "definitions": ["verkopen"],
	  "chapter": 37,
	  "searchForm": "poleo"
	}, {
	  "latin": "πῶς",
	  "info": "",
	  "definitions": ["hoe"],
	  "chapter": 11,
	  "searchForm": "pos"
	}, {
	  "latin": "ῥᾴδιος, -α, -ον",
	  "info": "",
	  "definitions": ["gemakkelijk"],
	  "chapter": 37,
	  "searchForm": "rhaidios, -a, -on"
	}, {
	  "latin": "ῥέω",
	  "info": "",
	  "definitions": ["stromen"],
	  "chapter": 16,
	  "searchForm": "rheo"
	}, {
	  "latin": "ῥίπτω",
	  "info": "",
	  "definitions": ["werpen"],
	  "chapter": 23,
	  "searchForm": "rhipto"
	}, {
	  "latin": "σαφής, -ές",
	  "info": "",
	  "definitions": ["duidelijk"],
	  "chapter": 37,
	  "searchForm": "safes, -es"
	}, {
	  "latin": "σέ",
	  "info": "",
	  "definitions": ["je"],
	  "chapter": 8,
	  "searchForm": "se"
	}, {
	  "latin": "ἡ σελήνη",
	  "info": "",
	  "definitions": ["maan"],
	  "chapter": 36,
	  "searchForm": "selene"
	}, {
	  "latin": "σημαίνω",
	  "info": "",
	  "definitions": ["duidelijk maken, markeren", "betekenen"],
	  "chapter": 29,
	  "searchForm": "semaino"
	}, {
	  "latin": "ὁ σῖτος",
	  "info": "",
	  "definitions": ["graan, brood", "voedsel"],
	  "chapter": 28,
	  "searchForm": "sitos"
	}, {
	  "latin": "σκοπέω",
	  "info": "",
	  "definitions": ["bekijken, beschouwen"],
	  "chapter": 16,
	  "searchForm": "skopeo"
	}, {
	  "latin": "σοί",
	  "info": "",
	  "definitions": ["aan/voor jou"],
	  "chapter": 8,
	  "searchForm": "soi"
	}, {
	  "latin": "σός, σή, σόν",
	  "info": "",
	  "definitions": ["jouw, uw"],
	  "chapter": 21,
	  "searchForm": "sos, se, son"
	}, {
	  "latin": "σοῦ",
	  "info": "",
	  "definitions": ["van jou"],
	  "chapter": 8,
	  "searchForm": "sou"
	}, {
	  "latin": "ἡ σοφία",
	  "info": "",
	  "definitions": ["(vak)kennis, wijsheid"],
	  "chapter": 8,
	  "searchForm": "sofia"
	}, {
	  "latin": "σοφός, -ή, -όν",
	  "info": "",
	  "definitions": ["wijs, verstandig"],
	  "chapter": 21,
	  "searchForm": "sofos, -e, -on"
	}, {
	  "latin": "ἡ σπουδή",
	  "info": "",
	  "definitions": ["serieuze inspanning", "haast"],
	  "chapter": 36,
	  "searchForm": "spoude"
	}, {
	  "latin": "ὁ στόλος",
	  "info": "",
	  "definitions": ["reis, expeditie"],
	  "chapter": 8,
	  "searchForm": "stolos"
	}, {
	  "latin": "τὸ στόμα, στόματος",
	  "info": "",
	  "definitions": ["mond"],
	  "chapter": 24,
	  "searchForm": "stoma, stomatos"
	}, {
	  "latin": "στρατεύομαι",
	  "info": "",
	  "definitions": ["een veldtocht ondernemen, optrekken"],
	  "chapter": 39,
	  "searchForm": "strateuomai"
	}, {
	  "latin": "ὁ στρατηγός",
	  "info": "",
	  "definitions": ["veldheer, aanvoerder"],
	  "chapter": 39,
	  "searchForm": "strategos"
	}, {
	  "latin": "ἡ στρατιά",
	  "info": "",
	  "definitions": ["leger"],
	  "chapter": 19,
	  "searchForm": "stratia"
	}, {
	  "latin": "ὁ στρατιώτης, -ου",
	  "info": "",
	  "definitions": ["soldaat"],
	  "chapter": 39,
	  "searchForm": "stratiotes, -ou"
	}, {
	  "latin": "σύ",
	  "info": "",
	  "definitions": ["jij"],
	  "chapter": 8,
	  "searchForm": "su"
	}, {
	  "latin": "(ὁ) συγγενής, -ές",
	  "info": "",
	  "definitions": ["verwant"],
	  "chapter": 42,
	  "searchForm": "suggenes, -es"
	}, {
	  "latin": "συλλέγω",
	  "info": "",
	  "definitions": ["verzamelen"],
	  "chapter": 26,
	  "searchForm": "sullego"
	}, {
	  "latin": "συμβουλεύω",
	  "info": "",
	  "definitions": ["raad geven", "**+ inf** aanraden om"],
	  "chapter": 17,
	  "searchForm": "sumbouleuo"
	}, {
	  "latin": "ὁ σύμμαχος",
	  "info": "",
	  "definitions": ["bondgenoot"],
	  "chapter": 39,
	  "searchForm": "summachos"
	}, {
	  "latin": "σύν",
	  "info": "+ dat",
	  "definitions": ["met"],
	  "chapter": 8,
	  "searchForm": "sun"
	}, {
	  "latin": "συν-",
	  "info": "voorvoegsel",
	  "definitions": ["bijeen-, samen-"],
	  "chapter": 41,
	  "searchForm": "sun-"
	}, {
	  "latin": "σφόδρα",
	  "info": "",
	  "definitions": ["hevig, zeer, erg"],
	  "chapter": 16,
	  "searchForm": "sfodra"
	}, {
	  "latin": "σῴζω",
	  "info": "",
	  "definitions": ["redden"],
	  "chapter": 11,
	  "searchForm": "soizo"
	}, {
	  "latin": "τὸ σῶμα, σώματος",
	  "info": "",
	  "definitions": ["lichaam"],
	  "chapter": 13,
	  "searchForm": "soma, somatos"
	}, {
	  "latin": "τὰ ὅπλα",
	  "info": "mv",
	  "definitions": ["wapens"],
	  "chapter": 6,
	  "searchForm": "hopla"
	}, {
	  "latin": "ἡ τάξις, -εως",
	  "info": "",
	  "definitions": ["slagorde, opstelling", "legereenheid"],
	  "chapter": 39,
	  "searchForm": "taxis, -eos"
	}, {
	  "latin": "τάττω",
	  "info": "",
	  "definitions": ["opstellen, ordenen"],
	  "chapter": 18,
	  "searchForm": "tatto"
	}, {
	  "latin": "ὁ ταῦρος",
	  "info": "",
	  "definitions": ["stier"],
	  "chapter": 34,
	  "searchForm": "tauros"
	}, {
	  "latin": "ὁ τάφος",
	  "info": "",
	  "definitions": ["graf", "begrafenis"],
	  "chapter": 29,
	  "searchForm": "tafos"
	}, {
	  "latin": "τάχα",
	  "info": "",
	  "definitions": ["snel, spoedig"],
	  "chapter": 11,
	  "searchForm": "tacha"
	}, {
	  "latin": "ταχύς, -εῖα, -ύ",
	  "info": "",
	  "definitions": ["snel"],
	  "chapter": 23,
	  "searchForm": "tachus, -eia, -u"
	}, {
	  "latin": "τε … καί",
	  "info": "",
	  "definitions": ["en"],
	  "chapter": 21,
	  "searchForm": "te … kai"
	}, {
	  "latin": "τε καί",
	  "info": "",
	  "definitions": ["en"],
	  "chapter": 21,
	  "searchForm": "te kai"
	}, {
	  "latin": "τὸ τέκνον",
	  "info": "",
	  "definitions": ["kind"],
	  "chapter": 4,
	  "searchForm": "teknon"
	}, {
	  "latin": "τελέω",
	  "info": "",
	  "definitions": ["voltooien, afmaken"],
	  "chapter": 19,
	  "searchForm": "teleo"
	}, {
	  "latin": "τέλος",
	  "info": "bijw",
	  "definitions": ["tenslotte"],
	  "chapter": 4,
	  "searchForm": "telos"
	}, {
	  "latin": "τέμνω",
	  "info": "",
	  "definitions": ["snijden"],
	  "chapter": 36,
	  "searchForm": "temno"
	}, {
	  "latin": "τέτταρες, -α",
	  "info": "mv",
	  "definitions": ["vier"],
	  "chapter": 24,
	  "searchForm": "tettares, -a"
	}, {
	  "latin": "ἡ τέχνη",
	  "info": "",
	  "definitions": ["kunst, vaardigheid"],
	  "chapter": 6,
	  "searchForm": "techne"
	}, {
	  "latin": "τί",
	  "info": "",
	  "definitions": ["wat (*nom/acc*)", "waarom"],
	  "chapter": 16,
	  "searchForm": "ti"
	}, {
	  "latin": "τίκτω",
	  "info": "",
	  "definitions": ["ter wereld brengen, voortbrengen"],
	  "chapter": 4,
	  "searchForm": "tikto"
	}, {
	  "latin": "τιμάω",
	  "info": "",
	  "definitions": ["eren, vereren"],
	  "chapter": 16,
	  "searchForm": "timao"
	}, {
	  "latin": "ἡ τιμή",
	  "info": "",
	  "definitions": ["eer, aanzien"],
	  "chapter": 8,
	  "searchForm": "time"
	}, {
	  "latin": "τίς, τί, τίνος",
	  "info": "",
	  "definitions": ["**zelfst** wie, wat", "**bijv** welk(e)"],
	  "chapter": 38,
	  "searchForm": "tis, ti, tinos"
	}, {
	  "latin": "τις, τι, τινος",
	  "info": "",
	  "definitions": ["**zelfst** iemand, iets", "**bijv** een of ander(e), bepaalde"],
	  "chapter": 38,
	  "searchForm": "tis, ti, tinos"
	}, {
	  "latin": "τό",
	  "info": "",
	  "definitions": ["de, het"],
	  "chapter": 2,
	  "searchForm": "to"
	}, {
	  "latin": "τολμάω",
	  "info": "+ inf",
	  "definitions": ["het wagen om, durven"],
	  "chapter": 41,
	  "searchForm": "tolmao"
	}, {
	  "latin": "ὁ τόπος",
	  "info": "",
	  "definitions": ["plaats"],
	  "chapter": 29,
	  "searchForm": "topos"
	}, {
	  "latin": "τότε",
	  "info": "bijw",
	  "definitions": ["dan, toen, op dat moment"],
	  "chapter": 2,
	  "searchForm": "tote"
	}, {
	  "latin": "τρεῖς, τρία",
	  "info": "",
	  "definitions": ["drie"],
	  "chapter": 36,
	  "searchForm": "treis, tria"
	}, {
	  "latin": "τρέπω",
	  "info": "",
	  "definitions": ["wenden, keren"],
	  "chapter": 12,
	  "searchForm": "trepo"
	}, {
	  "latin": "τρεχω",
	  "info": "",
	  "definitions": ["rennen"],
	  "chapter": 13,
	  "searchForm": "trecho"
	}, {
	  "latin": "τυγχάνω",
	  "info": "+ gen",
	  "definitions": ["treffen, raken", "krijgen"],
	  "chapter": 12,
	  "searchForm": "tugchano"
	}, {
	  "latin": "τύπτω",
	  "info": "",
	  "definitions": ["slaan"],
	  "chapter": 32,
	  "searchForm": "tupto"
	}, {
	  "latin": "ἡ τύχη",
	  "info": "",
	  "definitions": ["lot, kans", "geluk", "ongeluk"],
	  "chapter": 17,
	  "searchForm": "tuche"
	}, {
	  "latin": "ὁ υἱός",
	  "info": "",
	  "definitions": ["zoon"],
	  "chapter": 4,
	  "searchForm": "huios"
	}, {
	  "latin": "φαίνομαι",
	  "info": "",
	  "definitions": ["zich tonen, verschijnen", "schijnen, lijken *(+ inf)*"],
	  "chapter": 32,
	  "searchForm": "fainomai"
	}, {
	  "latin": "φαίνω",
	  "info": "",
	  "definitions": ["laten zien, tonen"],
	  "chapter": 7,
	  "searchForm": "faino"
	}, {
	  "latin": "φανερός, -ά, -όν",
	  "info": "",
	  "definitions": ["duidelijk, zichtbaar"],
	  "chapter": 36,
	  "searchForm": "faneros, -a, -on"
	}, {
	  "latin": "φέρω",
	  "info": "",
	  "definitions": ["dragen, brengen"],
	  "chapter": 3,
	  "searchForm": "fero"
	}, {
	  "latin": "φεύγω",
	  "info": "",
	  "definitions": ["vluchten, ontvluchten"],
	  "chapter": 7,
	  "searchForm": "feugo"
	}, {
	  "latin": "φιλέω",
	  "info": "",
	  "definitions": ["**+ acc** houden van", "**+ inf** ervan houden om"],
	  "chapter": 41,
	  "searchForm": "fileo"
	}, {
	  "latin": "ὁ φίλος",
	  "info": "",
	  "definitions": ["vriend"],
	  "chapter": 8,
	  "searchForm": "filos"
	}, {
	  "latin": "φίλος, -η, -ον",
	  "info": "",
	  "definitions": ["geliefd, dierbaar"],
	  "chapter": 21,
	  "searchForm": "filos, -e, -on"
	}, {
	  "latin": "ὁ φιλόσοφος",
	  "info": "",
	  "definitions": ["wijsgeer, filosoof"],
	  "chapter": 29,
	  "searchForm": "filosofos"
	}, {
	  "latin": "φοβέομαι",
	  "info": "",
	  "definitions": ["bang zijn, vrezen"],
	  "chapter": 31,
	  "searchForm": "fobeomai"
	}, {
	  "latin": "φοβερός, -ά, -όν",
	  "info": "",
	  "definitions": ["angstaanjagend"],
	  "chapter": 29,
	  "searchForm": "foberos, -a, -on"
	}, {
	  "latin": "φοβέω",
	  "info": "",
	  "definitions": ["bang maken"],
	  "chapter": 29,
	  "searchForm": "fobeo"
	}, {
	  "latin": "ὁ φόβος",
	  "info": "",
	  "definitions": ["angst"],
	  "chapter": 7,
	  "searchForm": "fobos"
	}, {
	  "latin": "φράζω",
	  "info": "",
	  "definitions": ["vertellen, meedelen"],
	  "chapter": 42,
	  "searchForm": "frazo"
	}, {
	  "latin": "φρονέω",
	  "info": "",
	  "definitions": ["verstandig zijn, denken"],
	  "chapter": 43,
	  "searchForm": "froneo"
	}, {
	  "latin": "φροντίζω",
	  "info": "+ gen",
	  "definitions": ["bezig zijn met, zorgen voor"],
	  "chapter": 44,
	  "searchForm": "frontizo"
	}, {
	  "latin": "φυλάττω",
	  "info": "",
	  "definitions": ["bewaken", "beschermen"],
	  "chapter": 14,
	  "searchForm": "fulatto"
	}, {
	  "latin": "φύομαι",
	  "info": "",
	  "definitions": ["groeien"],
	  "chapter": 36,
	  "searchForm": "fuomai"
	}, {
	  "latin": "φύω",
	  "info": "",
	  "definitions": ["laten groeien, ontstaan"],
	  "chapter": 26,
	  "searchForm": "fuo"
	}, {
	  "latin": "τὸ φῶς, φωτός",
	  "info": "",
	  "definitions": ["(dag)licht"],
	  "chapter": 6,
	  "searchForm": "fos, fotos"
	}, {
	  "latin": "χαίρω",
	  "info": "",
	  "definitions": ["blij zijn"],
	  "chapter": 7,
	  "searchForm": "chairo"
	}, {
	  "latin": "χαλεπός, -ή, -όν",
	  "info": "",
	  "definitions": ["moeilijk, lastig"],
	  "chapter": 22,
	  "searchForm": "chalepos, -e, -on"
	}, {
	  "latin": "ὁ χειμών, χειμῶνος",
	  "info": "",
	  "definitions": ["winter", "storm"],
	  "chapter": 26,
	  "searchForm": "cheimon, cheimonos"
	}, {
	  "latin": "ἡ χείρ, χειρός",
	  "info": "",
	  "definitions": ["hand, arm"],
	  "chapter": 26,
	  "searchForm": "cheir, cheiros"
	}, {
	  "latin": "χρή",
	  "info": "",
	  "definitions": ["**+ gen** er is behoefte aan", "**+ aci** het is nodig dat"],
	  "chapter": 41,
	  "searchForm": "chre"
	}, {
	  "latin": "τὸ χρῆμα, χρηματος ",
	  "info": "",
	  "definitions": ["zaak, ding", "**mv** geld, bezit"],
	  "chapter": 23,
	  "searchForm": "chrema, chrematos "
	}, {
	  "latin": "χρήομαι",
	  "info": "+ dat",
	  "definitions": ["gebruiken, omgaan met"],
	  "chapter": 31,
	  "searchForm": "chreomai"
	}, {
	  "latin": "χρήσιμος, -ον",
	  "info": "",
	  "definitions": ["bruikbaar, nuttig"],
	  "chapter": 43,
	  "searchForm": "chresimos, -on"
	}, {
	  "latin": "ὁ χρόνος",
	  "info": "",
	  "definitions": ["tijd, periode"],
	  "chapter": 23,
	  "searchForm": "chronos"
	}, {
	  "latin": "ἡ χώρα",
	  "info": "",
	  "definitions": ["gebied, plaats"],
	  "chapter": 7,
	  "searchForm": "chora"
	}, {
	  "latin": "ψεύδω",
	  "info": "",
	  "definitions": ["bedriegen"],
	  "chapter": 17,
	  "searchForm": "pseudo"
	}, {
	  "latin": "ἡ ψῆφος",
	  "info": "",
	  "definitions": ["stem(steen)"],
	  "chapter": 44,
	  "searchForm": "psefos"
	}, {
	  "latin": "ἡ ψυχή",
	  "info": "",
	  "definitions": ["leven, ziel", "geest, schim"],
	  "chapter": 26,
	  "searchForm": "psuche"
	}, {
	  "latin": "ὦ",
	  "info": "",
	  "definitions": ["o (*aanhef, meestal niet vertalen*)"],
	  "chapter": 8,
	  "searchForm": "o"
	}, {
	  "latin": "ὤν, οὖσα, ὄν, ὄντος",
	  "info": "",
	  "definitions": ["*ptc prs van εἰμί*"],
	  "chapter": 26,
	  "searchForm": "on, ousa, on, ontos"
	}];
	
	module.exports = dictionaryData;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 20px;\n"], ["\n  position: relative;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 20px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: $color-white;\n  width: 100%;\n  height: calc(100% - 100px);\n  overflow: auto;\n  padding: 0 20px 20px 20px;\n  display: block;\n  margin: 0 auto;\n  z-index: 1;\n"], ["\n  position: relative;\n  background-color: $color-white;\n  width: 100%;\n  height: calc(100% - 100px);\n  overflow: auto;\n  padding: 0 20px 20px 20px;\n  display: block;\n  margin: 0 auto;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(214);
	
	var _store = __webpack_require__(619);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _connect = __webpack_require__(222);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _WordSearch = __webpack_require__(616);
	
	var _WordSearch2 = _interopRequireDefault(_WordSearch);
	
	var _Result = __webpack_require__(615);
	
	var _Result2 = _interopRequireDefault(_Result);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var mapResults = function mapResults(words) {
	  return words.map(function (word, i) {
	    return _react2.default.createElement(_Result2.default, { word: word, key: i });
	  });
	};
	
	var SearchContainer = _styledComponents2.default.div(_templateObject);
	
	var ResultsContainer = _styledComponents2.default.div(_templateObject2);
	
	var Lexicon = function Lexicon(props) {
	  var dictionary = props.dictionary;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      SearchContainer,
	      null,
	      _react2.default.createElement(_WordSearch2.default, null)
	    ),
	    _react2.default.createElement(
	      ResultsContainer,
	      null,
	      mapResults(dictionary)
	    )
	  );
	};
	
	var ConnectedLexicon = (0, _connect2.default)(Lexicon);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(ConnectedLexicon, null)
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 10px 0;\n  width: 100%;\n  > div {\n    margin: 10px 0;\n  }\n"], ["\n  display: block;\n  padding: 10px 0;\n  width: 100%;\n  > div {\n    margin: 10px 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 17.6px;\n  color: ", ";\n  letter-spacing: 2px;\n  -webkit-font-variant-ligatures: no-common-ligatures;\n"], ["\n  font-size: 17.6px;\n  color: ", ";\n  letter-spacing: 2px;\n  -webkit-font-variant-ligatures: no-common-ligatures;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-transform: uppercase;\n  font-size: 11.2px;\n  letter-spacing: 0.5px;\n"], ["\n  color: ", ";\n  text-transform: uppercase;\n  font-size: 11.2px;\n  letter-spacing: 0.5px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 14.4px;\n  > div {\n    line-height: 1.7;\n  }\n"], ["\n  color: ", ";\n  font-size: 14.4px;\n  > div {\n    line-height: 1.7;\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _connect = __webpack_require__(223);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _markdown = __webpack_require__(494);
	
	var _markdown2 = _interopRequireDefault(_markdown);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ResultContainer = _styledComponents2.default.div(_templateObject);
	
	var Latin = _styledComponents2.default.span(_templateObject2, _colors2.default.accent);
	
	var Info = _styledComponents2.default.span(_templateObject3, _colors2.default.main);
	
	var Definitions = _styledComponents2.default.div(_templateObject4, _colors2.default.header);
	
	var mapDefinitions = function mapDefinitions(defs) {
	  return defs.map(function (def, i) {
	    return _react2.default.createElement("div", {
	      dangerouslySetInnerHTML: {
	        __html: (defs.length < 2 ? "" : ++i + ".&nbsp;") + " " + (0, _markdown2.default)(def)
	      },
	      key: i
	    });
	  });
	};
	
	var Result = function (_Component) {
	  _inherits(Result, _Component);
	
	  function Result(props) {
	    _classCallCheck(this, Result);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Result.prototype.render = function render() {
	    var _props$word = this.props.word,
	        chapter = _props$word.chapter,
	        definitions = _props$word.definitions,
	        info = _props$word.info,
	        latin = _props$word.latin;
	
	    return _react2.default.createElement(
	      ResultContainer,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          Latin,
	          null,
	          latin + " "
	        ),
	        _react2.default.createElement(
	          Info,
	          null,
	          info
	        )
	      ),
	      _react2.default.createElement(
	        Definitions,
	        null,
	        mapDefinitions(definitions)
	      )
	    );
	  };
	
	  return Result;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(Result);
	module.exports = exports["default"];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  padding: 10px;\n  border: 1px solid ', ';\n  width: 100%;\n  font-size: 20px;\n  &:focus {\n    outline: none;\n    border-color: ', ';\n  }\n'], ['\n  display: block;\n  padding: 10px;\n  border: 1px solid ', ';\n  width: 100%;\n  font-size: 20px;\n  &:focus {\n    outline: none;\n    border-color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _connect = __webpack_require__(223);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledInput = _styledComponents2.default.input(_templateObject, _colors2.default.border, _colors2.default.accent);
	
	var search = function search(action) {
	  return function (e) {
	    var value = e.target.value;
	
	    if (value !== '') {
	      action(value);
	    } else {
	      action('');
	    }
	  };
	};
	
	var WordSearch = function (_Component) {
	  _inherits(WordSearch, _Component);
	
	  function WordSearch(props) {
	    _classCallCheck(this, WordSearch);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  WordSearch.prototype.render = function render() {
	    var updateDictionary = this.props.actions.updateDictionary;
	
	    return _react2.default.createElement(StyledInput, {
	      type: 'text',
	      placeholder: 'Zoek een woord',
	      onChange: search(updateDictionary),
	      autofocus: true
	    });
	  };
	
	  return WordSearch;
	}(_react.Component);
	
	exports.default = (0, _connect2.default)(WordSearch);
	module.exports = exports['default'];

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ACTION = exports.ACTION = 'UPDATE_DICTIONARY';
	
	exports.default = function (payload) {
	  return { type: ACTION, payload: payload };
	};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _words = __webpack_require__(627);
	
	var _words2 = _interopRequireDefault(_words);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = [];
	
	var dictionaryReducer = function dictionaryReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case "UPDATE_DICTIONARY":
	      if (action.payload === "") {
	        return [];
	      } else {
	        var regex = new RegExp("^" + action.payload.toLowerCase() + ".*");
	        return _words2.default.filter(function (x) {
	          return regex.test(x.searchForm);
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = dictionaryReducer;
	module.exports = exports["default"];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _redux = __webpack_require__(186);
	
	var _dictionary = __webpack_require__(625);
	
	var _dictionary2 = _interopRequireDefault(_dictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Create store
	// Import main dependencies
	var store = (0, _redux.createStore)((0, _redux.combineReducers)({
	  dictionary: _dictionary2.default
	}));
	
	// Import reducers
	
	exports.default = store;
	module.exports = exports["default"];

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	'use strict';
	
	var dictionaryData = [{
	  latin: '-ne',
	  info: '',
	  definitions: ['*vraagwoord (niet vertalen)*'],
	  chapter: '22',
	  searchForm: '-ne'
	}, {
	  latin: '-que',
	  info: '',
	  definitions: ['en'],
	  chapter: '19',
	  searchForm: '-que'
	}, {
	  latin: 'a',
	  info: '+ abl',
	  definitions: ['vanaf', 'door'],
	  chapter: '10',
	  searchForm: 'a'
	}, {
	  latin: 'ab',
	  info: '+ abl',
	  definitions: ['vanaf', 'door'],
	  chapter: '10',
	  searchForm: 'ab'
	}, {
	  latin: 'abesse',
	  info: '',
	  definitions: ['afwezig zijn'],
	  chapter: '5',
	  searchForm: 'abesse'
	}, {
	  latin: 'abii',
	  info: '',
	  definitions: ['*pf van* abire'],
	  chapter: '29',
	  searchForm: 'abii'
	}, {
	  latin: 'abire',
	  info: '',
	  definitions: ['weggaan'],
	  chapter: '29',
	  searchForm: 'abire'
	}, {
	  latin: 'abiturus',
	  info: '',
	  definitions: ['*pfa van* abire'],
	  chapter: '32',
	  searchForm: 'abiturus'
	}, {
	  latin: 'ablatus',
	  info: '',
	  definitions: ['*ppp van* auferre'],
	  chapter: '55',
	  searchForm: 'ablatus'
	}, {
	  latin: 'abstuli',
	  info: '',
	  definitions: ['*pf van* auferre'],
	  chapter: '55',
	  searchForm: 'abstuli'
	}, {
	  latin: 'ac',
	  info: '',
	  definitions: ['en'],
	  chapter: '54',
	  searchForm: 'ac'
	}, {
	  latin: 'accedere',
	  info: '',
	  definitions: ['gaan naar', 'naderen'],
	  chapter: '2',
	  searchForm: 'accedere'
	}, {
	  latin: 'accendere',
	  info: '',
	  definitions: ['aansteken, ontsteken'],
	  chapter: '17',
	  searchForm: 'accendere'
	}, {
	  latin: 'accendi',
	  info: '',
	  definitions: ['*pf van* accendere'],
	  chapter: '17',
	  searchForm: 'accendi'
	}, {
	  latin: 'accensus',
	  info: '',
	  definitions: ['*ppp van* accendere'],
	  chapter: '34',
	  searchForm: 'accensus'
	}, {
	  latin: 'accepi',
	  info: '',
	  definitions: ['*pf van* accipere'],
	  chapter: '30, 47',
	  searchForm: 'accepi'
	}, {
	  latin: 'acceptus',
	  info: '',
	  definitions: ['*ppp van* accipere'],
	  chapter: '30, 47',
	  searchForm: 'acceptus'
	}, {
	  latin: 'accessi',
	  info: '',
	  definitions: ['*pf van* accedere'],
	  chapter: '16, 32',
	  searchForm: 'accessi'
	}, {
	  latin: 'accessus',
	  info: '',
	  definitions: ['*ppp van* accedere'],
	  chapter: '32',
	  searchForm: 'accessus'
	}, {
	  latin: 'accidere',
	  info: '',
	  definitions: ['gebeuren'],
	  chapter: '25',
	  searchForm: 'accidere'
	}, {
	  latin: 'accidi',
	  info: '',
	  definitions: ['*pf van* accidere'],
	  chapter: '27',
	  searchForm: 'accidi'
	}, {
	  latin: 'accipere, accipio',
	  info: '',
	  definitions: ['ontvangen, aannemen'],
	  chapter: '30',
	  searchForm: 'accipere, accipio'
	}, {
	  latin: 'acer, acris, acre',
	  info: '',
	  definitions: ['scherp, fel'],
	  chapter: '17',
	  searchForm: 'acer, acris, acre'
	}, {
	  latin: 'acies',
	  info: '5',
	  definitions: ['slaglinie'],
	  chapter: '36',
	  searchForm: 'acies'
	}, {
	  latin: 'actus',
	  info: '',
	  definitions: ['*ppp van* agere'],
	  chapter: '39',
	  searchForm: 'actus'
	}, {
	  latin: 'ad',
	  info: '+ acc',
	  definitions: ['naar, tot', 'bij'],
	  chapter: '1',
	  searchForm: 'ad'
	}, {
	  latin: 'addere',
	  info: '',
	  definitions: ['toevoegen'],
	  chapter: '5',
	  searchForm: 'addere'
	}, {
	  latin: 'addidi',
	  info: '',
	  definitions: ['*pf van* addere'],
	  chapter: '25',
	  searchForm: 'addidi'
	}, {
	  latin: 'adducere',
	  info: '',
	  definitions: ['brengen (naar)'],
	  chapter: '54',
	  searchForm: 'adducere'
	}, {
	  latin: 'adeo',
	  info: '',
	  definitions: ['zo(zeer)'],
	  chapter: '44',
	  searchForm: 'adeo'
	}, {
	  latin: 'adesse',
	  info: '(+ dat)',
	  definitions: ['aanwezig zijn (bij)'],
	  chapter: '16',
	  searchForm: 'adesse'
	}, {
	  latin: 'adfui',
	  info: '',
	  definitions: ['*pf van* adesse'],
	  chapter: '47',
	  searchForm: 'adfui'
	}, {
	  latin: 'adfuturus',
	  info: '',
	  definitions: ['*pfa van* adesse'],
	  chapter: '47',
	  searchForm: 'adfuturus'
	}, {
	  latin: 'adhibēre',
	  info: '',
	  definitions: ['toepassen, gebruiken'],
	  chapter: '52',
	  searchForm: 'adhibere'
	}, {
	  latin: 'adhuc',
	  info: '',
	  definitions: ['nog, tot nu toe'],
	  chapter: '11',
	  searchForm: 'adhuc'
	}, {
	  latin: 'adii',
	  info: '',
	  definitions: ['*pf van* adire'],
	  chapter: '40',
	  searchForm: 'adii'
	}, {
	  latin: 'adipisci',
	  info: '',
	  definitions: ['verkrijgen'],
	  chapter: '54',
	  searchForm: 'adipisci'
	}, {
	  latin: 'adire (ad)',
	  info: '+ acc',
	  definitions: ['gaan naar'],
	  chapter: '40',
	  searchForm: 'adire (ad)'
	}, {
	  latin: 'aditurus',
	  info: '',
	  definitions: ['*pfa van* adire'],
	  chapter: '40',
	  searchForm: 'aditurus'
	}, {
	  latin: 'adulescens, -entes',
	  info: 'm',
	  definitions: ['jongeman, jongen'],
	  chapter: '45',
	  searchForm: 'adulescens, -entes'
	}, {
	  latin: 'adventus',
	  info: '4',
	  definitions: ['aankomst'],
	  chapter: '37',
	  searchForm: 'adventus'
	}, {
	  latin: 'aedificare',
	  info: '',
	  definitions: ['bouwen'],
	  chapter: '3',
	  searchForm: 'aedificare'
	}, {
	  latin: 'aedificium',
	  info: '',
	  definitions: ['gebouw'],
	  chapter: '13',
	  searchForm: 'aedificium'
	}, {
	  latin: 'aeger, -gra, -grum',
	  info: '',
	  definitions: ['ziek'],
	  chapter: '43',
	  searchForm: 'aeger, -gra, -grum'
	}, {
	  latin: 'aestus',
	  info: '4',
	  definitions: ['hitte', 'branding'],
	  chapter: '53',
	  searchForm: 'aestus'
	}, {
	  latin: 'aetas, aetates',
	  info: 'v',
	  definitions: ['leeftijd'],
	  chapter: '33',
	  searchForm: 'aetas, aetates'
	}, {
	  latin: 'affeci',
	  info: '',
	  definitions: ['*pf van* afficere'],
	  chapter: '33',
	  searchForm: 'affeci'
	}, {
	  latin: 'affectus',
	  info: '',
	  definitions: ['*ppp van* afficere'],
	  chapter: '33',
	  searchForm: 'affectus'
	}, {
	  latin: 'afferre',
	  info: '',
	  definitions: ['(mee)brengen'],
	  chapter: '32',
	  searchForm: 'afferre'
	}, {
	  latin: 'afficere, afficio',
	  info: '',
	  definitions: ['treffen, vervullen'],
	  chapter: '33',
	  searchForm: 'afficere, afficio'
	}, {
	  latin: 'ager *mv* agri',
	  info: '',
	  definitions: ['akker'],
	  chapter: '20',
	  searchForm: 'ager *mv* agri'
	}, {
	  latin: 'agere',
	  info: '',
	  definitions: ['leiden, voeren', 'doen'],
	  chapter: '18',
	  searchForm: 'agere'
	}, {
	  latin: 'aggredi, aggredior',
	  info: '',
	  definitions: ['aanvallen', 'beginnen (aan)'],
	  chapter: '51',
	  searchForm: 'aggredi, aggredior'
	}, {
	  latin: 'aggressus sum',
	  info: '',
	  definitions: ['*pf van* aggredi'],
	  chapter: '51',
	  searchForm: 'aggressus sum'
	}, {
	  latin: 'agmen, agmina',
	  info: '',
	  definitions: ['rij, stoet'],
	  chapter: '10',
	  searchForm: 'agmen, agmina'
	}, {
	  latin: 'alere',
	  info: '',
	  definitions: ['voeden'],
	  chapter: '45',
	  searchForm: 'alere'
	}, {
	  latin: 'alienus, -a, -um',
	  info: '',
	  definitions: ['vreemd, van een ander'],
	  chapter: '54',
	  searchForm: 'alienus, -a, -um'
	}, {
	  latin: 'alii … alii',
	  info: 'mv',
	  definitions: ['sommige(n) … andere(n)'],
	  chapter: '51',
	  searchForm: 'alii … alii'
	}, {
	  latin: 'aliqui, aliqua, aliquod',
	  info: '',
	  definitions: ['**ev** een (zekere), een of andere', '**mv** sommige, enige'],
	  chapter: '46',
	  searchForm: 'aliqui, aliqua, aliquod'
	}, {
	  latin: 'aliquid',
	  info: '',
	  definitions: ['iets'],
	  chapter: '45',
	  searchForm: 'aliquid'
	}, {
	  latin: 'aliquis',
	  info: '',
	  definitions: ['iemand'],
	  chapter: '45',
	  searchForm: 'aliquis'
	}, {
	  latin: 'alius … alius',
	  info: '',
	  definitions: ['de een … de ander'],
	  chapter: '25',
	  searchForm: 'alius … alius'
	}, {
	  latin: 'alius, alia, aliud',
	  info: '',
	  definitions: ['ander'],
	  chapter: '18',
	  searchForm: 'alius, alia, aliud'
	}, {
	  latin: 'allatus',
	  info: '',
	  definitions: ['*ppp van* afferre'],
	  chapter: '32',
	  searchForm: 'allatus'
	}, {
	  latin: 'altus, -a, -um',
	  info: '',
	  definitions: ['hoog', 'diep'],
	  chapter: '19',
	  searchForm: 'altus, -a, -um'
	}, {
	  latin: 'amare',
	  info: '',
	  definitions: ['houden van, liefhebben'],
	  chapter: '6',
	  searchForm: 'amare'
	}, {
	  latin: 'amica',
	  info: '',
	  definitions: ['vriendin'],
	  chapter: '1',
	  searchForm: 'amica'
	}, {
	  latin: 'amicus',
	  info: '',
	  definitions: ['vriend'],
	  chapter: '3',
	  searchForm: 'amicus'
	}, {
	  latin: 'amisi',
	  info: '',
	  definitions: ['*pf van* amittere'],
	  chapter: '15, 51',
	  searchForm: 'amisi'
	}, {
	  latin: 'amissus',
	  info: '',
	  definitions: ['*ppp van* amittere'],
	  chapter: '51',
	  searchForm: 'amissus'
	}, {
	  latin: 'amittere',
	  info: '',
	  definitions: ['verliezen'],
	  chapter: '15',
	  searchForm: 'amittere'
	}, {
	  latin: 'amor, amores',
	  info: 'm',
	  definitions: ['liefde'],
	  chapter: '15',
	  searchForm: 'amor, amores'
	}, {
	  latin: 'amplus, -a, -um',
	  info: '',
	  definitions: ['ruim, groot', 'belangrijk'],
	  chapter: '26',
	  searchForm: 'amplus, -a, -um'
	}, {
	  latin: 'an',
	  info: 'in vraag',
	  definitions: ['of'],
	  chapter: '47',
	  searchForm: 'an'
	}, {
	  latin: 'animal, animalia',
	  info: 'o',
	  definitions: ['dier'],
	  chapter: '9',
	  searchForm: 'animal, animalia'
	}, {
	  latin: 'animus',
	  info: '',
	  definitions: ['geest, aandacht'],
	  chapter: '29',
	  searchForm: 'animus'
	}, {
	  latin: 'annus',
	  info: '',
	  definitions: ['jaar'],
	  chapter: '5',
	  searchForm: 'annus'
	}, {
	  latin: 'ante',
	  info: '+ acc',
	  definitions: ['voor'],
	  chapter: '8, 41',
	  searchForm: 'ante'
	}, {
	  latin: 'ante',
	  info: 'bijw',
	  definitions: ['eerder'],
	  chapter: '41',
	  searchForm: 'ante'
	}, {
	  latin: 'antea',
	  info: '',
	  definitions: ['eerder'],
	  chapter: '11',
	  searchForm: 'antea'
	}, {
	  latin: 'anxius, -a, -um',
	  info: '',
	  definitions: ['angstig, bezorgd'],
	  chapter: '27',
	  searchForm: 'anxius, -a, -um'
	}, {
	  latin: 'aperire',
	  info: '',
	  definitions: ['openen'],
	  chapter: '30',
	  searchForm: 'aperire'
	}, {
	  latin: 'apparēre',
	  info: '',
	  definitions: ['verschijnen', 'duidelijk zijn'],
	  chapter: '17, 47',
	  searchForm: 'apparere'
	}, {
	  latin: 'appropinquare',
	  info: '+ dat',
	  definitions: ['naderen'],
	  chapter: '11',
	  searchForm: 'appropinquare'
	}, {
	  latin: 'apud',
	  info: '+ acc',
	  definitions: ['bij'],
	  chapter: '13',
	  searchForm: 'apud'
	}, {
	  latin: 'aqua',
	  info: '',
	  definitions: ['water'],
	  chapter: '1',
	  searchForm: 'aqua'
	}, {
	  latin: 'ara',
	  info: '',
	  definitions: ['altaar'],
	  chapter: '29',
	  searchForm: 'ara'
	}, {
	  latin: 'arbor, arbores',
	  info: '',
	  definitions: ['boom'],
	  chapter: '1',
	  searchForm: 'arbor, arbores'
	}, {
	  latin: 'arcessere',
	  info: '',
	  definitions: ['laten komen'],
	  chapter: '22',
	  searchForm: 'arcessere'
	}, {
	  latin: 'arcessitus',
	  info: '',
	  definitions: ['*ppp van* arcessere'],
	  chapter: '43',
	  searchForm: 'arcessitus'
	}, {
	  latin: 'arcessivi',
	  info: '',
	  definitions: ['*pf van* arcessere'],
	  chapter: '22, 43',
	  searchForm: 'arcessivi'
	}, {
	  latin: 'ardēre',
	  info: '',
	  definitions: ['branden'],
	  chapter: '5',
	  searchForm: 'ardere'
	}, {
	  latin: 'arma',
	  info: 'mv',
	  definitions: ['wapens'],
	  chapter: '4',
	  searchForm: 'arma'
	}, {
	  latin: 'ars, artes',
	  info: 'v',
	  definitions: ['vaardigheid, kunst'],
	  chapter: '29',
	  searchForm: 'ars, artes'
	}, {
	  latin: 'arx, arces',
	  info: 'v',
	  definitions: ['burcht'],
	  chapter: '4',
	  searchForm: 'arx, arces'
	}, {
	  latin: 'ascendere',
	  info: '',
	  definitions: ['bestijgen, klimmen (op)'],
	  chapter: '32',
	  searchForm: 'ascendere'
	}, {
	  latin: 'ascendi',
	  info: '',
	  definitions: ['*pf van* ascendere'],
	  chapter: '32',
	  searchForm: 'ascendi'
	}, {
	  latin: 'ascensus',
	  info: '',
	  definitions: ['*ppp van* ascendere'],
	  chapter: '32',
	  searchForm: 'ascensus'
	}, {
	  latin: 'aspexi',
	  info: '',
	  definitions: ['*pf van* aspicere'],
	  chapter: '23',
	  searchForm: 'aspexi'
	}, {
	  latin: 'aspicere, aspicio',
	  info: '',
	  definitions: ['bekijken, aankijken'],
	  chapter: '23',
	  searchForm: 'aspicere, aspicio'
	}, {
	  latin: 'at',
	  info: '',
	  definitions: ['maar'],
	  chapter: '22',
	  searchForm: 'at'
	}, {
	  latin: 'atque',
	  info: '',
	  definitions: ['en'],
	  chapter: '32',
	  searchForm: 'atque'
	}, {
	  latin: 'attuli',
	  info: '',
	  definitions: ['*pf van* afferre'],
	  chapter: '32',
	  searchForm: 'attuli'
	}, {
	  latin: 'audacia',
	  info: '',
	  definitions: ['(over)moed'],
	  chapter: '43',
	  searchForm: 'audacia'
	}, {
	  latin: 'audax, audac-',
	  info: '',
	  definitions: ['moedig, roekeloos'],
	  chapter: '19',
	  searchForm: 'audax, audac-'
	}, {
	  latin: 'audēre',
	  info: '',
	  definitions: ['durven'],
	  chapter: '20',
	  searchForm: 'audere'
	}, {
	  latin: 'audire',
	  info: '',
	  definitions: ['horen'],
	  chapter: '1',
	  searchForm: 'audire'
	}, {
	  latin: 'auferre',
	  info: '',
	  definitions: ['wegnemen', '**se** zich verwijderen'],
	  chapter: '55',
	  searchForm: 'auferre'
	}, {
	  latin: 'augēre',
	  info: '',
	  definitions: ['vergroten, vermeerderen'],
	  chapter: '47',
	  searchForm: 'augere'
	}, {
	  latin: 'aureus, -a, -um',
	  info: '',
	  definitions: ['gouden, van goud'],
	  chapter: '48',
	  searchForm: 'aureus, -a, -um'
	}, {
	  latin: 'ausus sum',
	  info: '',
	  definitions: ['*pf van* audēre'],
	  chapter: '50',
	  searchForm: 'ausus sum'
	}, {
	  latin: 'aut',
	  info: '',
	  definitions: ['of'],
	  chapter: '8',
	  searchForm: 'aut'
	}, {
	  latin: 'autem',
	  info: '',
	  definitions: ['echter'],
	  chapter: '5',
	  searchForm: 'autem'
	}, {
	  latin: 'auxilium',
	  info: '',
	  definitions: ['hulp', '**mv** hulptroepen'],
	  chapter: '4, 37',
	  searchForm: 'auxilium'
	}, {
	  latin: 'avus',
	  info: '',
	  definitions: ['grootvader'],
	  chapter: '52',
	  searchForm: 'avus'
	}, {
	  latin: 'barbarus',
	  info: '',
	  definitions: ['barbaar'],
	  chapter: '37',
	  searchForm: 'barbarus'
	}, {
	  latin: 'barbarus, -a, -um',
	  info: '',
	  definitions: ['barbaars'],
	  chapter: '37',
	  searchForm: 'barbarus, -a, -um'
	}, {
	  latin: 'bellum',
	  info: '',
	  definitions: ['oorlog'],
	  chapter: '6',
	  searchForm: 'bellum'
	}, {
	  latin: 'bene',
	  info: 'bijw',
	  definitions: ['goed'],
	  chapter: '17',
	  searchForm: 'bene'
	}, {
	  latin: 'bibere',
	  info: '',
	  definitions: ['drinken'],
	  chapter: '2',
	  searchForm: 'bibere'
	}, {
	  latin: 'bibi',
	  info: '',
	  definitions: ['*pf van* bibere'],
	  chapter: '34',
	  searchForm: 'bibi'
	}, {
	  latin: 'bis',
	  info: '',
	  definitions: ['tweemaal'],
	  chapter: '37',
	  searchForm: 'bis'
	}, {
	  latin: 'bona',
	  info: 'mv',
	  definitions: ['goederen'],
	  chapter: '45',
	  searchForm: 'bona'
	}, {
	  latin: 'bonus, -a, -um',
	  info: '',
	  definitions: ['goed'],
	  chapter: '15',
	  searchForm: 'bonus, -a, -um'
	}, {
	  latin: 'brevis, -e',
	  info: '',
	  definitions: ['kort'],
	  chapter: '16',
	  searchForm: 'brevis, -e'
	}, {
	  latin: 'cadere',
	  info: '',
	  definitions: ['vallen'],
	  chapter: '4',
	  searchForm: 'cadere'
	}, {
	  latin: 'campus',
	  info: '',
	  definitions: ['veld'],
	  chapter: '31',
	  searchForm: 'campus'
	}, {
	  latin: 'canere',
	  info: '',
	  definitions: ['zingen'],
	  chapter: '25',
	  searchForm: 'canere'
	}, {
	  latin: 'canis, canes',
	  info: 'm',
	  definitions: ['hond'],
	  chapter: '34',
	  searchForm: 'canis, canes'
	}, {
	  latin: 'capere, capio',
	  info: '',
	  definitions: ['pakken, nemen'],
	  chapter: '13',
	  searchForm: 'capere, capio'
	}, {
	  latin: 'captivus',
	  info: '',
	  definitions: ['krijgsgevangene'],
	  chapter: '46',
	  searchForm: 'captivus'
	}, {
	  latin: 'captivus, -a, -um',
	  info: '',
	  definitions: ['krijgsgevangen'],
	  chapter: '46',
	  searchForm: 'captivus, -a, -um'
	}, {
	  latin: 'captus',
	  info: '',
	  definitions: ['*ppp van* capere'],
	  chapter: '37',
	  searchForm: 'captus'
	}, {
	  latin: 'caput, capita',
	  info: '',
	  definitions: ['hoofd'],
	  chapter: '10',
	  searchForm: 'caput, capita'
	}, {
	  latin: 'carēre',
	  info: '+ abl',
	  definitions: ['missen'],
	  chapter: '17',
	  searchForm: 'carere'
	}, {
	  latin: 'carmen, carmina',
	  info: '',
	  definitions: ['lied, gedicht'],
	  chapter: '25',
	  searchForm: 'carmen, carmina'
	}, {
	  latin: 'carus, -a, -um',
	  info: '',
	  definitions: ['geliefd'],
	  chapter: '15',
	  searchForm: 'carus, -a, -um'
	}, {
	  latin: 'castra',
	  info: 'mv',
	  definitions: ['legerkamp'],
	  chapter: '30',
	  searchForm: 'castra'
	}, {
	  latin: 'causa',
	  info: 'gen +',
	  definitions: ['wegens'],
	  chapter: '54',
	  searchForm: 'causa'
	}, {
	  latin: 'causa',
	  info: '',
	  definitions: ['reden'],
	  chapter: '11',
	  searchForm: 'causa'
	}, {
	  latin: 'cavēre',
	  info: '(+ acc)',
	  definitions: ['oppassen (voor)'],
	  chapter: '41',
	  searchForm: 'cavere'
	}, {
	  latin: 'cecidi',
	  info: '',
	  definitions: ['*pf van* cadere'],
	  chapter: '12',
	  searchForm: 'cecidi'
	}, {
	  latin: 'cedere',
	  info: '',
	  definitions: ['(aan de kant) gaan', 'toegeven'],
	  chapter: '12',
	  searchForm: 'cedere'
	}, {
	  latin: 'celebrare',
	  info: '',
	  definitions: ['(feest)vieren'],
	  chapter: '6',
	  searchForm: 'celebrare'
	}, {
	  latin: 'celer, celeris, celere',
	  info: '',
	  definitions: ['snel'],
	  chapter: '17',
	  searchForm: 'celer, celeris, celere'
	}, {
	  latin: 'cena',
	  info: '',
	  definitions: ['maaltijd'],
	  chapter: '16',
	  searchForm: 'cena'
	}, {
	  latin: 'censēre',
	  info: '',
	  definitions: ['van mening zijn'],
	  chapter: '26',
	  searchForm: 'censere'
	}, {
	  latin: 'centum',
	  info: '',
	  definitions: ['honderd'],
	  chapter: '11',
	  searchForm: 'centum'
	}, {
	  latin: 'centurio, -ones',
	  info: 'm',
	  definitions: ['centurio, officier'],
	  chapter: '37',
	  searchForm: 'centurio, -ones'
	}, {
	  latin: 'cepi',
	  info: '',
	  definitions: ['*pf van* capere'],
	  chapter: '19',
	  searchForm: 'cepi'
	}, {
	  latin: 'cernere',
	  info: '',
	  definitions: ['onderscheiden, zien'],
	  chapter: '44',
	  searchForm: 'cernere'
	}, {
	  latin: 'certamen, certamina',
	  info: '',
	  definitions: ['wedstrijd'],
	  chapter: '12',
	  searchForm: 'certamen, certamina'
	}, {
	  latin: 'certare',
	  info: '',
	  definitions: ['strijden'],
	  chapter: '36',
	  searchForm: 'certare'
	}, {
	  latin: 'certus, -a, -um',
	  info: '',
	  definitions: ['zeker, vast'],
	  chapter: '25',
	  searchForm: 'certus, -a, -um'
	}, {
	  latin: 'ceteri, -ae, -a',
	  info: 'mv',
	  definitions: ['(de) andere, overige'],
	  chapter: '18',
	  searchForm: 'ceteri, -ae, -a'
	}, {
	  latin: 'cibus',
	  info: '',
	  definitions: ['voedsel'],
	  chapter: '19',
	  searchForm: 'cibus'
	}, {
	  latin: 'cingere',
	  info: '',
	  definitions: ['omringen'],
	  chapter: '53',
	  searchForm: 'cingere'
	}, {
	  latin: 'cito',
	  info: 'bijw',
	  definitions: ['snel'],
	  chapter: '9',
	  searchForm: 'cito'
	}, {
	  latin: 'civilis, -e',
	  info: '',
	  definitions: ['burger-', 'openbaar'],
	  chapter: '39',
	  searchForm: 'civilis, -e'
	}, {
	  latin: 'civis, cives',
	  info: 'm',
	  definitions: ['burger'],
	  chapter: '3',
	  searchForm: 'civis, cives'
	}, {
	  latin: 'civitas, civitates',
	  info: 'v',
	  definitions: ['burgerij', 'stad'],
	  chapter: '39',
	  searchForm: 'civitas, civitates'
	}, {
	  latin: 'clades, clades',
	  info: 'v',
	  definitions: ['nederlaag'],
	  chapter: '30',
	  searchForm: 'clades, clades'
	}, {
	  latin: 'clamare',
	  info: '',
	  definitions: ['schreeuwen'],
	  chapter: '1',
	  searchForm: 'clamare'
	}, {
	  latin: 'clamor, clamores',
	  info: 'm',
	  definitions: ['geschreeuw'],
	  chapter: '19',
	  searchForm: 'clamor, clamores'
	}, {
	  latin: 'clarus, -a, -um',
	  info: '',
	  definitions: ['helder', 'beroemd'],
	  chapter: '22',
	  searchForm: 'clarus, -a, -um'
	}, {
	  latin: 'classis, classes',
	  info: 'v',
	  definitions: ['vloot'],
	  chapter: '53',
	  searchForm: 'classis, classes'
	}, {
	  latin: 'claudere',
	  info: '',
	  definitions: ['sluiten'],
	  chapter: '9',
	  searchForm: 'claudere'
	}, {
	  latin: 'clausi',
	  info: '',
	  definitions: ['*pf van* claudere'],
	  chapter: '38',
	  searchForm: 'clausi'
	}, {
	  latin: 'clausus',
	  info: '',
	  definitions: ['*ppp van* claudere'],
	  chapter: '38',
	  searchForm: 'clausus'
	}, {
	  latin: 'clementia',
	  info: '',
	  definitions: ['genade, mildheid'],
	  chapter: '39',
	  searchForm: 'clementia'
	}, {
	  latin: 'coactus',
	  info: '',
	  definitions: ['*ppp van* cogere'],
	  chapter: '41',
	  searchForm: 'coactus'
	}, {
	  latin: 'coegi',
	  info: '',
	  definitions: ['*pf van* cogere'],
	  chapter: '27',
	  searchForm: 'coegi'
	}, {
	  latin: 'coepi',
	  info: 'pf',
	  definitions: ['ik ben begonnen'],
	  chapter: '39',
	  searchForm: 'coepi'
	}, {
	  latin: 'cogere',
	  info: '',
	  definitions: ['bijeenbrengen', 'dwingen'],
	  chapter: '27',
	  searchForm: 'cogere'
	}, {
	  latin: 'cogitare',
	  info: '',
	  definitions: ['(na)denken'],
	  chapter: '2',
	  searchForm: 'cogitare'
	}, {
	  latin: 'cognitus',
	  info: '',
	  definitions: ['*ppp van* cognoscere'],
	  chapter: '44',
	  searchForm: 'cognitus'
	}, {
	  latin: 'cognoscere',
	  info: '',
	  definitions: ['te weten komen', 'leren kennen'],
	  chapter: '44',
	  searchForm: 'cognoscere'
	}, {
	  latin: 'cognovi',
	  info: 'pf',
	  definitions: ['weten', 'kennen'],
	  chapter: '44',
	  searchForm: 'cognovi'
	}, {
	  latin: 'cohors, cohortes',
	  info: 'v',
	  definitions: ['cohort'],
	  chapter: '54',
	  searchForm: 'cohors, cohortes'
	}, {
	  latin: 'colere',
	  info: '',
	  definitions: ['verzorgen', 'bebouwen', 'vereren'],
	  chapter: '29',
	  searchForm: 'colere'
	}, {
	  latin: 'collectus',
	  info: '',
	  definitions: ['*ppp van* colligere'],
	  chapter: '33',
	  searchForm: 'collectus'
	}, {
	  latin: 'collegi',
	  info: '',
	  definitions: ['*pf van* colligere'],
	  chapter: '29',
	  searchForm: 'collegi'
	}, {
	  latin: 'colligere',
	  info: '',
	  definitions: ['verzamelen'],
	  chapter: '25',
	  searchForm: 'colligere'
	}, {
	  latin: 'color, colores',
	  info: 'm',
	  definitions: ['kleur'],
	  chapter: '37',
	  searchForm: 'color, colores'
	}, {
	  latin: 'comes, comites',
	  info: 'm',
	  definitions: ['metgezel'],
	  chapter: '44',
	  searchForm: 'comes, comites'
	}, {
	  latin: 'commisi',
	  info: '',
	  definitions: ['*pf van* committere'],
	  chapter: '26',
	  searchForm: 'commisi'
	}, {
	  latin: 'committere',
	  info: '',
	  definitions: ['toevertrouwen', '**scelus** begaan', '**proelium** aangaan'],
	  chapter: '26, 54',
	  searchForm: 'committere'
	}, {
	  latin: 'communis, -e',
	  info: '',
	  definitions: ['gemeenschappelijk'],
	  chapter: '16',
	  searchForm: 'communis, -e'
	}, {
	  latin: 'complecti',
	  info: '',
	  definitions: ['omarmen'],
	  chapter: '52',
	  searchForm: 'complecti'
	}, {
	  latin: 'complēre',
	  info: '',
	  definitions: ['vullen'],
	  chapter: '8',
	  searchForm: 'complere'
	}, {
	  latin: 'complexus sum',
	  info: '',
	  definitions: ['*pf van* complecti'],
	  chapter: '52',
	  searchForm: 'complexus sum'
	}, {
	  latin: 'conari',
	  info: '',
	  definitions: ['proberen'],
	  chapter: '50',
	  searchForm: 'conari'
	}, {
	  latin: 'condere',
	  info: '',
	  definitions: ['stichten', 'verbergen'],
	  chapter: '24',
	  searchForm: 'condere'
	}, {
	  latin: 'condicio, -ones',
	  info: 'v',
	  definitions: ['voorwaarde', 'toestand'],
	  chapter: '54',
	  searchForm: 'condicio, -ones'
	}, {
	  latin: 'condidi',
	  info: '',
	  definitions: ['*pf van* condere'],
	  chapter: '24',
	  searchForm: 'condidi'
	}, {
	  latin: 'conditus',
	  info: '',
	  definitions: ['*ppp van* condere'],
	  chapter: '40',
	  searchForm: 'conditus'
	}, {
	  latin: 'confirmare',
	  info: '',
	  definitions: ['bevestigen'],
	  chapter: '34',
	  searchForm: 'confirmare'
	}, {
	  latin: 'coniungere',
	  info: '',
	  definitions: ['verbinden'],
	  chapter: '22',
	  searchForm: 'coniungere'
	}, {
	  latin: 'coniunx, coniuges',
	  info: '',
	  definitions: ['**m** echtgenoot', '**v** echtgenote'],
	  chapter: '52',
	  searchForm: 'coniunx, coniuges'
	}, {
	  latin: 'consilium',
	  info: '',
	  definitions: ['plan', 'besluit'],
	  chapter: '15',
	  searchForm: 'consilium'
	}, {
	  latin: 'consistere',
	  info: '',
	  definitions: ['blijven staan'],
	  chapter: '11',
	  searchForm: 'consistere'
	}, {
	  latin: 'conspectus',
	  info: '4',
	  definitions: ['aanblik'],
	  chapter: '48',
	  searchForm: 'conspectus'
	}, {
	  latin: 'conspexi',
	  info: '',
	  definitions: ['*pf van* conspicere'],
	  chapter: '23',
	  searchForm: 'conspexi'
	}, {
	  latin: 'conspicere, conspicio',
	  info: '',
	  definitions: ['zien'],
	  chapter: '23',
	  searchForm: 'conspicere, conspicio'
	}, {
	  latin: 'constat',
	  info: '',
	  definitions: ['het staat vast'],
	  chapter: '33',
	  searchForm: 'constat'
	}, {
	  latin: 'constiti',
	  info: '',
	  definitions: ['*pf van* consistere'],
	  chapter: '12',
	  searchForm: 'constiti'
	}, {
	  latin: 'constituere',
	  info: '',
	  definitions: ['besluiten'],
	  chapter: '20',
	  searchForm: 'constituere'
	}, {
	  latin: 'constitui',
	  info: '',
	  definitions: ['*pf van* constituere'],
	  chapter: '20',
	  searchForm: 'constitui'
	}, {
	  latin: 'consul, consules',
	  info: 'm',
	  definitions: ['consul'],
	  chapter: '20',
	  searchForm: 'consul, consules'
	}, {
	  latin: 'consulere',
	  info: '',
	  definitions: ['beraadslagen', '**+ acc** raadplegen'],
	  chapter: '48',
	  searchForm: 'consulere'
	}, {
	  latin: 'consultus',
	  info: '',
	  definitions: ['*ppp van* consulere'],
	  chapter: '48',
	  searchForm: 'consultus'
	}, {
	  latin: 'consului',
	  info: '',
	  definitions: ['*pf van* consulere'],
	  chapter: '48',
	  searchForm: 'consului'
	}, {
	  latin: 'contemnere',
	  info: '',
	  definitions: ['minachten'],
	  chapter: '34',
	  searchForm: 'contemnere'
	}, {
	  latin: 'contempsi',
	  info: '',
	  definitions: ['*pf van* contemnere'],
	  chapter: '34',
	  searchForm: 'contempsi'
	}, {
	  latin: 'contemptus',
	  info: '',
	  definitions: ['*ppp van* contemnere'],
	  chapter: '34',
	  searchForm: 'contemptus'
	}, {
	  latin: 'contentus, -a, -um',
	  info: '(+ abl)',
	  definitions: ['tevreden (met)'],
	  chapter: '15',
	  searchForm: 'contentus, -a, -um'
	}, {
	  latin: 'contigi',
	  info: '',
	  definitions: ['*pf van* contingere'],
	  chapter: '41',
	  searchForm: 'contigi'
	}, {
	  latin: 'continēre',
	  info: '',
	  definitions: ['bijeenhouden', 'bevatten'],
	  chapter: '47',
	  searchForm: 'continere'
	}, {
	  latin: 'contingere',
	  info: '',
	  definitions: ['**+ acc** aanraken', 'gebeuren'],
	  chapter: '41',
	  searchForm: 'contingere'
	}, {
	  latin: 'contra',
	  info: '+ acc',
	  definitions: ['tegen(over)'],
	  chapter: '11',
	  searchForm: 'contra'
	}, {
	  latin: 'conveni',
	  info: '',
	  definitions: ['*pf van* convenire'],
	  chapter: '30',
	  searchForm: 'conveni'
	}, {
	  latin: 'convenire',
	  info: '',
	  definitions: ['bijeenkomen', '**+ acc** ontmoeten'],
	  chapter: '30, 41',
	  searchForm: 'convenire'
	}, {
	  latin: 'conventus',
	  info: '',
	  definitions: ['*ppp van* convenire'],
	  chapter: '30',
	  searchForm: 'conventus'
	}, {
	  latin: 'conversus',
	  info: '',
	  definitions: ['*ppp van* convertere'],
	  chapter: '48',
	  searchForm: 'conversus'
	}, {
	  latin: 'convertere',
	  info: '',
	  definitions: ['(om)draaien'],
	  chapter: '48',
	  searchForm: 'convertere'
	}, {
	  latin: 'converti',
	  info: '',
	  definitions: ['*pf van* convertere'],
	  chapter: '48',
	  searchForm: 'converti'
	}, {
	  latin: 'convocare',
	  info: '',
	  definitions: ['bijeenroepen'],
	  chapter: '38',
	  searchForm: 'convocare'
	}, {
	  latin: 'copiae',
	  info: 'mv',
	  definitions: ['troepen'],
	  chapter: '29',
	  searchForm: 'copiae'
	}, {
	  latin: 'cornu',
	  info: '4',
	  definitions: ['hoorn'],
	  chapter: '36',
	  searchForm: 'cornu'
	}, {
	  latin: 'corpus, corpora',
	  info: '',
	  definitions: ['lichaam'],
	  chapter: '10',
	  searchForm: 'corpus, corpora'
	}, {
	  latin: 'corrumpere',
	  info: '',
	  definitions: ['bederven', 'omkopen'],
	  chapter: '37',
	  searchForm: 'corrumpere'
	}, {
	  latin: 'cotidie',
	  info: '',
	  definitions: ['dagelijks'],
	  chapter: '20',
	  searchForm: 'cotidie'
	}, {
	  latin: 'cras',
	  info: '',
	  definitions: ['morgen'],
	  chapter: '30',
	  searchForm: 'cras'
	}, {
	  latin: 'credere',
	  info: '+ dat',
	  definitions: ['geloven'],
	  chapter: '13',
	  searchForm: 'credere'
	}, {
	  latin: 'credidi',
	  info: '',
	  definitions: ['*pf van* credere'],
	  chapter: '18',
	  searchForm: 'credidi'
	}, {
	  latin: 'crescere',
	  info: '',
	  definitions: ['groeien'],
	  chapter: '20',
	  searchForm: 'crescere'
	}, {
	  latin: 'cretus',
	  info: '',
	  definitions: ['*ppp van* cernere'],
	  chapter: '44',
	  searchForm: 'cretus'
	}, {
	  latin: 'crevi',
	  info: '',
	  definitions: ['*pf van* cernere'],
	  chapter: '44',
	  searchForm: 'crevi'
	}, {
	  latin: 'crudelis, -e',
	  info: '',
	  definitions: ['wreed'],
	  chapter: '19',
	  searchForm: 'crudelis, -e'
	}, {
	  latin: 'cucurri',
	  info: '',
	  definitions: ['*pf van* currere'],
	  chapter: '13',
	  searchForm: 'cucurri'
	}, {
	  latin: 'culpa',
	  info: '',
	  definitions: ['schuld'],
	  chapter: '5',
	  searchForm: 'culpa'
	}, {
	  latin: 'cultus',
	  info: '4',
	  definitions: ['verzorging, beschaving', 'verering'],
	  chapter: '47',
	  searchForm: 'cultus'
	}, {
	  latin: 'cum',
	  info: '+ abl',
	  definitions: ['met'],
	  chapter: '3',
	  searchForm: 'cum'
	}, {
	  latin: 'cum',
	  info: '+ conj',
	  definitions: ['toen, nadat', 'omdat', 'hoewel'],
	  chapter: '44',
	  searchForm: 'cum'
	}, {
	  latin: 'cum',
	  info: '+ ind',
	  definitions: ['wanneer, toen'],
	  chapter: '23',
	  searchForm: 'cum'
	}, {
	  latin: 'cuncti, -ae, -a',
	  info: 'mv',
	  definitions: ['**bnw** alle', '**znw** allen, alles'],
	  chapter: '23',
	  searchForm: 'cuncti, -ae, -a'
	}, {
	  latin: 'cupere, cupio',
	  info: '',
	  definitions: ['graag willen, verlangen'],
	  chapter: '6',
	  searchForm: 'cupere, cupio'
	}, {
	  latin: 'cupivi',
	  info: '',
	  definitions: ['*pf van* cupere'],
	  chapter: '24',
	  searchForm: 'cupivi'
	}, {
	  latin: 'cur',
	  info: '',
	  definitions: ['waarom'],
	  chapter: '3',
	  searchForm: 'cur'
	}, {
	  latin: 'curare',
	  info: '+ acc',
	  definitions: ['verzorgen, zorgen voor'],
	  chapter: '8',
	  searchForm: 'curare'
	}, {
	  latin: 'curia',
	  info: '',
	  definitions: ['senaatsgebouw'],
	  chapter: '30',
	  searchForm: 'curia'
	}, {
	  latin: 'currere',
	  info: '',
	  definitions: ['rennen'],
	  chapter: '9',
	  searchForm: 'currere'
	}, {
	  latin: 'currus',
	  info: '4',
	  definitions: ['wagen'],
	  chapter: '52',
	  searchForm: 'currus'
	}, {
	  latin: 'custodire',
	  info: '',
	  definitions: ['bewaken'],
	  chapter: '2',
	  searchForm: 'custodire'
	}, {
	  latin: 'custos, custodes',
	  info: 'm',
	  definitions: ['bewaker'],
	  chapter: '4',
	  searchForm: 'custos, custodes'
	}, {
	  latin: 'dare',
	  info: '',
	  definitions: ['geven'],
	  chapter: '2',
	  searchForm: 'dare'
	}, {
	  latin: 'datum',
	  info: '',
	  definitions: ['*ppp van* dare'],
	  chapter: '37',
	  searchForm: 'datum'
	}, {
	  latin: 'de',
	  info: '+ abl',
	  definitions: ['van(af)', 'over'],
	  chapter: '3',
	  searchForm: 'de'
	}, {
	  latin: 'dea',
	  info: '',
	  definitions: ['godin'],
	  chapter: '5',
	  searchForm: 'dea'
	}, {
	  latin: 'debēre',
	  info: '',
	  definitions: ['moeten'],
	  chapter: '5',
	  searchForm: 'debere'
	}, {
	  latin: 'decernere',
	  info: '',
	  definitions: ['beslissen'],
	  chapter: '36',
	  searchForm: 'decernere'
	}, {
	  latin: 'decet',
	  info: '+ acc',
	  definitions: ['(het) past bij'],
	  chapter: '22',
	  searchForm: 'decet'
	}, {
	  latin: 'decretus',
	  info: '',
	  definitions: ['*ppp van* decernere'],
	  chapter: '47',
	  searchForm: 'decretus'
	}, {
	  latin: 'decrevi',
	  info: '',
	  definitions: ['*pf van* decernere'],
	  chapter: '47',
	  searchForm: 'decrevi'
	}, {
	  latin: 'dedere (se)',
	  info: '',
	  definitions: ['(zich) overgeven'],
	  chapter: '38',
	  searchForm: 'dedere (se)'
	}, {
	  latin: 'dedi',
	  info: '',
	  definitions: ['*pf van* dare'],
	  chapter: '13',
	  searchForm: 'dedi'
	}, {
	  latin: 'dedidi',
	  info: '',
	  definitions: ['*pf van* dedere (se)'],
	  chapter: '46',
	  searchForm: 'dedidi'
	}, {
	  latin: 'deditus',
	  info: '',
	  definitions: ['*ppp van* dedere (se)'],
	  chapter: '46',
	  searchForm: 'deditus'
	}, {
	  latin: 'defendere',
	  info: '',
	  definitions: ['verdedigen'],
	  chapter: '30',
	  searchForm: 'defendere'
	}, {
	  latin: 'deficere, deficio',
	  info: '',
	  definitions: ['ontbreken'],
	  chapter: '23',
	  searchForm: 'deficere, deficio'
	}, {
	  latin: 'deicere, deicio',
	  info: '',
	  definitions: ['neergooien, afwerpen'],
	  chapter: '32',
	  searchForm: 'deicere, deicio'
	}, {
	  latin: 'deieci',
	  info: '',
	  definitions: ['*pf van* deicere'],
	  chapter: '32',
	  searchForm: 'deieci'
	}, {
	  latin: 'deiectus',
	  info: '',
	  definitions: ['*ppp van* deicere'],
	  chapter: '32',
	  searchForm: 'deiectus'
	}, {
	  latin: 'deinde',
	  info: '',
	  definitions: ['daarna'],
	  chapter: '9',
	  searchForm: 'deinde'
	}, {
	  latin: 'delectare',
	  info: '',
	  definitions: ['blij maken'],
	  chapter: '48',
	  searchForm: 'delectare'
	}, {
	  latin: 'delēre',
	  info: '',
	  definitions: ['vernielen'],
	  chapter: '27',
	  searchForm: 'delere'
	}, {
	  latin: 'demisi',
	  info: '',
	  definitions: ['*pf van* demittere'],
	  chapter: '44',
	  searchForm: 'demisi'
	}, {
	  latin: 'demissus',
	  info: '',
	  definitions: ['*ppp van* demittere'],
	  chapter: '44',
	  searchForm: 'demissus'
	}, {
	  latin: 'demittere',
	  info: '',
	  definitions: ['laten zakken, neerlaten'],
	  chapter: '44',
	  searchForm: 'demittere'
	}, {
	  latin: 'descendere',
	  info: '',
	  definitions: ['afdalen'],
	  chapter: '38',
	  searchForm: 'descendere'
	}, {
	  latin: 'descendi',
	  info: '',
	  definitions: ['*pf van* descendere'],
	  chapter: '38',
	  searchForm: 'descendi'
	}, {
	  latin: 'descensus',
	  info: '',
	  definitions: ['*ppp van* descendere'],
	  chapter: '38',
	  searchForm: 'descensus'
	}, {
	  latin: 'desiderare',
	  info: '',
	  definitions: ['verlangen (naar)'],
	  chapter: '34',
	  searchForm: 'desiderare'
	}, {
	  latin: 'desii',
	  info: '',
	  definitions: ['*pf van* desinere'],
	  chapter: '54',
	  searchForm: 'desii'
	}, {
	  latin: 'desinere',
	  info: '',
	  definitions: ['ophouden'],
	  chapter: '16',
	  searchForm: 'desinere'
	}, {
	  latin: 'desitus',
	  info: '',
	  definitions: ['*ppp van* desinere'],
	  chapter: '54',
	  searchForm: 'desitus'
	}, {
	  latin: 'detractus',
	  info: '',
	  definitions: ['*ppp van* detrahere'],
	  chapter: '55',
	  searchForm: 'detractus'
	}, {
	  latin: 'detrahere',
	  info: '',
	  definitions: ['wegnemen, afrukken'],
	  chapter: '55',
	  searchForm: 'detrahere'
	}, {
	  latin: 'detraxi',
	  info: '',
	  definitions: ['*pf van* detrahere'],
	  chapter: '55',
	  searchForm: 'detraxi'
	}, {
	  latin: 'deus',
	  info: '',
	  definitions: ['god'],
	  chapter: '2',
	  searchForm: 'deus'
	}, {
	  latin: 'dexter, -tra, -trum',
	  info: '',
	  definitions: ['rechter-, rechts'],
	  chapter: '36',
	  searchForm: 'dexter, -tra, -trum'
	}, {
	  latin: 'dicere',
	  info: '',
	  definitions: ['zeggen'],
	  chapter: '2',
	  searchForm: 'dicere'
	}, {
	  latin: 'dictus',
	  info: '',
	  definitions: ['*ppp van* dicere'],
	  chapter: '34',
	  searchForm: 'dictus'
	}, {
	  latin: 'didici',
	  info: '',
	  definitions: ['*pf van* discere'],
	  chapter: '29',
	  searchForm: 'didici'
	}, {
	  latin: 'dies',
	  info: '5 m',
	  definitions: ['dag'],
	  chapter: '36',
	  searchForm: 'dies'
	}, {
	  latin: 'difficilis, -e',
	  info: '',
	  definitions: ['moeilijk'],
	  chapter: '18',
	  searchForm: 'difficilis, -e'
	}, {
	  latin: 'discedere',
	  info: '',
	  definitions: ['weggaan'],
	  chapter: '5',
	  searchForm: 'discedere'
	}, {
	  latin: 'discere (a(b) + *abl*)',
	  info: '',
	  definitions: ['leren (van)'],
	  chapter: '29',
	  searchForm: 'discere (a(b) + *abl*)'
	}, {
	  latin: 'discessi',
	  info: '',
	  definitions: ['*pf van* discedere'],
	  chapter: '47',
	  searchForm: 'discessi'
	}, {
	  latin: 'discessus',
	  info: '',
	  definitions: ['*ppp van* discedere'],
	  chapter: '47',
	  searchForm: 'discessus'
	}, {
	  latin: 'diu',
	  info: '',
	  definitions: ['lang, lange tijd'],
	  chapter: '5',
	  searchForm: 'diu'
	}, {
	  latin: 'dives, divit-',
	  info: '',
	  definitions: ['rijk'],
	  chapter: '23',
	  searchForm: 'dives, divit-'
	}, {
	  latin: 'dividere',
	  info: '',
	  definitions: ['verdelen'],
	  chapter: '3',
	  searchForm: 'dividere'
	}, {
	  latin: 'divitiae',
	  info: 'mv',
	  definitions: ['rijkdom'],
	  chapter: '29',
	  searchForm: 'divitiae'
	}, {
	  latin: 'dixi',
	  info: '',
	  definitions: ['*pf van* dicere'],
	  chapter: '12',
	  searchForm: 'dixi'
	}, {
	  latin: 'docēre',
	  info: '',
	  definitions: ['onderwijzen'],
	  chapter: '5',
	  searchForm: 'docere'
	}, {
	  latin: 'doctus',
	  info: '',
	  definitions: ['*ppp van* docēre'],
	  chapter: '33',
	  searchForm: 'doctus'
	}, {
	  latin: 'docui',
	  info: '',
	  definitions: ['*pf van* docēre'],
	  chapter: '33',
	  searchForm: 'docui'
	}, {
	  latin: 'dolēre',
	  info: '',
	  definitions: ['treuren, pijn hebben'],
	  chapter: '30',
	  searchForm: 'dolere'
	}, {
	  latin: 'dolor, dolores',
	  info: 'm',
	  definitions: ['pijn, verdriet'],
	  chapter: '24',
	  searchForm: 'dolor, dolores'
	}, {
	  latin: 'dolus',
	  info: '',
	  definitions: ['list'],
	  chapter: '22',
	  searchForm: 'dolus'
	}, {
	  latin: 'domi',
	  info: '',
	  definitions: ['thuis'],
	  chapter: '9',
	  searchForm: 'domi'
	}, {
	  latin: 'dominus',
	  info: '',
	  definitions: ['meester, heer des huizes'],
	  chapter: '13',
	  searchForm: 'dominus'
	}, {
	  latin: 'domum',
	  info: 'bijw',
	  definitions: ['naar huis'],
	  chapter: '11',
	  searchForm: 'domum'
	}, {
	  latin: 'domus',
	  info: '4 v',
	  definitions: ['huis'],
	  chapter: '13',
	  searchForm: 'domus'
	}, {
	  latin: 'donec',
	  info: '',
	  definitions: ['totdat'],
	  chapter: '24',
	  searchForm: 'donec'
	}, {
	  latin: 'donum',
	  info: '',
	  definitions: ['geschenk'],
	  chapter: '5',
	  searchForm: 'donum'
	}, {
	  latin: 'dormire',
	  info: '',
	  definitions: ['slapen'],
	  chapter: '4',
	  searchForm: 'dormire'
	}, {
	  latin: 'dubitare',
	  info: '',
	  definitions: ['aarzelen, twijfelen'],
	  chapter: '24',
	  searchForm: 'dubitare'
	}, {
	  latin: 'ducere',
	  info: '',
	  definitions: ['leiden, brengen'],
	  chapter: '12',
	  searchForm: 'ducere'
	}, {
	  latin: 'ductus',
	  info: '',
	  definitions: ['*ppp van* ducere'],
	  chapter: '33',
	  searchForm: 'ductus'
	}, {
	  latin: 'dulcis, -e',
	  info: '',
	  definitions: ['zoet', 'lief'],
	  chapter: '16',
	  searchForm: 'dulcis, -e'
	}, {
	  latin: 'dum',
	  info: '+ ind',
	  definitions: ['terwijl', 'zolang als'],
	  chapter: '3',
	  searchForm: 'dum'
	}, {
	  latin: 'durus, -a, -um',
	  info: '',
	  definitions: ['hard'],
	  chapter: '43',
	  searchForm: 'durus, -a, -um'
	}, {
	  latin: 'dux, duces',
	  info: 'm',
	  definitions: ['aanvoerder, leider'],
	  chapter: '6',
	  searchForm: 'dux, duces'
	}, {
	  latin: 'duxi',
	  info: '',
	  definitions: ['*pf van* ducere'],
	  chapter: '12',
	  searchForm: 'duxi'
	}, {
	  latin: 'e',
	  info: '+ abl',
	  definitions: ['uit'],
	  chapter: '5',
	  searchForm: 'e'
	}, {
	  latin: 'ecce',
	  info: '',
	  definitions: ['kijk'],
	  chapter: '4',
	  searchForm: 'ecce'
	}, {
	  latin: 'effeci',
	  info: '',
	  definitions: ['*pf van* efficere'],
	  chapter: '43',
	  searchForm: 'effeci'
	}, {
	  latin: 'effectus',
	  info: '',
	  definitions: ['*ppp van* efficere'],
	  chapter: '43',
	  searchForm: 'effectus'
	}, {
	  latin: 'efferre',
	  info: '',
	  definitions: ['naar buiten dragen'],
	  chapter: '40',
	  searchForm: 'efferre'
	}, {
	  latin: 'efficere, efficio',
	  info: '',
	  definitions: ['gedaan krijgen, bereiken'],
	  chapter: '43',
	  searchForm: 'efficere, efficio'
	}, {
	  latin: 'effugere, effugio',
	  info: '(+ acc)',
	  definitions: ['wegvluchten (voor)'],
	  chapter: '45',
	  searchForm: 'effugere, effugio'
	}, {
	  latin: 'effugi',
	  info: '',
	  definitions: ['*pf van* effugere'],
	  chapter: '45',
	  searchForm: 'effugi'
	}, {
	  latin: 'effugitus',
	  info: '',
	  definitions: ['*ppp van* effugere'],
	  chapter: '45',
	  searchForm: 'effugitus'
	}, {
	  latin: 'egēre',
	  info: '+ abl',
	  definitions: ['nodig hebben'],
	  chapter: '26',
	  searchForm: 'egere'
	}, {
	  latin: 'egi',
	  info: '',
	  definitions: ['*pf van* agere'],
	  chapter: '26',
	  searchForm: 'egi'
	}, {
	  latin: 'egredi, egredior',
	  info: '',
	  definitions: ['weggaan'],
	  chapter: '52',
	  searchForm: 'egredi, egredior'
	}, {
	  latin: 'egressus sum',
	  info: '',
	  definitions: ['*pf van* egredi'],
	  chapter: '52',
	  searchForm: 'egressus sum'
	}, {
	  latin: 'electus',
	  info: '',
	  definitions: ['*ppp van* eligere'],
	  chapter: '43',
	  searchForm: 'electus'
	}, {
	  latin: 'elegi',
	  info: '',
	  definitions: ['*pf van* eligere'],
	  chapter: '43',
	  searchForm: 'elegi'
	}, {
	  latin: 'eligere',
	  info: '',
	  definitions: ['uitkiezen'],
	  chapter: '43',
	  searchForm: 'eligere'
	}, {
	  latin: 'emere',
	  info: '',
	  definitions: ['kopen'],
	  chapter: '8',
	  searchForm: 'emere'
	}, {
	  latin: 'emi',
	  info: '',
	  definitions: ['*pf van* emere'],
	  chapter: '18',
	  searchForm: 'emi'
	}, {
	  latin: 'enim',
	  info: '',
	  definitions: ['immers, want'],
	  chapter: '10',
	  searchForm: 'enim'
	}, {
	  latin: 'epistula',
	  info: '',
	  definitions: ['brief'],
	  chapter: '50',
	  searchForm: 'epistula'
	}, {
	  latin: 'equus',
	  info: '',
	  definitions: ['paard'],
	  chapter: '6',
	  searchForm: 'equus'
	}, {
	  latin: 'ergo',
	  info: '',
	  definitions: ['dus, dan'],
	  chapter: '16',
	  searchForm: 'ergo'
	}, {
	  latin: 'errare',
	  info: '',
	  definitions: ['zwerven', 'zich vergissen'],
	  chapter: '55',
	  searchForm: 'errare'
	}, {
	  latin: 'esse',
	  info: '',
	  definitions: ['zijn'],
	  chapter: '2',
	  searchForm: 'esse'
	}, {
	  latin: 'et',
	  info: '',
	  definitions: ['en', 'ook'],
	  chapter: '1',
	  searchForm: 'et'
	}, {
	  latin: 'etiam',
	  info: '',
	  definitions: ['zelfs'],
	  chapter: '17',
	  searchForm: 'etiam'
	}, {
	  latin: 'evadere',
	  info: '',
	  definitions: ['ontsnappen'],
	  chapter: '44',
	  searchForm: 'evadere'
	}, {
	  latin: 'evasi',
	  info: '',
	  definitions: ['*pf van* evadere'],
	  chapter: '45',
	  searchForm: 'evasi'
	}, {
	  latin: 'evasus',
	  info: '',
	  definitions: ['*ppp van* evadere'],
	  chapter: '45',
	  searchForm: 'evasus'
	}, {
	  latin: 'ex',
	  info: '+ abl',
	  definitions: ['uit'],
	  chapter: '5',
	  searchForm: 'ex'
	}, {
	  latin: 'exactus',
	  info: '',
	  definitions: ['*ppp van* exigere'],
	  chapter: '55',
	  searchForm: 'exactus'
	}, {
	  latin: 'excitare',
	  info: '',
	  definitions: ['(op)wekken'],
	  chapter: '41',
	  searchForm: 'excitare'
	}, {
	  latin: 'exclamare',
	  info: '',
	  definitions: ['uitroepen'],
	  chapter: '44',
	  searchForm: 'exclamare'
	}, {
	  latin: 'exegi',
	  info: '',
	  definitions: ['*pf van* exigere'],
	  chapter: '55',
	  searchForm: 'exegi'
	}, {
	  latin: 'exemplum',
	  info: '',
	  definitions: ['voorbeeld'],
	  chapter: '13',
	  searchForm: 'exemplum'
	}, {
	  latin: 'exercitus',
	  info: '4',
	  definitions: ['leger'],
	  chapter: '36',
	  searchForm: 'exercitus'
	}, {
	  latin: 'exigere',
	  info: '',
	  definitions: ['verdrijven', '(op)eisen'],
	  chapter: '55',
	  searchForm: 'exigere'
	}, {
	  latin: 'exii',
	  info: '',
	  definitions: ['*pf van* exire'],
	  chapter: '17',
	  searchForm: 'exii'
	}, {
	  latin: 'exilium',
	  info: '',
	  definitions: ['verbanning, ballingschap'],
	  chapter: '54',
	  searchForm: 'exilium'
	}, {
	  latin: 'exire',
	  info: '',
	  definitions: ['naar buiten gaan'],
	  chapter: '17',
	  searchForm: 'exire'
	}, {
	  latin: 'exitium',
	  info: '',
	  definitions: ['ondergang'],
	  chapter: '45',
	  searchForm: 'exitium'
	}, {
	  latin: 'exiturus',
	  info: '',
	  definitions: ['*pfa van* exire'],
	  chapter: '32',
	  searchForm: 'exiturus'
	}, {
	  latin: 'exitus',
	  info: '4',
	  definitions: ['uitgang', 'afloop'],
	  chapter: '38',
	  searchForm: 'exitus'
	}, {
	  latin: 'expellere',
	  info: '',
	  definitions: ['verdrijven'],
	  chapter: '55',
	  searchForm: 'expellere'
	}, {
	  latin: 'experiri',
	  info: '',
	  definitions: ['beproeven'],
	  chapter: '50',
	  searchForm: 'experiri'
	}, {
	  latin: 'expertus sum',
	  info: '',
	  definitions: ['*pf van* experiri'],
	  chapter: '50',
	  searchForm: 'expertus sum'
	}, {
	  latin: 'expugnare',
	  info: '',
	  definitions: ['veroveren'],
	  chapter: '29',
	  searchForm: 'expugnare'
	}, {
	  latin: 'expuli',
	  info: '',
	  definitions: ['*pf van* expellere'],
	  chapter: '55',
	  searchForm: 'expuli'
	}, {
	  latin: 'expulsus',
	  info: '',
	  definitions: ['*ppp van* expellere'],
	  chapter: '55',
	  searchForm: 'expulsus'
	}, {
	  latin: 'exspectare',
	  info: '',
	  definitions: ['wachten (op)'],
	  chapter: '6',
	  searchForm: 'exspectare'
	}, {
	  latin: 'exstinguere',
	  info: '',
	  definitions: ['blussen'],
	  chapter: '45',
	  searchForm: 'exstinguere'
	}, {
	  latin: 'extra',
	  info: '+ acc',
	  definitions: ['buiten'],
	  chapter: '48',
	  searchForm: 'extra'
	}, {
	  latin: 'extra',
	  info: 'bijw',
	  definitions: ['buiten'],
	  chapter: '48',
	  searchForm: 'extra'
	}, {
	  latin: 'fabula',
	  info: '',
	  definitions: ['verhaal'],
	  chapter: '13',
	  searchForm: 'fabula'
	}, {
	  latin: 'facere, facio',
	  info: '',
	  definitions: ['doen', 'maken'],
	  chapter: '3',
	  searchForm: 'facere, facio'
	}, {
	  latin: 'facies',
	  info: '5',
	  definitions: ['gezicht, gedaante'],
	  chapter: '40',
	  searchForm: 'facies'
	}, {
	  latin: 'facilis, -e',
	  info: '',
	  definitions: ['gemakkelijk'],
	  chapter: '18',
	  searchForm: 'facilis, -e'
	}, {
	  latin: 'facinus, facinora',
	  info: '',
	  definitions: ['daad', 'misdaad'],
	  chapter: '54',
	  searchForm: 'facinus, facinora'
	}, {
	  latin: 'factus',
	  info: '',
	  definitions: ['*ppp van* facere'],
	  chapter: '33',
	  searchForm: 'factus'
	}, {
	  latin: 'factus sum',
	  info: '',
	  definitions: ['*pf van* fieri'],
	  chapter: '50',
	  searchForm: 'factus sum'
	}, {
	  latin: 'fallere',
	  info: '',
	  definitions: ['bedriegen', 'ontgaan'],
	  chapter: '55',
	  searchForm: 'fallere'
	}, {
	  latin: 'falsus',
	  info: '',
	  definitions: ['*ppp van* fallere'],
	  chapter: '55',
	  searchForm: 'falsus'
	}, {
	  latin: 'falsus, -a, -um',
	  info: '',
	  definitions: ['onwaar, ongegrond'],
	  chapter: '34',
	  searchForm: 'falsus, -a, -um'
	}, {
	  latin: 'fama',
	  info: '',
	  definitions: ['gerucht', 'goede naam', 'slechte naam'],
	  chapter: '45',
	  searchForm: 'fama'
	}, {
	  latin: 'fames, fames',
	  info: 'v',
	  definitions: ['honger'],
	  chapter: '46',
	  searchForm: 'fames, fames'
	}, {
	  latin: 'familia',
	  info: '',
	  definitions: ['familie, huishouden'],
	  chapter: '16',
	  searchForm: 'familia'
	}, {
	  latin: 'favēre',
	  info: '+ dat',
	  definitions: ['steun geven aan'],
	  chapter: '2',
	  searchForm: 'favere'
	}, {
	  latin: 'feci',
	  info: '',
	  definitions: ['*pf van* facere'],
	  chapter: '12',
	  searchForm: 'feci'
	}, {
	  latin: 'fefelli',
	  info: '',
	  definitions: ['*pf van* fallere'],
	  chapter: '55',
	  searchForm: 'fefelli'
	}, {
	  latin: 'felix, felic-',
	  info: '',
	  definitions: ['gelukkig'],
	  chapter: '17',
	  searchForm: 'felix, felic-'
	}, {
	  latin: 'femina',
	  info: '',
	  definitions: ['vrouw'],
	  chapter: '2',
	  searchForm: 'femina'
	}, {
	  latin: 'ferox, feroc-',
	  info: '',
	  definitions: ['woest, onstuimig'],
	  chapter: '19',
	  searchForm: 'ferox, feroc-'
	}, {
	  latin: 'ferre',
	  info: '',
	  definitions: ['dragen, brengen', 'verdragen'],
	  chapter: '32',
	  searchForm: 'ferre'
	}, {
	  latin: 'fides',
	  info: '5',
	  definitions: ['(woord van) trouw', 'vertrouwen'],
	  chapter: '38',
	  searchForm: 'fides'
	}, {
	  latin: 'fidus, -a, -um',
	  info: '',
	  definitions: ['trouw', 'betrouwbaar'],
	  chapter: '18',
	  searchForm: 'fidus, -a, -um'
	}, {
	  latin: 'fieri',
	  info: '',
	  definitions: ['(gemaakt) worden', 'gebeuren'],
	  chapter: '50',
	  searchForm: 'fieri'
	}, {
	  latin: 'filia',
	  info: '',
	  definitions: ['dochter'],
	  chapter: '8',
	  searchForm: 'filia'
	}, {
	  latin: 'filius',
	  info: '',
	  definitions: ['zoon'],
	  chapter: '2',
	  searchForm: 'filius'
	}, {
	  latin: 'finire',
	  info: '',
	  definitions: ['beëindigen'],
	  chapter: '9',
	  searchForm: 'finire'
	}, {
	  latin: 'finis, fines',
	  info: 'm',
	  definitions: ['grens, einde', '**mv** gebied'],
	  chapter: '26',
	  searchForm: 'finis, fines'
	}, {
	  latin: 'flamma',
	  info: '',
	  definitions: ['vlam'],
	  chapter: '45',
	  searchForm: 'flamma'
	}, {
	  latin: 'fluctus',
	  info: '4',
	  definitions: ['golf'],
	  chapter: '53',
	  searchForm: 'fluctus'
	}, {
	  latin: 'fluere',
	  info: '',
	  definitions: ['stromen'],
	  chapter: '9',
	  searchForm: 'fluere'
	}, {
	  latin: 'flumen, flumina',
	  info: '',
	  definitions: ['rivier'],
	  chapter: '1',
	  searchForm: 'flumen, flumina'
	}, {
	  latin: 'fons, fontes',
	  info: 'v',
	  definitions: ['bron'],
	  chapter: '51',
	  searchForm: 'fons, fontes'
	}, {
	  latin: 'forma',
	  info: '',
	  definitions: ['gestalte, schoonheid'],
	  chapter: '23',
	  searchForm: 'forma'
	}, {
	  latin: 'fortasse',
	  info: '',
	  definitions: ['misschien'],
	  chapter: '8',
	  searchForm: 'fortasse'
	}, {
	  latin: 'fortis, -e',
	  info: '',
	  definitions: ['dapper', 'sterk'],
	  chapter: '16',
	  searchForm: 'fortis, -e'
	}, {
	  latin: 'forum',
	  info: '',
	  definitions: ['forum, marktplaats'],
	  chapter: '6',
	  searchForm: 'forum'
	}, {
	  latin: 'fractus',
	  info: '',
	  definitions: ['*ppp van* frangere'],
	  chapter: '29, 54',
	  searchForm: 'fractus'
	}, {
	  latin: 'frangere',
	  info: '',
	  definitions: ['breken'],
	  chapter: '29',
	  searchForm: 'frangere'
	}, {
	  latin: 'frater, fratres',
	  info: 'm',
	  definitions: ['broer'],
	  chapter: '3',
	  searchForm: 'frater, fratres'
	}, {
	  latin: 'fregi',
	  info: '',
	  definitions: ['*pf van* frangere'],
	  chapter: '29, 54',
	  searchForm: 'fregi'
	}, {
	  latin: 'frequens, frequent-',
	  info: '',
	  definitions: ['herhaaldelijk'],
	  chapter: '27',
	  searchForm: 'frequens, frequent-'
	}, {
	  latin: 'fructus sum',
	  info: '',
	  definitions: ['*pf van* frui'],
	  chapter: '50',
	  searchForm: 'fructus sum'
	}, {
	  latin: 'frui',
	  info: '+ abl',
	  definitions: ['genieten van'],
	  chapter: '51',
	  searchForm: 'frui'
	}, {
	  latin: 'frumentum',
	  info: '',
	  definitions: ['graan'],
	  chapter: '26',
	  searchForm: 'frumentum'
	}, {
	  latin: 'frustra',
	  info: '',
	  definitions: ['tevergeefs'],
	  chapter: '10',
	  searchForm: 'frustra'
	}, {
	  latin: 'fuga',
	  info: '',
	  definitions: ['vlucht'],
	  chapter: '20',
	  searchForm: 'fuga'
	}, {
	  latin: 'fugere, fugio',
	  info: '',
	  definitions: ['vluchten', '**+ acc** ontvluchten'],
	  chapter: '6, 19',
	  searchForm: 'fugere, fugio'
	}, {
	  latin: 'fugi',
	  info: '',
	  definitions: ['*pf van* fugere'],
	  chapter: '13',
	  searchForm: 'fugi'
	}, {
	  latin: 'fui',
	  info: '',
	  definitions: ['*pf van* esse'],
	  chapter: '12',
	  searchForm: 'fui'
	}, {
	  latin: 'functus sum',
	  info: '',
	  definitions: ['*pf van* fungi'],
	  chapter: '50',
	  searchForm: 'functus sum'
	}, {
	  latin: 'fundere',
	  info: '',
	  definitions: ['gieten, storten'],
	  chapter: '25',
	  searchForm: 'fundere'
	}, {
	  latin: 'fungi',
	  info: '+ abl',
	  definitions: ['verrichten, vervullen'],
	  chapter: '50',
	  searchForm: 'fungi'
	}, {
	  latin: 'funus, funera',
	  info: '',
	  definitions: ['begrafenis'],
	  chapter: '17',
	  searchForm: 'funus, funera'
	}, {
	  latin: 'furere',
	  info: '',
	  definitions: ['tekeer gaan'],
	  chapter: '53',
	  searchForm: 'furere'
	}, {
	  latin: 'futurum',
	  info: '',
	  definitions: ['*pfa van* esse'],
	  chapter: '33',
	  searchForm: 'futurum'
	}, {
	  latin: 'gaudēre',
	  info: '',
	  definitions: ['blij zijn'],
	  chapter: '9',
	  searchForm: 'gaudere'
	}, {
	  latin: 'gaudium',
	  info: '',
	  definitions: ['vreugde'],
	  chapter: '16',
	  searchForm: 'gaudium'
	}, {
	  latin: 'gavisus sum',
	  info: '',
	  definitions: ['*pf van* gaudēre'],
	  chapter: '50',
	  searchForm: 'gavisus sum'
	}, {
	  latin: 'gens, gentes',
	  info: 'v',
	  definitions: ['volk, stam', 'geslacht'],
	  chapter: '37',
	  searchForm: 'gens, gentes'
	}, {
	  latin: 'genu, genua',
	  info: '',
	  definitions: ['knie'],
	  chapter: '44',
	  searchForm: 'genu, genua'
	}, {
	  latin: 'gerere',
	  info: '',
	  definitions: ['dragen', 'voeren'],
	  chapter: '6',
	  searchForm: 'gerere'
	}, {
	  latin: 'gladius',
	  info: '',
	  definitions: ['zwaard'],
	  chapter: '3',
	  searchForm: 'gladius'
	}, {
	  latin: 'gloria',
	  info: '',
	  definitions: ['roem'],
	  chapter: '34',
	  searchForm: 'gloria'
	}, {
	  latin: 'gradus',
	  info: '4',
	  definitions: ['stap, trede'],
	  chapter: '36',
	  searchForm: 'gradus'
	}, {
	  latin: 'Graecus',
	  info: '',
	  definitions: ['Griek'],
	  chapter: '43',
	  searchForm: 'Graecus'
	}, {
	  latin: 'Graecus, -a, -um',
	  info: '',
	  definitions: ['Grieks'],
	  chapter: '43',
	  searchForm: 'Graecus, -a, -um'
	}, {
	  latin: 'gratia',
	  info: '',
	  definitions: ['gunst', 'charme', 'dank'],
	  chapter: '44',
	  searchForm: 'gratia'
	}, {
	  latin: 'gratias agere',
	  info: '',
	  definitions: ['dank betuigen'],
	  chapter: '46',
	  searchForm: 'gratias agere'
	}, {
	  latin: 'gravis, -e',
	  info: '',
	  definitions: ['zwaar, ernstig'],
	  chapter: '18',
	  searchForm: 'gravis, -e'
	}, {
	  latin: 'habēre',
	  info: '',
	  definitions: ['hebben', 'houden'],
	  chapter: '8, 30',
	  searchForm: 'habere'
	}, {
	  latin: 'habitare',
	  info: '',
	  definitions: ['(be)wonen'],
	  chapter: '13',
	  searchForm: 'habitare'
	}, {
	  latin: 'haerēre',
	  info: '',
	  definitions: ['blijven steken'],
	  chapter: '36',
	  searchForm: 'haerere'
	}, {
	  latin: 'haud',
	  info: '',
	  definitions: ['helemaal niet'],
	  chapter: '2',
	  searchForm: 'haud'
	}, {
	  latin: 'heri',
	  info: '',
	  definitions: ['gisteren'],
	  chapter: '12',
	  searchForm: 'heri'
	}, {
	  latin: 'hic',
	  info: 'bijw',
	  definitions: ['hier'],
	  chapter: '8',
	  searchForm: 'hic'
	}, {
	  latin: 'hic, haec, hoc',
	  info: '',
	  definitions: ['deze, dit'],
	  chapter: '40',
	  searchForm: 'hic, haec, hoc'
	}, {
	  latin: 'hiems, hiemes',
	  info: 'v',
	  definitions: ['winter'],
	  chapter: '53',
	  searchForm: 'hiems, hiemes'
	}, {
	  latin: 'hinc',
	  info: '',
	  definitions: ['hiervandaan'],
	  chapter: '45',
	  searchForm: 'hinc'
	}, {
	  latin: 'hodie',
	  info: '',
	  definitions: ['vandaag'],
	  chapter: '9',
	  searchForm: 'hodie'
	}, {
	  latin: 'homo, homines',
	  info: 'm',
	  definitions: ['mens, man'],
	  chapter: '10',
	  searchForm: 'homo, homines'
	}, {
	  latin: 'honor, honores',
	  info: 'm',
	  definitions: ['eer', '(ere)ambt'],
	  chapter: '34',
	  searchForm: 'honor, honores'
	}, {
	  latin: 'hora',
	  info: '',
	  definitions: ['uur'],
	  chapter: '11',
	  searchForm: 'hora'
	}, {
	  latin: 'hortari',
	  info: '',
	  definitions: ['aansporen'],
	  chapter: '50',
	  searchForm: 'hortari'
	}, {
	  latin: 'hospes, hospites',
	  info: 'm',
	  definitions: ['gast'],
	  chapter: '13',
	  searchForm: 'hospes, hospites'
	}, {
	  latin: 'hostis, hostes',
	  info: 'm',
	  definitions: ['vijand'],
	  chapter: '3',
	  searchForm: 'hostis, hostes'
	}, {
	  latin: 'humilis, -e',
	  info: '',
	  definitions: ['laag', 'nederig'],
	  chapter: '18',
	  searchForm: 'humilis, -e'
	}, {
	  latin: 'iacēre',
	  info: '',
	  definitions: ['liggen'],
	  chapter: '1',
	  searchForm: 'iacere'
	}, {
	  latin: 'iacere, iacio',
	  info: '',
	  definitions: ['werpen'],
	  chapter: '36',
	  searchForm: 'iacere, iacio'
	}, {
	  latin: 'iactare',
	  info: '',
	  definitions: ['slingeren', 'opscheppen over'],
	  chapter: '44',
	  searchForm: 'iactare'
	}, {
	  latin: 'iactus',
	  info: '',
	  definitions: ['*ppp van* iacere'],
	  chapter: '39',
	  searchForm: 'iactus'
	}, {
	  latin: 'iam',
	  info: '',
	  definitions: ['al, reeds'],
	  chapter: '3',
	  searchForm: 'iam'
	}, {
	  latin: 'ibi',
	  info: '',
	  definitions: ['daar'],
	  chapter: '1',
	  searchForm: 'ibi'
	}, {
	  latin: 'id',
	  info: 'nom/acc',
	  definitions: ['dit'],
	  chapter: '11',
	  searchForm: 'id'
	}, {
	  latin: 'idem, eadem, idem',
	  info: '',
	  definitions: ['dezelfde, hetzelfde'],
	  chapter: '40',
	  searchForm: 'idem, eadem, idem'
	}, {
	  latin: 'ideo',
	  info: '',
	  definitions: ['daarom'],
	  chapter: '1',
	  searchForm: 'ideo'
	}, {
	  latin: 'ieci',
	  info: '',
	  definitions: ['*pf van* iacere'],
	  chapter: '39',
	  searchForm: 'ieci'
	}, {
	  latin: 'igitur',
	  info: '',
	  definitions: ['dus'],
	  chapter: '47',
	  searchForm: 'igitur'
	}, {
	  latin: 'ignis, ignes',
	  info: 'm',
	  definitions: ['vuur'],
	  chapter: '5',
	  searchForm: 'ignis, ignes'
	}, {
	  latin: 'ignoscere',
	  info: '+ dat',
	  definitions: ['vergeven'],
	  chapter: '52',
	  searchForm: 'ignoscere'
	}, {
	  latin: 'ignotus, -a, -um',
	  info: '',
	  definitions: ['onbekend'],
	  chapter: '26',
	  searchForm: 'ignotus, -a, -um'
	}, {
	  latin: 'ii',
	  info: '',
	  definitions: ['*pf van* ire'],
	  chapter: '17',
	  searchForm: 'ii'
	}, {
	  latin: 'ille, illa, illud',
	  info: '',
	  definitions: ['die, dat'],
	  chapter: '40',
	  searchForm: 'ille, illa, illud'
	}, {
	  latin: 'illustris, -e',
	  info: '',
	  definitions: ['aanzienlijk, beroemd'],
	  chapter: '16',
	  searchForm: 'illustris, -e'
	}, {
	  latin: 'imago, imagines',
	  info: 'v',
	  definitions: ['beeld, afbeelding'],
	  chapter: '24',
	  searchForm: 'imago, imagines'
	}, {
	  latin: 'immensus, -a, -um',
	  info: '',
	  definitions: ['onmetelijk'],
	  chapter: '46',
	  searchForm: 'immensus, -a, -um'
	}, {
	  latin: 'imminēre',
	  info: '+ dat',
	  definitions: ['(be)dreigen'],
	  chapter: '39',
	  searchForm: 'imminere'
	}, {
	  latin: 'immo',
	  info: '',
	  definitions: ['integendeel'],
	  chapter: '8',
	  searchForm: 'immo'
	}, {
	  latin: 'impedire',
	  info: '',
	  definitions: ['belemmeren, verhinderen'],
	  chapter: '36',
	  searchForm: 'impedire'
	}, {
	  latin: 'imperare',
	  info: '',
	  definitions: ['bevelen, opdragen'],
	  chapter: '54',
	  searchForm: 'imperare'
	}, {
	  latin: 'imperator, -ores',
	  info: 'm',
	  definitions: ['opperbevelhebber', 'keizer'],
	  chapter: '38',
	  searchForm: 'imperator, -ores'
	}, {
	  latin: 'imperium',
	  info: '',
	  definitions: ['bevel, gezag', 'heerschappij, rijk'],
	  chapter: '38',
	  searchForm: 'imperium'
	}, {
	  latin: 'impetus',
	  info: '4',
	  definitions: ['het aanstormen', 'aanval'],
	  chapter: '36',
	  searchForm: 'impetus'
	}, {
	  latin: 'imponere',
	  info: '',
	  definitions: ['plaatsen op, opleggen'],
	  chapter: '46',
	  searchForm: 'imponere'
	}, {
	  latin: 'improbus, -a, -um',
	  info: '',
	  definitions: ['slecht, gemeen'],
	  chapter: '43',
	  searchForm: 'improbus, -a, -um'
	}, {
	  latin: 'in',
	  info: '+ abl',
	  definitions: ['in', 'op'],
	  chapter: '3',
	  searchForm: 'in'
	}, {
	  latin: 'in',
	  info: '+ acc',
	  definitions: ['in, naar'],
	  chapter: '1',
	  searchForm: 'in'
	}, {
	  latin: 'inanis, -e',
	  info: '',
	  definitions: ['leeg, zinloos'],
	  chapter: '39',
	  searchForm: 'inanis, -e'
	}, {
	  latin: 'incendium',
	  info: '',
	  definitions: ['brand'],
	  chapter: '45',
	  searchForm: 'incendium'
	}, {
	  latin: 'incepi',
	  info: '',
	  definitions: ['*pf van* incipere'],
	  chapter: '12',
	  searchForm: 'incepi'
	}, {
	  latin: 'inceptus',
	  info: '',
	  definitions: ['*ppp van* incipere'],
	  chapter: '32',
	  searchForm: 'inceptus'
	}, {
	  latin: 'incertus, -a, -um',
	  info: '',
	  definitions: ['onzeker'],
	  chapter: '53',
	  searchForm: 'incertus, -a, -um'
	}, {
	  latin: 'incipere, incipio',
	  info: '',
	  definitions: ['beginnen'],
	  chapter: '8',
	  searchForm: 'incipere, incipio'
	}, {
	  latin: 'includere',
	  info: '',
	  definitions: ['insluiten'],
	  chapter: '40',
	  searchForm: 'includere'
	}, {
	  latin: 'inclusi',
	  info: '',
	  definitions: ['*pf van* includere'],
	  chapter: '40',
	  searchForm: 'inclusi'
	}, {
	  latin: 'inclusus',
	  info: '',
	  definitions: ['*ppp van* includere'],
	  chapter: '40',
	  searchForm: 'inclusus'
	}, {
	  latin: 'ingenium',
	  info: '',
	  definitions: ['karakter', 'aanleg'],
	  chapter: '47',
	  searchForm: 'ingenium'
	}, {
	  latin: 'ingens, ingent-',
	  info: '',
	  definitions: ['enorm, geweldig'],
	  chapter: '16',
	  searchForm: 'ingens, ingent-'
	}, {
	  latin: 'inii',
	  info: '',
	  definitions: ['*pf van* inire'],
	  chapter: '38',
	  searchForm: 'inii'
	}, {
	  latin: 'inimicus',
	  info: '',
	  definitions: ['vijand'],
	  chapter: '39',
	  searchForm: 'inimicus'
	}, {
	  latin: 'inimicus, -a, -um',
	  info: '',
	  definitions: ['vijandig'],
	  chapter: '39',
	  searchForm: 'inimicus, -a, -um'
	}, {
	  latin: 'inire',
	  info: '',
	  definitions: ['ingaan', 'beginnen'],
	  chapter: '38',
	  searchForm: 'inire'
	}, {
	  latin: 'initium',
	  info: '',
	  definitions: ['begin'],
	  chapter: '8',
	  searchForm: 'initium'
	}, {
	  latin: 'initurus',
	  info: '',
	  definitions: ['*pfa van* inire'],
	  chapter: '38',
	  searchForm: 'initurus'
	}, {
	  latin: 'iniuria',
	  info: '',
	  definitions: ['onrecht'],
	  chapter: '12',
	  searchForm: 'iniuria'
	}, {
	  latin: 'incolumis, -e',
	  info: '',
	  definitions: ['ongedeerd'],
	  chapter: '36',
	  searchForm: 'incolumis, -e'
	}, {
	  latin: 'inopia',
	  info: '',
	  definitions: ['gebrek, armoede'],
	  chapter: '46',
	  searchForm: 'inopia'
	}, {
	  latin: 'inquit',
	  info: '',
	  definitions: ['hij/zij zegt', 'hij/zij zei'],
	  chapter: '24',
	  searchForm: 'inquit'
	}, {
	  latin: 'insignis, -e',
	  info: '',
	  definitions: ['opvallend'],
	  chapter: '40',
	  searchForm: 'insignis, -e'
	}, {
	  latin: 'instare',
	  info: '+ dat',
	  definitions: ['achterna zitten'],
	  chapter: '36',
	  searchForm: 'instare'
	}, {
	  latin: 'instituere',
	  info: '',
	  definitions: ['oprichten'],
	  chapter: '47',
	  searchForm: 'instituere'
	}, {
	  latin: 'instructus',
	  info: '',
	  definitions: ['*ppp van* instruere'],
	  chapter: '31',
	  searchForm: 'instructus'
	}, {
	  latin: 'instruere',
	  info: '',
	  definitions: ['opstellen'],
	  chapter: '31',
	  searchForm: 'instruere'
	}, {
	  latin: 'instruxi',
	  info: '',
	  definitions: ['*pf van* instruere'],
	  chapter: '31',
	  searchForm: 'instruxi'
	}, {
	  latin: 'insula',
	  info: '',
	  definitions: ['eiland'],
	  chapter: '55',
	  searchForm: 'insula'
	}, {
	  latin: 'intellegere',
	  info: '',
	  definitions: ['begrijpen'],
	  chapter: '23',
	  searchForm: 'intellegere'
	}, {
	  latin: 'intellexi',
	  info: '',
	  definitions: ['*pf van* intellegere'],
	  chapter: '25',
	  searchForm: 'intellexi'
	}, {
	  latin: 'intendere',
	  info: '',
	  definitions: ['richten'],
	  chapter: '30',
	  searchForm: 'intendere'
	}, {
	  latin: 'inter',
	  info: '+ acc',
	  definitions: ['tussen', 'tijdens'],
	  chapter: '1',
	  searchForm: 'inter'
	}, {
	  latin: 'inter se',
	  info: '',
	  definitions: ['onderling'],
	  chapter: '44',
	  searchForm: 'inter se'
	}, {
	  latin: 'interea',
	  info: '',
	  definitions: ['intussen'],
	  chapter: '6',
	  searchForm: 'interea'
	}, {
	  latin: 'interest',
	  info: '',
	  definitions: ['het is van belang'],
	  chapter: '41',
	  searchForm: 'interest'
	}, {
	  latin: 'interfeci',
	  info: '',
	  definitions: ['*pf van* interficere'],
	  chapter: '33',
	  searchForm: 'interfeci'
	}, {
	  latin: 'interfectus',
	  info: '',
	  definitions: ['*ppp van* interficere'],
	  chapter: '31',
	  searchForm: 'interfectus'
	}, {
	  latin: 'interficere, -ficio',
	  info: '',
	  definitions: ['doden'],
	  chapter: '31',
	  searchForm: 'interficere, -ficio'
	}, {
	  latin: 'interii',
	  info: '',
	  definitions: ['*pf van* interire'],
	  chapter: '41',
	  searchForm: 'interii'
	}, {
	  latin: 'interire',
	  info: '',
	  definitions: ['omkomen, sterven'],
	  chapter: '41',
	  searchForm: 'interire'
	}, {
	  latin: 'interiturus',
	  info: '',
	  definitions: ['*pfa van* interire'],
	  chapter: '41',
	  searchForm: 'interiturus'
	}, {
	  latin: 'intra',
	  info: '+ acc',
	  definitions: ['binnen'],
	  chapter: '38',
	  searchForm: 'intra'
	}, {
	  latin: 'intrare',
	  info: '',
	  definitions: ['binnenkomen'],
	  chapter: '3',
	  searchForm: 'intrare'
	}, {
	  latin: 'invadere',
	  info: '',
	  definitions: ['binnendringen, aanvallen'],
	  chapter: '36',
	  searchForm: 'invadere'
	}, {
	  latin: 'invasi',
	  info: '',
	  definitions: ['*pf van* invadere'],
	  chapter: '41',
	  searchForm: 'invasi'
	}, {
	  latin: 'invasus',
	  info: '',
	  definitions: ['*ppp van* invadere'],
	  chapter: '41',
	  searchForm: 'invasus'
	}, {
	  latin: 'inveni',
	  info: '',
	  definitions: ['*pf van* invenire'],
	  chapter: '17',
	  searchForm: 'inveni'
	}, {
	  latin: 'invenire',
	  info: '',
	  definitions: ['vinden', 'uitvinden'],
	  chapter: '17, 33',
	  searchForm: 'invenire'
	}, {
	  latin: 'inventus',
	  info: '',
	  definitions: ['*ppp van* invenire'],
	  chapter: '33',
	  searchForm: 'inventus'
	}, {
	  latin: 'invitare',
	  info: '',
	  definitions: ['uitnodigen'],
	  chapter: '16',
	  searchForm: 'invitare'
	}, {
	  latin: 'Iovis',
	  info: '',
	  definitions: ['*gen van* Iupiter'],
	  chapter: '27',
	  searchForm: 'Iovis'
	}, {
	  latin: 'ipse, ipsa, ipsum',
	  info: '',
	  definitions: ['zelf'],
	  chapter: '22',
	  searchForm: 'ipse, ipsa, ipsum'
	}, {
	  latin: 'ira',
	  info: '',
	  definitions: ['woede'],
	  chapter: '33',
	  searchForm: 'ira'
	}, {
	  latin: 'iratus, -a, -um',
	  info: '',
	  definitions: ['boos'],
	  chapter: '17',
	  searchForm: 'iratus, -a, -um'
	}, {
	  latin: 'ire',
	  info: '',
	  definitions: ['gaan'],
	  chapter: '11',
	  searchForm: 'ire'
	}, {
	  latin: 'is, ea, id',
	  info: '',
	  definitions: ['*bnw* deze/dit, die/dat', '*znw* hij, zij, het'],
	  chapter: '40',
	  searchForm: 'iste, ista, istud'
	}, {
	  latin: 'iste, ista, istud',
	  info: '',
	  definitions: ['die, dat'],
	  chapter: '40',
	  searchForm: 'iste, ista, istud'
	}, {
	  latin: 'ita',
	  info: '',
	  definitions: ['zo'],
	  chapter: '9',
	  searchForm: 'ita'
	}, {
	  latin: 'itaque',
	  info: '',
	  definitions: ['dus'],
	  chapter: '45',
	  searchForm: 'itaque'
	}, {
	  latin: 'iter, itinera',
	  info: '',
	  definitions: ['reis'],
	  chapter: '13',
	  searchForm: 'iter, itinera'
	}, {
	  latin: 'iterum',
	  info: '',
	  definitions: ['weer, opnieuw'],
	  chapter: '9',
	  searchForm: 'iterum'
	}, {
	  latin: 'iturus',
	  info: '',
	  definitions: ['*pfa van* ire'],
	  chapter: '32',
	  searchForm: 'iturus'
	}, {
	  latin: 'iubēre',
	  info: '',
	  definitions: ['bevelen'],
	  chapter: '1',
	  searchForm: 'iubere'
	}, {
	  latin: 'iungere',
	  info: '',
	  definitions: ['verbinden'],
	  chapter: '41',
	  searchForm: 'iungere'
	}, {
	  latin: 'iurare (per + *acc*)',
	  info: '',
	  definitions: ['zweren (bij)'],
	  chapter: '29',
	  searchForm: 'iurare (per + *acc*)'
	}, {
	  latin: 'iussi',
	  info: '',
	  definitions: ['*pf van* iubēre'],
	  chapter: '18',
	  searchForm: 'iussi'
	}, {
	  latin: 'iutus',
	  info: '',
	  definitions: ['*ppp van* iuvare'],
	  chapter: '40',
	  searchForm: 'iutus'
	}, {
	  latin: 'iuvare',
	  info: '',
	  definitions: ['helpen'],
	  chapter: '40',
	  searchForm: 'iuvare'
	}, {
	  latin: 'iuvat (me)',
	  info: '',
	  definitions: ['het doet (me) plezier'],
	  chapter: '23',
	  searchForm: 'iuvat (me)'
	}, {
	  latin: 'iuvenis, iuvenes',
	  info: 'm',
	  definitions: ['jongeman'],
	  chapter: '24',
	  searchForm: 'iuvenis, iuvenes'
	}, {
	  latin: 'iuventus, -tutes',
	  info: 'v',
	  definitions: ['jeugd'],
	  chapter: '26',
	  searchForm: 'iuventus, -tutes'
	}, {
	  latin: 'iuvi',
	  info: '',
	  definitions: ['*pf van* iuvare'],
	  chapter: '40',
	  searchForm: 'iuvi'
	}, {
	  latin: 'labor, labores',
	  info: 'm',
	  definitions: ['werk, inspanning'],
	  chapter: '25',
	  searchForm: 'labor, labores'
	}, {
	  latin: 'laborare',
	  info: '',
	  definitions: ['hard werken'],
	  chapter: '23',
	  searchForm: 'laborare'
	}, {
	  latin: 'lacrima',
	  info: '',
	  definitions: ['traan'],
	  chapter: '52',
	  searchForm: 'lacrima'
	}, {
	  latin: 'lacrimare',
	  info: '',
	  definitions: ['huilen'],
	  chapter: '1',
	  searchForm: 'lacrimare'
	}, {
	  latin: 'laedere',
	  info: '',
	  definitions: ['beledigen, kwetsen'],
	  chapter: '25',
	  searchForm: 'laedere'
	}, {
	  latin: 'laesi',
	  info: '',
	  definitions: ['*pf van* laedere'],
	  chapter: '25',
	  searchForm: 'laesi'
	}, {
	  latin: 'laetus, -a, -um',
	  info: '',
	  definitions: ['blij'],
	  chapter: '15',
	  searchForm: 'laetus, -a, -um'
	}, {
	  latin: 'lapis, lapides',
	  info: 'm',
	  definitions: ['steen(soort)'],
	  chapter: '51',
	  searchForm: 'lapis, lapides'
	}, {
	  latin: 'latēre',
	  info: '',
	  definitions: ['verborgen zijn'],
	  chapter: '53',
	  searchForm: 'latere'
	}, {
	  latin: 'latus',
	  info: '',
	  definitions: ['*ppp van* ferre'],
	  chapter: '32',
	  searchForm: 'latus'
	}, {
	  latin: 'latus, -a, -um',
	  info: '',
	  definitions: ['breed, wijd'],
	  chapter: '31',
	  searchForm: 'latus, -a, -um'
	}, {
	  latin: 'laudare',
	  info: '',
	  definitions: ['prijzen'],
	  chapter: '22',
	  searchForm: 'laudare'
	}, {
	  latin: 'laus, laudes',
	  info: 'v',
	  definitions: ['lof, roem'],
	  chapter: '31',
	  searchForm: 'laus, laudes'
	}, {
	  latin: 'lavare',
	  info: '',
	  definitions: ['wassen'],
	  chapter: '25',
	  searchForm: 'lavare'
	}, {
	  latin: 'legatus',
	  info: '',
	  definitions: ['gezant', 'onderbevelhebber'],
	  chapter: '38, 48',
	  searchForm: 'legatus'
	}, {
	  latin: 'legere',
	  info: '',
	  definitions: ['lezen'],
	  chapter: '18',
	  searchForm: 'legere'
	}, {
	  latin: 'legio, legiones',
	  info: 'v',
	  definitions: ['legioen'],
	  chapter: '20',
	  searchForm: 'legio, legiones'
	}, {
	  latin: 'lenis, -e',
	  info: '',
	  definitions: ['mild, zacht'],
	  chapter: '17',
	  searchForm: 'lenis, -e'
	}, {
	  latin: 'lentus, -a, -um',
	  info: '',
	  definitions: ['traag'],
	  chapter: '19',
	  searchForm: 'lentus, -a, -um'
	}, {
	  latin: 'leo, leones',
	  info: 'm',
	  definitions: ['leeuw'],
	  chapter: '10',
	  searchForm: 'leo, leones'
	}, {
	  latin: 'lex, leges',
	  info: 'v',
	  definitions: ['wet'],
	  chapter: '52',
	  searchForm: 'lex, leges'
	}, {
	  latin: 'libenter',
	  info: '',
	  definitions: ['graag'],
	  chapter: '23',
	  searchForm: 'libenter'
	}, {
	  latin: 'liberare (a + *abl*)',
	  info: '',
	  definitions: ['bevrijden (van)'],
	  chapter: '40',
	  searchForm: 'liberare (a + *abl*)'
	}, {
	  latin: 'liberi',
	  info: 'mv',
	  definitions: ['kinderen'],
	  chapter: '15',
	  searchForm: 'liberi'
	}, {
	  latin: 'libertas, libertates',
	  info: 'v',
	  definitions: ['vrijheid'],
	  chapter: '19',
	  searchForm: 'libertas, libertates'
	}, {
	  latin: 'licet',
	  info: '(+ dat)',
	  definitions: ['het is toegestaan (aan)'],
	  chapter: '3',
	  searchForm: 'licet'
	}, {
	  latin: 'lingua',
	  info: '',
	  definitions: ['tong', 'taal'],
	  chapter: '19',
	  searchForm: 'lingua'
	}, {
	  latin: 'littera',
	  info: '',
	  definitions: ['letter'],
	  chapter: '18',
	  searchForm: 'littera'
	}, {
	  latin: 'litus, litora',
	  info: '',
	  definitions: ['kust'],
	  chapter: '20',
	  searchForm: 'litus, litora'
	}, {
	  latin: 'locus',
	  info: '',
	  definitions: ['plaats'],
	  chapter: '1',
	  searchForm: 'locus'
	}, {
	  latin: 'locutus sum',
	  info: '',
	  definitions: ['*pf van* loqui'],
	  chapter: '50',
	  searchForm: 'locutus sum'
	}, {
	  latin: 'longe',
	  info: 'bijw',
	  definitions: ['ver (weg), verreweg'],
	  chapter: '10',
	  searchForm: 'longe'
	}, {
	  latin: 'longus, -a, -um',
	  info: '',
	  definitions: ['lang'],
	  chapter: '15',
	  searchForm: 'longus, -a, -um'
	}, {
	  latin: 'loqui',
	  info: '',
	  definitions: ['spreken'],
	  chapter: '50',
	  searchForm: 'loqui'
	}, {
	  latin: 'ludere',
	  info: '',
	  definitions: ['spelen'],
	  chapter: '5',
	  searchForm: 'ludere'
	}, {
	  latin: 'lumen, lumina',
	  info: '',
	  definitions: ['licht', 'lamp'],
	  chapter: '33',
	  searchForm: 'lumen, lumina'
	}, {
	  latin: 'lux, luces',
	  info: 'v',
	  definitions: ['(dag)licht'],
	  chapter: '34',
	  searchForm: 'lux, luces'
	}, {
	  latin: 'luxuria',
	  info: '',
	  definitions: ['(zucht naar) weelde'],
	  chapter: '39',
	  searchForm: 'luxuria'
	}, {
	  latin: 'magis',
	  info: '',
	  definitions: ['meer'],
	  chapter: '18',
	  searchForm: 'magis'
	}, {
	  latin: 'magnitudo, -dines',
	  info: 'v',
	  definitions: ['grootte'],
	  chapter: '32',
	  searchForm: 'magnitudo, -dines'
	}, {
	  latin: 'magnopere',
	  info: '',
	  definitions: ['zeer, erg'],
	  chapter: '17',
	  searchForm: 'magnopere'
	}, {
	  latin: 'magnus, -a, -um',
	  info: '',
	  definitions: ['groot'],
	  chapter: '15',
	  searchForm: 'magnus, -a, -um'
	}, {
	  latin: 'maior',
	  info: '',
	  definitions: ['groter'],
	  chapter: '18',
	  searchForm: 'maior'
	}, {
	  latin: 'malle',
	  info: 'inf.prs',
	  definitions: ['liever willen'],
	  chapter: '31',
	  searchForm: 'malle'
	}, {
	  latin: 'malui',
	  info: '',
	  definitions: ['*pf van* malle'],
	  chapter: '32',
	  searchForm: 'malui'
	}, {
	  latin: 'malus, -a, -um',
	  info: '',
	  definitions: ['slecht'],
	  chapter: '17',
	  searchForm: 'malus, -a, -um'
	}, {
	  latin: 'mandare',
	  info: '',
	  definitions: ['opdragen'],
	  chapter: '48',
	  searchForm: 'mandare'
	}, {
	  latin: 'mandatum',
	  info: '',
	  definitions: ['opdracht'],
	  chapter: '1',
	  searchForm: 'mandatum'
	}, {
	  latin: 'manēre',
	  info: '',
	  definitions: ['blijven'],
	  chapter: '8',
	  searchForm: 'manere'
	}, {
	  latin: 'mansi',
	  info: '',
	  definitions: ['*pf van* manēre'],
	  chapter: '52',
	  searchForm: 'mansi'
	}, {
	  latin: 'mansurus',
	  info: '',
	  definitions: ['*pfa van* manēre'],
	  chapter: '52',
	  searchForm: 'mansurus'
	}, {
	  latin: 'manus',
	  info: '4 v',
	  definitions: ['hand'],
	  chapter: '36',
	  searchForm: 'manus'
	}, {
	  latin: 'mare, maria',
	  info: '',
	  definitions: ['zee'],
	  chapter: '29',
	  searchForm: 'mare, maria'
	}, {
	  latin: 'mari',
	  info: '',
	  definitions: ['*abl van* mare'],
	  chapter: '29',
	  searchForm: 'mari'
	}, {
	  latin: 'maritus',
	  info: '',
	  definitions: ['echtgenoot'],
	  chapter: '15',
	  searchForm: 'maritus'
	}, {
	  latin: 'mater, matres',
	  info: 'v',
	  definitions: ['moeder'],
	  chapter: '2',
	  searchForm: 'mater, matres'
	}, {
	  latin: 'matrona',
	  info: '',
	  definitions: ['matrona, vrouw des huizes'],
	  chapter: '15',
	  searchForm: 'matrona'
	}, {
	  latin: 'maxime',
	  info: 'bijw',
	  definitions: ['het meest', 'vooral'],
	  chapter: '20',
	  searchForm: 'maxime'
	}, {
	  latin: 'maximus, -a, -um',
	  info: '',
	  definitions: ['grootst, zeer groot'],
	  chapter: '19',
	  searchForm: 'maximus, -a, -um'
	}, {
	  latin: 'melior',
	  info: '',
	  definitions: ['beter'],
	  chapter: '18',
	  searchForm: 'melior'
	}, {
	  latin: 'meminisse',
	  info: 'pf',
	  definitions: ['**+ aci** zich herinneren dat', '**+gen** zich (iets) herinneren'],
	  chapter: '26',
	  searchForm: 'meminisse'
	}, {
	  latin: 'mens, mentes',
	  info: 'v',
	  definitions: ['geest, verstand'],
	  chapter: '33',
	  searchForm: 'mens, mentes'
	}, {
	  latin: 'mensa',
	  info: '',
	  definitions: ['tafel'],
	  chapter: '23',
	  searchForm: 'mensa'
	}, {
	  latin: 'mercator, mercatores',
	  info: 'm',
	  definitions: ['koopman'],
	  chapter: '32',
	  searchForm: 'mercator, mercatores'
	}, {
	  latin: 'merēre',
	  info: '',
	  definitions: ['verdienen'],
	  chapter: '31',
	  searchForm: 'merere'
	}, {
	  latin: 'metuere',
	  info: '',
	  definitions: ['vrezen'],
	  chapter: '39',
	  searchForm: 'metuere'
	}, {
	  latin: 'metus',
	  info: '4',
	  definitions: ['vrees, zorg'],
	  chapter: '36',
	  searchForm: 'metus'
	}, {
	  latin: 'meus, -a, -um',
	  info: '',
	  definitions: ['mijn, van mij'],
	  chapter: '15',
	  searchForm: 'meus, -a, -um'
	}, {
	  latin: 'miles, milites',
	  info: 'm',
	  definitions: ['soldaat'],
	  chapter: '4',
	  searchForm: 'miles, milites'
	}, {
	  latin: 'militaris, -e',
	  info: '',
	  definitions: ['van de soldaat, militair'],
	  chapter: '29',
	  searchForm: 'militaris, -e'
	}, {
	  latin: 'militia',
	  info: '',
	  definitions: ['krijgsdienst'],
	  chapter: '54',
	  searchForm: 'militia'
	}, {
	  latin: 'mille, milia',
	  info: '',
	  definitions: ['duizend'],
	  chapter: '20',
	  searchForm: 'mille, milia'
	}, {
	  latin: 'minime',
	  info: 'bijw',
	  definitions: ['(aller)minst, helemaal niet'],
	  chapter: '18',
	  searchForm: 'minime'
	}, {
	  latin: 'minimus, -a, -um',
	  info: '',
	  definitions: ['kleinst, zeer klein'],
	  chapter: '18',
	  searchForm: 'minimus, -a, -um'
	}, {
	  latin: 'minor',
	  info: '',
	  definitions: ['kleiner'],
	  chapter: '20',
	  searchForm: 'minor'
	}, {
	  latin: 'minus',
	  info: 'bijw',
	  definitions: ['minder'],
	  chapter: '20',
	  searchForm: 'minus'
	}, {
	  latin: 'mirari',
	  info: '',
	  definitions: ['zich verwonderen', 'bewonderen'],
	  chapter: '50',
	  searchForm: 'mirari'
	}, {
	  latin: 'mirus, -a, -um',
	  info: '',
	  definitions: ['wonderlijk, bijzonder'],
	  chapter: '32',
	  searchForm: 'mirus, -a, -um'
	}, {
	  latin: 'miser, -sera, -serum',
	  info: '',
	  definitions: ['ongelukkig'],
	  chapter: '15',
	  searchForm: 'miser, -sera, -serum'
	}, {
	  latin: 'misericordia',
	  info: '',
	  definitions: ['medelijden'],
	  chapter: '23',
	  searchForm: 'misericordia'
	}, {
	  latin: 'misi',
	  info: '',
	  definitions: ['*pf van* mittere'],
	  chapter: '20',
	  searchForm: 'misi'
	}, {
	  latin: 'missus',
	  info: '',
	  definitions: ['*ppp van* mittere'],
	  chapter: '38',
	  searchForm: 'missus'
	}, {
	  latin: 'mittere',
	  info: '',
	  definitions: ['sturen'],
	  chapter: '18',
	  searchForm: 'mittere'
	}, {
	  latin: 'modo … modo',
	  info: '',
	  definitions: ['nu eens … dan weer'],
	  chapter: '53',
	  searchForm: 'modo … modo'
	}, {
	  latin: 'modus',
	  info: '',
	  definitions: ['manier', 'maat'],
	  chapter: '55',
	  searchForm: 'modus'
	}, {
	  latin: 'moenia',
	  info: 'mv',
	  definitions: ['(stads)muren'],
	  chapter: '30',
	  searchForm: 'moenia'
	}, {
	  latin: 'mollis, -e',
	  info: '',
	  definitions: ['zacht'],
	  chapter: '24',
	  searchForm: 'mollis, -e'
	}, {
	  latin: 'monēre',
	  info: '',
	  definitions: ['waarschuwen', 'aansporen'],
	  chapter: '41',
	  searchForm: 'monere'
	}, {
	  latin: 'mons, montes',
	  info: 'm',
	  definitions: ['berg, heuvel'],
	  chapter: '3',
	  searchForm: 'mons, montes'
	}, {
	  latin: 'morari',
	  info: '',
	  definitions: ['verblijven', '**+acc** vertragen'],
	  chapter: '51',
	  searchForm: 'morari'
	}, {
	  latin: 'morbus',
	  info: '',
	  definitions: ['ziekte'],
	  chapter: '43',
	  searchForm: 'morbus'
	}, {
	  latin: 'mori, morior',
	  info: '',
	  definitions: ['sterven'],
	  chapter: '50',
	  searchForm: 'mori, morior'
	}, {
	  latin: 'mors, mortes',
	  info: 'v',
	  definitions: ['(de) dood'],
	  chapter: '15',
	  searchForm: 'mors, mortes'
	}, {
	  latin: 'mortuus',
	  info: '',
	  definitions: ['dode'],
	  chapter: '30',
	  searchForm: 'mortuus'
	}, {
	  latin: 'mortuus sum',
	  info: '',
	  definitions: ['*pf van* mori'],
	  chapter: '52',
	  searchForm: 'mortuus sum'
	}, {
	  latin: 'mortuus, -a, -um',
	  info: '',
	  definitions: ['gestorven'],
	  chapter: '30',
	  searchForm: 'mortuus, -a, -um'
	}, {
	  latin: 'movēre',
	  info: '',
	  definitions: ['bewegen'],
	  chapter: '19',
	  searchForm: 'movere'
	}, {
	  latin: 'movi',
	  info: '',
	  definitions: ['*pf van* movēre'],
	  chapter: '24',
	  searchForm: 'movi'
	}, {
	  latin: 'mox',
	  info: '',
	  definitions: ['spoedig'],
	  chapter: '5',
	  searchForm: 'mox'
	}, {
	  latin: 'multitudo -tudines',
	  info: 'v',
	  definitions: ['menigte, massa'],
	  chapter: '30',
	  searchForm: 'multitudo, -tudines'
	}, {
	  latin: 'multo',
	  info: 'bijw',
	  definitions: ['veel'],
	  chapter: '18',
	  searchForm: 'multo'
	}, {
	  latin: 'multus, -a, -um',
	  info: '',
	  definitions: ['veel'],
	  chapter: '15',
	  searchForm: 'multus, -a, -um'
	}, {
	  latin: 'mundus',
	  info: '',
	  definitions: ['wereld'],
	  chapter: '33',
	  searchForm: 'mundus'
	}, {
	  latin: 'munus, munera',
	  info: '',
	  definitions: ['taak', 'geschenk'],
	  chapter: '37',
	  searchForm: 'munus, munera'
	}, {
	  latin: 'murus',
	  info: '',
	  definitions: ['muur'],
	  chapter: '3',
	  searchForm: 'murus'
	}, {
	  latin: 'mutare',
	  info: '',
	  definitions: ['veranderen'],
	  chapter: '24',
	  searchForm: 'mutare'
	}, {
	  latin: 'nam',
	  info: '',
	  definitions: ['want'],
	  chapter: '2',
	  searchForm: 'nam'
	}, {
	  latin: 'narrare',
	  info: '',
	  definitions: ['vertellen'],
	  chapter: '6',
	  searchForm: 'narrare'
	}, {
	  latin: 'navis, naves',
	  info: 'v',
	  definitions: ['schip'],
	  chapter: '53',
	  searchForm: 'navis, naves'
	}, {
	  latin: 'ne',
	  info: '+ conj (BZ)',
	  definitions: ['(met de bedoeling) dat niet, om niet te', '**ww van vrezen** dat'],
	  chapter: '44',
	  searchForm: 'ne'
	}, {
	  latin: 'ne',
	  info: '+ conj (HZ)',
	  definitions: ['niet'],
	  chapter: '43',
	  searchForm: 'ne'
	}, {
	  latin: 'ne … quidem',
	  info: '',
	  definitions: ['zelfs niet'],
	  chapter: '34',
	  searchForm: 'ne … quidem'
	}, {
	  latin: 'necare',
	  info: '',
	  definitions: ['doden'],
	  chapter: '1',
	  searchForm: 'necare'
	}, {
	  latin: 'necesse est',
	  info: '',
	  definitions: ['het is nodig'],
	  chapter: '27',
	  searchForm: 'necesse est'
	}, {
	  latin: 'necessitas, -tates',
	  info: 'v',
	  definitions: ['noodzaak'],
	  chapter: '52',
	  searchForm: 'necessitas, -tates'
	}, {
	  latin: 'negare',
	  info: '',
	  definitions: ['ontkennen', 'weigeren'],
	  chapter: '11',
	  searchForm: 'negare'
	}, {
	  latin: 'neglegere',
	  info: '',
	  definitions: ['verwaarlozen'],
	  chapter: '41',
	  searchForm: 'neglegere'
	}, {
	  latin: 'negotium',
	  info: '',
	  definitions: ['bezigheid, zaak'],
	  chapter: '55',
	  searchForm: 'negotium'
	}, {
	  latin: 'nemo, nemines',
	  info: 'm/v',
	  definitions: ['niemand'],
	  chapter: '9',
	  searchForm: 'nemo, nemines'
	}, {
	  latin: 'neque',
	  info: '',
	  definitions: ['en niet, ook niet', 'maar niet'],
	  chapter: '20',
	  searchForm: 'neque'
	}, {
	  latin: 'neque … neque',
	  info: '',
	  definitions: ['niet … en ook niet'],
	  chapter: '25',
	  searchForm: 'neque … neque'
	}, {
	  latin: 'nescire',
	  info: '',
	  definitions: ['niet weten'],
	  chapter: '27',
	  searchForm: 'nescire'
	}, {
	  latin: 'nihil',
	  info: '',
	  definitions: ['niets'],
	  chapter: '8',
	  searchForm: 'nihil'
	}, {
	  latin: 'nimium',
	  info: '+ gen',
	  definitions: ['te veel'],
	  chapter: '33',
	  searchForm: 'nimium'
	}, {
	  latin: 'nisi',
	  info: '',
	  definitions: ['als niet', 'behalve'],
	  chapter: '23, 32',
	  searchForm: 'nisi'
	}, {
	  latin: 'nobilis, -e',
	  info: '',
	  definitions: ['adellijk, aanzienlijk'],
	  chapter: '43',
	  searchForm: 'nobilis, -e'
	}, {
	  latin: 'nocēre',
	  info: '+ dat',
	  definitions: ['schaden, kwaad doen'],
	  chapter: '33',
	  searchForm: 'nocere'
	}, {
	  latin: 'nolle',
	  info: 'inf.prs',
	  definitions: ['niet willen'],
	  chapter: '33',
	  searchForm: 'nolle'
	}, {
	  latin: 'nolui',
	  info: '',
	  definitions: ['*pf van* nolle'],
	  chapter: '32, 55',
	  searchForm: 'nolui'
	}, {
	  latin: 'nomen, nomina',
	  info: '',
	  definitions: ['naam'],
	  chapter: '2',
	  searchForm: 'nomen, nomina'
	}, {
	  latin: 'non',
	  info: '',
	  definitions: ['niet'],
	  chapter: '1',
	  searchForm: 'non'
	}, {
	  latin: 'non iam',
	  info: '',
	  definitions: ['niet meer'],
	  chapter: '16',
	  searchForm: 'non iam'
	}, {
	  latin: 'non quicquam',
	  info: '',
	  definitions: ['niets'],
	  chapter: '46',
	  searchForm: 'non quicquam'
	}, {
	  latin: 'non quisquam',
	  info: '',
	  definitions: ['niemand'],
	  chapter: '46',
	  searchForm: 'non quisquam'
	}, {
	  latin: 'nondum',
	  info: '',
	  definitions: ['nog niet'],
	  chapter: '11',
	  searchForm: 'nondum'
	}, {
	  latin: 'nonne',
	  info: '',
	  definitions: ['(toch) zeker wel'],
	  chapter: '8',
	  searchForm: 'nonne'
	}, {
	  latin: 'nonnulli, -ae, -a',
	  info: 'mv',
	  definitions: ['**bnw** sommige', '**znw** sommigen'],
	  chapter: '27',
	  searchForm: 'nonnulli, -ae, -a'
	}, {
	  latin: 'noscere',
	  info: '',
	  definitions: ['te weten komen', 'leren kennen'],
	  chapter: '22',
	  searchForm: 'noscere'
	}, {
	  latin: 'noster, -stra, -strum',
	  info: '',
	  definitions: ['ons, onze'],
	  chapter: '15',
	  searchForm: 'noster, -stra, -strum'
	}, {
	  latin: 'novi',
	  info: '',
	  definitions: ['*pf van* noscere'],
	  chapter: '22',
	  searchForm: 'novi'
	}, {
	  latin: 'novisse',
	  info: 'pf',
	  definitions: ['weten', 'kennen'],
	  chapter: '22',
	  searchForm: 'novisse'
	}, {
	  latin: 'novus, -a, -um',
	  info: '',
	  definitions: ['nieuw'],
	  chapter: '15',
	  searchForm: 'novus, -a, -um'
	}, {
	  latin: 'nox, noctes',
	  info: 'v',
	  definitions: ['nacht'],
	  chapter: '4',
	  searchForm: 'nox, noctes'
	}, {
	  latin: 'nubes, nubes',
	  info: 'v',
	  definitions: ['wolk'],
	  chapter: '41',
	  searchForm: 'nubes, nubes'
	}, {
	  latin: 'nudus, -a, -um',
	  info: '',
	  definitions: ['naakt, bloot'],
	  chapter: '17',
	  searchForm: 'nudus, -a, -um'
	}, {
	  latin: 'nullus, -a, -um',
	  info: '',
	  definitions: ['geen'],
	  chapter: '24',
	  searchForm: 'nullus, -a, -um'
	}, {
	  latin: 'num',
	  info: '',
	  definitions: ['(toch) zeker niet'],
	  chapter: '6',
	  searchForm: 'num'
	}, {
	  latin: 'numerus',
	  info: '',
	  definitions: ['aantal'],
	  chapter: '20',
	  searchForm: 'numerus'
	}, {
	  latin: 'numquam',
	  info: '',
	  definitions: ['nooit'],
	  chapter: '9',
	  searchForm: 'numquam'
	}, {
	  latin: 'nunc',
	  info: '',
	  definitions: ['nu'],
	  chapter: '11',
	  searchForm: 'nunc'
	}, {
	  latin: 'nuntiare',
	  info: '',
	  definitions: ['berichten, aankondigen'],
	  chapter: '9',
	  searchForm: 'nuntiare'
	}, {
	  latin: 'nuntius',
	  info: '',
	  definitions: ['bode', 'bericht'],
	  chapter: '30',
	  searchForm: 'nuntius'
	}, {
	  latin: 'nuper',
	  info: '',
	  definitions: ['kort geleden'],
	  chapter: '5',
	  searchForm: 'nuper'
	}, {
	  latin: 'nusquam',
	  info: '',
	  definitions: ['nergens'],
	  chapter: '24',
	  searchForm: 'nusquam'
	}, {
	  latin: 'ob',
	  info: '+ acc',
	  definitions: ['wegens'],
	  chapter: '24',
	  searchForm: 'ob'
	}, {
	  latin: 'oblatus',
	  info: '',
	  definitions: ['*pf van* offerre'],
	  chapter: '32',
	  searchForm: 'oblatus'
	}, {
	  latin: 'oblitus sum',
	  info: '',
	  definitions: ['*pf van* oblivisci'],
	  chapter: '51',
	  searchForm: 'oblitus sum'
	}, {
	  latin: 'oblivisci',
	  info: '',
	  definitions: ['vergeten'],
	  chapter: '51',
	  searchForm: 'oblivisci'
	}, {
	  latin: 'obsedi',
	  info: '',
	  definitions: ['*pf van* obsidēre'],
	  chapter: '54',
	  searchForm: 'obsedi'
	}, {
	  latin: 'obsessus',
	  info: '',
	  definitions: ['*ppp van* obsidēre'],
	  chapter: '54',
	  searchForm: 'obsessus'
	}, {
	  latin: 'obsidēre',
	  info: '',
	  definitions: ['belegeren'],
	  chapter: '31',
	  searchForm: 'obsidere'
	}, {
	  latin: 'obtentus',
	  info: '',
	  definitions: ['*ppp van* obtinēre'],
	  chapter: '39',
	  searchForm: 'obtentus'
	}, {
	  latin: 'obtinēre',
	  info: '',
	  definitions: ['in bezit krijgen', 'in bezit hebben'],
	  chapter: '37',
	  searchForm: 'obtinere'
	}, {
	  latin: 'obtinui',
	  info: '',
	  definitions: ['*pf van* obtinēre'],
	  chapter: '39',
	  searchForm: 'obtinui'
	}, {
	  latin: 'obtuli',
	  info: '',
	  definitions: ['*pf van* offerre'],
	  chapter: '32',
	  searchForm: 'obtuli'
	}, {
	  latin: 'oceanus',
	  info: '',
	  definitions: ['oceaan, zee'],
	  chapter: '53',
	  searchForm: 'oceanus'
	}, {
	  latin: 'oculus',
	  info: '',
	  definitions: ['oog'],
	  chapter: '9',
	  searchForm: 'oculus'
	}, {
	  latin: 'odisse',
	  info: 'pf',
	  definitions: ['haten'],
	  chapter: '29',
	  searchForm: 'odisse'
	}, {
	  latin: 'offerre',
	  info: '',
	  definitions: ['aanbieden'],
	  chapter: '31',
	  searchForm: 'offerre'
	}, {
	  latin: 'officium',
	  info: '',
	  definitions: ['plicht, taak'],
	  chapter: '26',
	  searchForm: 'officium'
	}, {
	  latin: 'olim',
	  info: '',
	  definitions: ['vroeger, eens'],
	  chapter: '25',
	  searchForm: 'olim'
	}, {
	  latin: 'omen, omina',
	  info: '',
	  definitions: ['voorteken'],
	  chapter: '41',
	  searchForm: 'omen, omina'
	}, {
	  latin: 'omittere',
	  info: '',
	  definitions: ['achterwege laten, weglaten'],
	  chapter: '45',
	  searchForm: 'omittere'
	}, {
	  latin: 'omnes',
	  info: 'mv m/v',
	  definitions: ['**bnw** alle', '**znw** allen'],
	  chapter: '16',
	  searchForm: 'omnes'
	}, {
	  latin: 'omnia',
	  info: 'mv o',
	  definitions: ['**bnw** alle', '**znw** alles'],
	  chapter: '16',
	  searchForm: 'omnia'
	}, {
	  latin: 'omnis, -e',
	  info: 'ev',
	  definitions: ['ieder, elk', 'geheel'],
	  chapter: '16',
	  searchForm: 'omnis, -e'
	}, {
	  latin: 'onus, onera',
	  info: '',
	  definitions: ['last, lading'],
	  chapter: '18',
	  searchForm: 'onus, onera'
	}, {
	  latin: 'oportet',
	  info: '',
	  definitions: ['het behoort'],
	  chapter: '50',
	  searchForm: 'oportet'
	}, {
	  latin: 'oppidum',
	  info: '',
	  definitions: ['(vesting)stad'],
	  chapter: '37',
	  searchForm: 'oppidum'
	}, {
	  latin: 'optimus, -a, -um',
	  info: '',
	  definitions: ['best, zeer goed'],
	  chapter: '16',
	  searchForm: 'optimus, -a, -um'
	}, {
	  latin: 'opus, opera',
	  info: '',
	  definitions: ['werk'],
	  chapter: '22',
	  searchForm: 'opus, opera'
	}, {
	  latin: 'orare',
	  info: '',
	  definitions: ['bidden (tot)', 'smeken (om)'],
	  chapter: '5',
	  searchForm: 'orare'
	}, {
	  latin: 'orbis, orbes',
	  info: 'm',
	  definitions: ['kring, cirkel'],
	  chapter: '26',
	  searchForm: 'orbis, orbes'
	}, {
	  latin: 'oriens, orientes',
	  info: 'm',
	  definitions: ['het oosten'],
	  chapter: '47',
	  searchForm: 'oriens, orientes'
	}, {
	  latin: 'oriri',
	  info: '',
	  definitions: ['ontstaan, opgaan'],
	  chapter: '50',
	  searchForm: 'oriri'
	}, {
	  latin: 'ortus sum',
	  info: '',
	  definitions: ['*pf van* oriri'],
	  chapter: '50',
	  searchForm: 'ortus sum'
	}, {
	  latin: 'ostendere',
	  info: '',
	  definitions: ['tonen'],
	  chapter: '5',
	  searchForm: 'ostendere'
	}, {
	  latin: 'ostendi',
	  info: '',
	  definitions: ['*pf van* ostendere'],
	  chapter: '13',
	  searchForm: 'ostendi'
	}, {
	  latin: 'paene',
	  info: '',
	  definitions: ['bijna'],
	  chapter: '31',
	  searchForm: 'paene'
	}, {
	  latin: 'par, par-',
	  info: '',
	  definitions: ['gelijk(waardig)', '**+ dat** opgewassen tegen'],
	  chapter: '32',
	  searchForm: 'par, par-'
	}, {
	  latin: 'parare',
	  info: '',
	  definitions: ['klaarmaken'],
	  chapter: '12',
	  searchForm: 'parare'
	}, {
	  latin: 'parcere',
	  info: '+ dat',
	  definitions: ['sparen'],
	  chapter: '19',
	  searchForm: 'parcere'
	}, {
	  latin: 'parentes',
	  info: 'mv',
	  definitions: ['ouders'],
	  chapter: '16',
	  searchForm: 'parentes'
	}, {
	  latin: 'parēre',
	  info: '',
	  definitions: ['gehoorzamen'],
	  chapter: '31',
	  searchForm: 'parere'
	}, {
	  latin: 'parere, pario',
	  info: '',
	  definitions: ['verwerven', 'voortbrengen'],
	  chapter: '55',
	  searchForm: 'parere, pario'
	}, {
	  latin: 'pars, partes',
	  info: 'v',
	  definitions: ['deel'],
	  chapter: '4',
	  searchForm: 'pars, partes'
	}, {
	  latin: 'partus',
	  info: '',
	  definitions: ['*ppp van* parere'],
	  chapter: '55',
	  searchForm: 'partus'
	}, {
	  latin: 'parum',
	  info: 'bijw',
	  definitions: ['niet genoeg'],
	  chapter: '19',
	  searchForm: 'parum'
	}, {
	  latin: 'parvus, -a, -um',
	  info: '',
	  definitions: ['klein'],
	  chapter: '15',
	  searchForm: 'parvus, -a, -um'
	}, {
	  latin: 'passus sum',
	  info: '',
	  definitions: ['*pf van* pati'],
	  chapter: '50',
	  searchForm: 'passus sum'
	}, {
	  latin: 'pater, patres',
	  info: 'm',
	  definitions: ['vader'],
	  chapter: '2',
	  searchForm: 'pater, patres'
	}, {
	  latin: 'patēre',
	  info: '',
	  definitions: ['openstaan'],
	  chapter: '38',
	  searchForm: 'patere'
	}, {
	  latin: 'pati, patior',
	  info: '',
	  definitions: ['lijden, doorstaan', 'toestaan'],
	  chapter: '50',
	  searchForm: 'pati, patior'
	}, {
	  latin: 'patria',
	  info: '',
	  definitions: ['vaderland'],
	  chapter: '29',
	  searchForm: 'patria'
	}, {
	  latin: 'pauci, -ae, -a',
	  info: 'mv',
	  definitions: ['weinig, enkele'],
	  chapter: '20',
	  searchForm: 'pauci, -ae, -a'
	}, {
	  latin: 'paulatim',
	  info: '',
	  definitions: ['langzamerhand'],
	  chapter: '30',
	  searchForm: 'paulatim'
	}, {
	  latin: 'paulo',
	  info: '',
	  definitions: ['een beetje'],
	  chapter: '37',
	  searchForm: 'paulo'
	}, {
	  latin: 'paulum',
	  info: 'bijw',
	  definitions: ['een beetje'],
	  chapter: '17',
	  searchForm: 'paulum'
	}, {
	  latin: 'pauper, pauper-',
	  info: '',
	  definitions: ['arm(oedig)'],
	  chapter: '34',
	  searchForm: 'pauper, pauper-'
	}, {
	  latin: 'pax, paces',
	  info: 'v',
	  definitions: ['vrede'],
	  chapter: '31',
	  searchForm: 'pax, paces'
	}, {
	  latin: 'pectus, pectora',
	  info: '',
	  definitions: ['borst'],
	  chapter: '53',
	  searchForm: 'pectus, pectora'
	}, {
	  latin: 'pecunia',
	  info: '',
	  definitions: ['geld'],
	  chapter: '8',
	  searchForm: 'pecunia'
	}, {
	  latin: 'peior',
	  info: '',
	  definitions: ['slechter'],
	  chapter: '18',
	  searchForm: 'peior'
	}, {
	  latin: 'pendēre',
	  info: '',
	  definitions: ['hangen'],
	  chapter: '10',
	  searchForm: 'pendere'
	}, {
	  latin: 'peperci',
	  info: '',
	  definitions: ['*pf van* parcere'],
	  chapter: '19',
	  searchForm: 'peperci'
	}, {
	  latin: 'peperi',
	  info: '',
	  definitions: ['*pf van* parere'],
	  chapter: '55',
	  searchForm: 'peperi'
	}, {
	  latin: 'per',
	  info: '+ acc',
	  definitions: ['door(heen)', 'gedurende', 'over(heen)'],
	  chapter: '5, 10',
	  searchForm: 'per'
	}, {
	  latin: 'perdere',
	  info: '',
	  definitions: ['vernietigen', 'verliezen'],
	  chapter: '29, 46',
	  searchForm: 'perdere'
	}, {
	  latin: 'perdidi',
	  info: '',
	  definitions: ['*pf van* perdere'],
	  chapter: '46',
	  searchForm: 'perdidi'
	}, {
	  latin: 'perditus',
	  info: '',
	  definitions: ['*ppp van* perdere'],
	  chapter: '46',
	  searchForm: 'perditus'
	}, {
	  latin: 'perfeci',
	  info: '',
	  definitions: ['*pf van* perficere'],
	  chapter: '27',
	  searchForm: 'perfeci'
	}, {
	  latin: 'perficere, perficio',
	  info: '',
	  definitions: ['voltooien'],
	  chapter: '25',
	  searchForm: 'perficere, perficio'
	}, {
	  latin: 'pergere',
	  info: '',
	  definitions: ['doorgaan'],
	  chapter: '47',
	  searchForm: 'pergere'
	}, {
	  latin: 'periculum',
	  info: '',
	  definitions: ['gevaar'],
	  chapter: '4',
	  searchForm: 'periculum'
	}, {
	  latin: 'perii',
	  info: '',
	  definitions: ['*pf van* perire'],
	  chapter: '46',
	  searchForm: 'perii'
	}, {
	  latin: 'perire',
	  info: '',
	  definitions: ['omkomen'],
	  chapter: '46',
	  searchForm: 'perire'
	}, {
	  latin: 'periturus',
	  info: '',
	  definitions: ['*pfa van* perire'],
	  chapter: '46',
	  searchForm: 'periturus'
	}, {
	  latin: 'permittere',
	  info: '',
	  definitions: ['toelaten, toestaan'],
	  chapter: '29',
	  searchForm: 'permittere'
	}, {
	  latin: 'perpetuus, -a, -um',
	  info: '',
	  definitions: ['voortdurend'],
	  chapter: '25',
	  searchForm: 'perpetuus, -a, -um'
	}, {
	  latin: 'perrexi',
	  info: '',
	  definitions: ['*pf van* pergere'],
	  chapter: '47',
	  searchForm: 'perrexi'
	}, {
	  latin: 'persuadēre',
	  info: '+ dat',
	  definitions: ['overhalen', 'overtuigen'],
	  chapter: '45',
	  searchForm: 'persuadere'
	}, {
	  latin: 'persuasi',
	  info: '',
	  definitions: ['*pf van* persuadēre'],
	  chapter: '45',
	  searchForm: 'persuasi'
	}, {
	  latin: 'persuasus',
	  info: '',
	  definitions: ['*ppp van* persuadēre'],
	  chapter: '45',
	  searchForm: 'persuasus'
	}, {
	  latin: 'pertinēre ad',
	  info: '+ acc',
	  definitions: ['zich uitstrekken tot', 'betrekking hebben op'],
	  chapter: '51',
	  searchForm: 'pertinere ad'
	}, {
	  latin: 'perveni',
	  info: '',
	  definitions: ['*pf van* pervenire'],
	  chapter: '26',
	  searchForm: 'perveni'
	}, {
	  latin: 'pervenire',
	  info: '',
	  definitions: ['aankomen'],
	  chapter: '26',
	  searchForm: 'pervenire'
	}, {
	  latin: 'pes, pedes',
	  info: 'm',
	  definitions: ['voet, poot'],
	  chapter: '10',
	  searchForm: 'pes, pedes'
	}, {
	  latin: 'pessimus, -a, -um',
	  info: '',
	  definitions: ['slechtst, zeer slecht'],
	  chapter: '18',
	  searchForm: 'pessimus, -a, -um'
	}, {
	  latin: 'petere',
	  info: '',
	  definitions: ['zoeken, vragen', 'proberen te bereiken', 'aanvallen'],
	  chapter: '10, 32',
	  searchForm: 'petere'
	}, {
	  latin: 'pietas, pietates',
	  info: 'v',
	  definitions: ['plichtsgevoel', 'liefde, trouw'],
	  chapter: '41',
	  searchForm: 'pietas, pietates'
	}, {
	  latin: 'placēre',
	  info: '+ dat',
	  definitions: ['bevallen, in de smaak vallen'],
	  chapter: '3',
	  searchForm: 'placere'
	}, {
	  latin: 'plebs, plebes',
	  info: 'v',
	  definitions: ['het gewone volk'],
	  chapter: '39',
	  searchForm: 'plebs, plebes'
	}, {
	  latin: 'plenus',
	  info: '+ gen',
	  definitions: ['vol (met)'],
	  chapter: '25',
	  searchForm: 'plenus'
	}, {
	  latin: 'plurimi, -ae, -a',
	  info: 'mv',
	  definitions: ['(de) meeste, zeer vele'],
	  chapter: '20',
	  searchForm: 'plurimi, -ae, -a'
	}, {
	  latin: 'plus, plures',
	  info: 'com',
	  definitions: ['meer'],
	  chapter: '20',
	  searchForm: 'plus, plures'
	}, {
	  latin: 'poculum',
	  info: '',
	  definitions: ['beker'],
	  chapter: '8',
	  searchForm: 'poculum'
	}, {
	  latin: 'poena',
	  info: '',
	  definitions: ['straf'],
	  chapter: '5',
	  searchForm: 'poena'
	}, {
	  latin: 'poeta',
	  info: 'm',
	  definitions: ['dichter'],
	  chapter: '45',
	  searchForm: 'poeta'
	}, {
	  latin: 'pondus, pondera',
	  info: '',
	  definitions: ['gewicht'],
	  chapter: '33',
	  searchForm: 'pondus, pondera'
	}, {
	  latin: 'ponere',
	  info: '',
	  definitions: ['plaatsen'],
	  chapter: '1',
	  searchForm: 'ponere'
	}, {
	  latin: 'pons, pontes',
	  info: 'm',
	  definitions: ['brug'],
	  chapter: '48',
	  searchForm: 'pons, pontes'
	}, {
	  latin: 'populus',
	  info: '',
	  definitions: ['volk'],
	  chapter: '3',
	  searchForm: 'populus'
	}, {
	  latin: 'porta',
	  info: '',
	  definitions: ['poort'],
	  chapter: '30',
	  searchForm: 'porta'
	}, {
	  latin: 'portare',
	  info: '',
	  definitions: ['dragen'],
	  chapter: '1',
	  searchForm: 'portare'
	}, {
	  latin: 'poscere',
	  info: '',
	  definitions: ['(op)eisen'],
	  chapter: '54',
	  searchForm: 'poscere'
	}, {
	  latin: 'positus',
	  info: '',
	  definitions: ['*ppp van* ponere'],
	  chapter: '55',
	  searchForm: 'positus'
	}, {
	  latin: 'posse',
	  info: '',
	  definitions: ['kunnen'],
	  chapter: '9',
	  searchForm: 'posse'
	}, {
	  latin: 'possedi',
	  info: '',
	  definitions: ['*pf van* possidēre'],
	  chapter: '34',
	  searchForm: 'possedi'
	}, {
	  latin: 'possessus',
	  info: '',
	  definitions: ['*ppp van* possidēre'],
	  chapter: '32',
	  searchForm: 'possessus'
	}, {
	  latin: 'possidēre',
	  info: '',
	  definitions: ['bezitten'],
	  chapter: '23',
	  searchForm: 'possidere'
	}, {
	  latin: 'post',
	  info: '+ acc',
	  definitions: ['achter', 'na'],
	  chapter: '4, 27',
	  searchForm: 'post'
	}, {
	  latin: 'post',
	  info: 'bijw',
	  definitions: ['later'],
	  chapter: '27',
	  searchForm: 'post'
	}, {
	  latin: 'postea',
	  info: '',
	  definitions: ['later'],
	  chapter: '16',
	  searchForm: 'postea'
	}, {
	  latin: 'posterus, -a, -um',
	  info: '',
	  definitions: ['volgend'],
	  chapter: '38',
	  searchForm: 'posterus, -a, -um'
	}, {
	  latin: 'postquam',
	  info: '+ pf',
	  definitions: ['nadat'],
	  chapter: '12',
	  searchForm: 'postquam'
	}, {
	  latin: 'postremo',
	  info: '',
	  definitions: ['tenslotte'],
	  chapter: '30',
	  searchForm: 'postremo'
	}, {
	  latin: 'posui',
	  info: '',
	  definitions: ['*pf van* ponere'],
	  chapter: '13, 55',
	  searchForm: 'posui'
	}, {
	  latin: 'potens, potent-',
	  info: '',
	  definitions: ['machtig'],
	  chapter: '47',
	  searchForm: 'potens, potent-'
	}, {
	  latin: 'potestas, -ates',
	  info: 'v',
	  definitions: ['macht', 'gelegenheid'],
	  chapter: '34',
	  searchForm: 'potestas, -ates'
	}, {
	  latin: 'potiri',
	  info: '+ abl',
	  definitions: ['zich meester maken van'],
	  chapter: '54',
	  searchForm: 'potiri'
	}, {
	  latin: 'potius',
	  info: 'bijw',
	  definitions: ['liever, eerder'],
	  chapter: '51',
	  searchForm: 'potius'
	}, {
	  latin: 'potui',
	  info: '',
	  definitions: ['*pf van* posse'],
	  chapter: '12',
	  searchForm: 'potui'
	}, {
	  latin: 'praebēre',
	  info: '',
	  definitions: ['(aan)bieden'],
	  chapter: '2',
	  searchForm: 'praebere'
	}, {
	  latin: 'praeceptum',
	  info: '',
	  definitions: ['voorschrift'],
	  chapter: '52',
	  searchForm: 'praeceptum'
	}, {
	  latin: 'praeda',
	  info: '',
	  definitions: ['buit'],
	  chapter: '44',
	  searchForm: 'praeda'
	}, {
	  latin: 'praeferre',
	  info: '',
	  definitions: ['liever hebben, verkiezen'],
	  chapter: '34',
	  searchForm: 'praeferre'
	}, {
	  latin: 'praelatus',
	  info: '',
	  definitions: ['*ppp van* praeferre'],
	  chapter: '32',
	  searchForm: 'praelatus'
	}, {
	  latin: 'praemium',
	  info: '',
	  definitions: ['beloning'],
	  chapter: '37',
	  searchForm: 'praemium'
	}, {
	  latin: 'praestare',
	  info: '',
	  definitions: ['verrichten', '**se** zich betonen'],
	  chapter: '39',
	  searchForm: 'praestare'
	}, {
	  latin: 'praeterea',
	  info: '',
	  definitions: ['bovendien'],
	  chapter: '23',
	  searchForm: 'praeterea'
	}, {
	  latin: 'praeterii',
	  info: '',
	  definitions: ['*pf van* praeterire'],
	  chapter: '26',
	  searchForm: 'praeterii'
	}, {
	  latin: 'praeterire',
	  info: '',
	  definitions: ['voorbijgaan'],
	  chapter: '26',
	  searchForm: 'praeterire'
	}, {
	  latin: 'praeteriturus',
	  info: '',
	  definitions: ['*pfa van* praeterire'],
	  chapter: '32',
	  searchForm: 'praeteriturus'
	}, {
	  latin: 'praetuli',
	  info: '',
	  definitions: ['*pf van* praeferre'],
	  chapter: '32',
	  searchForm: 'praetuli'
	}, {
	  latin: 'premere',
	  info: '',
	  definitions: ['drukken (op)'],
	  chapter: '26',
	  searchForm: 'premere'
	}, {
	  latin: 'pressi',
	  info: '',
	  definitions: ['*pf van* premere'],
	  chapter: '32, 48',
	  searchForm: 'pressi'
	}, {
	  latin: 'pressus',
	  info: '',
	  definitions: ['*ppp van* premere'],
	  chapter: '32, 48',
	  searchForm: 'pressus'
	}, {
	  latin: 'pretium',
	  info: '',
	  definitions: ['prijs'],
	  chapter: '18',
	  searchForm: 'pretium'
	}, {
	  latin: 'primum',
	  info: 'bijw',
	  definitions: ['eerst'],
	  chapter: '3',
	  searchForm: 'primum'
	}, {
	  latin: 'primus, -a, -um',
	  info: '',
	  definitions: ['eerste'],
	  chapter: '25',
	  searchForm: 'primus, -a, -um'
	}, {
	  latin: 'princeps, princip-',
	  info: '',
	  definitions: ['voornaamste'],
	  chapter: '38',
	  searchForm: 'princeps, princip-'
	}, {
	  latin: 'princeps, principes',
	  info: 'm',
	  definitions: ['leider'],
	  chapter: '38',
	  searchForm: 'princeps, principes'
	}, {
	  latin: 'prior, prius',
	  info: '',
	  definitions: ['eerdere, eerste'],
	  chapter: '43',
	  searchForm: 'prior, prius'
	}, {
	  latin: 'priusquam',
	  info: '',
	  definitions: ['voordat'],
	  chapter: '13',
	  searchForm: 'priusquam'
	}, {
	  latin: 'privatus, -a, -um',
	  info: '',
	  definitions: ['persoonlijk'],
	  chapter: '30',
	  searchForm: 'privatus, -a, -um'
	}, {
	  latin: 'pro',
	  info: '+ abl',
	  definitions: ['voor', 'in plaats van'],
	  chapter: '6',
	  searchForm: 'pro'
	}, {
	  latin: 'procedere',
	  info: '',
	  definitions: ['voortgaan, lopen'],
	  chapter: '10',
	  searchForm: 'procedere'
	}, {
	  latin: 'processi',
	  info: '',
	  definitions: ['*pf van* procedere'],
	  chapter: '17',
	  searchForm: 'processi'
	}, {
	  latin: 'processus',
	  info: '',
	  definitions: ['*ppp van* procedere'],
	  chapter: '32',
	  searchForm: 'processus'
	}, {
	  latin: 'procul',
	  info: '',
	  definitions: ['ver, in de verte'],
	  chapter: '26',
	  searchForm: 'procul'
	}, {
	  latin: 'prodesse',
	  info: '',
	  definitions: ['voordelig zijn'],
	  chapter: '39',
	  searchForm: 'prodesse'
	}, {
	  latin: 'proelium',
	  info: '',
	  definitions: ['gevecht, veldslag'],
	  chapter: '31',
	  searchForm: 'proelium'
	}, {
	  latin: 'profectus sum',
	  info: '',
	  definitions: ['*pf van* proficisci'],
	  chapter: '50',
	  searchForm: 'profectus sum'
	}, {
	  latin: 'proficisci',
	  info: '',
	  definitions: ['vertrekken'],
	  chapter: '50',
	  searchForm: 'proficisci'
	}, {
	  latin: 'profui',
	  info: '',
	  definitions: ['*pf van* prodesse'],
	  chapter: '54',
	  searchForm: 'profui'
	}, {
	  latin: 'profuturus',
	  info: '',
	  definitions: ['*pfa van* prodesse'],
	  chapter: '54',
	  searchForm: 'profuturus'
	}, {
	  latin: 'prohibēre',
	  info: '',
	  definitions: ['**(a(b)) + abl** afhouden van', '**+ inf** verhinderen'],
	  chapter: '48, 52',
	  searchForm: 'prohibere'
	}, {
	  latin: 'promisi',
	  info: '',
	  definitions: ['*pf van* promittere'],
	  chapter: '32',
	  searchForm: 'promisi'
	}, {
	  latin: 'promissus',
	  info: '',
	  definitions: ['*ppp van* promittere'],
	  chapter: '32',
	  searchForm: 'promissus'
	}, {
	  latin: 'promittere',
	  info: '',
	  definitions: ['beloven'],
	  chapter: '32',
	  searchForm: 'promittere'
	}, {
	  latin: 'prope',
	  info: '+ acc',
	  definitions: ['dichtbij'],
	  chapter: '6',
	  searchForm: 'prope'
	}, {
	  latin: 'properare',
	  info: '',
	  definitions: ['zich haasten'],
	  chapter: '38',
	  searchForm: 'properare'
	}, {
	  latin: 'proponere',
	  info: '',
	  definitions: ['voorleggen', 'voorstellen'],
	  chapter: '38',
	  searchForm: 'proponere'
	}, {
	  latin: 'propositus',
	  info: '',
	  definitions: ['*ppp van* proponere'],
	  chapter: '38, 44',
	  searchForm: 'propositus'
	}, {
	  latin: 'proposui',
	  info: '',
	  definitions: ['*pf van* proponere'],
	  chapter: '38, 44',
	  searchForm: 'proposui'
	}, {
	  latin: 'proprius, -a, -um',
	  info: '',
	  definitions: ['eigen'],
	  chapter: '54',
	  searchForm: 'proprius, -a, -um'
	}, {
	  latin: 'propter',
	  info: '+ acc',
	  definitions: ['wegens'],
	  chapter: '31',
	  searchForm: 'propter'
	}, {
	  latin: 'protegere',
	  info: '',
	  definitions: ['beschermen'],
	  chapter: '2',
	  searchForm: 'protegere'
	}, {
	  latin: 'protexi',
	  info: '',
	  definitions: ['*pf van* protegere'],
	  chapter: '16',
	  searchForm: 'protexi'
	}, {
	  latin: 'provincia',
	  info: '',
	  definitions: ['provincie, ambtsgebied'],
	  chapter: '47',
	  searchForm: 'provincia'
	}, {
	  latin: 'prudens, prudent-',
	  info: '',
	  definitions: ['verstandig'],
	  chapter: '18',
	  searchForm: 'prudens, prudent-'
	}, {
	  latin: 'publicus, -a, -um',
	  info: '',
	  definitions: ['openbaar'],
	  chapter: '30',
	  searchForm: 'publicus, -a, -um'
	}, {
	  latin: 'puella',
	  info: '',
	  definitions: ['meisje'],
	  chapter: '4',
	  searchForm: 'puella'
	}, {
	  latin: 'puer, pueri',
	  info: '',
	  definitions: ['jongen'],
	  chapter: '1',
	  searchForm: 'puer, pueri'
	}, {
	  latin: 'pugna',
	  info: '',
	  definitions: ['gevecht'],
	  chapter: '6',
	  searchForm: 'pugna'
	}, {
	  latin: 'pugnare',
	  info: '',
	  definitions: ['vechten'],
	  chapter: '6',
	  searchForm: 'pugnare'
	}, {
	  latin: 'pulcher, -chra, -chrum',
	  info: '',
	  definitions: ['mooi'],
	  chapter: '15',
	  searchForm: 'pulcher, -chra, -chrum'
	}, {
	  latin: 'punire',
	  info: '',
	  definitions: ['straffen'],
	  chapter: '24',
	  searchForm: 'punire'
	}, {
	  latin: 'putare',
	  info: '',
	  definitions: ['menen', 'vinden, beschouwen als'],
	  chapter: '18',
	  searchForm: 'putare'
	}, {
	  latin: 'quaerere',
	  info: '',
	  definitions: ['zoeken', 'vragen'],
	  chapter: '17',
	  searchForm: 'quaerere'
	}, {
	  latin: 'quaesitus',
	  info: '',
	  definitions: ['*ppp van* quaerere'],
	  chapter: '29',
	  searchForm: 'quaesitus'
	}, {
	  latin: 'quaesivi',
	  info: '',
	  definitions: ['*pf van* quaerere'],
	  chapter: '34',
	  searchForm: 'quaesivi'
	}, {
	  latin: 'qualis, -e',
	  info: '',
	  definitions: ['hoedanig', 'zodanig als'],
	  chapter: '47',
	  searchForm: 'qualis, -e'
	}, {
	  latin: 'quam',
	  info: 'uitroep',
	  definitions: ['wat, hoe'],
	  chapter: '43',
	  searchForm: 'quam'
	}, {
	  latin: 'quam',
	  info: '',
	  definitions: ['**+ comp** … dan', '**+ sup** zo … mogelijk'],
	  chapter: '18',
	  searchForm: 'quam'
	}, {
	  latin: 'quamquam',
	  info: '',
	  definitions: ['hoewel'],
	  chapter: '23',
	  searchForm: 'quamquam'
	}, {
	  latin: 'quando',
	  info: '',
	  definitions: ['wanneer'],
	  chapter: '8',
	  searchForm: 'quando'
	}, {
	  latin: 'quantus, -a, -um',
	  info: '',
	  definitions: ['hoe groot', 'zo groot als'],
	  chapter: '30',
	  searchForm: 'quantus, -a, -um'
	}, {
	  latin: 'quare',
	  info: '',
	  definitions: ['waarom'],
	  chapter: '34',
	  searchForm: 'quare'
	}, {
	  latin: 'quasi',
	  info: '',
	  definitions: ['als(of)', 'als het ware'],
	  chapter: '34',
	  searchForm: 'quasi'
	}, {
	  latin: 'queri',
	  info: '(+ acc)',
	  definitions: ['klagen (over)'],
	  chapter: '51',
	  searchForm: 'queri'
	}, {
	  latin: 'questus sum',
	  info: '',
	  definitions: ['*pf van* queri'],
	  chapter: '51',
	  searchForm: 'questus sum'
	}, {
	  latin: 'qui, quae, quod',
	  info: '',
	  definitions: ['welke', 'die, dat'],
	  chapter: '24',
	  searchForm: 'qui, quae, quod'
	}, {
	  latin: 'quia',
	  info: '',
	  definitions: ['omdat'],
	  chapter: '19',
	  searchForm: 'quia'
	}, {
	  latin: 'quicquam',
	  info: '',
	  definitions: ['iets'],
	  chapter: '46',
	  searchForm: 'quicquam'
	}, {
	  latin: 'quid',
	  info: '',
	  definitions: ['wat'],
	  chapter: '9',
	  searchForm: 'quid'
	}, {
	  latin: 'quidam, quaedam, quoddam',
	  info: '',
	  definitions: ['**ev** een (zekere), een of andere', '**mv** sommige, enige'],
	  chapter: '46',
	  searchForm: 'quidam, quaedam, quoddam'
	}, {
	  latin: 'quidem … sed',
	  info: '',
	  definitions: ['wel(iswaar) … maar'],
	  chapter: '11',
	  searchForm: 'quidem … sed'
	}, {
	  latin: 'quies, quietes',
	  info: 'v',
	  definitions: ['rust'],
	  chapter: '48',
	  searchForm: 'quies, quietes'
	}, {
	  latin: 'quietus, -a, -um',
	  info: '',
	  definitions: ['rustig'],
	  chapter: '51',
	  searchForm: 'quietus, -a, -um'
	}, {
	  latin: 'quis',
	  info: '',
	  definitions: ['wie'],
	  chapter: '9',
	  searchForm: 'quis'
	}, {
	  latin: 'quisquam',
	  info: '',
	  definitions: ['iemand'],
	  chapter: '46',
	  searchForm: 'quisquam'
	}, {
	  latin: 'quisque',
	  info: '',
	  definitions: ['iedereen'],
	  chapter: '27',
	  searchForm: 'quisque'
	}, {
	  latin: 'quisque, quaeque, quodque',
	  info: '',
	  definitions: ['iedere, elke'],
	  chapter: '46',
	  searchForm: 'quisque, quaeque, quodque'
	}, {
	  latin: 'quo',
	  info: '',
	  definitions: ['waarheen'],
	  chapter: '9',
	  searchForm: 'quo'
	}, {
	  latin: 'quod',
	  info: '',
	  definitions: ['omdat', '(datgene) wat'],
	  chapter: '8',
	  searchForm: 'quod'
	}, {
	  latin: 'quomodo',
	  info: '',
	  definitions: ['hoe'],
	  chapter: '22',
	  searchForm: 'quomodo'
	}, {
	  latin: 'quondam',
	  info: '',
	  definitions: ['eens, ooit'],
	  chapter: '13',
	  searchForm: 'quondam'
	}, {
	  latin: 'quoniam',
	  info: '',
	  definitions: ['aangezien'],
	  chapter: '37',
	  searchForm: 'quoniam'
	}, {
	  latin: 'quoque',
	  info: '',
	  definitions: ['ook'],
	  chapter: '3',
	  searchForm: 'quoque'
	}, {
	  latin: 'rapere, rapio',
	  info: '',
	  definitions: ['roven', 'grijpen'],
	  chapter: '27',
	  searchForm: 'rapere, rapio'
	}, {
	  latin: 'rapui',
	  info: '',
	  definitions: ['*pf van* rapere'],
	  chapter: '27',
	  searchForm: 'rapui'
	}, {
	  latin: 'ratus sum',
	  info: '',
	  definitions: ['*pf van* reri'],
	  chapter: '50',
	  searchForm: 'ratus sum'
	}, {
	  latin: 'recepi',
	  info: '',
	  definitions: ['*pf van* recipere'],
	  chapter: '46, 55',
	  searchForm: 'recepi'
	}, {
	  latin: 'receptus',
	  info: '',
	  definitions: ['*ppp van* recipere'],
	  chapter: '46, 55',
	  searchForm: 'receptus'
	}, {
	  latin: 'recipere, recipio',
	  info: '',
	  definitions: ['ontvangen', '**se** zich terugtrekken'],
	  chapter: '36',
	  searchForm: 'recipere, recipio'
	}, {
	  latin: 'rectus, -a, -um',
	  info: '',
	  definitions: ['recht, juist'],
	  chapter: '43',
	  searchForm: 'rectus, -a, -um'
	}, {
	  latin: 'recusare',
	  info: '',
	  definitions: ['weigeren'],
	  chapter: '1',
	  searchForm: 'recusare'
	}, {
	  latin: 'reddere',
	  info: '',
	  definitions: ['teruggeven'],
	  chapter: '53',
	  searchForm: 'reddere'
	}, {
	  latin: 'reddidi',
	  info: '',
	  definitions: ['*pf van* reddere'],
	  chapter: '53',
	  searchForm: 'reddidi'
	}, {
	  latin: 'redditus',
	  info: '',
	  definitions: ['*ppp van* reddere'],
	  chapter: '53',
	  searchForm: 'redditus'
	}, {
	  latin: 'redii',
	  info: '',
	  definitions: ['*pf van* redire'],
	  chapter: '32, 41',
	  searchForm: 'redii'
	}, {
	  latin: 'redire',
	  info: '',
	  definitions: ['teruggaan'],
	  chapter: '20',
	  searchForm: 'redire'
	}, {
	  latin: 'rediturus',
	  info: '',
	  definitions: ['*pfa van* redire'],
	  chapter: '32, 41',
	  searchForm: 'rediturus'
	}, {
	  latin: 'referre',
	  info: '',
	  definitions: ['terugbrengen', '(be)halen', 'rapporteren'],
	  chapter: '31',
	  searchForm: 'referre'
	}, {
	  latin: 'regere',
	  info: '',
	  definitions: ['besturen, leiden'],
	  chapter: '12',
	  searchForm: 'regere'
	}, {
	  latin: 'regina',
	  info: '',
	  definitions: ['koningin'],
	  chapter: '40',
	  searchForm: 'regina'
	}, {
	  latin: 'regio, regiones',
	  info: 'v',
	  definitions: ['streek, gebied'],
	  chapter: '27',
	  searchForm: 'regio, regiones'
	}, {
	  latin: 'regnare',
	  info: '',
	  definitions: ['koning zijn'],
	  chapter: '40',
	  searchForm: 'regnare'
	}, {
	  latin: 'regnum',
	  info: '',
	  definitions: ['koningschap', 'koninkrijk'],
	  chapter: '32',
	  searchForm: 'regnum'
	}, {
	  latin: 'relatus',
	  info: '',
	  definitions: ['*ppp van* referre'],
	  chapter: '31, 53',
	  searchForm: 'relatus'
	}, {
	  latin: 'relictus',
	  info: '',
	  definitions: ['*ppp van* relinquere'],
	  chapter: '31',
	  searchForm: 'relictus'
	}, {
	  latin: 'relinquere',
	  info: '',
	  definitions: ['verlaten', 'achterlaten'],
	  chapter: '20',
	  searchForm: 'relinquere'
	}, {
	  latin: 'reliqui',
	  info: '',
	  definitions: ['*pf van* relinquere'],
	  chapter: '20',
	  searchForm: 'reliqui'
	}, {
	  latin: 'reperire',
	  info: '',
	  definitions: ['vinden, ontdekken'],
	  chapter: '53',
	  searchForm: 'reperire'
	}, {
	  latin: 'repertus',
	  info: '',
	  definitions: ['*ppp van* reperire'],
	  chapter: '53',
	  searchForm: 'repertus'
	}, {
	  latin: 'repetere',
	  info: '',
	  definitions: ['herhalen'],
	  chapter: '24',
	  searchForm: 'repetere'
	}, {
	  latin: 'repetivi',
	  info: '',
	  definitions: ['*pf van* repetere'],
	  chapter: '24',
	  searchForm: 'repetivi'
	}, {
	  latin: 'repperi',
	  info: '',
	  definitions: ['*pf van* reperire'],
	  chapter: '53',
	  searchForm: 'repperi'
	}, {
	  latin: 'reri',
	  info: '',
	  definitions: ['menen'],
	  chapter: '50',
	  searchForm: 'reri'
	}, {
	  latin: 'res',
	  info: '5',
	  definitions: ['zaak, ding, kwestie'],
	  chapter: '36',
	  searchForm: 'res'
	}, {
	  latin: 'res gestae',
	  info: 'mv',
	  definitions: ['(oorlogs)daden'],
	  chapter: '44',
	  searchForm: 'res gestae'
	}, {
	  latin: 'res publica',
	  info: '',
	  definitions: ['staat, republiek'],
	  chapter: '39',
	  searchForm: 'res publica'
	}, {
	  latin: 'resistere',
	  info: '',
	  definitions: ['weerstand bieden'],
	  chapter: '10',
	  searchForm: 'resistere'
	}, {
	  latin: 'respondēre',
	  info: '',
	  definitions: ['antwoorden'],
	  chapter: '8',
	  searchForm: 'respondere'
	}, {
	  latin: 'respondi',
	  info: '',
	  definitions: ['*pf van* respondēre'],
	  chapter: '12',
	  searchForm: 'respondi'
	}, {
	  latin: 'retinēre',
	  info: '',
	  definitions: ['tegenhouden'],
	  chapter: '4',
	  searchForm: 'retinere'
	}, {
	  latin: 'rettuli',
	  info: '',
	  definitions: ['*pf van* referre'],
	  chapter: '53',
	  searchForm: 'rettuli'
	}, {
	  latin: 'retuli',
	  info: '',
	  definitions: ['*pf van* referre'],
	  chapter: '32',
	  searchForm: 'retuli'
	}, {
	  latin: 'revocare',
	  info: '',
	  definitions: ['terugroepen'],
	  chapter: '31',
	  searchForm: 'revocare'
	}, {
	  latin: 'rex, reges',
	  info: 'm',
	  definitions: ['koning'],
	  chapter: '1',
	  searchForm: 'rex, reges'
	}, {
	  latin: 'rexi',
	  info: '',
	  definitions: ['*pf van* regere'],
	  chapter: '12',
	  searchForm: 'rexi'
	}, {
	  latin: 'ridēre',
	  info: '',
	  definitions: ['lachen'],
	  chapter: '2',
	  searchForm: 'ridere'
	}, {
	  latin: 'ripa',
	  info: '',
	  definitions: ['oever'],
	  chapter: '54',
	  searchForm: 'ripa'
	}, {
	  latin: 'risi',
	  info: '',
	  definitions: ['*pf van* ridēre'],
	  chapter: '12',
	  searchForm: 'risi'
	}, {
	  latin: 'rogare',
	  info: '',
	  definitions: ['vragen'],
	  chapter: '8',
	  searchForm: 'rogare'
	}, {
	  latin: 'Roma',
	  info: '',
	  definitions: ['Rome'],
	  chapter: '4',
	  searchForm: 'Roma'
	}, {
	  latin: 'Romae',
	  info: '',
	  definitions: ['te Rome, in Rome'],
	  chapter: '20',
	  searchForm: 'Romae'
	}, {
	  latin: 'Romam',
	  info: 'bijw',
	  definitions: ['naar Rome'],
	  chapter: '13',
	  searchForm: 'Romam'
	}, {
	  latin: 'Romanus',
	  info: '',
	  definitions: ['Romein'],
	  chapter: '4',
	  searchForm: 'Romanus'
	}, {
	  latin: 'Romanus, -a, -um',
	  info: '',
	  definitions: ['Romeins'],
	  chapter: '15',
	  searchForm: 'Romanus, -a, -um'
	}, {
	  latin: 'ruere',
	  info: '',
	  definitions: ['zich haasten', 'neerstorten, instorten'],
	  chapter: '27',
	  searchForm: 'ruere'
	}, {
	  latin: 'rui',
	  info: '',
	  definitions: ['*pf van* ruere'],
	  chapter: '27, 51',
	  searchForm: 'rui'
	}, {
	  latin: 'rumpere',
	  info: '',
	  definitions: ['breken'],
	  chapter: '52',
	  searchForm: 'rumpere'
	}, {
	  latin: 'rutus',
	  info: '',
	  definitions: ['*ppp van* ruere'],
	  chapter: '51',
	  searchForm: 'rutus'
	}, {
	  latin: 'sacer, -cra, -crum',
	  info: '',
	  definitions: ['heilig', '**+ dat** gewijd aan'],
	  chapter: '46',
	  searchForm: 'sacer, -cra, -crum'
	}, {
	  latin: 'sacerdos, sacerdotes',
	  info: 'm',
	  definitions: ['priester'],
	  chapter: '46',
	  searchForm: 'sacerdos, sacerdotes'
	}, {
	  latin: 'saeculum',
	  info: '',
	  definitions: ['tijdperk, eeuw'],
	  chapter: '47',
	  searchForm: 'saeculum'
	}, {
	  latin: 'saepe',
	  info: '',
	  definitions: ['vaak'],
	  chapter: '12',
	  searchForm: 'saepe'
	}, {
	  latin: 'saevus, -a, -um',
	  info: '',
	  definitions: ['wild, woest'],
	  chapter: '37',
	  searchForm: 'saevus, -a, -um'
	}, {
	  latin: 'salus, salutes',
	  info: 'v',
	  definitions: ['welzijn', 'redding'],
	  chapter: '45',
	  searchForm: 'salus, salutes'
	}, {
	  latin: 'salutare',
	  info: '',
	  definitions: ['(be)groeten'],
	  chapter: '10',
	  searchForm: 'salutare'
	}, {
	  latin: 'sanctus, -a, -um',
	  info: '',
	  definitions: ['heilig, onschendbaar'],
	  chapter: '46',
	  searchForm: 'sanctus, -a, -um'
	}, {
	  latin: 'sanguis, sanguines',
	  info: 'm',
	  definitions: ['bloed'],
	  chapter: '9',
	  searchForm: 'sanguis, sanguines'
	}, {
	  latin: 'sapientia',
	  info: '',
	  definitions: ['wijsheid'],
	  chapter: '43',
	  searchForm: 'sapientia'
	}, {
	  latin: 'satis',
	  info: '',
	  definitions: ['genoeg'],
	  chapter: '12',
	  searchForm: 'satis'
	}, {
	  latin: 'saxum',
	  info: '',
	  definitions: ['rots, rotsblok'],
	  chapter: '3',
	  searchForm: 'saxum'
	}, {
	  latin: 'scelus, scelera',
	  info: '',
	  definitions: ['misdaad'],
	  chapter: '54',
	  searchForm: 'scelus, scelera'
	}, {
	  latin: 'scientia',
	  info: '',
	  definitions: ['kennis, wetenschap'],
	  chapter: '33',
	  searchForm: 'scientia'
	}, {
	  latin: 'scii',
	  info: '',
	  definitions: ['*pf van* scire'],
	  chapter: '25',
	  searchForm: 'scii'
	}, {
	  latin: 'scilicet',
	  info: '',
	  definitions: ['natuurlijk'],
	  chapter: '6',
	  searchForm: 'scilicet'
	}, {
	  latin: 'scire',
	  info: '',
	  definitions: ['weten'],
	  chapter: '11',
	  searchForm: 'scire'
	}, {
	  latin: 'scivi',
	  info: '',
	  definitions: ['*pf van* scire'],
	  chapter: '25',
	  searchForm: 'scivi'
	}, {
	  latin: 'scribere',
	  info: '',
	  definitions: ['schrijven'],
	  chapter: '50',
	  searchForm: 'scribere'
	}, {
	  latin: 'scripsi',
	  info: '',
	  definitions: ['*pf van* scribere'],
	  chapter: '50',
	  searchForm: 'scripsi'
	}, {
	  latin: 'scriptus',
	  info: '',
	  definitions: ['*ppp van* scribere'],
	  chapter: '51',
	  searchForm: 'scriptus'
	}, {
	  latin: 'se',
	  info: '',
	  definitions: ['zich(zelf)', '**aci** dat hij, dat zij'],
	  chapter: '19, 25',
	  searchForm: 'se'
	}, {
	  latin: 'secundus, -a, -um',
	  info: '',
	  definitions: ['tweede'],
	  chapter: '17',
	  searchForm: 'secundus, -a, -um'
	}, {
	  latin: 'securus, -a, -um',
	  info: '',
	  definitions: ['onbezorgd'],
	  chapter: '46',
	  searchForm: 'securus, -a, -um'
	}, {
	  latin: 'secutus sum',
	  info: '',
	  definitions: ['*pf van* sequi'],
	  chapter: '52',
	  searchForm: 'secutus sum'
	}, {
	  latin: 'sed',
	  info: '',
	  definitions: ['maar'],
	  chapter: '3',
	  searchForm: 'sed'
	}, {
	  latin: 'sedēre',
	  info: '',
	  definitions: ['zitten'],
	  chapter: '6',
	  searchForm: 'sedere'
	}, {
	  latin: 'sedes, sedes',
	  info: 'v',
	  definitions: ['zitplaats', 'woonplaats'],
	  chapter: '48',
	  searchForm: 'sedes, sedes'
	}, {
	  latin: 'sedi',
	  info: '',
	  definitions: ['*pf van* sedēre'],
	  chapter: '55',
	  searchForm: 'sedi'
	}, {
	  latin: 'semel',
	  info: '',
	  definitions: ['eenmaal'],
	  chapter: '55',
	  searchForm: 'semel'
	}, {
	  latin: 'semper',
	  info: '',
	  definitions: ['altijd'],
	  chapter: '4',
	  searchForm: 'semper'
	}, {
	  latin: 'senator, senatores',
	  info: 'm',
	  definitions: ['senator'],
	  chapter: '29',
	  searchForm: 'senator, senatores'
	}, {
	  latin: 'senatus',
	  info: '4',
	  definitions: ['senaat'],
	  chapter: '39',
	  searchForm: 'senatus'
	}, {
	  latin: 'senex, senes',
	  info: 'm',
	  definitions: ['oude man'],
	  chapter: '13',
	  searchForm: 'senex, senes'
	}, {
	  latin: 'sensi',
	  info: '',
	  definitions: ['*pf van* sentire'],
	  chapter: '24',
	  searchForm: 'sensi'
	}, {
	  latin: 'sententia',
	  info: '',
	  definitions: ['mening', 'uitspraak, zin'],
	  chapter: '22',
	  searchForm: 'sententia'
	}, {
	  latin: 'sentire',
	  info: '',
	  definitions: ['merken, voelen', 'menen'],
	  chapter: '24',
	  searchForm: 'sentire'
	}, {
	  latin: 'sequi',
	  info: '',
	  definitions: ['volgen'],
	  chapter: '52',
	  searchForm: 'sequi'
	}, {
	  latin: 'sermo, sermones',
	  info: 'm',
	  definitions: ['gesprek'],
	  chapter: '13',
	  searchForm: 'sermo, sermones'
	}, {
	  latin: 'serva',
	  info: '',
	  definitions: ['slavin'],
	  chapter: '23',
	  searchForm: 'serva'
	}, {
	  latin: 'servare',
	  info: '',
	  definitions: ['redden'],
	  chapter: '4',
	  searchForm: 'servare'
	}, {
	  latin: 'servus',
	  info: '',
	  definitions: ['slaaf'],
	  chapter: '1',
	  searchForm: 'servus'
	}, {
	  latin: 'sessus',
	  info: '',
	  definitions: ['*ppp van* sedēre'],
	  chapter: '55',
	  searchForm: 'sessus'
	}, {
	  latin: 'si',
	  info: '',
	  definitions: ['als, indien'],
	  chapter: '4',
	  searchForm: 'si'
	}, {
	  latin: 'sibi',
	  info: 'dat',
	  definitions: ['(aan/voor) zichzelf'],
	  chapter: '40',
	  searchForm: 'sibi'
	}, {
	  latin: 'sic',
	  info: '',
	  definitions: ['zo'],
	  chapter: '2',
	  searchForm: 'sic'
	}, {
	  latin: 'sicut',
	  info: '',
	  definitions: ['zoals'],
	  chapter: '2',
	  searchForm: 'sicut'
	}, {
	  latin: 'signum',
	  info: '',
	  definitions: ['teken', 'veldteken'],
	  chapter: '5, 53',
	  searchForm: 'signum'
	}, {
	  latin: 'silentium',
	  info: '',
	  definitions: ['stilte'],
	  chapter: '4',
	  searchForm: 'silentium'
	}, {
	  latin: 'silva',
	  info: '',
	  definitions: ['bos'],
	  chapter: '19',
	  searchForm: 'silva'
	}, {
	  latin: 'similis, -e',
	  info: '',
	  definitions: ['gelijk'],
	  chapter: '16',
	  searchForm: 'similis, -e'
	}, {
	  latin: 'simulare',
	  info: '',
	  definitions: ['doen alsof, simuleren'],
	  chapter: '40',
	  searchForm: 'simulare'
	}, {
	  latin: 'sine',
	  info: '+ abl',
	  definitions: ['zonder'],
	  chapter: '11',
	  searchForm: 'sine'
	}, {
	  latin: 'singuli, -ae, -a',
	  info: 'mv',
	  definitions: ['stuk voor stuk'],
	  chapter: '38',
	  searchForm: 'singuli, -ae, -a'
	}, {
	  latin: 'socius',
	  info: '',
	  definitions: ['bondgenoot'],
	  chapter: '37',
	  searchForm: 'socius'
	}, {
	  latin: 'sol, soles',
	  info: 'm',
	  definitions: ['zon'],
	  chapter: '5',
	  searchForm: 'sol, soles'
	}, {
	  latin: 'solēre',
	  info: '',
	  definitions: ['gewend zijn, gewoon zijn'],
	  chapter: '51',
	  searchForm: 'solere'
	}, {
	  latin: 'solitus sum',
	  info: '',
	  definitions: ['*pf van* solēre'],
	  chapter: '50',
	  searchForm: 'solitus sum'
	}, {
	  latin: 'solus, -a, -um',
	  info: '',
	  definitions: ['alleen'],
	  chapter: '37',
	  searchForm: 'solus, -a, -um'
	}, {
	  latin: 'solutus',
	  info: '',
	  definitions: ['*ppp van* solvere'],
	  chapter: '52',
	  searchForm: 'solutus'
	}, {
	  latin: 'solvere',
	  info: '',
	  definitions: ['losmaken', 'betalen'],
	  chapter: '44',
	  searchForm: 'solvere'
	}, {
	  latin: 'solvi',
	  info: '',
	  definitions: ['*pf van* solvere'],
	  chapter: '52',
	  searchForm: 'solvi'
	}, {
	  latin: 'somnium',
	  info: '',
	  definitions: ['droom'],
	  chapter: '41',
	  searchForm: 'somnium'
	}, {
	  latin: 'soror, sorores',
	  info: 'v',
	  definitions: ['zus'],
	  chapter: '8',
	  searchForm: 'soror, sorores'
	}, {
	  latin: 'sors, sortes',
	  info: 'v',
	  definitions: ['lot, toeval'],
	  chapter: '43',
	  searchForm: 'sors, sortes'
	}, {
	  latin: 'spargere',
	  info: '',
	  definitions: ['strooien', 'verspreiden'],
	  chapter: '50',
	  searchForm: 'spargere'
	}, {
	  latin: 'sparsi',
	  info: '',
	  definitions: ['*pf van* spargere'],
	  chapter: '50',
	  searchForm: 'sparsi'
	}, {
	  latin: 'sparsus',
	  info: '',
	  definitions: ['*ppp van* spargere'],
	  chapter: '50',
	  searchForm: 'sparsus'
	}, {
	  latin: 'spatium',
	  info: '',
	  definitions: ['afstand', 'ruimte'],
	  chapter: '31',
	  searchForm: 'spatium'
	}, {
	  latin: 'species',
	  info: '5',
	  definitions: ['uiterlijk'],
	  chapter: '37',
	  searchForm: 'species'
	}, {
	  latin: 'spectaculum',
	  info: '',
	  definitions: ['voorstelling'],
	  chapter: '9',
	  searchForm: 'spectaculum'
	}, {
	  latin: 'spectare',
	  info: '',
	  definitions: ['kijken (naar)'],
	  chapter: '9',
	  searchForm: 'spectare'
	}, {
	  latin: 'spectator, spectatores',
	  info: 'm',
	  definitions: ['toeschouwer'],
	  chapter: '8',
	  searchForm: 'spectator, spectatores'
	}, {
	  latin: 'sperare',
	  info: '',
	  definitions: ['hopen'],
	  chapter: '33',
	  searchForm: 'sperare'
	}, {
	  latin: 'spernere',
	  info: '',
	  definitions: ['afwijzen'],
	  chapter: '24',
	  searchForm: 'spernere'
	}, {
	  latin: 'spes',
	  info: '5',
	  definitions: ['hoop, verwachting'],
	  chapter: '38',
	  searchForm: 'spes'
	}, {
	  latin: 'spiritus',
	  info: '4',
	  definitions: ['adem', 'geest'],
	  chapter: '40',
	  searchForm: 'spiritus'
	}, {
	  latin: 'sprevi',
	  info: '',
	  definitions: ['*pf van* spernere'],
	  chapter: '24',
	  searchForm: 'sprevi'
	}, {
	  latin: 'stare',
	  info: '',
	  definitions: ['staan'],
	  chapter: '3',
	  searchForm: 'stare'
	}, {
	  latin: 'statim',
	  info: '',
	  definitions: ['meteen'],
	  chapter: '4',
	  searchForm: 'statim'
	}, {
	  latin: 'statuere',
	  info: '',
	  definitions: ['besluiten'],
	  chapter: '48',
	  searchForm: 'statuere'
	}, {
	  latin: 'statui',
	  info: '',
	  definitions: ['*pf van* statuere'],
	  chapter: '48',
	  searchForm: 'statui'
	}, {
	  latin: 'statutus',
	  info: '',
	  definitions: ['*ppp van* statuere'],
	  chapter: '48',
	  searchForm: 'statutus'
	}, {
	  latin: 'sternere',
	  info: '',
	  definitions: ['neergooien', 'bedekken'],
	  chapter: '53',
	  searchForm: 'sternere'
	}, {
	  latin: 'strepitus',
	  info: '4',
	  definitions: ['lawaai'],
	  chapter: '36',
	  searchForm: 'strepitus'
	}, {
	  latin: 'studēre',
	  info: '(+ dat)',
	  definitions: ['zijn best doen (voor)'],
	  chapter: '47',
	  searchForm: 'studere'
	}, {
	  latin: 'studium',
	  info: '',
	  definitions: ['ijver, enthousiasme', 'studie'],
	  chapter: '34',
	  searchForm: 'studium'
	}, {
	  latin: 'stultus, -a, -um',
	  info: '',
	  definitions: ['dom'],
	  chapter: '22',
	  searchForm: 'stultus, -a, -um'
	}, {
	  latin: 'suadēre',
	  info: '',
	  definitions: ['aanraden, adviseren'],
	  chapter: '48',
	  searchForm: 'suadere'
	}, {
	  latin: 'suasi',
	  info: '',
	  definitions: ['*pf van* suadēre'],
	  chapter: '48',
	  searchForm: 'suasi'
	}, {
	  latin: 'suasus',
	  info: '',
	  definitions: ['*ppp van* suadēre'],
	  chapter: '48',
	  searchForm: 'suasus'
	}, {
	  latin: 'sub',
	  info: '+ abl',
	  definitions: ['onder'],
	  chapter: '8',
	  searchForm: 'sub'
	}, {
	  latin: 'subito',
	  info: '',
	  definitions: ['plotseling'],
	  chapter: '2',
	  searchForm: 'subito'
	}, {
	  latin: 'sumere',
	  info: '',
	  definitions: ['nemen'],
	  chapter: '23',
	  searchForm: 'sumere'
	}, {
	  latin: 'summus, -a, -um',
	  info: '',
	  definitions: ['hoogste', 'de top van'],
	  chapter: '33',
	  searchForm: 'summus, -a, -um'
	}, {
	  latin: 'sumpsi',
	  info: '',
	  definitions: ['*pf van* sumere'],
	  chapter: '23',
	  searchForm: 'sumpsi'
	}, {
	  latin: 'super',
	  info: '+ acc',
	  definitions: ['boven(op), over'],
	  chapter: '5',
	  searchForm: 'super'
	}, {
	  latin: 'superare',
	  info: '',
	  definitions: ['overtreffen', 'overwinnen'],
	  chapter: '9',
	  searchForm: 'superare'
	}, {
	  latin: 'superbia',
	  info: '',
	  definitions: ['trots, arrogantie'],
	  chapter: '24',
	  searchForm: 'superbia'
	}, {
	  latin: 'supra',
	  info: '+ acc',
	  definitions: ['boven'],
	  chapter: '41',
	  searchForm: 'supra'
	}, {
	  latin: 'supra',
	  info: 'bijw',
	  definitions: ['(er)boven'],
	  chapter: '41',
	  searchForm: 'supra'
	}, {
	  latin: 'surgere',
	  info: '',
	  definitions: ['opstaan'],
	  chapter: '40',
	  searchForm: 'surgere'
	}, {
	  latin: 'surrectus',
	  info: '',
	  definitions: ['*ppp van* surgere'],
	  chapter: '40',
	  searchForm: 'surrectus'
	}, {
	  latin: 'surrexi',
	  info: '',
	  definitions: ['*pf van* surgere'],
	  chapter: '40',
	  searchForm: 'surrexi'
	}, {
	  latin: 'sustuli',
	  info: '',
	  definitions: ['*pf van* tollere'],
	  chapter: '13',
	  searchForm: 'sustuli'
	}, {
	  latin: 'suus, -a, -um',
	  info: '',
	  definitions: ['zijn (eigen)', 'haar (eigen)', 'hun (eigen)'],
	  chapter: '15',
	  searchForm: 'suus, -a, -um'
	}, {
	  latin: 'tacēre',
	  info: '',
	  definitions: ['zwijgen'],
	  chapter: '3',
	  searchForm: 'tacere'
	}, {
	  latin: 'talis, -e',
	  info: '',
	  definitions: ['zodanig'],
	  chapter: '43',
	  searchForm: 'talis, -e'
	}, {
	  latin: 'tam',
	  info: '',
	  definitions: ['zo'],
	  chapter: '37',
	  searchForm: 'tam'
	}, {
	  latin: 'tamen',
	  info: '',
	  definitions: ['toch'],
	  chapter: '1',
	  searchForm: 'tamen'
	}, {
	  latin: 'tandem',
	  info: '',
	  definitions: ['eindelijk'],
	  chapter: '3',
	  searchForm: 'tandem'
	}, {
	  latin: 'tangere',
	  info: '',
	  definitions: ['aanraken'],
	  chapter: '12',
	  searchForm: 'tangere'
	}, {
	  latin: 'tantum',
	  info: 'bijw',
	  definitions: ['slechts, alleen maar'],
	  chapter: '5',
	  searchForm: 'tantum'
	}, {
	  latin: 'tantus, -a, -um',
	  info: '',
	  definitions: ['zo groot'],
	  chapter: '44',
	  searchForm: 'tantus, -a, -um'
	}, {
	  latin: 'tardus, -a, -um',
	  info: '',
	  definitions: ['traag', 'laat'],
	  chapter: '45',
	  searchForm: 'tardus, -a, -um'
	}, {
	  latin: 'tegere',
	  info: '',
	  definitions: ['bedekken'],
	  chapter: '55',
	  searchForm: 'tegere'
	}, {
	  latin: 'templum',
	  info: '',
	  definitions: ['tempel'],
	  chapter: '6',
	  searchForm: 'templum'
	}, {
	  latin: 'temptare',
	  info: '',
	  definitions: ['proberen'],
	  chapter: '4',
	  searchForm: 'temptare'
	}, {
	  latin: 'tempus, tempora',
	  info: '',
	  definitions: ['tijd, periode'],
	  chapter: '15',
	  searchForm: 'tempus, tempora'
	}, {
	  latin: 'tener, -era, -erum',
	  info: '',
	  definitions: ['teer', 'jong'],
	  chapter: '33',
	  searchForm: 'tener, -era, -erum'
	}, {
	  latin: 'tenēre',
	  info: '',
	  definitions: ['(vast)houden'],
	  chapter: '10',
	  searchForm: 'tenere'
	}, {
	  latin: 'terra',
	  info: '',
	  definitions: ['aarde, grond'],
	  chapter: '10',
	  searchForm: 'terra'
	}, {
	  latin: 'terrēre',
	  info: '',
	  definitions: ['bang maken'],
	  chapter: '11',
	  searchForm: 'terrere'
	}, {
	  latin: 'tetigi',
	  info: '',
	  definitions: ['*pf van* tangere'],
	  chapter: '12',
	  searchForm: 'tetigi'
	}, {
	  latin: 'timēre',
	  info: '',
	  definitions: ['vrezen, bang zijn voor'],
	  chapter: '1',
	  searchForm: 'timere'
	}, {
	  latin: 'timidus, -a, -um',
	  info: '',
	  definitions: ['angstig, timide'],
	  chapter: '17',
	  searchForm: 'timidus, -a, -um'
	}, {
	  latin: 'tollere',
	  info: '',
	  definitions: ['optillen'],
	  chapter: '1',
	  searchForm: 'tollere'
	}, {
	  latin: 'totus, -a, -um',
	  info: '',
	  definitions: ['(ge)heel'],
	  chapter: '31',
	  searchForm: 'totus, -a, -um'
	}, {
	  latin: 'tradere',
	  info: '',
	  definitions: ['overhandigen'],
	  chapter: '2',
	  searchForm: 'tradere'
	}, {
	  latin: 'tradidi',
	  info: '',
	  definitions: ['*pf van* tradere'],
	  chapter: '16',
	  searchForm: 'tradidi'
	}, {
	  latin: 'trahere',
	  info: '',
	  definitions: ['trekken'],
	  chapter: '36',
	  searchForm: 'trahere'
	}, {
	  latin: 'trans',
	  info: '+ acc',
	  definitions: ['over, aan de overzijde van'],
	  chapter: '13',
	  searchForm: 'trans'
	}, {
	  latin: 'transii',
	  info: '',
	  definitions: ['*pf van* transire'],
	  chapter: '32, 39',
	  searchForm: 'transii'
	}, {
	  latin: 'transire',
	  info: '',
	  definitions: ['oversteken'],
	  chapter: '39',
	  searchForm: 'transire'
	}, {
	  latin: 'transiturus',
	  info: '',
	  definitions: ['*pfa van* transire'],
	  chapter: '32, 39',
	  searchForm: 'transiturus'
	}, {
	  latin: 'tremere',
	  info: '',
	  definitions: ['trillen, beven'],
	  chapter: '27',
	  searchForm: 'tremere'
	}, {
	  latin: 'tribuere',
	  info: '',
	  definitions: ['toekennen'],
	  chapter: '19',
	  searchForm: 'tribuere'
	}, {
	  latin: 'tristis, -e',
	  info: '',
	  definitions: ['droevig, somber'],
	  chapter: '17',
	  searchForm: 'tristis, -e'
	}, {
	  latin: 'tueri',
	  info: '',
	  definitions: ['bekijken, onderzoeken', 'beschermen'],
	  chapter: '51',
	  searchForm: 'tueri'
	}, {
	  latin: 'tuli',
	  info: '',
	  definitions: ['*pf van* ferre'],
	  chapter: '32',
	  searchForm: 'tuli'
	}, {
	  latin: 'tumultus',
	  info: '4',
	  definitions: ['opschudding, tumult'],
	  chapter: '36',
	  searchForm: 'tumultus'
	}, {
	  latin: 'tunc',
	  info: '',
	  definitions: ['op dat moment, toen'],
	  chapter: '11',
	  searchForm: 'tunc'
	}, {
	  latin: 'turba',
	  info: '',
	  definitions: ['menigte'],
	  chapter: '4',
	  searchForm: 'turba'
	}, {
	  latin: 'turbare',
	  info: '',
	  definitions: ['verstoren'],
	  chapter: '48',
	  searchForm: 'turbare'
	}, {
	  latin: 'tutus, -a, -um',
	  info: '',
	  definitions: ['veilig'],
	  chapter: '30',
	  searchForm: 'tutus, -a, -um'
	}, {
	  latin: 'tuus, -a, -um',
	  info: '',
	  definitions: ['jouw, uw'],
	  chapter: '15',
	  searchForm: 'tuus, -a, -um'
	}, {
	  latin: 'ubi',
	  info: '',
	  definitions: ['waar'],
	  chapter: '1',
	  searchForm: 'ubi'
	}, {
	  latin: 'ubique',
	  info: '',
	  definitions: ['overal'],
	  chapter: '9',
	  searchForm: 'ubique'
	}, {
	  latin: 'ullus, -a, -um',
	  info: '',
	  definitions: ['enige, een of andere'],
	  chapter: '47',
	  searchForm: 'ullus, -a, -um'
	}, {
	  latin: 'ultimus, -a, -um',
	  info: '',
	  definitions: ['laatste, uiterste'],
	  chapter: '24',
	  searchForm: 'ultimus, -a, -um'
	}, {
	  latin: 'ultro',
	  info: '',
	  definitions: ['uit zichzelf'],
	  chapter: '24',
	  searchForm: 'ultro'
	}, {
	  latin: 'umbra',
	  info: '',
	  definitions: ['schaduw', 'schim *(van een overledene)*'],
	  chapter: '10, 17',
	  searchForm: 'umbra'
	}, {
	  latin: 'umquam',
	  info: '',
	  definitions: ['ooit'],
	  chapter: '29',
	  searchForm: 'umquam'
	}, {
	  latin: 'unda',
	  info: '',
	  definitions: ['golf'],
	  chapter: '53',
	  searchForm: 'unda'
	}, {
	  latin: 'unde',
	  info: '',
	  definitions: ['waarvandaan'],
	  chapter: '27',
	  searchForm: 'unde'
	}, {
	  latin: 'undique',
	  info: '',
	  definitions: ['van alle kanten'],
	  chapter: '53',
	  searchForm: 'undique'
	}, {
	  latin: 'universus, -a, -um',
	  info: '',
	  definitions: ['gezamenlijk'],
	  chapter: '36',
	  searchForm: 'universus, -a, -um'
	}, {
	  latin: 'unus, -a, -um',
	  info: '',
	  definitions: ['één'],
	  chapter: '15',
	  searchForm: 'unus, -a, -um'
	}, {
	  latin: 'urbs, urbes',
	  info: 'v',
	  definitions: ['stad'],
	  chapter: '3',
	  searchForm: 'urbs, urbes'
	}, {
	  latin: 'urgēre',
	  info: '',
	  definitions: ['in het nauw brengen'],
	  chapter: '36',
	  searchForm: 'urgere'
	}, {
	  latin: 'usque ad',
	  info: '+ acc',
	  definitions: ['tot aan'],
	  chapter: '37',
	  searchForm: 'usque ad'
	}, {
	  latin: 'usus',
	  info: '4',
	  definitions: ['gebruik', 'nut'],
	  chapter: '52',
	  searchForm: 'usus'
	}, {
	  latin: 'usus sum',
	  info: '',
	  definitions: ['*pf van* uti'],
	  chapter: '51',
	  searchForm: 'usus sum'
	}, {
	  latin: 'ut',
	  info: '+ conj',
	  definitions: ['(met de bedoeling) dat, om te', '(met het gevolg) dat, zodat'],
	  chapter: '44',
	  searchForm: 'ut'
	}, {
	  latin: 'ut',
	  info: '+ ind',
	  definitions: ['zoals', '**+ pf** zodra'],
	  chapter: '23',
	  searchForm: 'ut'
	}, {
	  latin: 'uter, utra, utrum',
	  info: '',
	  definitions: ['welk(e) van beiden'],
	  chapter: '36',
	  searchForm: 'uter, utra, utrum'
	}, {
	  latin: 'uterque, utraque, utrumque',
	  info: '',
	  definitions: ['elk van beide'],
	  chapter: '36, 54',
	  searchForm: 'uterque, utraque, utrumque'
	}, {
	  latin: 'uti',
	  info: '+ abl',
	  definitions: ['gebruiken'],
	  chapter: '50',
	  searchForm: 'uti'
	}, {
	  latin: 'utilis, -e',
	  info: '',
	  definitions: ['nuttig'],
	  chapter: '33',
	  searchForm: 'utilis, -e'
	}, {
	  latin: 'utinam',
	  info: '',
	  definitions: ['*leidt een wens in (niet vertalen)*'],
	  chapter: '43',
	  searchForm: 'utinam'
	}, {
	  latin: 'utique',
	  info: '',
	  definitions: ['hoe dan ook'],
	  chapter: '47',
	  searchForm: 'utique'
	}, {
	  latin: 'utrum … an',
	  info: '',
	  definitions: ['(of) … of'],
	  chapter: '22',
	  searchForm: 'utrum … an'
	}, {
	  latin: 'uxor, uxores',
	  info: 'v',
	  definitions: ['echtgenote'],
	  chapter: '2',
	  searchForm: 'uxor, uxores'
	}, {
	  latin: 'valde',
	  info: '',
	  definitions: ['zeer, erg'],
	  chapter: '9',
	  searchForm: 'valde'
	}, {
	  latin: 'vale, *mv* valete',
	  info: '',
	  definitions: ['gegroet, vaarwel'],
	  chapter: '53',
	  searchForm: 'vale, *mv* valete'
	}, {
	  latin: 'varius, -a, -um',
	  info: '',
	  definitions: ['verschillend, afwisselend'],
	  chapter: '51',
	  searchForm: 'varius, -a, -um'
	}, {
	  latin: 'vates, vates',
	  info: 'm',
	  definitions: ['waarzegger', 'zanger'],
	  chapter: '48',
	  searchForm: 'vates, vates'
	}, {
	  latin: 'vehemens, vehement-',
	  info: '',
	  definitions: ['hevig, krachtig'],
	  chapter: '27',
	  searchForm: 'vehemens, vehement-'
	}, {
	  latin: 'vehere',
	  info: '',
	  definitions: ['**act** vervoeren', '**pass** reizen'],
	  chapter: '52',
	  searchForm: 'vehere'
	}, {
	  latin: 'velle',
	  info: 'inf.prs',
	  definitions: ['willen'],
	  chapter: '31',
	  searchForm: 'velle'
	}, {
	  latin: 'vendere',
	  info: '',
	  definitions: ['verkopen'],
	  chapter: '6',
	  searchForm: 'vendere'
	}, {
	  latin: 'vendidi',
	  info: '',
	  definitions: ['*pf van* vendere'],
	  chapter: '25',
	  searchForm: 'vendidi'
	}, {
	  latin: 'veni',
	  info: '',
	  definitions: ['*pf van* venire'],
	  chapter: '12',
	  searchForm: 'veni'
	}, {
	  latin: 'venire',
	  info: '',
	  definitions: ['komen'],
	  chapter: '1',
	  searchForm: 'venire'
	}, {
	  latin: 'ventus',
	  info: '',
	  definitions: ['wind'],
	  chapter: '50',
	  searchForm: 'ventus'
	}, {
	  latin: 'verbum',
	  info: '',
	  definitions: ['woord'],
	  chapter: '11',
	  searchForm: 'verbum'
	}, {
	  latin: 'vereri',
	  info: '',
	  definitions: ['vrezen'],
	  chapter: '50',
	  searchForm: 'vereri'
	}, {
	  latin: 'vero',
	  info: '',
	  definitions: ['inderdaad', 'echter'],
	  chapter: '22',
	  searchForm: 'vero'
	}, {
	  latin: 'vertere',
	  info: '',
	  definitions: ['keren, wenden'],
	  chapter: '11',
	  searchForm: 'vertere'
	}, {
	  latin: 'verti',
	  info: '',
	  definitions: ['*pf van* vertere'],
	  chapter: '23',
	  searchForm: 'verti'
	}, {
	  latin: 'verus, -a, -um',
	  info: '',
	  definitions: ['echt, waar'],
	  chapter: '34',
	  searchForm: 'verus, -a, -um'
	}, {
	  latin: 'vester, -stra, -strum',
	  info: '',
	  definitions: ['jullie, van jullie'],
	  chapter: '15',
	  searchForm: 'vester, -stra, -strum'
	}, {
	  latin: 'vestis, vestes',
	  info: 'v',
	  definitions: ['kleding(stuk)'],
	  chapter: '17',
	  searchForm: 'vestis, vestes'
	}, {
	  latin: 'vetare',
	  info: '',
	  definitions: ['verbieden'],
	  chapter: '8',
	  searchForm: 'vetare'
	}, {
	  latin: 'vetus, veter-',
	  info: '',
	  definitions: ['oud'],
	  chapter: '27',
	  searchForm: 'vetus, veter-'
	}, {
	  latin: 'via',
	  info: '',
	  definitions: ['weg, straat'],
	  chapter: '8',
	  searchForm: 'via'
	}, {
	  latin: 'vici',
	  info: '',
	  definitions: ['*pf van* vincere'],
	  chapter: '12',
	  searchForm: 'vici'
	}, {
	  latin: 'victor, victores',
	  info: 'm',
	  definitions: ['(over)winnaar'],
	  chapter: '11',
	  searchForm: 'victor, victores'
	}, {
	  latin: 'victoria',
	  info: '',
	  definitions: ['overwinning'],
	  chapter: '6',
	  searchForm: 'victoria'
	}, {
	  latin: 'victurus',
	  info: '',
	  definitions: ['*pfa van* vivere'],
	  chapter: '43',
	  searchForm: 'victurus'
	}, {
	  latin: 'victus',
	  info: '',
	  definitions: ['*ppp van* vincere'],
	  chapter: '31',
	  searchForm: 'victus'
	}, {
	  latin: 'vidēre',
	  info: '',
	  definitions: ['zien'],
	  chapter: '1',
	  searchForm: 'videre'
	}, {
	  latin: 'videri',
	  info: '',
	  definitions: ['schijnen, lijken'],
	  chapter: '50',
	  searchForm: 'videri'
	}, {
	  latin: 'vidi',
	  info: '',
	  definitions: ['*pf van* vidēre'],
	  chapter: '13',
	  searchForm: 'vidi'
	}, {
	  latin: 'villa',
	  info: '',
	  definitions: ['landgoed'],
	  chapter: '26',
	  searchForm: 'villa'
	}, {
	  latin: 'vincere',
	  info: '',
	  definitions: ['(over)winnen'],
	  chapter: '6',
	  searchForm: 'vincere'
	}, {
	  latin: 'vinum',
	  info: '',
	  definitions: ['wijn'],
	  chapter: '10',
	  searchForm: 'vinum'
	}, {
	  latin: 'vir, *mv* viri',
	  info: '',
	  definitions: ['man'],
	  chapter: '3',
	  searchForm: 'vir, *mv* viri'
	}, {
	  latin: 'virgo, virgines',
	  info: 'v',
	  definitions: ['meisje, maagd'],
	  chapter: '39',
	  searchForm: 'virgo, virgines'
	}, {
	  latin: 'virtus, virtutes',
	  info: 'v',
	  definitions: ['dapperheid'],
	  chapter: '22',
	  searchForm: 'virtus, virtutes'
	}, {
	  latin: 'vis *van* velle',
	  info: '',
	  definitions: ['jij wilt'],
	  chapter: '31',
	  searchForm: 'vis *van* velle'
	}, {
	  latin: 'vis, vires',
	  info: 'v',
	  definitions: ['kracht, geweld'],
	  chapter: '37',
	  searchForm: 'vis, vires'
	}, {
	  latin: 'visus sum',
	  info: '',
	  definitions: ['*pf van* videri'],
	  chapter: '50',
	  searchForm: 'visus sum'
	}, {
	  latin: 'vita',
	  info: '',
	  definitions: ['(het) leven'],
	  chapter: '6',
	  searchForm: 'vita'
	}, {
	  latin: 'vitare',
	  info: '',
	  definitions: ['vermijden'],
	  chapter: '11',
	  searchForm: 'vitare'
	}, {
	  latin: 'vivere',
	  info: '',
	  definitions: ['leven'],
	  chapter: '5',
	  searchForm: 'vivere'
	}, {
	  latin: 'vivus, -a, -um',
	  info: '',
	  definitions: ['levend'],
	  chapter: '38',
	  searchForm: 'vivus, -a, -um'
	}, {
	  latin: 'vix',
	  info: '',
	  definitions: ['met moeite, nauwelijks'],
	  chapter: '38',
	  searchForm: 'vix'
	}, {
	  latin: 'vixi',
	  info: '',
	  definitions: ['*pf van* vivere'],
	  chapter: '13, 43',
	  searchForm: 'vixi'
	}, {
	  latin: 'vocare',
	  info: '',
	  definitions: ['roepen', 'noemen'],
	  chapter: '1',
	  searchForm: 'vocare'
	}, {
	  latin: 'volui',
	  info: '',
	  definitions: ['*pf van* velle'],
	  chapter: '32',
	  searchForm: 'volui'
	}, {
	  latin: 'vox, voces',
	  info: 'v',
	  definitions: ['stem', 'uitspraak'],
	  chapter: '16',
	  searchForm: 'vox, voces'
	}, {
	  latin: 'vulnerare',
	  info: '',
	  definitions: ['verwonden'],
	  chapter: '10',
	  searchForm: 'vulnerare'
	}, {
	  latin: 'vulnus, vulnera',
	  info: '',
	  definitions: ['wond'],
	  chapter: '19',
	  searchForm: 'vulnus, vulnera'
	}, {
	  latin: 'vultus',
	  info: '4',
	  definitions: ['gezicht'],
	  chapter: '41',
	  searchForm: 'vultus'
	}];
	
	module.exports = dictionaryData;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 20px;\n"], ["\n  position: relative;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 20px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: $color-white;\n  width: 100%;\n  height: calc(100% - 100px);\n  overflow: auto;\n  padding: 0 20px 20px 20px;\n  display: block;\n  margin: 0 auto;\n  z-index: 1;\n"], ["\n  position: relative;\n  background-color: $color-white;\n  width: 100%;\n  height: calc(100% - 100px);\n  overflow: auto;\n  padding: 0 20px 20px 20px;\n  display: block;\n  margin: 0 auto;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactRedux = __webpack_require__(214);
	
	var _store = __webpack_require__(626);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _connect = __webpack_require__(223);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	var _WordSearch = __webpack_require__(623);
	
	var _WordSearch2 = _interopRequireDefault(_WordSearch);
	
	var _Result = __webpack_require__(622);
	
	var _Result2 = _interopRequireDefault(_Result);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var mapResults = function mapResults(words) {
	  return words.map(function (word, i) {
	    return _react2.default.createElement(_Result2.default, { word: word, key: i });
	  });
	};
	
	var SearchContainer = _styledComponents2.default.div(_templateObject);
	
	var ResultsContainer = _styledComponents2.default.div(_templateObject2);
	
	var Vocabularium = function Vocabularium(props) {
	  var dictionary = props.dictionary;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      SearchContainer,
	      null,
	      _react2.default.createElement(_WordSearch2.default, null)
	    ),
	    _react2.default.createElement(
	      ResultsContainer,
	      null,
	      mapResults(dictionary)
	    )
	  );
	};
	
	var ConnectedVocabularium = (0, _connect2.default)(Vocabularium);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(ConnectedVocabularium, null)
	  );
	};
	
	module.exports = exports["default"];

/***/ }),
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rehypeReact = __webpack_require__(187);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Helmet = __webpack_require__(72);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _lexikon = __webpack_require__(621);
	
	var _lexikon2 = _interopRequireDefault(_lexikon);
	
	var _vocabularium = __webpack_require__(628);
	
	var _vocabularium2 = _interopRequireDefault(_vocabularium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var renderAst = new _rehypeReact2.default({
	  createElement: _react2.default.createElement,
	  components: {
	    lexikon: _lexikon2.default,
	    vocabularium: _vocabularium2.default
	  }
	}).Compiler;
	
	var Title = _styledComponents2.default.h1(_templateObject);
	
	var Post = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  var title = post.frontmatter.title;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Helmet2.default, { data: data }),
	    _react2.default.createElement(
	      Title,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      Post,
	      null,
	      renderAst(post.htmlAst)
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1402);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 1403 */,
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(257),
	    getPrototype = __webpack_require__(1401),
	    isObjectLike = __webpack_require__(261);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(3);
	
	var _propTypes = __webpack_require__(15);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(564);
	
	var _warning = __webpack_require__(479);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(562);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1503);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1497);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1498);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1499);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1500);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(186);
	
	var _wrapMapToProps = __webpack_require__(563);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(563);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(565);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1501);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(479);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1573);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(189)(module)))

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ })
]);


// WEBPACK FOOTER //
// component---src-templates-app-js-262ce4673509063b78fc.js